//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})

@Injectable({
    providedIn: 'root'
})
export class AdjustmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: AdjustmentSearchRequest | undefined): Observable<AdjustmentResponse> {
        let url_ = this.baseUrl + "/api/Adjustment/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdjustmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdjustmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isBulkServCodeActiveInAuthsAndPayRates(body?: BulkServCodeRequest | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/Adjustment/IsBulkServCodeActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsBulkServCodeActiveInAuthsAndPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsBulkServCodeActiveInAuthsAndPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processIsBulkServCodeActiveInAuthsAndPayRates(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdjustmentProcessorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    billRateAdjustment(body?: RefreshRequestDTO | undefined): Observable<RefreshBillRateResponseDTO[]> {
        let url_ = this.baseUrl + "/api/AdjustmentProcessor/refresBillrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBillRateAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBillRateAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshBillRateResponseDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshBillRateResponseDTO[]>;
        }));
    }

    protected processBillRateAdjustment(response: HttpResponseBase): Observable<RefreshBillRateResponseDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshBillRateResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    agreementNoAdjustment(body?: RefreshRequestDTO | undefined): Observable<RefreshACNResponseDTO[]> {
        let url_ = this.baseUrl + "/api/AdjustmentProcessor/refreshAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgreementNoAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgreementNoAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshACNResponseDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshACNResponseDTO[]>;
        }));
    }

    protected processAgreementNoAdjustment(response: HttpResponseBase): Observable<RefreshACNResponseDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshACNResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    payRateAdjustment(body?: RefreshRequestDTO | undefined): Observable<RefreshPayRateResponseDTO[]> {
        let url_ = this.baseUrl + "/api/AdjustmentProcessor/refreshPayrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayRateAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayRateAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshPayRateResponseDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshPayRateResponseDTO[]>;
        }));
    }

    protected processPayRateAdjustment(response: HttpResponseBase): Observable<RefreshPayRateResponseDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshPayRateResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgencyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    get(): Observable<Agency[]> {
        let url_ = this.baseUrl + "/api/agency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Agency[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agency.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: AgencyCreateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: AgencyCreateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param agencyIds (optional)
     * @return Success
     */
    delete(agencyIds?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency?";
        if (agencyIds === null)
            throw new Error("The parameter 'agencyIds' cannot be null.");
        else if (agencyIds !== undefined)
            url_ += "agencyIds=" + encodeURIComponent("" + agencyIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantIds (optional)
     * @param agencyId (optional)
     * @return Success
     */
    addParticipantsToAgency(participantIds?: string | undefined, agencyId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency/addparticipantstoagency?";
        if (participantIds === null)
            throw new Error("The parameter 'participantIds' cannot be null.");
        else if (participantIds !== undefined)
            url_ += "ParticipantIds=" + encodeURIComponent("" + participantIds) + "&";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParticipantsToAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParticipantsToAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAddParticipantsToAgency(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param agencyIds (optional)
     * @return Success
     */
    checkAgencyMappings(agencyIds?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/agency/Checkagencymappings?";
        if (agencyIds === null)
            throw new Error("The parameter 'agencyIds' cannot be null.");
        else if (agencyIds !== undefined)
            url_ += "agencyIds=" + encodeURIComponent("" + agencyIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAgencyMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAgencyMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCheckAgencyMappings(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional)
     * @return Success
     */
    checkAgencyUsersCaseloadMapping(userIds?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/agency/checkagencyuserscaseloadmapping?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            url_ += "userIds=" + encodeURIComponent("" + userIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAgencyUsersCaseloadMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAgencyUsersCaseloadMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCheckAgencyUsersCaseloadMapping(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantIds (optional)
     * @return Success
     */
    checkParticipantsCaseloadMapping(participantIds?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/agency/checkparticipantscaseloadmapping?";
        if (participantIds === null)
            throw new Error("The parameter 'participantIds' cannot be null.");
        else if (participantIds !== undefined)
            url_ += "participantIds=" + encodeURIComponent("" + participantIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckParticipantsCaseloadMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckParticipantsCaseloadMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCheckParticipantsCaseloadMapping(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(agencyId: number): Observable<Agency> {
        let url_ = this.baseUrl + "/api/agency/id/{agencyId}";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Agency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Agency>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Agency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agency.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param agencyId (optional)
     * @param userIds (optional)
     * @return Success
     */
    mapPortalUsers(agencyId?: string | undefined, userIds?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency/mapportalusers?";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            url_ += "UserIds=" + encodeURIComponent("" + userIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapPortalUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapPortalUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processMapPortalUsers(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantIds (optional)
     * @param agencyId (optional)
     * @return Success
     */
    removeParticipantsFromAgency(participantIds?: string | undefined, agencyId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency/removeparticipantsfromagency?";
        if (participantIds === null)
            throw new Error("The parameter 'participantIds' cannot be null.");
        else if (participantIds !== undefined)
            url_ += "ParticipantIds=" + encodeURIComponent("" + participantIds) + "&";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveParticipantsFromAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveParticipantsFromAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processRemoveParticipantsFromAgency(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional)
     * @param agencyId (optional)
     * @return Success
     */
    removeUsersFromAgency(userIds?: string | undefined, agencyId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/agency/removeusersfromagency?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            url_ += "UserIds=" + encodeURIComponent("" + userIds) + "&";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUsersFromAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUsersFromAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processRemoveUsersFromAgency(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AmtRangeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    get(): Observable<AmtRangeDto[]> {
        let url_ = this.baseUrl + "/api/amtrange";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AmtRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AmtRangeDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AmtRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AmtRangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AnnouncementsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdateAnnouncements(body?: AnnouncementCreateUpdateRequest | undefined): Observable<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/Announcements/create-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HttpResponseMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HttpResponseMessage>;
        }));
    }

    protected processCreateUpdateAnnouncements(response: HttpResponseBase): Observable<HttpResponseMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HttpResponseMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteAnnouncements(body?: AnnouncementDeleteRequest | undefined): Observable<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/Announcements/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HttpResponseMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HttpResponseMessage>;
        }));
    }

    protected processDeleteAnnouncements(response: HttpResponseBase): Observable<HttpResponseMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HttpResponseMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllAnnouncements(): Observable<AnnouncementResponseDto[]> {
        let url_ = this.baseUrl + "/api/Announcements/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementResponseDto[]>;
        }));
    }

    protected processGetAllAnnouncements(response: HttpResponseBase): Observable<AnnouncementResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnnouncementResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllAnnouncementLanguages(): Observable<AnnouncementLanguageResponseDto[]> {
        let url_ = this.baseUrl + "/api/Announcements/fetch-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAnnouncementLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAnnouncementLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementLanguageResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementLanguageResponseDto[]>;
        }));
    }

    protected processGetAllAnnouncementLanguages(response: HttpResponseBase): Observable<AnnouncementLanguageResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnnouncementLanguageResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: AuthorizationCreateRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/authorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: AuthorizationUpdateRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/authorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByAcn(acn: string): Observable<Authorization> {
        let url_ = this.baseUrl + "/api/authorization/acn/{acn}";
        if (acn === undefined || acn === null)
            throw new Error("The parameter 'acn' must be defined.");
        url_ = url_.replace("{acn}", encodeURIComponent("" + acn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Authorization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Authorization>;
        }));
    }

    protected processGetByAcn(response: HttpResponseBase): Observable<Authorization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Authorization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAmountDisableCompanies(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/authorization/amountdisablecompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmountDisableCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmountDisableCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAmountDisableCompanies(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param acn (optional)
     * @param companyId (optional)
     * @param billCode (optional)
     * @param servCode (optional)
     * @return Success
     */
    getAuthDetailsByAgreementNumber(acn?: string | undefined, companyId?: number | undefined, billCode?: string | undefined, servCode?: string | undefined): Observable<ClaimAuthDetails> {
        let url_ = this.baseUrl + "/api/authorization/authdetails/acn?";
        if (acn === null)
            throw new Error("The parameter 'acn' cannot be null.");
        else if (acn !== undefined)
            url_ += "acn=" + encodeURIComponent("" + acn) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&";
        if (servCode === null)
            throw new Error("The parameter 'servCode' cannot be null.");
        else if (servCode !== undefined)
            url_ += "servCode=" + encodeURIComponent("" + servCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthDetailsByAgreementNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthDetailsByAgreementNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAuthDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAuthDetails>;
        }));
    }

    protected processGetAuthDetailsByAgreementNumber(response: HttpResponseBase): Observable<ClaimAuthDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimAuthDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional)
     * @param programId (optional)
     * @return Success
     */
    getClientInsIdentification(clientId?: number | undefined, programId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/authorization/clientinsidentification?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientInsIdentification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientInsIdentification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetClientInsIdentification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: AuthorizationSearchRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/authorization/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getInactiveBudgetSummaries(acn: string): Observable<BudgetSummary[]> {
        let url_ = this.baseUrl + "/api/authorization/inactivebudgetsummaries/{acn}";
        if (acn === undefined || acn === null)
            throw new Error("The parameter 'acn' must be defined.");
        url_ = url_.replace("{acn}", encodeURIComponent("" + acn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInactiveBudgetSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInactiveBudgetSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BudgetSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BudgetSummary[]>;
        }));
    }

    protected processGetInactiveBudgetSummaries(response: HttpResponseBase): Observable<BudgetSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAuthorizationFilteredByMco(body?: AuthorizationSearchRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/authorization/mco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationFilteredByMco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationFilteredByMco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetAuthorizationFilteredByMco(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteAuthorization(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/authorization/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteAuthorization(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getUnitMultiplier(body?: UnitMultiplierRequest | undefined): Observable<UnitMultiplierResponse> {
        let url_ = this.baseUrl + "/api/authorization/unitmultiplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitMultiplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitMultiplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitMultiplierResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitMultiplierResponse>;
        }));
    }

    protected processGetUnitMultiplier(response: HttpResponseBase): Observable<UnitMultiplierResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitMultiplierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BenefitContributionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdate(body?: BenefitContributionRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/benefitContribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approveBenefitContribution(body?: BenefitContributionRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/benefitContribution/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveBenefitContribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveBenefitContribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApproveBenefitContribution(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/benefitContribution/delete?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfBenefitContributionResponseDto> {
        let url_ = this.baseUrl + "/api/benefitContribution/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfBenefitContributionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfBenefitContributionResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfBenefitContributionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfBenefitContributionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBenefitContirbutionById(id: number): Observable<BenefitContributionResponseDto> {
        let url_ = this.baseUrl + "/api/benefitContribution/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitContirbutionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitContirbutionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitContributionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitContributionResponseDto>;
        }));
    }

    protected processGetBenefitContirbutionById(response: HttpResponseBase): Observable<BenefitContributionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitContributionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillCodeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: BillCodeRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: BillCodeRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billcode?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDetailsById(id?: number | undefined): Observable<BillCodeDTO> {
        let url_ = this.baseUrl + "/api/billcode/details?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillCodeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillCodeDTO>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<BillCodeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillCodeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllBillCodesForExport(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billcode/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillCodesForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillCodesForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetAllBillCodesForExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeOnly (optional)
     * @param body (optional)
     * @return Success
     */
    get(activeOnly?: boolean | null | undefined, body?: CustomFilterRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/billcode/fetch?";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillRateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getBillRateHistory(billRateId: number, body?: GetHistoryRequestBase | undefined): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/billrate/{billRateId}/history";
        if (billRateId === undefined || billRateId === null)
            throw new Error("The parameter 'billRateId' must be defined.");
        url_ = url_.replace("{billRateId}", encodeURIComponent("" + billRateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillRateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillRateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetBillRateHistory(response: HttpResponseBase): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createBillRate(body?: BillRateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/billrate/billrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBillRate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @param programName (optional)
     * @return Success
     */
    getAllBillRateForExport(programId?: number | undefined, programName?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billrate/export?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (programName === null)
            throw new Error("The parameter 'programName' cannot be null.");
        else if (programName !== undefined)
            url_ += "programName=" + encodeURIComponent("" + programName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillRateForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillRateForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetAllBillRateForExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @param body (optional)
     * @return Success
     */
    getAllBillRate(programId?: number | undefined, body?: FilterRequest | undefined): Observable<GridResponseBaseOfBillRateResponseDto> {
        let url_ = this.baseUrl + "/api/billrate/fetch?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfBillRateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfBillRateResponseDto>;
        }));
    }

    protected processGetAllBillRate(response: HttpResponseBase): Observable<GridResponseBaseOfBillRateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfBillRateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBillRateConfig(): Observable<BillRateConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/billrate/getbillrateconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillRateConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillRateConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillRateConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillRateConfigurationDto[]>;
        }));
    }

    protected processGetBillRateConfig(response: HttpResponseBase): Observable<BillRateConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillRateConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBillRateById(id: number): Observable<BillRateByIdResponseDto> {
        let url_ = this.baseUrl + "/api/billrate/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillRateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillRateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillRateByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillRateByIdResponseDto>;
        }));
    }

    protected processGetBillRateById(response: HttpResponseBase): Observable<BillRateByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillRateByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @param beginDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getAllBillRateInfo(programId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined): Observable<GridResponseBaseOfBillRateResponseDto> {
        let url_ = this.baseUrl + "/api/billrate/info?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillRateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillRateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfBillRateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfBillRateResponseDto>;
        }));
    }

    protected processGetAllBillRateInfo(response: HttpResponseBase): Observable<GridResponseBaseOfBillRateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfBillRateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param billRateId (optional)
     * @return Success
     */
    deleteBillRate(billRateId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billrate/remove?";
        if (billRateId === null)
            throw new Error("The parameter 'billRateId' cannot be null.");
        else if (billRateId !== undefined)
            url_ += "billRateId=" + encodeURIComponent("" + billRateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBillRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBillRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteBillRate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CallCenterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param caregiverId (optional)
     * @return Success
     */
    getEmployersByCaregiverId(caregiverId?: string | undefined): Observable<CaregiverEmployerGHA[]> {
        let url_ = this.baseUrl + "/api/callcenter/caregiveremployer?";
        if (caregiverId === null)
            throw new Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployersByCaregiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployersByCaregiverId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerGHA[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerGHA[]>;
        }));
    }

    protected processGetEmployersByCaregiverId(response: HttpResponseBase): Observable<CaregiverEmployerGHA[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverEmployerGHA.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submitCaregiverMileageShift(body?: MileageSubmissionRequest | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/caregivermileageentry/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitCaregiverMileageShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitCaregiverMileageShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processSubmitCaregiverMileageShift(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCaregiverTimeShiftsGHA(body?: GetGHAShiftsRequest | undefined): Observable<GhaEntity[]> {
        let url_ = this.baseUrl + "/api/callcenter/caregivertimeshiftgha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverTimeShiftsGHA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverTimeShiftsGHA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GhaEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GhaEntity[]>;
        }));
    }

    protected processGetCaregiverTimeShiftsGHA(response: HttpResponseBase): Observable<GhaEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GhaEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCaregiverTimeShiftGHAById(body?: UpsertGHAShiftRequest | undefined): Observable<ShiftDataEntity> {
        let url_ = this.baseUrl + "/api/callcenter/caregivertimeshiftgha/id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverTimeShiftGHAById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverTimeShiftGHAById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDataEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDataEntity>;
        }));
    }

    protected processGetCaregiverTimeShiftGHAById(response: HttpResponseBase): Observable<ShiftDataEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDataEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submitCaregiverTimeShiftGHA(body?: GHAShiftSubmissionRequest | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/caregivertimeshiftgha/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitCaregiverTimeShiftGHA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitCaregiverTimeShiftGHA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processSubmitCaregiverTimeShiftGHA(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @return Success
     */
    getEvvExceptionReasonCodesByProgramId(programId?: string | null | undefined): Observable<EvvExceptionReasonCodeResponseDto[]> {
        let url_ = this.baseUrl + "/api/callcenter/evvexceptionreasoncode?";
        if (programId !== undefined && programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvvExceptionReasonCodesByProgramId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvvExceptionReasonCodesByProgramId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvvExceptionReasonCodeResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvvExceptionReasonCodeResponseDto[]>;
        }));
    }

    protected processGetEvvExceptionReasonCodesByProgramId(response: HttpResponseBase): Observable<EvvExceptionReasonCodeResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvvExceptionReasonCodeResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCaregiverMileageEntries(body?: TimeShiftRequest | undefined): Observable<MileageDataEntity[]> {
        let url_ = this.baseUrl + "/api/callcenter/getmileageentry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverMileageEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverMileageEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MileageDataEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MileageDataEntity[]>;
        }));
    }

    protected processGetCaregiverMileageEntries(response: HttpResponseBase): Observable<MileageDataEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MileageDataEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getMileageById(body?: TimeShiftByIdRequestDTO | undefined): Observable<MileageDataEntity> {
        let url_ = this.baseUrl + "/api/callcenter/mileage/id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMileageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMileageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MileageDataEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MileageDataEntity>;
        }));
    }

    protected processGetMileageById(response: HttpResponseBase): Observable<MileageDataEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MileageDataEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantTimeShift(body?: TimeShiftRequest | undefined): Observable<ShiftDetailsEntity[]> {
        let url_ = this.baseUrl + "/api/callcenter/participanttimeshift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantTimeShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantTimeShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsEntity[]>;
        }));
    }

    protected processGetParticipantTimeShift(response: HttpResponseBase): Observable<ShiftDetailsEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftDetailsEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantTimeShiftStatus(body?: TimeShiftRequest | undefined): Observable<ShiftDataEntity[]> {
        let url_ = this.baseUrl + "/api/callcenter/participanttimeshiftStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantTimeShiftStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantTimeShiftStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDataEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDataEntity[]>;
        }));
    }

    protected processGetParticipantTimeShiftStatus(response: HttpResponseBase): Observable<ShiftDataEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftDataEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approveTimeShift(body?: ApproveMultipleShiftsRequest | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTimeShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTimeShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processApproveTimeShift(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getTimeShiftById(body?: TimeShiftByIdRequestDTO | undefined): Observable<ShiftDetailsEntity> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeShiftById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeShiftById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsEntity>;
        }));
    }

    protected processGetTimeShiftById(response: HttpResponseBase): Observable<ShiftDetailsEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDetailsEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    multiSubmitRuleTest(body?: RuleTestSubmissionDto[] | undefined): Observable<RuleTesterResponse> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/multisubmitruletest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultiSubmitRuleTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultiSubmitRuleTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuleTesterResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuleTesterResponse>;
        }));
    }

    protected processMultiSubmitRuleTest(response: HttpResponseBase): Observable<RuleTesterResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleTesterResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rejectTimeShift(body?: RejectShiftsRequestDTO | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTimeShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTimeShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processRejectTimeShift(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteTimeShift(body?: DeleteShiftsRequestDTO | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTimeShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTimeShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processDeleteTimeShift(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submitRuleTest(body?: RuleTestSubmissionDto | undefined): Observable<RuleTesterEnrichmentResponse> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/ruletest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitRuleTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitRuleTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuleTesterEnrichmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuleTesterEnrichmentResponse>;
        }));
    }

    protected processSubmitRuleTest(response: HttpResponseBase): Observable<RuleTesterEnrichmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleTesterEnrichmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submitShiftEntry(body?: ShiftSubmissionDTO | undefined): Observable<ShiftActionResponseDTO> {
        let url_ = this.baseUrl + "/api/callcenter/timeshift/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitShiftEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitShiftEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftActionResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftActionResponseDTO>;
        }));
    }

    protected processSubmitShiftEntry(response: HttpResponseBase): Observable<ShiftActionResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftActionResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaseLoadService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdateCaseLoad(body?: CaseLoadCreateUpdateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caseload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateCaseLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateCaseLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateCaseLoad(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAll(body?: CaseLoadSearchRequest | undefined): Observable<GridResponseBaseOfCaseLoadResponse> {
        let url_ = this.baseUrl + "/api/caseload/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCaseLoadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCaseLoadResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GridResponseBaseOfCaseLoadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCaseLoadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaseLoadById(id: number): Observable<CaseLoadDetailsResponse> {
        let url_ = this.baseUrl + "/api/caseload/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseLoadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseLoadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseLoadDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseLoadDetailsResponse>;
        }));
    }

    protected processGetCaseLoadById(response: HttpResponseBase): Observable<CaseLoadDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseLoadDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    delete(body?: CaseLoadDeleteRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caseload/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientInsInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: ClientInsInfoRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/clientinsinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: ClientInsInfoRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/clientinsinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/clientinsinfo?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantInsuranceInformationHistory(id: number, body?: GetHistoryRequestBase | undefined): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/clientinsinfo/{id}/participantInsuranceInformationHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantInsuranceInformationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantInsuranceInformationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetParticipantInsuranceInformationHistory(response: HttpResponseBase): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @param clientId (optional)
     * @return Success
     */
    get(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined, clientId?: number | undefined): Observable<GridResponseBaseOfClientInsInfoDTO> {
        let url_ = this.baseUrl + "/api/clientinsinfo/fetch?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfClientInsInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfClientInsInfoDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfClientInsInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfClientInsInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id?: number | undefined): Observable<ClientInsInfoDTO> {
        let url_ = this.baseUrl + "/api/clientinsinfo/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientInsInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientInsInfoDTO>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ClientInsInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInsInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    participantsByInsuredIds(body?: string[] | undefined): Observable<ParticipantDto[]> {
        let url_ = this.baseUrl + "/api/clientinsinfo/participantsbyinsuredids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsByInsuredIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsByInsuredIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDto[]>;
        }));
    }

    protected processParticipantsByInsuredIds(response: HttpResponseBase): Observable<ParticipantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantid (optional)
     * @return Success
     */
    getParticipantSyncDetailsByParticipantId(participantid?: number | undefined): Observable<ClientInsInfoDTO> {
        let url_ = this.baseUrl + "/api/clientinsinfo/participantsyncdetails/participantid?";
        if (participantid === null)
            throw new Error("The parameter 'participantid' cannot be null.");
        else if (participantid !== undefined)
            url_ += "participantid=" + encodeURIComponent("" + participantid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantSyncDetailsByParticipantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantSyncDetailsByParticipantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientInsInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientInsInfoDTO>;
        }));
    }

    protected processGetParticipantSyncDetailsByParticipantId(response: HttpResponseBase): Observable<ClientInsInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInsInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getConfig(): Observable<CompanyConfigModel> {
        let url_ = this.baseUrl + "/api/company/Config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyConfigModel>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<CompanyConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConfigs(): Observable<CompanyConfigModel[]> {
        let url_ = this.baseUrl + "/api/company/Configs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyConfigModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyConfigModel[]>;
        }));
    }

    protected processGetConfigs(response: HttpResponseBase): Observable<CompanyConfigModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyConfigModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustExService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param einId (optional)
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param payorId (optional)
     * @return Success
     */
    get(einId?: number | null | undefined, sortColumn?: string | null | undefined, sortDirection?: string | null | undefined, filterColumn?: string | null | undefined, filterValue?: string | null | undefined, pageSize?: number | null | undefined, pageNumber?: number | null | undefined, payorId?: number | null | undefined): Observable<GridResponseBaseOfCustomerExDto> {
        let url_ = this.baseUrl + "/api/custex?";
        if (einId !== undefined && einId !== null)
            url_ += "EinId=" + encodeURIComponent("" + einId) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn !== undefined && filterColumn !== null)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue !== undefined && filterValue !== null)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (payorId !== undefined && payorId !== null)
            url_ += "PayorId=" + encodeURIComponent("" + payorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCustomerExDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCustomerExDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfCustomerExDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCustomerExDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantId (optional)
     * @return Success
     */
    getParticipantDetailsById(participantId?: string | undefined): Observable<GridResponseBaseOfCustomerExResponseDto> {
        let url_ = this.baseUrl + "/api/custex/participant/id?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCustomerExResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCustomerExResponseDto>;
        }));
    }

    protected processGetParticipantDetailsById(response: HttpResponseBase): Observable<GridResponseBaseOfCustomerExResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCustomerExResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCustBySolomon(body?: CustBySolomonRequestDto | undefined): Observable<GridResponseBaseOfCustomerExDto> {
        let url_ = this.baseUrl + "/api/custex/participantsbyuniqueid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustBySolomon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustBySolomon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCustomerExDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCustomerExDto>;
        }));
    }

    protected processGetCustBySolomon(response: HttpResponseBase): Observable<GridResponseBaseOfCustomerExDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCustomerExDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantsForAgency(body?: AgencyParticipantsFilterRequest | undefined): Observable<GridResponseBaseOfParticipantsList> {
        let url_ = this.baseUrl + "/api/custex/participantsforagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsForAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsForAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfParticipantsList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfParticipantsList>;
        }));
    }

    protected processGetParticipantsForAgency(response: HttpResponseBase): Observable<GridResponseBaseOfParticipantsList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfParticipantsList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantsWithoutAgency(body?: AgencyParticipantsFilterRequest | undefined): Observable<GridResponseBaseOfParticipantsList> {
        let url_ = this.baseUrl + "/api/custex/participantswithoutagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsWithoutAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsWithoutAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfParticipantsList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfParticipantsList>;
        }));
    }

    protected processGetParticipantsWithoutAgency(response: HttpResponseBase): Observable<GridResponseBaseOfParticipantsList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfParticipantsList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CvetCommonService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getCodes(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/cvet/codes?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetCodes(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFeeDist(): Observable<FeeDistDto[]> {
        let url_ = this.baseUrl + "/api/cvet/feedist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeeDist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeeDist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeeDistDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeeDistDto[]>;
        }));
    }

    protected processGetFeeDist(response: HttpResponseBase): Observable<FeeDistDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeeDistDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFeeType(): Observable<FeeTypeDto[]> {
        let url_ = this.baseUrl + "/api/cvet/feetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeeTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeeTypeDto[]>;
        }));
    }

    protected processGetFeeType(response: HttpResponseBase): Observable<FeeTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeeTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getFundingSource(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/cvet/fundingsource?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundingSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundingSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetFundingSource(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getFundingType(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/cvet/fundingtype?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetFundingType(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param enumName (optional)
     * @return Success
     */
    getLookupValuesForEnum(enumName?: string | undefined): Observable<LookupInstance[]> {
        let url_ = this.baseUrl + "/api/cvet/lookupvaluesforenum?";
        if (enumName === null)
            throw new Error("The parameter 'enumName' cannot be null.");
        else if (enumName !== undefined)
            url_ += "enumName=" + encodeURIComponent("" + enumName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupValuesForEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupValuesForEnum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupInstance[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupInstance[]>;
        }));
    }

    protected processGetLookupValuesForEnum(response: HttpResponseBase): Observable<LookupInstance[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupInstance.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMuType(): Observable<MUTypeDto[]> {
        let url_ = this.baseUrl + "/api/cvet/mutype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMuType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMuType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MUTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MUTypeDto[]>;
        }));
    }

    protected processGetMuType(response: HttpResponseBase): Observable<MUTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MUTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getProgramType(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/cvet/programtype?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetProgramType(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param relationshipBetween (optional)
     * @return Success
     */
    getRelationshipTypes(relationshipBetween?: string | undefined): Observable<GridResponseBaseOfRelationshipTypeDto> {
        let url_ = this.baseUrl + "/api/cvet/relationshiptypes?";
        if (relationshipBetween === null)
            throw new Error("The parameter 'relationshipBetween' cannot be null.");
        else if (relationshipBetween !== undefined)
            url_ += "relationshipBetween=" + encodeURIComponent("" + relationshipBetween) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationshipTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationshipTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfRelationshipTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfRelationshipTypeDto>;
        }));
    }

    protected processGetRelationshipTypes(response: HttpResponseBase): Observable<GridResponseBaseOfRelationshipTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfRelationshipTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional)
     * @param body (optional)
     * @return Success
     */
    getAllState(countryId?: number | undefined, body?: FilterRequest | undefined): Observable<GridResponseBaseOfStateLookupDto> {
        let url_ = this.baseUrl + "/api/cvet/state?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfStateLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfStateLookupDto>;
        }));
    }

    protected processGetAllState(response: HttpResponseBase): Observable<GridResponseBaseOfStateLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfStateLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiagCodeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param searchParameter (optional)
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @param activeOnly (optional)
     * @param exactMatchOnly (optional)
     * @return Success
     */
    get(searchParameter?: string | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined, activeOnly?: boolean | null | undefined, exactMatchOnly?: boolean | null | undefined): Observable<GridResponseBaseOfDiagCodeDto> {
        let url_ = this.baseUrl + "/api/diagcode?";
        if (searchParameter === null)
            throw new Error("The parameter 'searchParameter' cannot be null.");
        else if (searchParameter !== undefined)
            url_ += "SearchParameter=" + encodeURIComponent("" + searchParameter) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        if (exactMatchOnly !== undefined && exactMatchOnly !== null)
            url_ += "exactMatchOnly=" + encodeURIComponent("" + exactMatchOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfDiagCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfDiagCodeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfDiagCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfDiagCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: DiagCodeRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/diagcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: DiagCodeRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/diagcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/diagcode?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeOnly (optional)
     * @param exactMatchOnly (optional)
     * @param body (optional)
     * @return Success
     */
    diagCodeExport(activeOnly?: boolean | null | undefined, exactMatchOnly?: boolean | null | undefined, body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/diagcode/export?";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        if (exactMatchOnly !== undefined && exactMatchOnly !== null)
            url_ += "exactMatchOnly=" + encodeURIComponent("" + exactMatchOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiagCodeExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiagCodeExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDiagCodeExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id?: number | undefined): Observable<DiagCodeDto> {
        let url_ = this.baseUrl + "/api/diagcode/fetch?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagCodeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DiagCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getEinLkp(body?: FilterRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/employee/einlkp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEinLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEinLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetEinLkp(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getEmployeeLkp(body?: EmployeeFilterRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/employee/employeelkp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetEmployeeLkp(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getEmployeeLkpByIds(body?: EmployeeLkpByIdsRequestDto | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/employee/employeelkp/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeLkpByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeLkpByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetEmployeeLkpByIds(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EvvExceptionReasonCodeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllEVVExceptionReasons(): Observable<any> {
        let url_ = this.baseUrl + "/api/evvexceptionreasoncode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEVVExceptionReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEVVExceptionReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetAllEVVExceptionReasons(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    postEvvExceptionResponseCode(body?: EvvExceptionReasonCodeProgramDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/evvexceptionreasoncode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEvvExceptionResponseCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEvvExceptionResponseCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPostEvvExceptionResponseCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    putEvvExceptionResponseCode(body?: EvvExceptionReasonCodeProgramDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/evvexceptionreasoncode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutEvvExceptionResponseCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutEvvExceptionResponseCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPutEvvExceptionResponseCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteEvvExceptionResponseCode(body?: EvvExceptionReasonIdsDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/evvexceptionreasoncode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvvExceptionResponseCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvvExceptionResponseCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteEvvExceptionResponseCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExternalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAgencyList(portalUserId: string): Observable<AgencyModel> {
        let url_ = this.baseUrl + "/api/ex/agencies/{portalUserId}";
        if (portalUserId === undefined || portalUserId === null)
            throw new Error("The parameter 'portalUserId' must be defined.");
        url_ = url_.replace("{portalUserId}", encodeURIComponent("" + portalUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyModel>;
        }));
    }

    protected processGetAgencyList(response: HttpResponseBase): Observable<AgencyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAgencyUserMapping(body?: AgencyUserMappingRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ex/agencyusermapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgencyUserMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgencyUserMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateAgencyUserMapping(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEinDetails(einId: number, participantId: number): Observable<EINDetails> {
        let url_ = this.baseUrl + "/api/ex/ein/{einId}/{participantId}";
        if (einId === undefined || einId === null)
            throw new Error("The parameter 'einId' must be defined.");
        url_ = url_.replace("{einId}", encodeURIComponent("" + einId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEinDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEinDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EINDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EINDetails>;
        }));
    }

    protected processGetEinDetails(response: HttpResponseBase): Observable<EINDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EINDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEinList(participantId: number): Observable<GridResponseBaseOfEinList> {
        let url_ = this.baseUrl + "/api/ex/einbyparticipant/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEinList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEinList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfEinList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfEinList>;
        }));
    }

    protected processGetEinList(response: HttpResponseBase): Observable<GridResponseBaseOfEinList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfEinList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeDetails(empId: number, participantId: string): Observable<EmployeeDetails> {
        let url_ = this.baseUrl + "/api/ex/employee/{empId}/participant/{participantId}";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDetails>;
        }));
    }

    protected processGetEmployeeDetails(response: HttpResponseBase): Observable<EmployeeDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeByParticipants(participantId: number): Observable<EmpModel[]> {
        let url_ = this.baseUrl + "/api/ex/employeebyparticipants/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeByParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeByParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmpModel[]>;
        }));
    }

    protected processGetEmployeeByParticipants(response: HttpResponseBase): Observable<EmpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmpModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordList(participantId: number): Observable<GridResponseBaseOfEinList> {
        let url_ = this.baseUrl + "/api/ex/employerOfRecordbyparticipant/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfEinList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfEinList>;
        }));
    }

    protected processGetEmployerOfRecordList(response: HttpResponseBase): Observable<GridResponseBaseOfEinList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfEinList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getBcnMetadata(body?: BatchReviewDetailsRequestForJSON | undefined): Observable<ClaimBatchOutboundMetadata> {
        let url_ = this.baseUrl + "/api/ex/fetchbcnmatadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBcnMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBcnMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimBatchOutboundMetadata>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimBatchOutboundMetadata>;
        }));
    }

    protected processGetBcnMetadata(response: HttpResponseBase): Observable<ClaimBatchOutboundMetadata> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimBatchOutboundMetadata.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getManualBcnMetadata(body?: ManualBatchReviewDetailsRequestForJson | undefined): Observable<ManualClaimBatchOutboundMetadata> {
        let url_ = this.baseUrl + "/api/ex/fetchmanualbcnmetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualBcnMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualBcnMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualClaimBatchOutboundMetadata>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualClaimBatchOutboundMetadata>;
        }));
    }

    protected processGetManualBcnMetadata(response: HttpResponseBase): Observable<ManualClaimBatchOutboundMetadata> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualClaimBatchOutboundMetadata.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFullParticipantDetails(participantId: number): Observable<ParticipantsDetails> {
        let url_ = this.baseUrl + "/api/ex/fullparticipantdetails/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullParticipantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullParticipantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantsDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantsDetails>;
        }));
    }

    protected processGetFullParticipantDetails(response: HttpResponseBase): Observable<ParticipantsDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantsDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllParticipants(body?: AgencyParticipantListRequest | undefined): Observable<Participants[]> {
        let url_ = this.baseUrl + "/api/ex/getallparticipants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Participants[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Participants[]>;
        }));
    }

    protected processGetAllParticipants(response: HttpResponseBase): Observable<Participants[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Participants.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNameBySLId(id: string): Observable<GetUserNamesBySLId[]> {
        let url_ = this.baseUrl + "/api/ex/getnamebyslid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameBySLId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameBySLId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserNamesBySLId[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserNamesBySLId[]>;
        }));
    }

    protected processGetNameBySLId(response: HttpResponseBase): Observable<GetUserNamesBySLId[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserNamesBySLId.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getSolomonId(body?: PortalUserRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/ex/getsolomonid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSolomonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSolomonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetSolomonId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getUnmappedAgencyParticipants(body?: AgencyParticipantListRequest | undefined): Observable<Participants[]> {
        let url_ = this.baseUrl + "/api/ex/getUnmappedAgencyParticipants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnmappedAgencyParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnmappedAgencyParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Participants[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Participants[]>;
        }));
    }

    protected processGetUnmappedAgencyParticipants(response: HttpResponseBase): Observable<Participants[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Participants.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getGlAccountForJsonCreation(body?: GlAccountRequestForJson | undefined): Observable<GLAccountInfoForJson> {
        let url_ = this.baseUrl + "/api/ex/glaccount/json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlAccountForJsonCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlAccountForJsonCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GLAccountInfoForJson>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GLAccountInfoForJson>;
        }));
    }

    protected processGetGlAccountForJsonCreation(response: HttpResponseBase): Observable<GLAccountInfoForJson> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLAccountInfoForJson.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getGlInformationValidation(body?: GLInfoValidation | undefined): Observable<ErrorInfo> {
        let url_ = this.baseUrl + "/api/ex/glInfo/validation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlInformationValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlInformationValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorInfo>;
        }));
    }

    protected processGetGlInformationValidation(response: HttpResponseBase): Observable<ErrorInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getMcoParticipants(body?: McoParticipantsFilterRequest | undefined): Observable<GridResponseBaseOfParticipants> {
        let url_ = this.baseUrl + "/api/ex/mcoparticipants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcoParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcoParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfParticipants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfParticipants>;
        }));
    }

    protected processGetMcoParticipants(response: HttpResponseBase): Observable<GridResponseBaseOfParticipants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfParticipants.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipants(body?: ParticipantsFilterRequest | undefined): Observable<GridResponseBaseOfParticipantsList> {
        let url_ = this.baseUrl + "/api/ex/participants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfParticipantsList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfParticipantsList>;
        }));
    }

    protected processGetParticipants(response: HttpResponseBase): Observable<GridResponseBaseOfParticipantsList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfParticipantsList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantDetails(participantId: number): Observable<ParticipantsDetails> {
        let url_ = this.baseUrl + "/api/ex/participants/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantsDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantsDetails>;
        }));
    }

    protected processGetParticipantDetails(response: HttpResponseBase): Observable<ParticipantsDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantsDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getParticipantsWithoutCaseload(caseLoadId: number, body?: ParticipantsFilterRequest | undefined): Observable<GridResponseBaseOfParticipants> {
        let url_ = this.baseUrl + "/api/ex/participantswithoutcaseload/{caseLoadId}";
        if (caseLoadId === undefined || caseLoadId === null)
            throw new Error("The parameter 'caseLoadId' must be defined.");
        url_ = url_.replace("{caseLoadId}", encodeURIComponent("" + caseLoadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsWithoutCaseload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsWithoutCaseload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfParticipants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfParticipants>;
        }));
    }

    protected processGetParticipantsWithoutCaseload(response: HttpResponseBase): Observable<GridResponseBaseOfParticipants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfParticipants.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPortalUser(body?: PortalUserRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ex/portaluser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreatePortalUser(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getSFList(body?: SFListRequestDto | undefined): Observable<SFResponseModel[]> {
        let url_ = this.baseUrl + "/api/ex/sf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSFList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSFList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SFResponseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SFResponseModel[]>;
        }));
    }

    protected processGetSFList(response: HttpResponseBase): Observable<SFResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SFResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    removeSfsFromAgency(body?: ServiceFacilitatorRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ex/sf/removeSfsFromAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSfsFromAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSfsFromAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processRemoveSfsFromAgency(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSFWithOutCaseLoad(agencyId: number, caseLoadId: number): Observable<SFUserModel[]> {
        let url_ = this.baseUrl + "/api/ex/sfwithoutcaseload/{agencyId}/{caseLoadId}";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (caseLoadId === undefined || caseLoadId === null)
            throw new Error("The parameter 'caseLoadId' must be defined.");
        url_ = url_.replace("{caseLoadId}", encodeURIComponent("" + caseLoadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSFWithOutCaseLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSFWithOutCaseLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SFUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SFUserModel[]>;
        }));
    }

    protected processGetSFWithOutCaseLoad(response: HttpResponseBase): Observable<SFUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SFUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePortalUser(body?: PortalUserRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ex/updateportaluser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdatePortalUser(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExCaseMgrService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: ExCaseMgrCreateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/excasemgr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: ExCaseMgrUpdateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/excasemgr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ecmIds (optional)
     * @return Success
     */
    delete(ecmIds?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/excasemgr?";
        if (ecmIds === null)
            throw new Error("The parameter 'ecmIds' cannot be null.");
        else if (ecmIds !== undefined)
            url_ += "ecmIds=" + encodeURIComponent("" + ecmIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: ExCaseMgrSearchRequest | undefined): Observable<GridResponseBaseOfExCaseMgrDetailsDto> {
        let url_ = this.baseUrl + "/api/excasemgr/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfExCaseMgrDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfExCaseMgrDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfExCaseMgrDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfExCaseMgrDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(ecmId: string): Observable<ExCaseMgrDetailsDto> {
        let url_ = this.baseUrl + "/api/excasemgr/id/{ecmId}";
        if (ecmId === undefined || ecmId === null)
            throw new Error("The parameter 'ecmId' must be defined.");
        url_ = url_.replace("{ecmId}", encodeURIComponent("" + ecmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExCaseMgrDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExCaseMgrDetailsDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ExCaseMgrDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExCaseMgrDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Accepted
     */
    exportDetails(body?: ExportRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/export/exportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportDetails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ResponseModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ResponseModel.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeeRateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: FeeRateRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/feerate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: FeeRateRequest | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/feerate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feerate?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional) 
     * @param programName (optional) 
     * @param body (optional) 
     * @return Success
     */
    feeRatesExport(programId?: number | undefined, programName?: string | undefined, body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feerate/export?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (programName === null)
            throw new Error("The parameter 'programName' cannot be null.");
        else if (programName !== undefined)
            url_ += "programName=" + encodeURIComponent("" + programName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeeRatesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeeRatesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processFeeRatesExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @param body (optional)
     * @return Success
     */
    get(programId?: number | undefined, body?: FilterRequest | undefined): Observable<GridResponseBaseOfFeeRateDTO> {
        let url_ = this.baseUrl + "/api/feerate/fetch?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfFeeRateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfFeeRateDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfFeeRateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfFeeRateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDetailsById(id?: number | undefined): Observable<FeeRateDTO> {
        let url_ = this.baseUrl + "/api/feerate/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeeRateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeeRateDTO>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<FeeRateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeeRateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeeTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFeeType(body?: FeeTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFeeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFeeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateFeeType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param feeTypeId (optional)
     * @return Success
     */
    deleteFeeType(feeTypeId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feetype?";
        if (feeTypeId === null)
            throw new Error("The parameter 'feeTypeId' cannot be null.");
        else if (feeTypeId !== undefined)
            url_ += "feeTypeId=" + encodeURIComponent("" + feeTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFeeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFeeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteFeeType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    feeTypesExport(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feetype/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeeTypesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeeTypesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processFeeTypesExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfFeeTypeResponseDto> {
        let url_ = this.baseUrl + "/api/feetype/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfFeeTypeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfFeeTypeResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfFeeTypeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfFeeTypeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFeeTypeById(id: number): Observable<FeeTypeIdResponseDto> {
        let url_ = this.baseUrl + "/api/feetype/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeeTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeeTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeeTypeIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeeTypeIdResponseDto>;
        }));
    }

    protected processGetFeeTypeById(response: HttpResponseBase): Observable<FeeTypeIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeeTypeIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFeeType(body?: FeeTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/feetype/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFeeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFeeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateFeeType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FundingSourceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdate(body?: FundingSourceRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingsource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingsource?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    fundingSourceExport(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingsource/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFundingSourceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFundingSourceExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processFundingSourceExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfFundingSourceResponse> {
        let url_ = this.baseUrl + "/api/fundingsource/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfFundingSourceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfFundingSourceResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfFundingSourceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfFundingSourceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id?: number | undefined): Observable<FundingSourceByIdResponse> {
        let url_ = this.baseUrl + "/api/fundingsource/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundingSourceByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundingSourceByIdResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FundingSourceByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FundingSourceByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FundingTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFundingType(body?: FundingTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFundingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFundingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateFundingType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fundingTypeId (optional)
     * @param checkMappings (optional)
     * @return Success
     */
    deleteFundingType(fundingTypeId?: string | undefined, checkMappings?: boolean | null | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingtype?";
        if (fundingTypeId === null)
            throw new Error("The parameter 'fundingTypeId' cannot be null.");
        else if (fundingTypeId !== undefined)
            url_ += "fundingTypeId=" + encodeURIComponent("" + fundingTypeId) + "&";
        if (checkMappings !== undefined && checkMappings !== null)
            url_ += "checkMappings=" + encodeURIComponent("" + checkMappings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFundingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFundingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteFundingType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFundingType(body?: FundingTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingtype/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFundingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFundingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateFundingType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    fundingTypesExport(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/fundingtype/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFundingTypesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFundingTypesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processFundingTypesExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeOnly (optional)
     * @param body (optional)
     * @return Success
     */
    get(activeOnly?: boolean | null | undefined, body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfFundingTypeResponseDto> {
        let url_ = this.baseUrl + "/api/fundingtype/fetch?";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfFundingTypeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfFundingTypeResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfFundingTypeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfFundingTypeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFundingTypeById(id: number): Observable<FundingTypeByIdResponseDto> {
        let url_ = this.baseUrl + "/api/fundingtype/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFundingTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFundingTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FundingTypeByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FundingTypeByIdResponseDto>;
        }));
    }

    protected processGetFundingTypeById(response: HttpResponseBase): Observable<FundingTypeByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FundingTypeByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GLAccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdate(body?: GLAccountRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/glaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/glaccount?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approveAccount(body?: GLAccountRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/glaccount/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApproveAccount(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfGLAccountResponseDto> {
        let url_ = this.baseUrl + "/api/glaccount/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfGLAccountResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfGLAccountResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfGLAccountResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfGLAccountResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getGLAccount(body?: FilterRequest | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/glaccount/glaccountlkp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGLAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGLAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetGLAccount(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGLAccountId(id: number): Observable<GLAccountResponseById> {
        let url_ = this.baseUrl + "/api/glaccount/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGLAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGLAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GLAccountResponseById>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GLAccountResponseById>;
        }));
    }

    protected processGetGLAccountId(response: HttpResponseBase): Observable<GLAccountResponseById> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLAccountResponseById.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GLAccountAssignmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdate(body?: GLAccountAssignmentRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/glaccountassignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approve(body?: GLAccountAssignmentRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/glaccountassignment/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmailId(): Observable<string> {
        let url_ = this.baseUrl + "/api/glaccountassignment/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmailId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGLAccountId(): Observable<GLAccountAssignmentResponseById> {
        let url_ = this.baseUrl + "/api/glaccountassignment/id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGLAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGLAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GLAccountAssignmentResponseById>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GLAccountAssignmentResponseById>;
        }));
    }

    protected processGetGLAccountId(response: HttpResponseBase): Observable<GLAccountAssignmentResponseById> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLAccountAssignmentResponseById.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayrollProgram(): Observable<PayrollProgramDto[]> {
        let url_ = this.baseUrl + "/api/glaccountassignment/programpayroll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollProgramDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollProgramDto[]>;
        }));
    }

    protected processGetPayrollProgram(response: HttpResponseBase): Observable<PayrollProgramDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollProgramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MasterConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getDocumentTypes(): Observable<DocumentType[]> {
        let url_ = this.baseUrl + "/api/MasterConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentType[]>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<DocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClaimTypes(): Observable<ClaimType[]> {
        let url_ = this.baseUrl + "/api/MasterConfig/ClaimType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimType[]>;
        }));
    }

    protected processGetClaimTypes(response: HttpResponseBase): Observable<ClaimType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayCalculationMethods(): Observable<PayCalculationMethod[]> {
        let url_ = this.baseUrl + "/api/MasterConfig/PayCalculationMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayCalculationMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayCalculationMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayCalculationMethod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayCalculationMethod[]>;
        }));
    }

    protected processGetPayCalculationMethods(response: HttpResponseBase): Observable<PayCalculationMethod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayCalculationMethod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObserverMetaDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getObserverMetaDataForGha(body?: ObserverMetaDataRequest | undefined): Observable<ObserverMetaDataResponse[]> {
        let url_ = this.baseUrl + "/api/observermetadata/gha/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObserverMetaDataForGha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObserverMetaDataForGha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObserverMetaDataResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObserverMetaDataResponse[]>;
        }));
    }

    protected processGetObserverMetaDataForGha(response: HttpResponseBase): Observable<ObserverMetaDataResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObserverMetaDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPayWeekStartDay(body?: PayWeekStartDayRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/observermetadata/payweekstartdayfetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayWeekStartDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayWeekStartDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPayWeekStartDay(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PayorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: PayorRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: PayorRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payor?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payorId (optional)
     * @return Success
     */
    getPayorConfig(payorId?: string | undefined): Observable<PayorConfigDTO> {
        let url_ = this.baseUrl + "/api/payor/config?";
        if (payorId === null)
            throw new Error("The parameter 'payorId' cannot be null.");
        else if (payorId !== undefined)
            url_ += "payorId=" + encodeURIComponent("" + payorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayorConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayorConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayorConfigDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayorConfigDTO>;
        }));
    }

    protected processGetPayorConfig(response: HttpResponseBase): Observable<PayorConfigDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayorConfigDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeOnly (optional)
     * @param body (optional)
     * @return Success
     */
    exportPayorList(activeOnly?: boolean | null | undefined, body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payor/export?";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPayorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPayorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportPayorList(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeOnly (optional)
     * @param body (optional)
     * @return Success
     */
    get(activeOnly?: boolean | null | undefined, body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfPayorDTO> {
        let url_ = this.baseUrl + "/api/payor/fetch?";
        if (activeOnly !== undefined && activeOnly !== null)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfPayorDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfPayorDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfPayorDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfPayorDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDetailsById(id?: number | undefined): Observable<PayorDTO> {
        let url_ = this.baseUrl + "/api/payor/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayorDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayorDTO>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<PayorDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayorDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @return Success
     */
    getPayorByProgramId(programId?: number | undefined): Observable<BasePayorDTO> {
        let url_ = this.baseUrl + "/api/payor/programid?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayorByProgramId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayorByProgramId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasePayorDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasePayorDTO>;
        }));
    }

    protected processGetPayorByProgramId(response: HttpResponseBase): Observable<BasePayorDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasePayorDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyCode (optional)
     * @param payorId (optional)
     * @return Success
     */
    checkCompanyCodePayorIdExist(companyCode?: string | undefined, payorId?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/payor/validatecompanycodepayorid?";
        if (companyCode === null)
            throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined)
            url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (payorId === null)
            throw new Error("The parameter 'payorId' cannot be null.");
        else if (payorId !== undefined)
            url_ += "payorId=" + encodeURIComponent("" + payorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCompanyCodePayorIdExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCompanyCodePayorIdExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCompanyCodePayorIdExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getWeekStartingDateByPayorIds(body?: number[] | undefined): Observable<PayorDTO[]> {
        let url_ = this.baseUrl + "/api/payor/weekstartingday/payorids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekStartingDateByPayorIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekStartingDateByPayorIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayorDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayorDTO[]>;
        }));
    }

    protected processGetWeekStartingDateByPayorIds(response: HttpResponseBase): Observable<PayorDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PayRateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPayRate(body?: PayRatesDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/payrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePayRate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payRateId (optional)
     * @return Success
     */
    deletePayRate(payRateId?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/payrate?";
        if (payRateId === null)
            throw new Error("The parameter 'payRateId' cannot be null.");
        else if (payRateId !== undefined)
            url_ += "payRateId=" + encodeURIComponent("" + payRateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeletePayRate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    getAllPayRateByPerson(caregiverId: string, participantId: string): Observable<PayRateResponseDto[]> {
        let url_ = this.baseUrl + "/api/payrate/caregiver/{caregiverId}/participant/{participantId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayRateByPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayRateByPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateResponseDto[]>;
        }));
    }

    protected processGetAllPayRateByPerson(response: HttpResponseBase): Observable<PayRateResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayRateResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPayRateInfo(custId: number, empId: number): Observable<PayRateResponseDto[]> {
        let url_ = this.baseUrl + "/api/payrate/custId/{custId}/empId/{empId}";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayRateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayRateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateResponseDto[]>;
        }));
    }

    protected processGetAllPayRateInfo(response: HttpResponseBase): Observable<PayRateResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayRateResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayRateByEmployee(empId: number, participantId: number): Observable<PayRateModel[]> {
        let url_ = this.baseUrl + "/api/payrate/employee/{empId}/participant/{participantId}";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRateByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRateByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateModel[]>;
        }));
    }

    protected processGetPayRateByEmployee(response: HttpResponseBase): Observable<PayRateModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayRateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param custId (optional)
     * @param cgvEmpMapId (optional)
     * @param body (optional)
     * @return Success
     */
    getAllPayRate(custId?: number | undefined, cgvEmpMapId?: number | undefined, body?: FilterRequest | undefined): Observable<GridResponseBaseOfPayRateResponseDto> {
        let url_ = this.baseUrl + "/api/payrate/fetch?";
        if (custId === null)
            throw new Error("The parameter 'custId' cannot be null.");
        else if (custId !== undefined)
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (cgvEmpMapId === null)
            throw new Error("The parameter 'cgvEmpMapId' cannot be null.");
        else if (cgvEmpMapId !== undefined)
            url_ += "cgvEmpMapId=" + encodeURIComponent("" + cgvEmpMapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfPayRateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfPayRateResponseDto>;
        }));
    }

    protected processGetAllPayRate(response: HttpResponseBase): Observable<GridResponseBaseOfPayRateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfPayRateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPayRateById(id: number): Observable<PayRateByIdResponseDto> {
        let url_ = this.baseUrl + "/api/payrate/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayRateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayRateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateByIdResponseDto>;
        }));
    }

    protected processGetAllPayRateById(response: HttpResponseBase): Observable<PayRateByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayRateByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayRateByParticipant(empId: number, participantId: number): Observable<PayRateModel[]> {
        let url_ = this.baseUrl + "/api/payrate/payratebyparticipant/employee/{empId}/participant/{participantId}";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRateByParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRateByParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateModel[]>;
        }));
    }

    protected processGetPayRateByParticipant(response: HttpResponseBase): Observable<PayRateModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayRateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PortalUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    savePayorPortalUser(body?: PayorPortalUserMappingDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/portaluser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePayorPortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePayorPortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSavePayorPortalUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    deletePayorPortalUsers(ids?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/portaluser?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayorPortalUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayorPortalUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeletePayorPortalUsers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAgencyUsers(body?: AgencyUsersFilterRequest | undefined): Observable<GridResponseBaseOfAgencyUserDto> {
        let url_ = this.baseUrl + "/api/portaluser/agencyusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfAgencyUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfAgencyUserDto>;
        }));
    }

    protected processGetAgencyUsers(response: HttpResponseBase): Observable<GridResponseBaseOfAgencyUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfAgencyUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPayorPortalUsers(body?: PayorPortalUserMappingFilterRequest | undefined): Observable<GridResponseBaseOfPayorPortalUserMappingDto> {
        let url_ = this.baseUrl + "/api/portaluser/payor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayorPortalUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayorPortalUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfPayorPortalUserMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfPayorPortalUserMappingDto>;
        }));
    }

    protected processGetPayorPortalUsers(response: HttpResponseBase): Observable<GridResponseBaseOfPayorPortalUserMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfPayorPortalUserMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayorPortalUserById(id: string): Observable<PayorPortalUserMappingDto> {
        let url_ = this.baseUrl + "/api/portaluser/payor/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayorPortalUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayorPortalUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayorPortalUserMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayorPortalUserMappingDto>;
        }));
    }

    protected processGetPayorPortalUserById(response: HttpResponseBase): Observable<PayorPortalUserMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayorPortalUserMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPortalUsersWithoutAgency(body?: GetPortalUsersWithoutAgencyRequest | undefined): Observable<GridResponseBaseOfAgencyUserDto> {
        let url_ = this.baseUrl + "/api/portaluser/withoutagency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUsersWithoutAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUsersWithoutAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfAgencyUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfAgencyUserDto>;
        }));
    }

    protected processGetPortalUsersWithoutAgency(response: HttpResponseBase): Observable<GridResponseBaseOfAgencyUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfAgencyUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPortalUsersWithoutPayor(body?: PayorPortalUserMappingFilterRequest | undefined): Observable<GridResponseBaseOfPortalUserDto> {
        let url_ = this.baseUrl + "/api/portaluser/withoutpayor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUsersWithoutPayor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUsersWithoutPayor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfPortalUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfPortalUserDto>;
        }));
    }

    protected processGetPortalUsersWithoutPayor(response: HttpResponseBase): Observable<GridResponseBaseOfPortalUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfPortalUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProgramService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: ProgramCreateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/program";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: ProgramCreateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/program";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    delete(ids?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/program?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param copyPrvd (optional)
     * @return Success
     */
    getbyId(id: number, copyPrvd?: boolean | undefined): Observable<ProgramDto> {
        let url_ = this.baseUrl + "/api/program/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (copyPrvd === null)
            throw new Error("The parameter 'copyPrvd' cannot be null.");
        else if (copyPrvd !== undefined)
            url_ += "copyPrvd=" + encodeURIComponent("" + copyPrvd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramDto>;
        }));
    }

    protected processGetbyId(response: HttpResponseBase): Observable<ProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllProgramForExport(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/program/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgramForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgramForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetAllProgramForExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: ProgramFilterRequest | undefined): Observable<GridResponseBaseOfProgramDto> {
        let url_ = this.baseUrl + "/api/program/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfProgramDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfProgramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payorId (optional)
     * @return Success
     */
    getAllProgramByPayorId(payorId?: number | undefined): Observable<ProgramByPayorIdDto[]> {
        let url_ = this.baseUrl + "/api/program/payorid?";
        if (payorId === null)
            throw new Error("The parameter 'payorId' cannot be null.");
        else if (payorId !== undefined)
            url_ += "payorId=" + encodeURIComponent("" + payorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgramByPayorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgramByPayorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramByPayorIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramByPayorIdDto[]>;
        }));
    }

    protected processGetAllProgramByPayorId(response: HttpResponseBase): Observable<ProgramByPayorIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramByPayorIdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProgramTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteProgramType(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProgramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProgramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteProgramType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllProgramType(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfProgramServiceTypes> {
        let url_ = this.baseUrl + "/api/programtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfProgramServiceTypes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfProgramServiceTypes>;
        }));
    }

    protected processGetAllProgramType(response: HttpResponseBase): Observable<GridResponseBaseOfProgramServiceTypes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfProgramServiceTypes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addUpdateProgramType(body?: ProgramServiceTypes[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateProgramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateProgramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAddUpdateProgramType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approveProgramType(body?: ProgramTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveProgramType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveProgramType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApproveProgramType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteProgramServiceType(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype/delete/programservicetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProgramServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProgramServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteProgramServiceType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param filterCol (optional)
     * @param filterVal (optional)
     * @param sortCol (optional)
     * @param sortDir (optional)
     * @param pageNum (optional)
     * @param pageSize (optional)
     * @return Success
     */
    exportProgramTypes(id?: number | undefined, body?: ProgramServiceTypeExport | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype/{id}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' cannot be null.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProgramTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProgramTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportProgramTypes(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getProgramTypeById(id: number, body?: FilterRequest | undefined): Observable<GridResponseBaseOfProgramServiceTypes> {
        let url_ = this.baseUrl + "/api/programtype/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfProgramServiceTypes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfProgramServiceTypes>;
        }));
    }

    protected processGetProgramTypeById(response: HttpResponseBase): Observable<GridResponseBaseOfProgramServiceTypes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfProgramServiceTypes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProgramTypeNameAndDescription(id: number): Observable<ProgramServiceTypes[]> {
        let url_ = this.baseUrl + "/api/programtype/progName/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramTypeNameAndDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramTypeNameAndDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramServiceTypes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramServiceTypes[]>;
        }));
    }

    protected processGetProgramTypeNameAndDescription(response: HttpResponseBase): Observable<ProgramServiceTypes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramServiceTypes.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    programTypesExport(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/programtype/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgramTypesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramTypesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processProgramTypesExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllRoles(): Observable<RoleCompanyModel[]> {
        let url_ = this.baseUrl + "/api/role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleCompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleCompanyModel[]>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<RoleCompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleCompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleIds (optional)
     * @return Success
     */
    deleteRole(roleIds?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role?";
        if (roleIds === null)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            url_ += "roleIds=" + encodeURIComponent("" + roleIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addRole(body?: RoleModel | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/addrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAddRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addUserRole(body?: UserRoleModel | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/addusertorole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAddUserRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAssignedRolesByUserId(body?: UserRoleMappingRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/assignedroles/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignedRolesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignedRolesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateAssignedRolesByUserId(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAvilableAssignedRolesByUserId(userId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/role/avilableassignedroles/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvilableAssignedRolesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvilableAssignedRolesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetAvilableAssignedRolesByUserId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleIds (optional)
     * @return Success
     */
    checkUsersByRoleIds(roleIds?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/role/checkusers/roleids?";
        if (roleIds === null)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            url_ += "roleIds=" + encodeURIComponent("" + roleIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUsersByRoleIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUsersByRoleIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCheckUsersByRoleIds(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/role/company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    copyRole(body?: RoleModel | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/copyrole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCopyRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createRole(): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/role/createrole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processCreateRole(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNonUsersByRoleId(roleId: number): Observable<NonUserModel[]> {
        let url_ = this.baseUrl + "/api/role/getnonusers/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonUsersByRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonUsersByRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonUserModel[]>;
        }));
    }

    protected processGetNonUsersByRoleId(response: HttpResponseBase): Observable<NonUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRole(roleId: string): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/role/getrole/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUsersByRoleId(roleId: number): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/role/getusers/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersByRoleId(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRolesLookup(): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/role/lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel[]>;
        }));
    }

    protected processGetRolesLookup(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional)
     * @return Success
     */
    getRoleNameToCopy(roleId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/role/rolenametocopy/fetch?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleNameToCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleNameToCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRoleNameToCopy(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateRole(body?: RoleModel | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/updaterole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userRoleIds (optional)
     * @return Success
     */
    deleteUserRole(userRoleIds?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/role/user?";
        if (userRoleIds === null)
            throw new Error("The parameter 'userRoleIds' cannot be null.");
        else if (userRoleIds !== undefined)
            url_ += "userRoleIds=" + encodeURIComponent("" + userRoleIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteUserRole(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RulesConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param date (optional)
     * @param ruleSet (optional)
     * @return Success
     */
    getAllRuleDetails(date?: string | undefined, ruleSet?: string | undefined): Observable<RuleDetails[]> {
        let url_ = this.baseUrl + "/api/rulesconfig?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (ruleSet === null)
            throw new Error("The parameter 'ruleSet' cannot be null.");
        else if (ruleSet !== undefined)
            url_ += "ruleSet=" + encodeURIComponent("" + ruleSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRuleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRuleDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuleDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuleDetails[]>;
        }));
    }

    protected processGetAllRuleDetails(response: HttpResponseBase): Observable<RuleDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getRuleConfig(body?: RulesConfigRequest | undefined): Observable<RulesConfigDTO[]> {
        let url_ = this.baseUrl + "/api/rulesconfig/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRuleConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRuleConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RulesConfigDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RulesConfigDTO[]>;
        }));
    }

    protected processGetRuleConfig(response: HttpResponseBase): Observable<RulesConfigDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RulesConfigDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getRulesData(body?: GetBillingDataForRulesRequest | undefined): Observable<GetBillingDataForRulesResponse[]> {
        let url_ = this.baseUrl + "/api/rulesconfig/rulesdata/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRulesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRulesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBillingDataForRulesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBillingDataForRulesResponse[]>;
        }));
    }

    protected processGetRulesData(response: HttpResponseBase): Observable<GetBillingDataForRulesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBillingDataForRulesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServeCodeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @param programId (optional)
     * @param billCodeId (optional)
     * @param payRateMethod (optional)
     * @param showOnlyBillableCodes (optional)
     * @return Success
     */
    get(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined, programId?: number | null | undefined, billCodeId?: number | null | undefined, payRateMethod?: string | null | undefined, showOnlyBillableCodes?: boolean | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/servecode?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (programId !== undefined && programId !== null)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (billCodeId !== undefined && billCodeId !== null)
            url_ += "BillCodeId=" + encodeURIComponent("" + billCodeId) + "&";
        if (payRateMethod !== undefined && payRateMethod !== null)
            url_ += "PayRateMethod=" + encodeURIComponent("" + payRateMethod) + "&";
        if (showOnlyBillableCodes !== undefined && showOnlyBillableCodes !== null)
            url_ += "ShowOnlyBillableCodes=" + encodeURIComponent("" + showOnlyBillableCodes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param servCodeId (optional)
     * @return Success
     */
    deleteServCode(servCodeId?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/servecode?";
        if (servCodeId === null)
            throw new Error("The parameter 'servCodeId' cannot be null.");
        else if (servCodeId !== undefined)
            url_ += "servCodeId=" + encodeURIComponent("" + servCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteServCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServeCodeHistory(serveCodeId: number, body?: GetHistoryRequestBase | undefined): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/servecode/{serveCodeId}/history";
        if (serveCodeId === undefined || serveCodeId === null)
            throw new Error("The parameter 'serveCodeId' must be defined.");
        url_ = url_.replace("{serveCodeId}", encodeURIComponent("" + serveCodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServeCodeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServeCodeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetServeCodeHistory(response: HttpResponseBase): Observable<SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantId (optional)
     * @return Success
     */
    getParticipantAddress(participantId?: string | undefined): Observable<AddressDTO> {
        let url_ = this.baseUrl + "/api/servecode/address?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDTO>;
        }));
    }

    protected processGetParticipantAddress(response: HttpResponseBase): Observable<AddressDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServCodeAuthDetailsCache(body?: ServCodeAuthDetailsRequest | undefined): Observable<ServCodeAuthDetailsCacheEntity[]> {
        let url_ = this.baseUrl + "/api/servecode/authdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServCodeAuthDetailsCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServCodeAuthDetailsCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServCodeAuthDetailsCacheEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServCodeAuthDetailsCacheEntity[]>;
        }));
    }

    protected processGetServCodeAuthDetailsCache(response: HttpResponseBase): Observable<ServCodeAuthDetailsCacheEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServCodeAuthDetailsCacheEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodesForCallCenter(body?: ServiceCodeRequest | undefined): Observable<ShiftServeCodeResult> {
        let url_ = this.baseUrl + "/api/servecode/callcenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodesForCallCenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodesForCallCenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftServeCodeResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftServeCodeResult>;
        }));
    }

    protected processGetServiceCodesForCallCenter(response: HttpResponseBase): Observable<ShiftServeCodeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftServeCodeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodesByServiceType(body?: ServiceCodeWithDocTypeRequest | undefined): Observable<ShiftServeCodeResult> {
        let url_ = this.baseUrl + "/api/servecode/callcenter/serviceCodeByServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodesByServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodesByServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftServeCodeResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftServeCodeResult>;
        }));
    }

    protected processGetServiceCodesByServiceType(response: HttpResponseBase): Observable<ShiftServeCodeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftServeCodeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllServiceCode(body?: ServeCodeFilterRequest | undefined): Observable<GridResponseBaseOfServiceCodeResponseDto> {
        let url_ = this.baseUrl + "/api/servecode/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfServiceCodeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfServiceCodeResponseDto>;
        }));
    }

    protected processGetAllServiceCode(response: HttpResponseBase): Observable<GridResponseBaseOfServiceCodeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfServiceCodeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param servCode (optional)
     * @return Success
     */
    getDescriptionByServCode(servCode?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/servecode/description/servcode?";
        if (servCode === null)
            throw new Error("The parameter 'servCode' cannot be null.");
        else if (servCode !== undefined)
            url_ += "servCode=" + encodeURIComponent("" + servCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescriptionByServCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescriptionByServCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDescriptionByServCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServeCodeDetails(body?: ServiceLogRequest | undefined): Observable<ServiceLogDetailResponse> {
        let url_ = this.baseUrl + "/api/servecode/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServeCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServeCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDetailResponse>;
        }));
    }

    protected processGetServeCodeDetails(response: HttpResponseBase): Observable<ServiceLogDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportServeCodes(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/servecode/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportServeCodes(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodes(body?: ServiceCodeRequest | undefined): Observable<ServiceCodeRequest> {
        let url_ = this.baseUrl + "/api/servecode/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeRequest>;
        }));
    }

    protected processGetServiceCodes(response: HttpResponseBase): Observable<ServiceCodeRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodeAndDocTypes(body?: string[] | undefined): Observable<ServCodeDocTypeModel[]> {
        let url_ = this.baseUrl + "/api/servecode/getServiceCodeAndDocTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodeAndDocTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodeAndDocTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServCodeDocTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServCodeDocTypeModel[]>;
        }));
    }

    protected processGetServiceCodeAndDocTypes(response: HttpResponseBase): Observable<ServCodeDocTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServCodeDocTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getAllHCPCSCodes(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfHCPCSCodeResponseDto> {
        let url_ = this.baseUrl + "/api/servecode/hcpcscodes?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHCPCSCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHCPCSCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfHCPCSCodeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfHCPCSCodeResponseDto>;
        }));
    }

    protected processGetAllHCPCSCodes(response: HttpResponseBase): Observable<GridResponseBaseOfHCPCSCodeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfHCPCSCodeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serveId (optional)
     * @param authId (optional)
     * @param participantId (optional)
     * @return Success
     */
    getServCodeHistory(serveId?: number | undefined, authId?: number | undefined, participantId?: string | null | undefined): Observable<ServCodeHistory> {
        let url_ = this.baseUrl + "/api/servecode/history?";
        if (serveId === null)
            throw new Error("The parameter 'serveId' cannot be null.");
        else if (serveId !== undefined)
            url_ += "serveId=" + encodeURIComponent("" + serveId) + "&";
        if (authId === null)
            throw new Error("The parameter 'authId' cannot be null.");
        else if (authId !== undefined)
            url_ += "authId=" + encodeURIComponent("" + authId) + "&";
        if (participantId !== undefined && participantId !== null)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServCodeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServCodeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServCodeHistory>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServCodeHistory>;
        }));
    }

    protected processGetServCodeHistory(response: HttpResponseBase): Observable<ServCodeHistory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServCodeHistory.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceCodeByCode(servCode: string): Observable<ServiceCodeResponseDto> {
        let url_ = this.baseUrl + "/api/servecode/id/{servCode}/details";
        if (servCode === undefined || servCode === null)
            throw new Error("The parameter 'servCode' must be defined.");
        url_ = url_.replace("{servCode}", encodeURIComponent("" + servCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodeByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodeByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeResponseDto>;
        }));
    }

    protected processGetServiceCodeByCode(response: HttpResponseBase): Observable<ServiceCodeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceCodeById(servCodeId: number): Observable<ServiceCodeResponseDto> {
        let url_ = this.baseUrl + "/api/servecode/id/{servCodeId}";
        if (servCodeId === undefined || servCodeId === null)
            throw new Error("The parameter 'servCodeId' must be defined.");
        url_ = url_.replace("{servCodeId}", encodeURIComponent("" + servCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeResponseDto>;
        }));
    }

    protected processGetServiceCodeById(response: HttpResponseBase): Observable<ServiceCodeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllServiceCodeByGeneratesAdminTime(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/servecode/nonAdminTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceCodeByGeneratesAdminTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceCodeByGeneratesAdminTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllServiceCodeByGeneratesAdminTime(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodesForParticipant(body?: ServiceCodeRequest | undefined): Observable<ServiceCodeRequest> {
        let url_ = this.baseUrl + "/api/servecode/participant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodesForParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodesForParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeRequest>;
        }));
    }

    protected processGetServiceCodesForParticipant(response: HttpResponseBase): Observable<ServiceCodeRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPayCycleDate(body?: PayCycleDateRequest | undefined): Observable<PayCycleDate[]> {
        let url_ = this.baseUrl + "/api/servecode/paycycledate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayCycleDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayCycleDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayCycleDate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayCycleDate[]>;
        }));
    }

    protected processGetPayCycleDate(response: HttpResponseBase): Observable<PayCycleDate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayCycleDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceCodeDetails(body?: ServiceCodes | undefined): Observable<ServiceCodeDetailsDto[]> {
        let url_ = this.baseUrl + "/api/servecode/servecodedetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeDetailsDto[]>;
        }));
    }

    protected processGetServiceCodeDetails(response: HttpResponseBase): Observable<ServiceCodeDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCodeDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllServiceCodeByCompany(): Observable<ServiceCodeResponse[]> {
        let url_ = this.baseUrl + "/api/servecode/svcCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceCodeByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceCodeByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeResponse[]>;
        }));
    }

    protected processGetAllServiceCodeByCompany(response: HttpResponseBase): Observable<ServiceCodeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCodeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param programId (optional)
     * @param body (optional)
     * @return Success
     */
    getAllServTypesByServCodes(programId?: string | undefined, body?: string[] | undefined): Observable<ServCodeToServTypeDto[]> {
        let url_ = this.baseUrl + "/api/servecode/svcTypes?";
        if (programId === null)
            throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServTypesByServCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServTypesByServCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServCodeToServTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServCodeToServTypeDto[]>;
        }));
    }

    protected processGetAllServTypesByServCodes(response: HttpResponseBase): Observable<ServCodeToServTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServCodeToServTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdateServCodeDatabase(body?: ServeCodeDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/servecode/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateServCodeDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateServCodeDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateServCodeDatabase(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body?: ServiceTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/serviceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    put(body?: ServiceTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/serviceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    delete(body?: any[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/serviceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<ServiceTypeResponseDto> {
        let url_ = this.baseUrl + "/api/serviceType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTypeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTypeResponseDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ServiceTypeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTypeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    serviceTypesExport(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/serviceType/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTypesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTypesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processServiceTypesExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfServiceTypeResponseDto> {
        let url_ = this.baseUrl + "/api/serviceType/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfServiceTypeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfServiceTypeResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GridResponseBaseOfServiceTypeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfServiceTypeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getServiceTypeLookup(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfServiceTypeResponseDto> {
        let url_ = this.baseUrl + "/api/serviceType/fetch-lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypeLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypeLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfServiceTypeResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfServiceTypeResponseDto>;
        }));
    }

    protected processGetServiceTypeLookup(response: HttpResponseBase): Observable<GridResponseBaseOfServiceTypeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfServiceTypeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShiftsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param begDate (optional)
     * @param endDate (optional)
     * @param personId (optional)
     * @param personType (optional)
     * @return Success
     */
    getShifts(begDate?: Date | undefined, endDate?: Date | undefined, personId?: string | undefined, personType?: string | undefined): Observable<ShiftsViewModel> {
        let url_ = this.baseUrl + "/api/shifts?";
        if (begDate === null)
            throw new Error("The parameter 'begDate' cannot be null.");
        else if (begDate !== undefined)
            url_ += "BegDate=" + encodeURIComponent(begDate ? "" + begDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "PersonType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftsViewModel>;
        }));
    }

    protected processGetShifts(response: HttpResponseBase): Observable<ShiftsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getIdsFromName(body?: GetIdsFromNameRequest | undefined): Observable<GetIdsFromNameResponse[]> {
        let url_ = this.baseUrl + "/api/shifts/idsfromname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdsFromName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdsFromName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIdsFromNameResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIdsFromNameResponse[]>;
        }));
    }

    protected processGetIdsFromName(response: HttpResponseBase): Observable<GetIdsFromNameResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIdsFromNameResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubAccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getAccountLkp(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfSubAccountLookupDto> {
        let url_ = this.baseUrl + "/api/subaccount?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfSubAccountLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfSubAccountLookupDto>;
        }));
    }

    protected processGetAccountLkp(response: HttpResponseBase): Observable<GridResponseBaseOfSubAccountLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfSubAccountLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UnitRangeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    get(): Observable<UnitRangeDto[]> {
        let url_ = this.baseUrl + "/api/unitrange";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitRangeDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UnitRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitRangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createADUsers(body?: ADUserModel[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateADUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateADUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateADUsers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addLatestAccessedCompany(body?: UserRoleCompany | undefined): Observable<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/user/addlatestaccessedcompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLatestAccessedCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLatestAccessedCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel[]>;
        }));
    }

    protected processAddLatestAccessedCompany(response: HttpResponseBase): Observable<CompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUsers(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/user/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserAccessedCompanies(): Observable<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/user/getuseraccesscompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccessedCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccessedCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel[]>;
        }));
    }

    protected processGetUserAccessedCompanies(response: HttpResponseBase): Observable<CompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @param existingCompanyIds (optional)
     * @return Success
     */
    getOtherAccessedCompanies(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined, existingCompanyIds?: string | undefined): Observable<GridResponseBaseOfCompanyModel> {
        let url_ = this.baseUrl + "/api/user/otheraccesscompanies?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (existingCompanyIds === null)
            throw new Error("The parameter 'existingCompanyIds' cannot be null.");
        else if (existingCompanyIds !== undefined)
            url_ += "existingCompanyIds=" + encodeURIComponent("" + existingCompanyIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherAccessedCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherAccessedCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCompanyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCompanyModel>;
        }));
    }

    protected processGetOtherAccessedCompanies(response: HttpResponseBase): Observable<GridResponseBaseOfCompanyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCompanyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getOwnersList(body?: OwnersListRequestDto | undefined): Observable<GridResponseBaseOfOwnersResponse> {
        let url_ = this.baseUrl + "/api/user/owners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfOwnersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfOwnersResponse>;
        }));
    }

    protected processGetOwnersList(response: HttpResponseBase): Observable<GridResponseBaseOfOwnersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfOwnersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    refreshUserJobTitle(): Observable<UserJobTitleResponseModel> {
        let url_ = this.baseUrl + "/api/user/refreshjobtitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshUserJobTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshUserJobTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobTitleResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobTitleResponseModel>;
        }));
    }

    protected processRefreshUserJobTitle(response: HttpResponseBase): Observable<UserJobTitleResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserJobTitleResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refresh (optional)
     * @return Success
     */
    getUnregisteredUserList(refresh?: boolean | null | undefined): Observable<ADUserModel[]> {
        let url_ = this.baseUrl + "/api/user/unregistereduser?";
        if (refresh !== undefined && refresh !== null)
            url_ += "refresh=" + encodeURIComponent("" + refresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnregisteredUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnregisteredUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ADUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ADUserModel[]>;
        }));
    }

    protected processGetUnregisteredUserList(response: HttpResponseBase): Observable<ADUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ADUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updatesession(): Observable<any> {
        let url_ = this.baseUrl + "/api/user/updatesession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatesession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatesession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdatesession(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUserCompany(): Observable<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/user/usercompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel[]>;
        }));
    }

    protected processGetAllUserCompany(response: HttpResponseBase): Observable<CompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    userLogout(): Observable<string> {
        let url_ = this.baseUrl + "/api/user/userlogout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUserLogout(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    get(): Observable<ScreenUser> {
        let url_ = this.baseUrl + "/api/user/userpremission";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreenUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreenUser>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScreenUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUsersWithNoRole(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/user/userswithnorole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersWithNoRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersWithNoRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAllUsersWithNoRole(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VendorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getVendorLkp(body?: FilterRequest | undefined): Observable<GridResponseBaseOfCommonLkpDTO> {
        let url_ = this.baseUrl + "/api/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfCommonLkpDTO>;
        }));
    }

    protected processGetVendorLkp(response: HttpResponseBase): Observable<GridResponseBaseOfCommonLkpDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfCommonLkpDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getVendorList(): Observable<CommonLkpDTO[]> {
        let url_ = this.baseUrl + "/api/vendor/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonLkpDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonLkpDTO[]>;
        }));
    }

    protected processGetVendorList(response: HttpResponseBase): Observable<CommonLkpDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonLkpDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeekService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getWeekDetails(body?: WeekDetailsRequest | undefined): Observable<WeekDetailsDto> {
        let url_ = this.baseUrl + "/api/week/weekDetails/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeekDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeekDetailsDto>;
        }));
    }

    protected processGetWeekDetails(response: HttpResponseBase): Observable<WeekDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeekDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WriteOffCauseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createWriteOffCause(body?: WriteOffCauseRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/writeoffcause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateWriteOffCause(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param writeoffCauseId (optional)
     * @return Success
     */
    deleteWriteOffCause(writeoffCauseId?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/writeoffcause?";
        if (writeoffCauseId === null)
            throw new Error("The parameter 'writeoffCauseId' cannot be null.");
        else if (writeoffCauseId !== undefined)
            url_ += "writeoffCauseId=" + encodeURIComponent("" + writeoffCauseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteWriteOffCause(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approveWriteOffCause(body?: WriteOffCauseRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/writeoffcause/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApproveWriteOffCause(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportWriteOffCause(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/writeoffcause/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportWriteOffCause(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllWriteOffCause(body?: CustomFilterRequest | undefined): Observable<GridResponseBaseOfWriteOffCauseResponseDto> {
        let url_ = this.baseUrl + "/api/writeoffcause/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfWriteOffCauseResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfWriteOffCauseResponseDto>;
        }));
    }

    protected processGetAllWriteOffCause(response: HttpResponseBase): Observable<GridResponseBaseOfWriteOffCauseResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfWriteOffCauseResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional)
     * @param sortDirection (optional)
     * @param filterColumn (optional)
     * @param filterValue (optional)
     * @param pageSize (optional)
     * @param pageNumber (optional)
     * @param filterType (optional)
     * @return Success
     */
    getAllActiveApprovedWriteOffCause(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<GridResponseBaseOfWriteOffCauseResponseDto> {
        let url_ = this.baseUrl + "/api/writeoffcause/getActiveApprovedWoCause?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveApprovedWriteOffCause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveApprovedWriteOffCause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridResponseBaseOfWriteOffCauseResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridResponseBaseOfWriteOffCauseResponseDto>;
        }));
    }

    protected processGetAllActiveApprovedWriteOffCause(response: HttpResponseBase): Observable<GridResponseBaseOfWriteOffCauseResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridResponseBaseOfWriteOffCauseResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getWriteOffCauses(body?: WriteOffCauseIdRequestDto | undefined): Observable<WriteOffCauseIdResponseDto[]> {
        let url_ = this.baseUrl + "/api/writeoffcause/getwriteoffcausesbyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWriteOffCauses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffCauses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffCauseIdResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffCauseIdResponseDto[]>;
        }));
    }

    protected processGetWriteOffCauses(response: HttpResponseBase): Observable<WriteOffCauseIdResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WriteOffCauseIdResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWriteOffCauseById(id: number): Observable<WriteOffCauseByIdResponseDto> {
        let url_ = this.baseUrl + "/api/writeoffcause/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWriteOffCauseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffCauseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffCauseByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffCauseByIdResponseDto>;
        }));
    }

    protected processGetWriteOffCauseById(response: HttpResponseBase): Observable<WriteOffCauseByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WriteOffCauseByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HealthCheckService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getServicesStatus(): Observable<HealthCheckResponse[]> {
        let url_ = this.baseUrl + "/healthcheck/servicestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCheckResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCheckResponse[]>;
        }));
    }

    protected processGetServicesStatus(response: HttpResponseBase): Observable<HealthCheckResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthCheckResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CompanyModel implements ICompanyModel {
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyModel {
    companyId?: number;
    companyName?: string | undefined;
}

export class ScreenCompany implements IScreenCompany {
    companyID?: number;
    companyName?: string | undefined;

    constructor(data?: IScreenCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyID = _data["companyID"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): ScreenCompany {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyID"] = this.companyID;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IScreenCompany {
    companyID?: number;
    companyName?: string | undefined;
}

export class ScreenPermission implements IScreenPermission {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IScreenPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.permissionName = _data["permissionName"];
        }
    }

    static fromJS(data: any): ScreenPermission {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["permissionName"] = this.permissionName;
        return data;
    }
}

export interface IScreenPermission {
    permissionId?: number;
    permissionName?: string | undefined;
}

export class ScreenRole implements IScreenRole {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: ScreenCompany[] | undefined;
    screens?: Screens[] | undefined;

    constructor(data?: IScreenRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.canImpersonate = _data["canImpersonate"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(ScreenCompany.fromJS(item));
            }
            if (Array.isArray(_data["screens"])) {
                this.screens = [] as any;
                for (let item of _data["screens"])
                    this.screens!.push(Screens.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScreenRole {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["canImpersonate"] = this.canImpersonate;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.screens)) {
            data["screens"] = [];
            for (let item of this.screens)
                data["screens"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScreenRole {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: ScreenCompany[] | undefined;
    screens?: Screens[] | undefined;
}

export class ScreenUser implements IScreenUser {
    userId?: number;
    userName?: string | undefined;
    roles?: ScreenRole[] | undefined;
    objectId?: string | undefined;

    constructor(data?: IScreenUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ScreenRole.fromJS(item));
            }
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): ScreenUser {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IScreenUser {
    userId?: number;
    userName?: string | undefined;
    roles?: ScreenRole[] | undefined;
    objectId?: string | undefined;
}

export class Screens implements IScreens {
    screenId?: number;
    parentId?: number | undefined;
    displayOrder?: number | undefined;
    screenName?: string | undefined;
    screenCode?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: ScreenPermission[] | undefined;

    constructor(data?: IScreens) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenId = _data["screenId"];
            this.parentId = _data["parentId"];
            this.displayOrder = _data["displayOrder"];
            this.screenName = _data["screenName"];
            this.screenCode = _data["screenCode"];
            this.path = _data["path"];
            this.cssClass = _data["cssClass"];
            this.display = _data["display"];
            this.isAuthorized = _data["isAuthorized"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ScreenPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Screens {
        data = typeof data === 'object' ? data : {};
        let result = new Screens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenId"] = this.screenId;
        data["parentId"] = this.parentId;
        data["displayOrder"] = this.displayOrder;
        data["screenName"] = this.screenName;
        data["screenCode"] = this.screenCode;
        data["path"] = this.path;
        data["cssClass"] = this.cssClass;
        data["display"] = this.display;
        data["isAuthorized"] = this.isAuthorized;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScreens {
    screenId?: number;
    parentId?: number | undefined;
    displayOrder?: number | undefined;
    screenName?: string | undefined;
    screenCode?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: ScreenPermission[] | undefined;
}

export class ColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousColumnValue = _data["previousColumnValue"];
            this.currentColumnValue = _data["currentColumnValue"];
            this.columnName = _data["columnName"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousColumnValue"] = this.previousColumnValue;
        data["currentColumnValue"] = this.currentColumnValue;
        data["columnName"] = this.columnName;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;
}

export class SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase implements ISqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase {
    readonly columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ISqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnLevelChangeHistory"])) {
                (<any>this).columnLevelChangeHistory = [] as any;
                for (let item of _data["columnLevelChangeHistory"])
                    (<any>this).columnLevelChangeHistory!.push(ColumnLevelChangeHistoryBase.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new SqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnLevelChangeHistory)) {
            data["columnLevelChangeHistory"] = [];
            for (let item of this.columnLevelChangeHistory)
                data["columnLevelChangeHistory"].push(item ? item.toJSON() : <any>undefined);
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISqlColumnLevelChangeHistoryBaseOfColumnLevelChangeHistoryBase {
    columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class Address implements IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class AddressDTO implements IAddressDTO {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    type?: AddressType;
    personInternalId?: number;
    personAddressId?: number | undefined;
    isDefault?: boolean;
    verificationStatus?: AddressVerificationStatus;
    latitude?: number | undefined;
    longitude?: number | undefined;
    validationOverride?: boolean;

    constructor(data?: IAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.county = _data["county"];
            this.type = _data["type"];
            this.personInternalId = _data["personInternalId"];
            this.personAddressId = _data["personAddressId"];
            this.isDefault = _data["isDefault"];
            this.verificationStatus = _data["verificationStatus"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.validationOverride = _data["validationOverride"];
        }
    }

    static fromJS(data: any): AddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["county"] = this.county;
        data["type"] = this.type;
        data["personInternalId"] = this.personInternalId;
        data["personAddressId"] = this.personAddressId;
        data["isDefault"] = this.isDefault;
        data["verificationStatus"] = this.verificationStatus;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["validationOverride"] = this.validationOverride;
        return data;
    }
}

export interface IAddressDTO {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    type?: AddressType;
    personInternalId?: number;
    personAddressId?: number | undefined;
    isDefault?: boolean;
    verificationStatus?: AddressVerificationStatus;
    latitude?: number | undefined;
    longitude?: number | undefined;
    validationOverride?: boolean;
}

export class ApproveMultipleShiftsRequest implements IApproveMultipleShiftsRequest {
    participantId?: string | undefined;
    shiftIds!: string[];
    shiftComments?: ShiftComment[] | undefined;
    approvedByUserId!: string;
    logging?: ShiftDiagnosisLogging;

    constructor(data?: IApproveMultipleShiftsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shiftIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["shiftIds"])) {
                this.shiftIds = [] as any;
                for (let item of _data["shiftIds"])
                    this.shiftIds!.push(item);
            }
            if (Array.isArray(_data["shiftComments"])) {
                this.shiftComments = [] as any;
                for (let item of _data["shiftComments"])
                    this.shiftComments!.push(ShiftComment.fromJS(item));
            }
            this.approvedByUserId = _data["approvedByUserId"];
            this.logging = _data["logging"] ? ShiftDiagnosisLogging.fromJS(_data["logging"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApproveMultipleShiftsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveMultipleShiftsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        if (Array.isArray(this.shiftIds)) {
            data["shiftIds"] = [];
            for (let item of this.shiftIds)
                data["shiftIds"].push(item);
        }
        if (Array.isArray(this.shiftComments)) {
            data["shiftComments"] = [];
            for (let item of this.shiftComments)
                data["shiftComments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["approvedByUserId"] = this.approvedByUserId;
        data["logging"] = this.logging ? this.logging.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApproveMultipleShiftsRequest {
    participantId?: string | undefined;
    shiftIds: string[];
    shiftComments?: ShiftComment[] | undefined;
    approvedByUserId: string;
    logging?: ShiftDiagnosisLogging;
}

export class ClaimAuthDetails implements IClaimAuthDetails {
    unitRange?: number | undefined;
    amountRange?: number | undefined;
    rangeAmount?: number | undefined;
    budgetAmount?: number | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    unitRate?: number | undefined;
    rangeUnits?: number | undefined;

    constructor(data?: IClaimAuthDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitRange = _data["unitRange"];
            this.amountRange = _data["amountRange"];
            this.rangeAmount = _data["rangeAmount"];
            this.budgetAmount = _data["budgetAmount"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.unitRate = _data["unitRate"];
            this.rangeUnits = _data["rangeUnits"];
        }
    }

    static fromJS(data: any): ClaimAuthDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAuthDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitRange"] = this.unitRange;
        data["amountRange"] = this.amountRange;
        data["rangeAmount"] = this.rangeAmount;
        data["budgetAmount"] = this.budgetAmount;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["unitRate"] = this.unitRate;
        data["rangeUnits"] = this.rangeUnits;
        return data;
    }
}

export interface IClaimAuthDetails {
    unitRange?: number | undefined;
    amountRange?: number | undefined;
    rangeAmount?: number | undefined;
    budgetAmount?: number | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    unitRate?: number | undefined;
    rangeUnits?: number | undefined;
}

export class GhaEntity implements IGhaEntity {
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    employerId!: string;
    cgvId!: string;
    cgvCmpyCode?: string | undefined;
    svcCode!: string;
    inTime!: Date;
    outTime!: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType!: string;
    src!: string;
    destType?: string | undefined;
    transStatus!: number;
    ruleStatus!: string;
    ctdBy!: string;
    mdfdBy!: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId!: string;
    ptpntId!: string;
    readonly ptnKey?: string | undefined;
    docType!: string;
    ptpntCmpyCode!: string;
    ttl?: number | undefined;
    readonly version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;

    constructor(data?: IGhaEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inTimeActual = _data["inTimeActual"] ? new Date(_data["inTimeActual"].toString()) : <any>undefined;
            this.outTimeActual = _data["outTimeActual"] ? new Date(_data["outTimeActual"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.cgvId = _data["cgvId"];
            this.cgvCmpyCode = _data["cgvCmpyCode"];
            this.svcCode = _data["svcCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.extId = _data["extId"];
            if (Array.isArray(_data["Overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["Overrides"])
                    this.overrides!.push(RuleOverride.fromJS(item));
            }
            this.recTyp = _data["recTyp"];
            this.cgCmnts = _data["cgCmnts"];
            this.srcType = _data["srcType"];
            this.src = _data["src"];
            this.destType = _data["destType"];
            this.transStatus = _data["transStatus"];
            this.ruleStatus = _data["ruleStatus"];
            this.ctdBy = _data["ctdBy"];
            this.mdfdBy = _data["mdfdBy"];
            this.sysMdfdBy = _data["sysMdfdBy"];
            this.sysLstUpdtdDate = _data["sysLstUpdtdDate"] ? new Date(_data["sysLstUpdtdDate"].toString()) : <any>undefined;
            this.refTxId = _data["refTxId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.onHold = _data["onHold"];
            this.adjType = _data["adjType"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.isPSST = _data["isPSST"];
            this.statusDisplayText = _data["statusDisplayText"];
            this.statusTitle = _data["statusTitle"];
            this.statusDisplayTitle = _data["statusDisplayTitle"];
            this.id = _data["id"];
            this.txId = _data["txId"];
            this.ptpntId = _data["ptpntId"];
            (<any>this).ptnKey = _data["ptnKey"];
            this.docType = _data["docType"];
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            this.ttl = _data["ttl"];
            (<any>this).version = _data["version"];
            this.isDel = _data["isDel"];
            this.ctdDate = _data["ctdDate"] ? new Date(_data["ctdDate"].toString()) : <any>undefined;
            this.lstUpdtdDate = _data["lstUpdtdDate"] ? new Date(_data["lstUpdtdDate"].toString()) : <any>undefined;
            this._etag = _data["_etag"];
            this.companyContext = _data["companyContext"];
            this.nwRetryCount = _data["nwRetryCount"];
            this.priority = _data["priority"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : <any>undefined;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : <any>undefined;
            this.ivrNbrIn = _data["ivrNbrIn"];
            this.ivrNbrOut = _data["ivrNbrOut"];
            this.adjReasonCode = _data["adjReasonCode"];
        }
    }

    static fromJS(data: any): GhaEntity {
        data = typeof data === 'object' ? data : {};
        let result = new GhaEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inTimeActual"] = this.inTimeActual ? this.inTimeActual.toISOString() : <any>undefined;
        data["outTimeActual"] = this.outTimeActual ? this.outTimeActual.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["cgvId"] = this.cgvId;
        data["cgvCmpyCode"] = this.cgvCmpyCode;
        data["svcCode"] = this.svcCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["extId"] = this.extId;
        if (Array.isArray(this.overrides)) {
            data["Overrides"] = [];
            for (let item of this.overrides)
                data["Overrides"].push(item ? item.toJSON() : <any>undefined);
        }
        data["recTyp"] = this.recTyp;
        data["cgCmnts"] = this.cgCmnts;
        data["srcType"] = this.srcType;
        data["src"] = this.src;
        data["destType"] = this.destType;
        data["transStatus"] = this.transStatus;
        data["ruleStatus"] = this.ruleStatus;
        data["ctdBy"] = this.ctdBy;
        data["mdfdBy"] = this.mdfdBy;
        data["sysMdfdBy"] = this.sysMdfdBy;
        data["sysLstUpdtdDate"] = this.sysLstUpdtdDate ? this.sysLstUpdtdDate.toISOString() : <any>undefined;
        data["refTxId"] = this.refTxId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["onHold"] = this.onHold;
        data["adjType"] = this.adjType;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["isPSST"] = this.isPSST;
        data["statusDisplayText"] = this.statusDisplayText;
        data["statusTitle"] = this.statusTitle;
        data["statusDisplayTitle"] = this.statusDisplayTitle;
        data["id"] = this.id;
        data["txId"] = this.txId;
        data["ptpntId"] = this.ptpntId;
        data["ptnKey"] = this.ptnKey;
        data["docType"] = this.docType;
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["ttl"] = this.ttl;
        data["version"] = this.version;
        data["isDel"] = this.isDel;
        data["ctdDate"] = this.ctdDate ? this.ctdDate.toISOString() : <any>undefined;
        data["lstUpdtdDate"] = this.lstUpdtdDate ? this.lstUpdtdDate.toISOString() : <any>undefined;
        data["_etag"] = this._etag;
        data["companyContext"] = this.companyContext;
        data["nwRetryCount"] = this.nwRetryCount;
        data["priority"] = this.priority;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : <any>undefined;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : <any>undefined;
        data["ivrNbrIn"] = this.ivrNbrIn;
        data["ivrNbrOut"] = this.ivrNbrOut;
        data["adjReasonCode"] = this.adjReasonCode;
        return data;
    }
}

export interface IGhaEntity {
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    employerId: string;
    cgvId: string;
    cgvCmpyCode?: string | undefined;
    svcCode: string;
    inTime: Date;
    outTime: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType: string;
    src: string;
    destType?: string | undefined;
    transStatus: number;
    ruleStatus: string;
    ctdBy: string;
    mdfdBy: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId: string;
    ptpntId: string;
    ptnKey?: string | undefined;
    docType: string;
    ptpntCmpyCode: string;
    ttl?: number | undefined;
    version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;
}

export class OwnersResponse implements IOwnersResponse {
    id?: number;
    name?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string | undefined;

    constructor(data?: IOwnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.jobTitle = _data["jobTitle"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): OwnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OwnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["jobTitle"] = this.jobTitle;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IOwnersResponse {
    id?: number;
    name?: string | undefined;
    jobTitle?: string | undefined;
    objectId?: string | undefined;
}

export class PhoneDetail implements IPhoneDetail {
    type?: Phone;
    number?: string | undefined;
    extension?: string | undefined;
    personId?: string | undefined;
    personInternalId?: number;
    personPhoneId?: number | undefined;
    phoneType?: string | undefined;
    isDefault?: boolean;
    isIVR?: boolean;
    isSMSCapable?: boolean;

    constructor(data?: IPhoneDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
            this.extension = _data["extension"];
            this.personId = _data["personId"];
            this.personInternalId = _data["personInternalId"];
            this.personPhoneId = _data["personPhoneId"];
            this.phoneType = _data["phoneType"];
            this.isDefault = _data["isDefault"];
            this.isIVR = _data["isIVR"];
            this.isSMSCapable = _data["isSMSCapable"];
        }
    }

    static fromJS(data: any): PhoneDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        data["extension"] = this.extension;
        data["personId"] = this.personId;
        data["personInternalId"] = this.personInternalId;
        data["personPhoneId"] = this.personPhoneId;
        data["phoneType"] = this.phoneType;
        data["isDefault"] = this.isDefault;
        data["isIVR"] = this.isIVR;
        data["isSMSCapable"] = this.isSMSCapable;
        return data;
    }
}

export interface IPhoneDetail {
    type?: Phone;
    number?: string | undefined;
    extension?: string | undefined;
    personId?: string | undefined;
    personInternalId?: number;
    personPhoneId?: number | undefined;
    phoneType?: string | undefined;
    isDefault?: boolean;
    isIVR?: boolean;
    isSMSCapable?: boolean;
}

export class RuleTestEnrichmentDto implements IRuleTestEnrichmentDto {
    item?: string | undefined;
    value?: any | undefined;

    constructor(data?: IRuleTestEnrichmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RuleTestEnrichmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleTestEnrichmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["value"] = this.value;
        return data;
    }
}

export interface IRuleTestEnrichmentDto {
    item?: string | undefined;
    value?: any | undefined;
}

export class RuleTestSubmissionDto implements IRuleTestSubmissionDto {
    companyCode?: string | undefined;
    docType?: string | undefined;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    ruleSet?: string | undefined;
    system?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    miles?: number;
    units?: number;
    tcn?: string | undefined;
    isPositive?: boolean;

    constructor(data?: IRuleTestSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.docType = _data["docType"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.ruleSet = _data["ruleSet"];
            this.system = _data["system"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.miles = _data["miles"];
            this.units = _data["units"];
            this.tcn = _data["tcn"];
            this.isPositive = _data["isPositive"];
        }
    }

    static fromJS(data: any): RuleTestSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleTestSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["docType"] = this.docType;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["ruleSet"] = this.ruleSet;
        data["system"] = this.system;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["miles"] = this.miles;
        data["units"] = this.units;
        data["tcn"] = this.tcn;
        data["isPositive"] = this.isPositive;
        return data;
    }
}

export interface IRuleTestSubmissionDto {
    companyCode?: string | undefined;
    docType?: string | undefined;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    ruleSet?: string | undefined;
    system?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    miles?: number;
    units?: number;
    tcn?: string | undefined;
    isPositive?: boolean;
}

export class RuleTesterEnrichmentResponse implements IRuleTesterEnrichmentResponse {
    enrichmentData?: RuleTestEnrichmentDto[] | undefined;
    success?: boolean;
    failedRules?: RuleTesterValidation[] | undefined;
    tcn?: string | undefined;

    constructor(data?: IRuleTesterEnrichmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enrichmentData"])) {
                this.enrichmentData = [] as any;
                for (let item of _data["enrichmentData"])
                    this.enrichmentData!.push(RuleTestEnrichmentDto.fromJS(item));
            }
            this.success = _data["success"];
            if (Array.isArray(_data["failedRules"])) {
                this.failedRules = [] as any;
                for (let item of _data["failedRules"])
                    this.failedRules!.push(RuleTesterValidation.fromJS(item));
            }
            this.tcn = _data["tcn"];
        }
    }

    static fromJS(data: any): RuleTesterEnrichmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RuleTesterEnrichmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enrichmentData)) {
            data["enrichmentData"] = [];
            for (let item of this.enrichmentData)
                data["enrichmentData"].push(item ? item.toJSON() : <any>undefined);
        }
        data["success"] = this.success;
        if (Array.isArray(this.failedRules)) {
            data["failedRules"] = [];
            for (let item of this.failedRules)
                data["failedRules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["tcn"] = this.tcn;
        return data;
    }
}

export interface IRuleTesterEnrichmentResponse {
    enrichmentData?: RuleTestEnrichmentDto[] | undefined;
    success?: boolean;
    failedRules?: RuleTesterValidation[] | undefined;
    tcn?: string | undefined;
}

export class RuleTesterResponse implements IRuleTesterResponse {
    success?: boolean;
    failedRules?: RuleTesterValidation[] | undefined;
    tcn?: string | undefined;

    constructor(data?: IRuleTesterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["failedRules"])) {
                this.failedRules = [] as any;
                for (let item of _data["failedRules"])
                    this.failedRules!.push(RuleTesterValidation.fromJS(item));
            }
            this.tcn = _data["tcn"];
        }
    }

    static fromJS(data: any): RuleTesterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RuleTesterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.failedRules)) {
            data["failedRules"] = [];
            for (let item of this.failedRules)
                data["failedRules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["tcn"] = this.tcn;
        return data;
    }
}

export interface IRuleTesterResponse {
    success?: boolean;
    failedRules?: RuleTesterValidation[] | undefined;
    tcn?: string | undefined;
}

export class RuleTesterValidation implements IRuleTesterValidation {
    readonly ruleIdValue?: string | undefined;
    readonly ruleStatusValue?: string | undefined;
    ruleId?: RuleId;
    ruleErrorMessageIds?: string[] | undefined;
    ruleStatus?: RuleStatus;
    errors?: string[] | undefined;
    priority?: number;

    constructor(data?: IRuleTesterValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ruleIdValue = _data["ruleIdValue"];
            (<any>this).ruleStatusValue = _data["ruleStatusValue"];
            this.ruleId = _data["ruleId"];
            if (Array.isArray(_data["ruleErrorMessageIds"])) {
                this.ruleErrorMessageIds = [] as any;
                for (let item of _data["ruleErrorMessageIds"])
                    this.ruleErrorMessageIds!.push(item);
            }
            this.ruleStatus = _data["ruleStatus"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): RuleTesterValidation {
        data = typeof data === 'object' ? data : {};
        let result = new RuleTesterValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleIdValue"] = this.ruleIdValue;
        data["ruleStatusValue"] = this.ruleStatusValue;
        data["ruleId"] = this.ruleId;
        if (Array.isArray(this.ruleErrorMessageIds)) {
            data["ruleErrorMessageIds"] = [];
            for (let item of this.ruleErrorMessageIds)
                data["ruleErrorMessageIds"].push(item);
        }
        data["ruleStatus"] = this.ruleStatus;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["priority"] = this.priority;
        return data;
    }
}

export interface IRuleTesterValidation {
    ruleIdValue?: string | undefined;
    ruleStatusValue?: string | undefined;
    ruleId?: RuleId;
    ruleErrorMessageIds?: string[] | undefined;
    ruleStatus?: RuleStatus;
    errors?: string[] | undefined;
    priority?: number;
}

export class CustomFilterRequest implements ICustomFilterRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: ICustomFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): CustomFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface ICustomFilterRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class UserJobTitleResponseModel implements IUserJobTitleResponseModel {
    result?: string | undefined;

    constructor(data?: IUserJobTitleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): UserJobTitleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserJobTitleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IUserJobTitleResponseModel {
    result?: string | undefined;
}

export enum AddressType {
    Mailing = "Mailing",
    Physical = "Physical",
    IVR = "IVR",
}

export enum AddressVerificationStatus {
    NotRun = "NotRun",
    Valid = "Valid",
    Invalid = "Invalid",
    Error = "Error",
}

export enum AuthType {
    None = "None",
    Internal = "Internal",
    Participant = "Participant",
    Both = "Both",
}

export enum AuthorizationStatus {
    OnHold = "OnHold",
    Active = "Active",
    Inactive = "Inactive",
    Draft = "Draft",
}

export enum CommentsRequired {
    None = "None",
    Required = "Required",
    Optional = "Optional",
}

export enum PayCalcMethod {
    EMPE = "EMPE",
    NONE = "NONE",
    CH = "CH",
    EMPR = "EMPR",
}

export enum Phone {
    CellPhone = "CellPhone",
    HomePhone = "HomePhone",
    IvrPhone = "IvrPhone",
}

export enum RuleId {
    ParticipantSig = "ParticipantSig",
    CaregiverSig = "CaregiverSig",
    Participant = "Participant",
    ServiceCode = "ServiceCode",
    Program = "Program",
    ServiceDate = "ServiceDate",
    TimeTest = "TimeTest",
    AuthHeader = "AuthHeader",
    AuthOnHold = "AuthOnHold",
    AuthOverlap = "AuthOverlap",
    BillRateOverlap = "BillRateOverlap",
    AuthCode = "AuthCode",
    ParticipantEmployer = "ParticipantEmployer",
    Caregiver = "Caregiver",
    ParticipantCaregiverRel = "ParticipantCaregiverRel",
    LateService = "LateService",
    InvoiceNumber = "InvoiceNumber",
    PayUnits = "PayUnits",
    PayRate = "PayRate",
    BillUnits = "BillUnits",
    BillRate = "BillRate",
    ExceededWWL = "ExceededWWL",
    ServiceTimeOverlap = "ServiceTimeOverlap",
    OverBudgetDollars = "OverBudgetDollars",
    OverBudgetUnits = "OverBudgetUnits",
    ExpenseAccount = "ExpenseAccount",
    RevenueAccount = "RevenueAccount",
    SubAccount = "SubAccount",
    HireDate = "HireDate",
    ParticipantSigDate = "ParticipantSigDate",
    CaregiverSigDate = "CaregiverSigDate",
    ServiceData = "ServiceData",
    DuplicateShift = "DuplicateShift",
    NonHourlyUnits = "NonHourlyUnits",
    PersonId = "PersonId",
    DocumentBad = "DocumentBad",
    BudgetQuantity = "BudgetQuantity",
    Task = "Task",
    RowInitials = "RowInitials",
    RangeOverBudgetUnits = "RangeOverBudgetUnits",
    Hospital = "Hospital",
    RequireAdjust = "RequireAdjust",
    HoursOverDailyLimit = "HoursOverDailyLimit",
    MonthlyUnitsAllocation = "MonthlyUnitsAllocation",
    Exceeded24Hours = "Exceeded24Hours",
    LiveIn = "LiveIn",
    CanPaperTimesheet = "CanPaperTimesheet",
    OverInternalAuth = "OverInternalAuth",
    MissingInternalAuth = "MissingInternalAuth",
    OkToWork = "OkToWork",
    OkToDrive = "OkToDrive",
    OkToAllocate = "OkToAllocate",
    ExemptionOverlap = "ExemptionOverlap",
    RoundShift = "RoundShift",
    ExternalId = "ExternalId",
    MonthlyServiceType = "MonthlyServiceType",
    ExceededServiceCodeUsageLimit = "ExceededServiceCodeUsageLimit",
    ParticipantStatus = "ParticipantStatus",
    CaregiverStatus = "CaregiverStatus",
    RangeOverBudgetDollars = "RangeOverBudgetDollars",
    PersonActionRule = "PersonActionRule",
    ServiceCutoff = "ServiceCutoff",
    PrerequisiteServiceValidation = "PrerequisiteServiceValidation",
    PayrollExternalKey = "PayrollExternalKey",
    ExceededDailyWorkLimit = "ExceededDailyWorkLimit",
    ExclusionaryService = "ExclusionaryService",
    ExceededRelationshipWWL = "ExceededRelationshipWWL",
    NoComments = "NoComments",
}

export enum RuleStatus {
    Success = "Success",
    Failure = "Failure",
    Override = "Override",
    Deny = "Deny",
    Warning = "Warning",
}

export class ErrorInfo implements IErrorInfo {
    errorNumber?: number;
    errorCode?: string | undefined;
    errorDetail?: string | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorNumber = _data["errorNumber"];
            this.errorCode = _data["errorCode"];
            this.errorDetail = _data["errorDetail"];
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorNumber"] = this.errorNumber;
        data["errorCode"] = this.errorCode;
        data["errorDetail"] = this.errorDetail;
        return data;
    }
}

export interface IErrorInfo {
    errorNumber?: number;
    errorCode?: string | undefined;
    errorDetail?: string | undefined;
}

export class Gps implements IGps {
    lat?: number;
    long?: number;

    constructor(data?: IGps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["Lat"];
            this.long = _data["Long"];
        }
    }

    static fromJS(data: any): Gps {
        data = typeof data === 'object' ? data : {};
        let result = new Gps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat"] = this.lat;
        data["Long"] = this.long;
        return data;
    }
}

export interface IGps {
    lat?: number;
    long?: number;
}

export class MileageDataEntity implements IMileageDataEntity {
    cgvId!: string;
    cgvCmpyCode?: string | undefined;
    svcCode!: string;
    inTime!: Date;
    miles!: number;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    stAddress?: Address;
    endAddress?: Address;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    ptpntCmnts?: string | undefined;
    srcType!: string;
    src!: string;
    destType?: string | undefined;
    transStatus!: number;
    ruleStatus!: string;
    ctdBy!: string;
    mdfdBy!: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjReasonCode?: string | undefined;
    isMalformed?: boolean;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    adjType?: number;
    onHold?: boolean;
    isPSST?: boolean;
    id?: string | undefined;
    txId!: string;
    ptpntId!: string;
    readonly ptnKey?: string | undefined;
    docType!: string;
    ptpntCmpyCode!: string;
    ttl?: number | undefined;
    readonly version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;

    constructor(data?: IMileageDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cgvId = _data["cgvId"];
            this.cgvCmpyCode = _data["cgvCmpyCode"];
            this.svcCode = _data["svcCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.miles = _data["miles"];
            this.extId = _data["extId"];
            if (Array.isArray(_data["Overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["Overrides"])
                    this.overrides!.push(RuleOverride.fromJS(item));
            }
            this.stAddress = _data["stAddress"] ? Address.fromJS(_data["stAddress"]) : <any>undefined;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : <any>undefined;
            this.recTyp = _data["recTyp"];
            this.cgCmnts = _data["cgCmnts"];
            this.ptpntCmnts = _data["ptpntCmnts"];
            this.srcType = _data["srcType"];
            this.src = _data["src"];
            this.destType = _data["destType"];
            this.transStatus = _data["transStatus"];
            this.ruleStatus = _data["ruleStatus"];
            this.ctdBy = _data["ctdBy"];
            this.mdfdBy = _data["mdfdBy"];
            this.sysMdfdBy = _data["sysMdfdBy"];
            this.sysLstUpdtdDate = _data["sysLstUpdtdDate"] ? new Date(_data["sysLstUpdtdDate"].toString()) : <any>undefined;
            this.refTxId = _data["refTxId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.adjReasonCode = _data["adjReasonCode"];
            this.isMalformed = _data["isMalformed"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.statusDisplayText = _data["statusDisplayText"];
            this.statusTitle = _data["statusTitle"];
            this.adjType = _data["adjType"];
            this.onHold = _data["onHold"];
            this.isPSST = _data["isPSST"];
            this.id = _data["id"];
            this.txId = _data["txId"];
            this.ptpntId = _data["ptpntId"];
            (<any>this).ptnKey = _data["ptnKey"];
            this.docType = _data["docType"];
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            this.ttl = _data["ttl"];
            (<any>this).version = _data["version"];
            this.isDel = _data["isDel"];
            this.ctdDate = _data["ctdDate"] ? new Date(_data["ctdDate"].toString()) : <any>undefined;
            this.lstUpdtdDate = _data["lstUpdtdDate"] ? new Date(_data["lstUpdtdDate"].toString()) : <any>undefined;
            this._etag = _data["_etag"];
            this.companyContext = _data["companyContext"];
            this.nwRetryCount = _data["nwRetryCount"];
            this.priority = _data["priority"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : <any>undefined;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : <any>undefined;
            this.ivrNbrIn = _data["ivrNbrIn"];
            this.ivrNbrOut = _data["ivrNbrOut"];
        }
    }

    static fromJS(data: any): MileageDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new MileageDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cgvId"] = this.cgvId;
        data["cgvCmpyCode"] = this.cgvCmpyCode;
        data["svcCode"] = this.svcCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["miles"] = this.miles;
        data["extId"] = this.extId;
        if (Array.isArray(this.overrides)) {
            data["Overrides"] = [];
            for (let item of this.overrides)
                data["Overrides"].push(item ? item.toJSON() : <any>undefined);
        }
        data["stAddress"] = this.stAddress ? this.stAddress.toJSON() : <any>undefined;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : <any>undefined;
        data["recTyp"] = this.recTyp;
        data["cgCmnts"] = this.cgCmnts;
        data["ptpntCmnts"] = this.ptpntCmnts;
        data["srcType"] = this.srcType;
        data["src"] = this.src;
        data["destType"] = this.destType;
        data["transStatus"] = this.transStatus;
        data["ruleStatus"] = this.ruleStatus;
        data["ctdBy"] = this.ctdBy;
        data["mdfdBy"] = this.mdfdBy;
        data["sysMdfdBy"] = this.sysMdfdBy;
        data["sysLstUpdtdDate"] = this.sysLstUpdtdDate ? this.sysLstUpdtdDate.toISOString() : <any>undefined;
        data["refTxId"] = this.refTxId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["adjReasonCode"] = this.adjReasonCode;
        data["isMalformed"] = this.isMalformed;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["statusDisplayText"] = this.statusDisplayText;
        data["statusTitle"] = this.statusTitle;
        data["adjType"] = this.adjType;
        data["onHold"] = this.onHold;
        data["isPSST"] = this.isPSST;
        data["id"] = this.id;
        data["txId"] = this.txId;
        data["ptpntId"] = this.ptpntId;
        data["ptnKey"] = this.ptnKey;
        data["docType"] = this.docType;
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["ttl"] = this.ttl;
        data["version"] = this.version;
        data["isDel"] = this.isDel;
        data["ctdDate"] = this.ctdDate ? this.ctdDate.toISOString() : <any>undefined;
        data["lstUpdtdDate"] = this.lstUpdtdDate ? this.lstUpdtdDate.toISOString() : <any>undefined;
        data["_etag"] = this._etag;
        data["companyContext"] = this.companyContext;
        data["nwRetryCount"] = this.nwRetryCount;
        data["priority"] = this.priority;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : <any>undefined;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : <any>undefined;
        data["ivrNbrIn"] = this.ivrNbrIn;
        data["ivrNbrOut"] = this.ivrNbrOut;
        return data;
    }
}

export interface IMileageDataEntity {
    cgvId: string;
    cgvCmpyCode?: string | undefined;
    svcCode: string;
    inTime: Date;
    miles: number;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    stAddress?: Address;
    endAddress?: Address;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    ptpntCmnts?: string | undefined;
    srcType: string;
    src: string;
    destType?: string | undefined;
    transStatus: number;
    ruleStatus: string;
    ctdBy: string;
    mdfdBy: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjReasonCode?: string | undefined;
    isMalformed?: boolean;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    adjType?: number;
    onHold?: boolean;
    isPSST?: boolean;
    id?: string | undefined;
    txId: string;
    ptpntId: string;
    ptnKey?: string | undefined;
    docType: string;
    ptpntCmpyCode: string;
    ttl?: number | undefined;
    version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
}

export class Response implements IResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    id?: number;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface IResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    id?: number;
}

export class RuleOverride implements IRuleOverride {
    ruleId?: string | undefined;

    constructor(data?: IRuleOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["RuleId"];
        }
    }

    static fromJS(data: any): RuleOverride {
        data = typeof data === 'object' ? data : {};
        let result = new RuleOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RuleId"] = this.ruleId;
        return data;
    }
}

export interface IRuleOverride {
    ruleId?: string | undefined;
}

export class ShiftComment implements IShiftComment {
    shiftId?: string | undefined;
    docType?: string | undefined;
    comment!: string;
    svcCode?: string | undefined;

    constructor(data?: IShiftComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.docType = _data["docType"];
            this.comment = _data["comment"];
            this.svcCode = _data["svcCode"];
        }
    }

    static fromJS(data: any): ShiftComment {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["docType"] = this.docType;
        data["comment"] = this.comment;
        data["svcCode"] = this.svcCode;
        return data;
    }
}

export interface IShiftComment {
    shiftId?: string | undefined;
    docType?: string | undefined;
    comment: string;
    svcCode?: string | undefined;
}

export class ShiftDataEntity implements IShiftDataEntity {
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    stAddress?: Address;
    endAddress?: Address;
    isStLocPtpntLocSame?: boolean | undefined;
    ptpntCmnts?: string | undefined;
    isMalformed?: boolean;
    cgvId!: string;
    cgvCmpyCode?: string | undefined;
    svcCode!: string;
    inTime!: Date;
    outTime!: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType!: string;
    src!: string;
    destType?: string | undefined;
    transStatus!: number;
    ruleStatus!: string;
    ctdBy!: string;
    mdfdBy!: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId!: string;
    ptpntId!: string;
    readonly ptnKey?: string | undefined;
    docType!: string;
    ptpntCmpyCode!: string;
    ttl?: number | undefined;
    readonly version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;

    constructor(data?: IShiftDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inTimeActual = _data["inTimeActual"] ? new Date(_data["inTimeActual"].toString()) : <any>undefined;
            this.outTimeActual = _data["outTimeActual"] ? new Date(_data["outTimeActual"].toString()) : <any>undefined;
            this.stAddress = _data["stAddress"] ? Address.fromJS(_data["stAddress"]) : <any>undefined;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : <any>undefined;
            this.isStLocPtpntLocSame = _data["isStLocPtpntLocSame"];
            this.ptpntCmnts = _data["ptpntCmnts"];
            this.isMalformed = _data["isMalformed"];
            this.cgvId = _data["cgvId"];
            this.cgvCmpyCode = _data["cgvCmpyCode"];
            this.svcCode = _data["svcCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.extId = _data["extId"];
            if (Array.isArray(_data["Overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["Overrides"])
                    this.overrides!.push(RuleOverride.fromJS(item));
            }
            this.recTyp = _data["recTyp"];
            this.cgCmnts = _data["cgCmnts"];
            this.srcType = _data["srcType"];
            this.src = _data["src"];
            this.destType = _data["destType"];
            this.transStatus = _data["transStatus"];
            this.ruleStatus = _data["ruleStatus"];
            this.ctdBy = _data["ctdBy"];
            this.mdfdBy = _data["mdfdBy"];
            this.sysMdfdBy = _data["sysMdfdBy"];
            this.sysLstUpdtdDate = _data["sysLstUpdtdDate"] ? new Date(_data["sysLstUpdtdDate"].toString()) : <any>undefined;
            this.refTxId = _data["refTxId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.onHold = _data["onHold"];
            this.adjType = _data["adjType"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.isPSST = _data["isPSST"];
            this.statusDisplayText = _data["statusDisplayText"];
            this.statusTitle = _data["statusTitle"];
            this.statusDisplayTitle = _data["statusDisplayTitle"];
            this.id = _data["id"];
            this.txId = _data["txId"];
            this.ptpntId = _data["ptpntId"];
            (<any>this).ptnKey = _data["ptnKey"];
            this.docType = _data["docType"];
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            this.ttl = _data["ttl"];
            (<any>this).version = _data["version"];
            this.isDel = _data["isDel"];
            this.ctdDate = _data["ctdDate"] ? new Date(_data["ctdDate"].toString()) : <any>undefined;
            this.lstUpdtdDate = _data["lstUpdtdDate"] ? new Date(_data["lstUpdtdDate"].toString()) : <any>undefined;
            this._etag = _data["_etag"];
            this.companyContext = _data["companyContext"];
            this.nwRetryCount = _data["nwRetryCount"];
            this.priority = _data["priority"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : <any>undefined;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : <any>undefined;
            this.ivrNbrIn = _data["ivrNbrIn"];
            this.ivrNbrOut = _data["ivrNbrOut"];
            this.adjReasonCode = _data["adjReasonCode"];
        }
    }

    static fromJS(data: any): ShiftDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inTimeActual"] = this.inTimeActual ? this.inTimeActual.toISOString() : <any>undefined;
        data["outTimeActual"] = this.outTimeActual ? this.outTimeActual.toISOString() : <any>undefined;
        data["stAddress"] = this.stAddress ? this.stAddress.toJSON() : <any>undefined;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : <any>undefined;
        data["isStLocPtpntLocSame"] = this.isStLocPtpntLocSame;
        data["ptpntCmnts"] = this.ptpntCmnts;
        data["isMalformed"] = this.isMalformed;
        data["cgvId"] = this.cgvId;
        data["cgvCmpyCode"] = this.cgvCmpyCode;
        data["svcCode"] = this.svcCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["extId"] = this.extId;
        if (Array.isArray(this.overrides)) {
            data["Overrides"] = [];
            for (let item of this.overrides)
                data["Overrides"].push(item ? item.toJSON() : <any>undefined);
        }
        data["recTyp"] = this.recTyp;
        data["cgCmnts"] = this.cgCmnts;
        data["srcType"] = this.srcType;
        data["src"] = this.src;
        data["destType"] = this.destType;
        data["transStatus"] = this.transStatus;
        data["ruleStatus"] = this.ruleStatus;
        data["ctdBy"] = this.ctdBy;
        data["mdfdBy"] = this.mdfdBy;
        data["sysMdfdBy"] = this.sysMdfdBy;
        data["sysLstUpdtdDate"] = this.sysLstUpdtdDate ? this.sysLstUpdtdDate.toISOString() : <any>undefined;
        data["refTxId"] = this.refTxId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["onHold"] = this.onHold;
        data["adjType"] = this.adjType;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["isPSST"] = this.isPSST;
        data["statusDisplayText"] = this.statusDisplayText;
        data["statusTitle"] = this.statusTitle;
        data["statusDisplayTitle"] = this.statusDisplayTitle;
        data["id"] = this.id;
        data["txId"] = this.txId;
        data["ptpntId"] = this.ptpntId;
        data["ptnKey"] = this.ptnKey;
        data["docType"] = this.docType;
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["ttl"] = this.ttl;
        data["version"] = this.version;
        data["isDel"] = this.isDel;
        data["ctdDate"] = this.ctdDate ? this.ctdDate.toISOString() : <any>undefined;
        data["lstUpdtdDate"] = this.lstUpdtdDate ? this.lstUpdtdDate.toISOString() : <any>undefined;
        data["_etag"] = this._etag;
        data["companyContext"] = this.companyContext;
        data["nwRetryCount"] = this.nwRetryCount;
        data["priority"] = this.priority;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : <any>undefined;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : <any>undefined;
        data["ivrNbrIn"] = this.ivrNbrIn;
        data["ivrNbrOut"] = this.ivrNbrOut;
        data["adjReasonCode"] = this.adjReasonCode;
        return data;
    }
}

export interface IShiftDataEntity {
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    stAddress?: Address;
    endAddress?: Address;
    isStLocPtpntLocSame?: boolean | undefined;
    ptpntCmnts?: string | undefined;
    isMalformed?: boolean;
    cgvId: string;
    cgvCmpyCode?: string | undefined;
    svcCode: string;
    inTime: Date;
    outTime: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType: string;
    src: string;
    destType?: string | undefined;
    transStatus: number;
    ruleStatus: string;
    ctdBy: string;
    mdfdBy: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId: string;
    ptpntId: string;
    ptnKey?: string | undefined;
    docType: string;
    ptpntCmpyCode: string;
    ttl?: number | undefined;
    version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;
}

export class ShiftDiagnosisLogging implements IShiftDiagnosisLogging {
    companyCode?: string | undefined;
    callerId?: string | undefined;
    callerName?: string | undefined;
    tcnId?: string | undefined;
    reasonCode?: string | undefined;
    reasonText?: string | undefined;
    action?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IShiftDiagnosisLogging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.callerId = _data["callerId"];
            this.callerName = _data["callerName"];
            this.tcnId = _data["tcnId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonText = _data["reasonText"];
            this.action = _data["action"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftDiagnosisLogging {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDiagnosisLogging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["callerId"] = this.callerId;
        data["callerName"] = this.callerName;
        data["tcnId"] = this.tcnId;
        data["reasonCode"] = this.reasonCode;
        data["reasonText"] = this.reasonText;
        data["action"] = this.action;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IShiftDiagnosisLogging {
    companyCode?: string | undefined;
    callerId?: string | undefined;
    callerName?: string | undefined;
    tcnId?: string | undefined;
    reasonCode?: string | undefined;
    reasonText?: string | undefined;
    action?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class TimeShiftRequest implements ITimeShiftRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allCareGivers?: boolean;
    role?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: ITimeShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.allCareGivers = _data["allCareGivers"];
            this.role = _data["role"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): TimeShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimeShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["allCareGivers"] = this.allCareGivers;
        data["role"] = this.role;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface ITimeShiftRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allCareGivers?: boolean;
    role?: string | undefined;
    companyCode?: string | undefined;
}

export class KeyValuePairOfStringAndIEnumerableOfString implements IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IKeyValuePairOfStringAndIEnumerableOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class HttpContent implements IHttpContent {
    readonly headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IHttpContent {
    headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method?: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method?: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version?: string | undefined;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    readonly headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    readonly properties?: { [key: string]: any; } | undefined;
    readonly options?: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.versionPolicy = _data["versionPolicy"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            if (_data["options"]) {
                (<any>this).options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (<any>(<any>this).options)![key] = _data["options"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["versionPolicy"] = this.versionPolicy;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (<any>data["options"])[key] = (<any>this.options)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version?: string | undefined;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    properties?: { [key: string]: any; } | undefined;
    options?: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version?: string | undefined;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    readonly headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    readonly trailingHeaders?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    requestMessage?: HttpRequestMessage;
    readonly isSuccessStatusCode?: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item ? item.toJSON() : <any>undefined);
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version?: string | undefined;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    headers?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    trailingHeaders?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    requestMessage?: HttpRequestMessage;
    isSuccessStatusCode?: boolean;
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = "RequestVersionOrLower",
    RequestVersionOrHigher = "RequestVersionOrHigher",
    RequestVersionExact = "RequestVersionExact",
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    UnprocessableContent = "UnprocessableContent",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class Account implements IAccount {
    id?: number;
    acct?: string | undefined;
    companyId?: number | undefined;
    acctType?: string | undefined;
    isActive?: boolean;
    consolAcct?: string | undefined;
    curyId?: string | undefined;
    descr?: string | undefined;
    employSw?: string | undefined;
    noteId?: number;
    ratioGrp?: string | undefined;
    summPost?: string | undefined;
    unitsSw?: string | undefined;
    user1?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    payRateAccount?: PayRate[] | undefined;
    payRateAccountExp?: PayRate[] | undefined;
    billRateAccount?: BillRateModel[] | undefined;
    billRateExpAccount?: BillRateModel[] | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acct = _data["acct"];
            this.companyId = _data["companyId"];
            this.acctType = _data["acctType"];
            this.isActive = _data["isActive"];
            this.consolAcct = _data["consolAcct"];
            this.curyId = _data["curyId"];
            this.descr = _data["descr"];
            this.employSw = _data["employSw"];
            this.noteId = _data["noteId"];
            this.ratioGrp = _data["ratioGrp"];
            this.summPost = _data["summPost"];
            this.unitsSw = _data["unitsSw"];
            this.user1 = _data["user1"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["payRateAccount"])) {
                this.payRateAccount = [] as any;
                for (let item of _data["payRateAccount"])
                    this.payRateAccount!.push(PayRate.fromJS(item));
            }
            if (Array.isArray(_data["payRateAccountExp"])) {
                this.payRateAccountExp = [] as any;
                for (let item of _data["payRateAccountExp"])
                    this.payRateAccountExp!.push(PayRate.fromJS(item));
            }
            if (Array.isArray(_data["billRateAccount"])) {
                this.billRateAccount = [] as any;
                for (let item of _data["billRateAccount"])
                    this.billRateAccount!.push(BillRateModel.fromJS(item));
            }
            if (Array.isArray(_data["billRateExpAccount"])) {
                this.billRateExpAccount = [] as any;
                for (let item of _data["billRateExpAccount"])
                    this.billRateExpAccount!.push(BillRateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acct"] = this.acct;
        data["companyId"] = this.companyId;
        data["acctType"] = this.acctType;
        data["isActive"] = this.isActive;
        data["consolAcct"] = this.consolAcct;
        data["curyId"] = this.curyId;
        data["descr"] = this.descr;
        data["employSw"] = this.employSw;
        data["noteId"] = this.noteId;
        data["ratioGrp"] = this.ratioGrp;
        data["summPost"] = this.summPost;
        data["unitsSw"] = this.unitsSw;
        data["user1"] = this.user1;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.payRateAccount)) {
            data["payRateAccount"] = [];
            for (let item of this.payRateAccount)
                data["payRateAccount"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.payRateAccountExp)) {
            data["payRateAccountExp"] = [];
            for (let item of this.payRateAccountExp)
                data["payRateAccountExp"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billRateAccount)) {
            data["billRateAccount"] = [];
            for (let item of this.billRateAccount)
                data["billRateAccount"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billRateExpAccount)) {
            data["billRateExpAccount"] = [];
            for (let item of this.billRateExpAccount)
                data["billRateExpAccount"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAccount {
    id?: number;
    acct?: string | undefined;
    companyId?: number | undefined;
    acctType?: string | undefined;
    isActive?: boolean;
    consolAcct?: string | undefined;
    curyId?: string | undefined;
    descr?: string | undefined;
    employSw?: string | undefined;
    noteId?: number;
    ratioGrp?: string | undefined;
    summPost?: string | undefined;
    unitsSw?: string | undefined;
    user1?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    payRateAccount?: PayRate[] | undefined;
    payRateAccountExp?: PayRate[] | undefined;
    billRateAccount?: BillRateModel[] | undefined;
    billRateExpAccount?: BillRateModel[] | undefined;
}

export class Agency implements IAgency {
    id?: number | undefined;
    agencyCode?: string | undefined;
    name?: string | undefined;
    companyId?: number | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    company?: CompanyAuth;

    constructor(data?: IAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyCode = _data["agencyCode"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Agency {
        data = typeof data === 'object' ? data : {};
        let result = new Agency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyCode"] = this.agencyCode;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgency {
    id?: number | undefined;
    agencyCode?: string | undefined;
    name?: string | undefined;
    companyId?: number | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    company?: CompanyAuth;
}

export class AgencyAdminDetails implements IAgencyAdminDetails {
    agencyAdminName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    readonly address?: string | undefined;
    phoneNumber?: string | undefined;
    agencyId?: string | undefined;
    email?: string | undefined;
    agencyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IAgencyAdminDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyAdminName = _data["agencyAdminName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            (<any>this).address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.agencyId = _data["agencyId"];
            this.email = _data["email"];
            this.agencyName = _data["agencyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): AgencyAdminDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyAdminDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyAdminName"] = this.agencyAdminName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["agencyId"] = this.agencyId;
        data["email"] = this.email;
        data["agencyName"] = this.agencyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IAgencyAdminDetails {
    agencyAdminName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    agencyId?: string | undefined;
    email?: string | undefined;
    agencyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class AgencyList implements IAgencyList {
    id?: number;
    agencyId?: string | undefined;
    agencyName?: string | undefined;

    constructor(data?: IAgencyList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
        }
    }

    static fromJS(data: any): AgencyList {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        return data;
    }
}

export interface IAgencyList {
    id?: number;
    agencyId?: string | undefined;
    agencyName?: string | undefined;
}

export class AgencyModel implements IAgencyModel {
    agencyList?: AgencyList[] | undefined;
    hasMapping?: boolean;

    constructor(data?: IAgencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agencyList"])) {
                this.agencyList = [] as any;
                for (let item of _data["agencyList"])
                    this.agencyList!.push(AgencyList.fromJS(item));
            }
            this.hasMapping = _data["hasMapping"];
        }
    }

    static fromJS(data: any): AgencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencyList)) {
            data["agencyList"] = [];
            for (let item of this.agencyList)
                data["agencyList"].push(item ? item.toJSON() : <any>undefined);
        }
        data["hasMapping"] = this.hasMapping;
        return data;
    }
}

export interface IAgencyModel {
    agencyList?: AgencyList[] | undefined;
    hasMapping?: boolean;
}

export class AgencyUserMappingRequest implements IAgencyUserMappingRequest {
    agencyIds?: number[] | undefined;
    userId?: string | undefined;

    constructor(data?: IAgencyUserMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agencyIds"])) {
                this.agencyIds = [] as any;
                for (let item of _data["agencyIds"])
                    this.agencyIds!.push(item);
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AgencyUserMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyUserMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencyIds)) {
            data["agencyIds"] = [];
            for (let item of this.agencyIds)
                data["agencyIds"].push(item);
        }
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAgencyUserMappingRequest {
    agencyIds?: number[] | undefined;
    userId?: string | undefined;
}

export class AmtRange implements IAmtRange {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    authDetails?: AuthDetails[] | undefined;

    constructor(data?: IAmtRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["authDetails"])) {
                this.authDetails = [] as any;
                for (let item of _data["authDetails"])
                    this.authDetails!.push(AuthDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AmtRange {
        data = typeof data === 'object' ? data : {};
        let result = new AmtRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.authDetails)) {
            data["authDetails"] = [];
            for (let item of this.authDetails)
                data["authDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAmtRange {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    authDetails?: AuthDetails[] | undefined;
}

export class AuthDetails implements IAuthDetails {
    authCode?: string | undefined;
    begDate?: Date | undefined;
    holdStDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    budgAmt?: number | undefined;
    budgFlag?: string | undefined;
    dailyAmt?: number | undefined;
    endDate?: Date | undefined;
    feePctAdmin?: number | undefined;
    feePctPR?: number | undefined;
    hours?: number | undefined;
    keyField?: string | undefined;
    modifier?: string | undefined;
    noteID?: number | undefined;
    pmFee?: boolean | undefined;
    procCode?: string | undefined;
    range?: number | undefined;
    rangeA?: number | undefined;
    rangeAmt?: number | undefined;
    rangeUnits?: number | undefined;
    rate?: number | undefined;
    recordId?: number | undefined;
    units?: number | undefined;
    unitsDaily?: number | undefined;
    uom?: string | undefined;
    remAmt?: number | undefined;
    resAmt?: number | undefined;
    spentAmt?: number | undefined;
    lupdBudDate?: Date | undefined;
    servCodeId?: number | undefined;
    authHeaderId?: number;
    lastRefreshDate?: Date | undefined;
    amtRange?: AmtRange;
    unitRange?: UnitRange;
    authHeader?: AuthHeader;
    servCode?: ServCode;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IAuthDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authCode = _data["authCode"];
            this.begDate = _data["begDate"] ? new Date(_data["begDate"].toString()) : <any>undefined;
            this.holdStDate = _data["holdStDate"] ? new Date(_data["holdStDate"].toString()) : <any>undefined;
            this.holdEndDate = _data["holdEndDate"] ? new Date(_data["holdEndDate"].toString()) : <any>undefined;
            this.budgAmt = _data["budgAmt"];
            this.budgFlag = _data["budgFlag"];
            this.dailyAmt = _data["dailyAmt"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.feePctAdmin = _data["feePctAdmin"];
            this.feePctPR = _data["feePctPR"];
            this.hours = _data["hours"];
            this.keyField = _data["keyField"];
            this.modifier = _data["modifier"];
            this.noteID = _data["noteID"];
            this.pmFee = _data["pmFee"];
            this.procCode = _data["procCode"];
            this.range = _data["range"];
            this.rangeA = _data["rangeA"];
            this.rangeAmt = _data["rangeAmt"];
            this.rangeUnits = _data["rangeUnits"];
            this.rate = _data["rate"];
            this.recordId = _data["recordId"];
            this.units = _data["units"];
            this.unitsDaily = _data["unitsDaily"];
            this.uom = _data["uom"];
            this.remAmt = _data["remAmt"];
            this.resAmt = _data["resAmt"];
            this.spentAmt = _data["spentAmt"];
            this.lupdBudDate = _data["lupdBudDate"] ? new Date(_data["lupdBudDate"].toString()) : <any>undefined;
            this.servCodeId = _data["servCodeId"];
            this.authHeaderId = _data["authHeaderId"];
            this.lastRefreshDate = _data["lastRefreshDate"] ? new Date(_data["lastRefreshDate"].toString()) : <any>undefined;
            this.amtRange = _data["amtRange"] ? AmtRange.fromJS(_data["amtRange"]) : <any>undefined;
            this.unitRange = _data["unitRange"] ? UnitRange.fromJS(_data["unitRange"]) : <any>undefined;
            this.authHeader = _data["authHeader"] ? AuthHeader.fromJS(_data["authHeader"]) : <any>undefined;
            this.servCode = _data["servCode"] ? ServCode.fromJS(_data["servCode"]) : <any>undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authCode"] = this.authCode;
        data["begDate"] = this.begDate ? this.begDate.toISOString() : <any>undefined;
        data["holdStDate"] = this.holdStDate ? this.holdStDate.toISOString() : <any>undefined;
        data["holdEndDate"] = this.holdEndDate ? this.holdEndDate.toISOString() : <any>undefined;
        data["budgAmt"] = this.budgAmt;
        data["budgFlag"] = this.budgFlag;
        data["dailyAmt"] = this.dailyAmt;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["feePctAdmin"] = this.feePctAdmin;
        data["feePctPR"] = this.feePctPR;
        data["hours"] = this.hours;
        data["keyField"] = this.keyField;
        data["modifier"] = this.modifier;
        data["noteID"] = this.noteID;
        data["pmFee"] = this.pmFee;
        data["procCode"] = this.procCode;
        data["range"] = this.range;
        data["rangeA"] = this.rangeA;
        data["rangeAmt"] = this.rangeAmt;
        data["rangeUnits"] = this.rangeUnits;
        data["rate"] = this.rate;
        data["recordId"] = this.recordId;
        data["units"] = this.units;
        data["unitsDaily"] = this.unitsDaily;
        data["uom"] = this.uom;
        data["remAmt"] = this.remAmt;
        data["resAmt"] = this.resAmt;
        data["spentAmt"] = this.spentAmt;
        data["lupdBudDate"] = this.lupdBudDate ? this.lupdBudDate.toISOString() : <any>undefined;
        data["servCodeId"] = this.servCodeId;
        data["authHeaderId"] = this.authHeaderId;
        data["lastRefreshDate"] = this.lastRefreshDate ? this.lastRefreshDate.toISOString() : <any>undefined;
        data["amtRange"] = this.amtRange ? this.amtRange.toJSON() : <any>undefined;
        data["unitRange"] = this.unitRange ? this.unitRange.toJSON() : <any>undefined;
        data["authHeader"] = this.authHeader ? this.authHeader.toJSON() : <any>undefined;
        data["servCode"] = this.servCode ? this.servCode.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthDetails {
    authCode?: string | undefined;
    begDate?: Date | undefined;
    holdStDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    budgAmt?: number | undefined;
    budgFlag?: string | undefined;
    dailyAmt?: number | undefined;
    endDate?: Date | undefined;
    feePctAdmin?: number | undefined;
    feePctPR?: number | undefined;
    hours?: number | undefined;
    keyField?: string | undefined;
    modifier?: string | undefined;
    noteID?: number | undefined;
    pmFee?: boolean | undefined;
    procCode?: string | undefined;
    range?: number | undefined;
    rangeA?: number | undefined;
    rangeAmt?: number | undefined;
    rangeUnits?: number | undefined;
    rate?: number | undefined;
    recordId?: number | undefined;
    units?: number | undefined;
    unitsDaily?: number | undefined;
    uom?: string | undefined;
    remAmt?: number | undefined;
    resAmt?: number | undefined;
    spentAmt?: number | undefined;
    lupdBudDate?: Date | undefined;
    servCodeId?: number | undefined;
    authHeaderId?: number;
    lastRefreshDate?: Date | undefined;
    amtRange?: AmtRange;
    unitRange?: UnitRange;
    authHeader?: AuthHeader;
    servCode?: ServCode;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class AuthHeader implements IAuthHeader {
    programId?: number;
    acn?: string | undefined;
    diagId?: number;
    custId?: number;
    agreeNumber?: string | undefined;
    begDate?: Date | undefined;
    ecmid?: number;
    endDate?: Date | undefined;
    noteId?: number | undefined;
    programType?: string | undefined;
    subAcc?: string | undefined;
    isDeleted?: boolean;
    cust?: CustEx;
    diag?: DiagCode;
    ecm?: ExCaseMgr;
    program?: Program;
    authDetails?: AuthDetails[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IAuthHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.acn = _data["acn"];
            this.diagId = _data["diagId"];
            this.custId = _data["custId"];
            this.agreeNumber = _data["agreeNumber"];
            this.begDate = _data["begDate"] ? new Date(_data["begDate"].toString()) : <any>undefined;
            this.ecmid = _data["ecmid"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.noteId = _data["noteId"];
            this.programType = _data["programType"];
            this.subAcc = _data["subAcc"];
            this.isDeleted = _data["isDeleted"];
            this.cust = _data["cust"] ? CustEx.fromJS(_data["cust"]) : <any>undefined;
            this.diag = _data["diag"] ? DiagCode.fromJS(_data["diag"]) : <any>undefined;
            this.ecm = _data["ecm"] ? ExCaseMgr.fromJS(_data["ecm"]) : <any>undefined;
            this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
            if (Array.isArray(_data["authDetails"])) {
                this.authDetails = [] as any;
                for (let item of _data["authDetails"])
                    this.authDetails!.push(AuthDetails.fromJS(item));
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AuthHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["acn"] = this.acn;
        data["diagId"] = this.diagId;
        data["custId"] = this.custId;
        data["agreeNumber"] = this.agreeNumber;
        data["begDate"] = this.begDate ? this.begDate.toISOString() : <any>undefined;
        data["ecmid"] = this.ecmid;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["noteId"] = this.noteId;
        data["programType"] = this.programType;
        data["subAcc"] = this.subAcc;
        data["isDeleted"] = this.isDeleted;
        data["cust"] = this.cust ? this.cust.toJSON() : <any>undefined;
        data["diag"] = this.diag ? this.diag.toJSON() : <any>undefined;
        data["ecm"] = this.ecm ? this.ecm.toJSON() : <any>undefined;
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        if (Array.isArray(this.authDetails)) {
            data["authDetails"] = [];
            for (let item of this.authDetails)
                data["authDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthHeader {
    programId?: number;
    acn?: string | undefined;
    diagId?: number;
    custId?: number;
    agreeNumber?: string | undefined;
    begDate?: Date | undefined;
    ecmid?: number;
    endDate?: Date | undefined;
    noteId?: number | undefined;
    programType?: string | undefined;
    subAcc?: string | undefined;
    isDeleted?: boolean;
    cust?: CustEx;
    diag?: DiagCode;
    ecm?: ExCaseMgr;
    program?: Program;
    authDetails?: AuthDetails[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class BillCode implements IBillCode {
    id?: number;
    companyId?: number;
    billCodeId?: string | undefined;
    description?: string | undefined;
    hcpcsCode?: string | undefined;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;
    isDeleted?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBillCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.billCodeId = _data["billCodeId"];
            this.description = _data["description"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.m1 = _data["m1"];
            this.m2 = _data["m2"];
            this.m3 = _data["m3"];
            this.m4 = _data["m4"];
            this.active = _data["active"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BillCode {
        data = typeof data === 'object' ? data : {};
        let result = new BillCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["billCodeId"] = this.billCodeId;
        data["description"] = this.description;
        data["hcpcsCode"] = this.hcpcsCode;
        data["m1"] = this.m1;
        data["m2"] = this.m2;
        data["m3"] = this.m3;
        data["m4"] = this.m4;
        data["active"] = this.active;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBillCode {
    id?: number;
    companyId?: number;
    billCodeId?: string | undefined;
    description?: string | undefined;
    hcpcsCode?: string | undefined;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;
    isDeleted?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BillRateModel implements IBillRateModel {
    id?: number;
    programId?: number;
    serveCodeId?: number;
    billCodeId?: number;
    beginDate?: Date;
    endDate?: Date;
    rndMethodId?: number | undefined;
    budgetItem?: string | undefined;
    isDeleted?: boolean | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    unitMethod?: number;
    billRate?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markupPC?: number | undefined;
    unitMulti?: number;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    billCode?: BillCode;
    payer?: Program;
    rndMethod?: Codes;

    constructor(data?: IBillRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.serveCodeId = _data["serveCodeId"];
            this.billCodeId = _data["billCodeId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rndMethodId = _data["rndMethodId"];
            this.budgetItem = _data["budgetItem"];
            this.isDeleted = _data["isDeleted"];
            this.authReqd = _data["authReqd"];
            this.feeExempt = _data["feeExempt"];
            this.unitMethod = _data["unitMethod"];
            this.billRate = _data["billRate"];
            this.contAllow = _data["contAllow"];
            this.maxBillRate = _data["maxBillRate"];
            this.markUp = _data["markUp"];
            this.markupPC = _data["markupPC"];
            this.unitMulti = _data["unitMulti"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.billCode = _data["billCode"] ? BillCode.fromJS(_data["billCode"]) : <any>undefined;
            this.payer = _data["payer"] ? Program.fromJS(_data["payer"]) : <any>undefined;
            this.rndMethod = _data["rndMethod"] ? Codes.fromJS(_data["rndMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BillRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["serveCodeId"] = this.serveCodeId;
        data["billCodeId"] = this.billCodeId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rndMethodId"] = this.rndMethodId;
        data["budgetItem"] = this.budgetItem;
        data["isDeleted"] = this.isDeleted;
        data["authReqd"] = this.authReqd;
        data["feeExempt"] = this.feeExempt;
        data["unitMethod"] = this.unitMethod;
        data["billRate"] = this.billRate;
        data["contAllow"] = this.contAllow;
        data["maxBillRate"] = this.maxBillRate;
        data["markUp"] = this.markUp;
        data["markupPC"] = this.markupPC;
        data["unitMulti"] = this.unitMulti;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["billCode"] = this.billCode ? this.billCode.toJSON() : <any>undefined;
        data["payer"] = this.payer ? this.payer.toJSON() : <any>undefined;
        data["rndMethod"] = this.rndMethod ? this.rndMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBillRateModel {
    id?: number;
    programId?: number;
    serveCodeId?: number;
    billCodeId?: number;
    beginDate?: Date;
    endDate?: Date;
    rndMethodId?: number | undefined;
    budgetItem?: string | undefined;
    isDeleted?: boolean | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    unitMethod?: number;
    billRate?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markupPC?: number | undefined;
    unitMulti?: number;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    billCode?: BillCode;
    payer?: Program;
    rndMethod?: Codes;
}

export class CaseLoadsList implements ICaseLoadsList {
    id?: number;
    caseLoadId?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICaseLoadsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseLoadId = _data["caseLoadId"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CaseLoadsList {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseLoadId"] = this.caseLoadId;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICaseLoadsList {
    id?: number;
    caseLoadId?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class ClaimReceiver implements IClaimReceiver {
    id?: number;
    companyId?: number | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    contact?: string | undefined;
    fedTaxId?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    receiverCode?: string | undefined;
    stateId?: number;
    user1?: string | undefined;
    zip?: string | undefined;
    tstamp?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    state?: State;

    constructor(data?: IClaimReceiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.contact = _data["contact"];
            this.fedTaxId = _data["fedTaxId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.receiverCode = _data["receiverCode"];
            this.stateId = _data["stateId"];
            this.user1 = _data["user1"];
            this.zip = _data["zip"];
            this.tstamp = _data["tstamp"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            this.state = _data["state"] ? State.fromJS(_data["state"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimReceiver {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimReceiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["contact"] = this.contact;
        data["fedTaxId"] = this.fedTaxId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["receiverCode"] = this.receiverCode;
        data["stateId"] = this.stateId;
        data["user1"] = this.user1;
        data["zip"] = this.zip;
        data["tstamp"] = this.tstamp;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimReceiver {
    id?: number;
    companyId?: number | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    contact?: string | undefined;
    fedTaxId?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    receiverCode?: string | undefined;
    stateId?: number;
    user1?: string | undefined;
    zip?: string | undefined;
    tstamp?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    state?: State;
}

export class ClientInsuranceInfo implements IClientInsuranceInfo {
    id?: number;
    custId?: number;
    payorId?: number;
    clearinghouse?: string | undefined;
    identification?: string | undefined;
    group?: string | undefined;
    isDeleted?: boolean;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: ClientRelation;
    maritalStatus?: MaritalStatus;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: Gender;
    employer?: number | undefined;
    ptStatus?: PtStatus;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: CvetBoolean;
    otherAccident?: CvetBoolean;
    employment?: CvetBoolean;
    active?: Status;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    comment?: string | undefined;
    payor?: Payor;
    cust?: CustEx;

    constructor(data?: IClientInsuranceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.payorId = _data["payorId"];
            this.clearinghouse = _data["clearinghouse"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.isDeleted = _data["isDeleted"];
            this.firstName = _data["firstName"];
            this.mi = _data["mi"];
            this.lastName = _data["lastName"];
            this.clientRelation = _data["clientRelation"];
            this.maritalStatus = _data["maritalStatus"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.employer = _data["employer"];
            this.ptStatus = _data["ptStatus"];
            this.phone = _data["phone"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.autoAccident = _data["autoAccident"];
            this.otherAccident = _data["otherAccident"];
            this.employment = _data["employment"];
            this.active = _data["active"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.payor = _data["payor"] ? Payor.fromJS(_data["payor"]) : <any>undefined;
            this.cust = _data["cust"] ? CustEx.fromJS(_data["cust"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientInsuranceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInsuranceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["payorId"] = this.payorId;
        data["clearinghouse"] = this.clearinghouse;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["isDeleted"] = this.isDeleted;
        data["firstName"] = this.firstName;
        data["mi"] = this.mi;
        data["lastName"] = this.lastName;
        data["clientRelation"] = this.clientRelation;
        data["maritalStatus"] = this.maritalStatus;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["employer"] = this.employer;
        data["ptStatus"] = this.ptStatus;
        data["phone"] = this.phone;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["autoAccident"] = this.autoAccident;
        data["otherAccident"] = this.otherAccident;
        data["employment"] = this.employment;
        data["active"] = this.active;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["payor"] = this.payor ? this.payor.toJSON() : <any>undefined;
        data["cust"] = this.cust ? this.cust.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientInsuranceInfo {
    id?: number;
    custId?: number;
    payorId?: number;
    clearinghouse?: string | undefined;
    identification?: string | undefined;
    group?: string | undefined;
    isDeleted?: boolean;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: ClientRelation;
    maritalStatus?: MaritalStatus;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: Gender;
    employer?: number | undefined;
    ptStatus?: PtStatus;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: CvetBoolean;
    otherAccident?: CvetBoolean;
    employment?: CvetBoolean;
    active?: Status;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    comment?: string | undefined;
    payor?: Payor;
    cust?: CustEx;
}

export class Codes implements ICodes {
    id?: number;
    companyId?: number | undefined;
    systemCode?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    user1?: string | undefined;
    timeStamp?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    billRate?: BillRateModel[] | undefined;

    constructor(data?: ICodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.systemCode = _data["systemCode"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.user1 = _data["user1"];
            this.timeStamp = _data["timeStamp"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["billRate"])) {
                this.billRate = [] as any;
                for (let item of _data["billRate"])
                    this.billRate!.push(BillRateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Codes {
        data = typeof data === 'object' ? data : {};
        let result = new Codes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["systemCode"] = this.systemCode;
        data["code"] = this.code;
        data["description"] = this.description;
        data["user1"] = this.user1;
        data["timeStamp"] = this.timeStamp;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.billRate)) {
            data["billRate"] = [];
            for (let item of this.billRate)
                data["billRate"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICodes {
    id?: number;
    companyId?: number | undefined;
    systemCode?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    user1?: string | undefined;
    timeStamp?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
    billRate?: BillRateModel[] | undefined;
}

export class CompanyAuth implements ICompanyAuth {
    id?: number;
    companyCode?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    account?: Account[] | undefined;
    agency?: Agency[] | undefined;
    claimReceiver?: ClaimReceiver[] | undefined;
    codes?: Codes[] | undefined;
    custEx?: CustEx[] | undefined;
    employee?: Employee[] | undefined;
    exCaseMgr?: ExCaseMgr[] | undefined;
    payor?: Payor[] | undefined;
    program?: Program[] | undefined;
    servCode?: ServCode[] | undefined;

    constructor(data?: ICompanyAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["account"])) {
                this.account = [] as any;
                for (let item of _data["account"])
                    this.account!.push(Account.fromJS(item));
            }
            if (Array.isArray(_data["agency"])) {
                this.agency = [] as any;
                for (let item of _data["agency"])
                    this.agency!.push(Agency.fromJS(item));
            }
            if (Array.isArray(_data["claimReceiver"])) {
                this.claimReceiver = [] as any;
                for (let item of _data["claimReceiver"])
                    this.claimReceiver!.push(ClaimReceiver.fromJS(item));
            }
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(Codes.fromJS(item));
            }
            if (Array.isArray(_data["custEx"])) {
                this.custEx = [] as any;
                for (let item of _data["custEx"])
                    this.custEx!.push(CustEx.fromJS(item));
            }
            if (Array.isArray(_data["employee"])) {
                this.employee = [] as any;
                for (let item of _data["employee"])
                    this.employee!.push(Employee.fromJS(item));
            }
            if (Array.isArray(_data["exCaseMgr"])) {
                this.exCaseMgr = [] as any;
                for (let item of _data["exCaseMgr"])
                    this.exCaseMgr!.push(ExCaseMgr.fromJS(item));
            }
            if (Array.isArray(_data["payor"])) {
                this.payor = [] as any;
                for (let item of _data["payor"])
                    this.payor!.push(Payor.fromJS(item));
            }
            if (Array.isArray(_data["program"])) {
                this.program = [] as any;
                for (let item of _data["program"])
                    this.program!.push(Program.fromJS(item));
            }
            if (Array.isArray(_data["servCode"])) {
                this.servCode = [] as any;
                for (let item of _data["servCode"])
                    this.servCode!.push(ServCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyAuth {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.account)) {
            data["account"] = [];
            for (let item of this.account)
                data["account"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.agency)) {
            data["agency"] = [];
            for (let item of this.agency)
                data["agency"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.claimReceiver)) {
            data["claimReceiver"] = [];
            for (let item of this.claimReceiver)
                data["claimReceiver"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.custEx)) {
            data["custEx"] = [];
            for (let item of this.custEx)
                data["custEx"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.employee)) {
            data["employee"] = [];
            for (let item of this.employee)
                data["employee"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.exCaseMgr)) {
            data["exCaseMgr"] = [];
            for (let item of this.exCaseMgr)
                data["exCaseMgr"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.payor)) {
            data["payor"] = [];
            for (let item of this.payor)
                data["payor"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.program)) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.servCode)) {
            data["servCode"] = [];
            for (let item of this.servCode)
                data["servCode"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICompanyAuth {
    id?: number;
    companyCode?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    account?: Account[] | undefined;
    agency?: Agency[] | undefined;
    claimReceiver?: ClaimReceiver[] | undefined;
    codes?: Codes[] | undefined;
    custEx?: CustEx[] | undefined;
    employee?: Employee[] | undefined;
    exCaseMgr?: ExCaseMgr[] | undefined;
    payor?: Payor[] | undefined;
    program?: Program[] | undefined;
    servCode?: ServCode[] | undefined;
}

export class Country implements ICountry {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;
    state?: State[] | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["state"])) {
                this.state = [] as any;
                for (let item of _data["state"])
                    this.state!.push(State.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICountry {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;
    state?: State[] | undefined;
}

export class CustEx implements ICustEx {
    custId?: string | undefined;
    companyId?: number;
    billCountry?: string | undefined;
    billPhone?: string | undefined;
    county?: string | undefined;
    dischargeDate?: Date;
    dischargeReason?: string | undefined;
    dob?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    status?: string | undefined;
    middleName?: string | undefined;
    payOtflag?: string | undefined;
    pcid?: string | undefined;
    phone?: string | undefined;
    prrelation?: string | undefined;
    region?: string | undefined;
    visitraxId?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    authHeader?: AuthHeader[] | undefined;
    clientInsuranceInfo?: ClientInsuranceInfo[] | undefined;
    payRate?: PayRate[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: ICustEx) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custId = _data["custId"];
            this.companyId = _data["companyId"];
            this.billCountry = _data["billCountry"];
            this.billPhone = _data["billPhone"];
            this.county = _data["county"];
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.dischargeReason = _data["dischargeReason"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.status = _data["status"];
            this.middleName = _data["middleName"];
            this.payOtflag = _data["payOtflag"];
            this.pcid = _data["pcid"];
            this.phone = _data["phone"];
            this.prrelation = _data["prrelation"];
            this.region = _data["region"];
            this.visitraxId = _data["visitraxId"];
            this.isDeleted = _data["isDeleted"];
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["authHeader"])) {
                this.authHeader = [] as any;
                for (let item of _data["authHeader"])
                    this.authHeader!.push(AuthHeader.fromJS(item));
            }
            if (Array.isArray(_data["clientInsuranceInfo"])) {
                this.clientInsuranceInfo = [] as any;
                for (let item of _data["clientInsuranceInfo"])
                    this.clientInsuranceInfo!.push(ClientInsuranceInfo.fromJS(item));
            }
            if (Array.isArray(_data["payRate"])) {
                this.payRate = [] as any;
                for (let item of _data["payRate"])
                    this.payRate!.push(PayRate.fromJS(item));
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustEx {
        data = typeof data === 'object' ? data : {};
        let result = new CustEx();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custId"] = this.custId;
        data["companyId"] = this.companyId;
        data["billCountry"] = this.billCountry;
        data["billPhone"] = this.billPhone;
        data["county"] = this.county;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["dischargeReason"] = this.dischargeReason;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["status"] = this.status;
        data["middleName"] = this.middleName;
        data["payOtflag"] = this.payOtflag;
        data["pcid"] = this.pcid;
        data["phone"] = this.phone;
        data["prrelation"] = this.prrelation;
        data["region"] = this.region;
        data["visitraxId"] = this.visitraxId;
        data["isDeleted"] = this.isDeleted;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.authHeader)) {
            data["authHeader"] = [];
            for (let item of this.authHeader)
                data["authHeader"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.clientInsuranceInfo)) {
            data["clientInsuranceInfo"] = [];
            for (let item of this.clientInsuranceInfo)
                data["clientInsuranceInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.payRate)) {
            data["payRate"] = [];
            for (let item of this.payRate)
                data["payRate"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustEx {
    custId?: string | undefined;
    companyId?: number;
    billCountry?: string | undefined;
    billPhone?: string | undefined;
    county?: string | undefined;
    dischargeDate?: Date;
    dischargeReason?: string | undefined;
    dob?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    status?: string | undefined;
    middleName?: string | undefined;
    payOtflag?: string | undefined;
    pcid?: string | undefined;
    phone?: string | undefined;
    prrelation?: string | undefined;
    region?: string | undefined;
    visitraxId?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    authHeader?: AuthHeader[] | undefined;
    clientInsuranceInfo?: ClientInsuranceInfo[] | undefined;
    payRate?: PayRate[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class DiagCode implements IDiagCode {
    description?: string | undefined;
    diagCode1?: string | undefined;
    active?: string | undefined;
    isDeleted?: boolean;
    authHeader?: AuthHeader[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IDiagCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.diagCode1 = _data["diagCode1"];
            this.active = _data["active"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["authHeader"])) {
                this.authHeader = [] as any;
                for (let item of _data["authHeader"])
                    this.authHeader!.push(AuthHeader.fromJS(item));
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DiagCode {
        data = typeof data === 'object' ? data : {};
        let result = new DiagCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["diagCode1"] = this.diagCode1;
        data["active"] = this.active;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.authHeader)) {
            data["authHeader"] = [];
            for (let item of this.authHeader)
                data["authHeader"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDiagCode {
    description?: string | undefined;
    diagCode1?: string | undefined;
    active?: string | undefined;
    isDeleted?: boolean;
    authHeader?: AuthHeader[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class EINDetails implements IEINDetails {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    einId?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;

    constructor(data?: IEINDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.einId = _data["einId"];
            this.ein = _data["ein"];
            this.ssn = _data["ssn"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): EINDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EINDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["einId"] = this.einId;
        data["ein"] = this.ein;
        data["ssn"] = this.ssn;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["state"] = this.state;
        return data;
    }
}

export interface IEINDetails {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    einId?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
}

export class EinList implements IEinList {
    id?: number;
    ein?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    status?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    relation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IEinList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ein = _data["ein"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.relation = _data["relation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): EinList {
        data = typeof data === 'object' ? data : {};
        let result = new EinList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ein"] = this.ein;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["relation"] = this.relation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IEinList {
    id?: number;
    ein?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    status?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    relation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class EmpModel implements IEmpModel {
    id?: number;
    empId?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    relationshipType?: string | undefined;

    constructor(data?: IEmpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.relationshipType = _data["relationshipType"];
        }
    }

    static fromJS(data: any): EmpModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["relationshipType"] = this.relationshipType;
        return data;
    }
}

export interface IEmpModel {
    id?: number;
    empId?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    relationshipType?: string | undefined;
}

export class Employee implements IEmployee {
    id?: number;
    empId?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    email?: string | undefined;
    birthDate?: Date;
    calYr?: string | undefined;
    ssn?: string | undefined;
    currStdUnitRate?: number;
    department?: string | undefined;
    dfltEarnType?: string | undefined;
    dfltExpAcct?: string | undefined;
    dfltExpSub?: string | undefined;
    dfltOthrExmpt?: number;
    dfltPersExmpt?: number;
    dfltWrkloc?: string | undefined;
    directDeposit?: string | undefined;
    endDate?: Date;
    hireAct?: number;
    lastPaidDate?: Date;
    magW2?: number;
    marStat?: string | undefined;
    maxGarnWarn?: number;
    medGovtEmpl?: number;
    noteId?: number | undefined;
    payGrpId?: string | undefined;
    payType?: string | undefined;
    percentDispEarn?: number;
    status?: string | undefined;
    statutory?: number;
    stdSlry?: number;
    stdUnitRate?: number;
    strtDate?: Date;
    ytdEarn?: number;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    country?: number;
    state?: number;
    zip?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.calYr = _data["calYr"];
            this.ssn = _data["ssn"];
            this.currStdUnitRate = _data["currStdUnitRate"];
            this.department = _data["department"];
            this.dfltEarnType = _data["dfltEarnType"];
            this.dfltExpAcct = _data["dfltExpAcct"];
            this.dfltExpSub = _data["dfltExpSub"];
            this.dfltOthrExmpt = _data["dfltOthrExmpt"];
            this.dfltPersExmpt = _data["dfltPersExmpt"];
            this.dfltWrkloc = _data["dfltWrkloc"];
            this.directDeposit = _data["directDeposit"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hireAct = _data["hireAct"];
            this.lastPaidDate = _data["lastPaidDate"] ? new Date(_data["lastPaidDate"].toString()) : <any>undefined;
            this.magW2 = _data["magW2"];
            this.marStat = _data["marStat"];
            this.maxGarnWarn = _data["maxGarnWarn"];
            this.medGovtEmpl = _data["medGovtEmpl"];
            this.noteId = _data["noteId"];
            this.payGrpId = _data["payGrpId"];
            this.payType = _data["payType"];
            this.percentDispEarn = _data["percentDispEarn"];
            this.status = _data["status"];
            this.statutory = _data["statutory"];
            this.stdSlry = _data["stdSlry"];
            this.stdUnitRate = _data["stdUnitRate"];
            this.strtDate = _data["strtDate"] ? new Date(_data["strtDate"].toString()) : <any>undefined;
            this.ytdEarn = _data["ytdEarn"];
            this.phone = _data["phone"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["calYr"] = this.calYr;
        data["ssn"] = this.ssn;
        data["currStdUnitRate"] = this.currStdUnitRate;
        data["department"] = this.department;
        data["dfltEarnType"] = this.dfltEarnType;
        data["dfltExpAcct"] = this.dfltExpAcct;
        data["dfltExpSub"] = this.dfltExpSub;
        data["dfltOthrExmpt"] = this.dfltOthrExmpt;
        data["dfltPersExmpt"] = this.dfltPersExmpt;
        data["dfltWrkloc"] = this.dfltWrkloc;
        data["directDeposit"] = this.directDeposit;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hireAct"] = this.hireAct;
        data["lastPaidDate"] = this.lastPaidDate ? this.lastPaidDate.toISOString() : <any>undefined;
        data["magW2"] = this.magW2;
        data["marStat"] = this.marStat;
        data["maxGarnWarn"] = this.maxGarnWarn;
        data["medGovtEmpl"] = this.medGovtEmpl;
        data["noteId"] = this.noteId;
        data["payGrpId"] = this.payGrpId;
        data["payType"] = this.payType;
        data["percentDispEarn"] = this.percentDispEarn;
        data["status"] = this.status;
        data["statutory"] = this.statutory;
        data["stdSlry"] = this.stdSlry;
        data["stdUnitRate"] = this.stdUnitRate;
        data["strtDate"] = this.strtDate ? this.strtDate.toISOString() : <any>undefined;
        data["ytdEarn"] = this.ytdEarn;
        data["phone"] = this.phone;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["country"] = this.country;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployee {
    id?: number;
    empId?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    email?: string | undefined;
    birthDate?: Date;
    calYr?: string | undefined;
    ssn?: string | undefined;
    currStdUnitRate?: number;
    department?: string | undefined;
    dfltEarnType?: string | undefined;
    dfltExpAcct?: string | undefined;
    dfltExpSub?: string | undefined;
    dfltOthrExmpt?: number;
    dfltPersExmpt?: number;
    dfltWrkloc?: string | undefined;
    directDeposit?: string | undefined;
    endDate?: Date;
    hireAct?: number;
    lastPaidDate?: Date;
    magW2?: number;
    marStat?: string | undefined;
    maxGarnWarn?: number;
    medGovtEmpl?: number;
    noteId?: number | undefined;
    payGrpId?: string | undefined;
    payType?: string | undefined;
    percentDispEarn?: number;
    status?: string | undefined;
    statutory?: number;
    stdSlry?: number;
    stdUnitRate?: number;
    strtDate?: Date;
    ytdEarn?: number;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    country?: number;
    state?: number;
    zip?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    company?: CompanyAuth;
}

export class EmployeeDetails implements IEmployeeDetails {
    id?: number;
    name?: string | undefined;
    dob?: Date;
    empId?: string | undefined;
    hireDate?: Date;
    phone?: string | undefined;
    emailId?: string | undefined;
    ssn?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    gender?: string | undefined;
    stateId?: number | undefined;
    stateName?: string | undefined;

    constructor(data?: IEmployeeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.empId = _data["empId"];
            this.hireDate = _data["hireDate"] ? new Date(_data["hireDate"].toString()) : <any>undefined;
            this.phone = _data["phone"];
            this.emailId = _data["emailId"];
            this.ssn = _data["ssn"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.gender = _data["gender"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): EmployeeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["empId"] = this.empId;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["emailId"] = this.emailId;
        data["ssn"] = this.ssn;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["gender"] = this.gender;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IEmployeeDetails {
    id?: number;
    name?: string | undefined;
    dob?: Date;
    empId?: string | undefined;
    hireDate?: Date;
    phone?: string | undefined;
    emailId?: string | undefined;
    ssn?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    gender?: string | undefined;
    stateId?: number | undefined;
    stateName?: string | undefined;
}

export class ExCaseMgr implements IExCaseMgr {
    ecmexId?: string | undefined;
    companyId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    attn?: string | undefined;
    payorId?: number;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    noteId?: number | undefined;
    phone?: string | undefined;
    stateId?: number;
    active?: string | undefined;
    vendId?: number;
    zip?: string | undefined;
    isDeleted?: boolean;
    programId?: number;
    comment?: string | undefined;
    company?: CompanyAuth;
    program?: Program;
    authHeader?: AuthHeader[] | undefined;
    programTypeDetails?: ExCmProgramType[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IExCaseMgr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ecmexId = _data["ecmexId"];
            this.companyId = _data["companyId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.attn = _data["attn"];
            this.payorId = _data["payorId"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.emailAddress = _data["emailAddress"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.noteId = _data["noteId"];
            this.phone = _data["phone"];
            this.stateId = _data["stateId"];
            this.active = _data["active"];
            this.vendId = _data["vendId"];
            this.zip = _data["zip"];
            this.isDeleted = _data["isDeleted"];
            this.programId = _data["programId"];
            this.comment = _data["comment"];
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
            if (Array.isArray(_data["authHeader"])) {
                this.authHeader = [] as any;
                for (let item of _data["authHeader"])
                    this.authHeader!.push(AuthHeader.fromJS(item));
            }
            if (Array.isArray(_data["programTypeDetails"])) {
                this.programTypeDetails = [] as any;
                for (let item of _data["programTypeDetails"])
                    this.programTypeDetails!.push(ExCmProgramType.fromJS(item));
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExCaseMgr {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ecmexId"] = this.ecmexId;
        data["companyId"] = this.companyId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["attn"] = this.attn;
        data["payorId"] = this.payorId;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["emailAddress"] = this.emailAddress;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["noteId"] = this.noteId;
        data["phone"] = this.phone;
        data["stateId"] = this.stateId;
        data["active"] = this.active;
        data["vendId"] = this.vendId;
        data["zip"] = this.zip;
        data["isDeleted"] = this.isDeleted;
        data["programId"] = this.programId;
        data["comment"] = this.comment;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        if (Array.isArray(this.authHeader)) {
            data["authHeader"] = [];
            for (let item of this.authHeader)
                data["authHeader"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.programTypeDetails)) {
            data["programTypeDetails"] = [];
            for (let item of this.programTypeDetails)
                data["programTypeDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExCaseMgr {
    ecmexId?: string | undefined;
    companyId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    attn?: string | undefined;
    payorId?: number;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    noteId?: number | undefined;
    phone?: string | undefined;
    stateId?: number;
    active?: string | undefined;
    vendId?: number;
    zip?: string | undefined;
    isDeleted?: boolean;
    programId?: number;
    comment?: string | undefined;
    company?: CompanyAuth;
    program?: Program;
    authHeader?: AuthHeader[] | undefined;
    programTypeDetails?: ExCmProgramType[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class ExCmProgramType implements IExCmProgramType {
    id?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    ecmid?: string | undefined;
    programTypeId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IExCmProgramType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.ecmid = _data["ecmid"];
            this.programTypeId = _data["programTypeId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExCmProgramType {
        data = typeof data === 'object' ? data : {};
        let result = new ExCmProgramType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["ecmid"] = this.ecmid;
        data["programTypeId"] = this.programTypeId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExCmProgramType {
    id?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    ecmid?: string | undefined;
    programTypeId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class FundingSourceByIdResponse implements IFundingSourceByIdResponse {
    id?: number;
    fundingSource?: string | undefined;
    description?: string | undefined;
    companyId?: number;
    active?: string | undefined;

    constructor(data?: IFundingSourceByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fundingSource = _data["fundingSource"];
            this.description = _data["description"];
            this.companyId = _data["companyId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): FundingSourceByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FundingSourceByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fundingSource"] = this.fundingSource;
        data["description"] = this.description;
        data["companyId"] = this.companyId;
        data["active"] = this.active;
        return data;
    }
}

export interface IFundingSourceByIdResponse {
    id?: number;
    fundingSource?: string | undefined;
    description?: string | undefined;
    companyId?: number;
    active?: string | undefined;
}

export class FundingSourceResponse implements IFundingSourceResponse {
    id?: number;
    fundingSource?: string | undefined;
    description?: string | undefined;
    isActive?: string | undefined;
    company?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IFundingSourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fundingSource = _data["fundingSource"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.company = _data["company"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FundingSourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FundingSourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fundingSource"] = this.fundingSource;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["company"] = this.company;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFundingSourceResponse {
    id?: number;
    fundingSource?: string | undefined;
    description?: string | undefined;
    isActive?: string | undefined;
    company?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class Participants implements IParticipants {
    id?: number;
    participantId?: string | undefined;
    name?: string | undefined;
    insurerId?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IParticipants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.name = _data["name"];
            this.insurerId = _data["insurerId"];
            this.emailId = _data["emailId"];
            this.agencyId = _data["agencyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): Participants {
        data = typeof data === 'object' ? data : {};
        let result = new Participants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["name"] = this.name;
        data["insurerId"] = this.insurerId;
        data["emailId"] = this.emailId;
        data["agencyId"] = this.agencyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IParticipants {
    id?: number;
    participantId?: string | undefined;
    name?: string | undefined;
    insurerId?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class ParticipantsDetails implements IParticipantsDetails {
    id?: number;
    participantId?: string | undefined;
    insuredId?: string | undefined;
    waiverCode?: string | undefined;
    waiverName?: string | undefined;
    dob?: Date | undefined;
    ssn?: string | undefined;
    fipsCode?: string | undefined;
    agencyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    agency?: string | undefined;
    primaryPhone?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    emailId?: string | undefined;
    readonly addresses?: AddressDTO[] | undefined;
    employeeResponse?: EmpModel[] | undefined;
    employerAdminResponses?: EinList[] | undefined;
    agencyAdminResponse?: AgencyAdminDetails[] | undefined;
    serviceFacilitatorResponse?: SFDetails[] | undefined;

    constructor(data?: IParticipantsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.insuredId = _data["insuredId"];
            this.waiverCode = _data["waiverCode"];
            this.waiverName = _data["waiverName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.fipsCode = _data["fipsCode"];
            this.agencyId = _data["agencyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.agency = _data["agency"];
            this.primaryPhone = _data["primaryPhone"];
            this.homePhone = _data["homePhone"];
            this.cellPhone = _data["cellPhone"];
            this.emailId = _data["emailId"];
            if (Array.isArray(_data["addresses"])) {
                (<any>this).addresses = [] as any;
                for (let item of _data["addresses"])
                    (<any>this).addresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["employeeResponse"])) {
                this.employeeResponse = [] as any;
                for (let item of _data["employeeResponse"])
                    this.employeeResponse!.push(EmpModel.fromJS(item));
            }
            if (Array.isArray(_data["employerAdminResponses"])) {
                this.employerAdminResponses = [] as any;
                for (let item of _data["employerAdminResponses"])
                    this.employerAdminResponses!.push(EinList.fromJS(item));
            }
            if (Array.isArray(_data["agencyAdminResponse"])) {
                this.agencyAdminResponse = [] as any;
                for (let item of _data["agencyAdminResponse"])
                    this.agencyAdminResponse!.push(AgencyAdminDetails.fromJS(item));
            }
            if (Array.isArray(_data["serviceFacilitatorResponse"])) {
                this.serviceFacilitatorResponse = [] as any;
                for (let item of _data["serviceFacilitatorResponse"])
                    this.serviceFacilitatorResponse!.push(SFDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["insuredId"] = this.insuredId;
        data["waiverCode"] = this.waiverCode;
        data["waiverName"] = this.waiverName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["fipsCode"] = this.fipsCode;
        data["agencyId"] = this.agencyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["agency"] = this.agency;
        data["primaryPhone"] = this.primaryPhone;
        data["homePhone"] = this.homePhone;
        data["cellPhone"] = this.cellPhone;
        data["emailId"] = this.emailId;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.employeeResponse)) {
            data["employeeResponse"] = [];
            for (let item of this.employeeResponse)
                data["employeeResponse"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.employerAdminResponses)) {
            data["employerAdminResponses"] = [];
            for (let item of this.employerAdminResponses)
                data["employerAdminResponses"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.agencyAdminResponse)) {
            data["agencyAdminResponse"] = [];
            for (let item of this.agencyAdminResponse)
                data["agencyAdminResponse"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.serviceFacilitatorResponse)) {
            data["serviceFacilitatorResponse"] = [];
            for (let item of this.serviceFacilitatorResponse)
                data["serviceFacilitatorResponse"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IParticipantsDetails {
    id?: number;
    participantId?: string | undefined;
    insuredId?: string | undefined;
    waiverCode?: string | undefined;
    waiverName?: string | undefined;
    dob?: Date | undefined;
    ssn?: string | undefined;
    fipsCode?: string | undefined;
    agencyId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    agency?: string | undefined;
    primaryPhone?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    emailId?: string | undefined;
    addresses?: AddressDTO[] | undefined;
    employeeResponse?: EmpModel[] | undefined;
    employerAdminResponses?: EinList[] | undefined;
    agencyAdminResponse?: AgencyAdminDetails[] | undefined;
    serviceFacilitatorResponse?: SFDetails[] | undefined;
}

export class ParticipantsList implements IParticipantsList {
    id?: number;
    participantId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    insuredId?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    caseLoads?: CaseLoadsList[] | undefined;
    sfUsers?: SFParticipantModel[] | undefined;

    constructor(data?: IParticipantsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.insuredId = _data["insuredId"];
            this.emailId = _data["emailId"];
            this.agencyId = _data["agencyId"];
            if (Array.isArray(_data["caseLoads"])) {
                this.caseLoads = [] as any;
                for (let item of _data["caseLoads"])
                    this.caseLoads!.push(CaseLoadsList.fromJS(item));
            }
            if (Array.isArray(_data["sfUsers"])) {
                this.sfUsers = [] as any;
                for (let item of _data["sfUsers"])
                    this.sfUsers!.push(SFParticipantModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantsList {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["insuredId"] = this.insuredId;
        data["emailId"] = this.emailId;
        data["agencyId"] = this.agencyId;
        if (Array.isArray(this.caseLoads)) {
            data["caseLoads"] = [];
            for (let item of this.caseLoads)
                data["caseLoads"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.sfUsers)) {
            data["sfUsers"] = [];
            for (let item of this.sfUsers)
                data["sfUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IParticipantsList {
    id?: number;
    participantId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    insuredId?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    caseLoads?: CaseLoadsList[] | undefined;
    sfUsers?: SFParticipantModel[] | undefined;
}

export class PayRate implements IPayRate {
    crtdDateTime?: Date | undefined;
    crtdProg?: string | undefined;
    crtdUser?: string | undefined;
    custId?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    daysValid?: string | undefined;
    earnType?: string | undefined;
    empId?: number;
    hcpcs?: number | undefined;
    lupdDateTime?: Date | undefined;
    lupdUser?: string | undefined;
    muflag?: string | undefined;
    noteId?: number | undefined;
    otflag?: string | undefined;
    ratePay?: number | undefined;
    ratePayHoliMulti?: number | undefined;
    rndMethod?: string | undefined;
    servCode?: number;
    status?: string | undefined;
    timeBegin?: string | undefined;
    timeEnd?: string | undefined;
    unitType?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    comment?: string | undefined;
    isDeleted?: boolean | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    cust?: CustEx;

    constructor(data?: IPayRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crtdDateTime = _data["crtdDateTime"] ? new Date(_data["crtdDateTime"].toString()) : <any>undefined;
            this.crtdProg = _data["crtdProg"];
            this.crtdUser = _data["crtdUser"];
            this.custId = _data["custId"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.daysValid = _data["daysValid"];
            this.earnType = _data["earnType"];
            this.empId = _data["empId"];
            this.hcpcs = _data["hcpcs"];
            this.lupdDateTime = _data["lupdDateTime"] ? new Date(_data["lupdDateTime"].toString()) : <any>undefined;
            this.lupdUser = _data["lupdUser"];
            this.muflag = _data["muflag"];
            this.noteId = _data["noteId"];
            this.otflag = _data["otflag"];
            this.ratePay = _data["ratePay"];
            this.ratePayHoliMulti = _data["ratePayHoliMulti"];
            this.rndMethod = _data["rndMethod"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.timeBegin = _data["timeBegin"];
            this.timeEnd = _data["timeEnd"];
            this.unitType = _data["unitType"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.cust = _data["cust"] ? CustEx.fromJS(_data["cust"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayRate {
        data = typeof data === 'object' ? data : {};
        let result = new PayRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crtdDateTime"] = this.crtdDateTime ? this.crtdDateTime.toISOString() : <any>undefined;
        data["crtdProg"] = this.crtdProg;
        data["crtdUser"] = this.crtdUser;
        data["custId"] = this.custId;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["daysValid"] = this.daysValid;
        data["earnType"] = this.earnType;
        data["empId"] = this.empId;
        data["hcpcs"] = this.hcpcs;
        data["lupdDateTime"] = this.lupdDateTime ? this.lupdDateTime.toISOString() : <any>undefined;
        data["lupdUser"] = this.lupdUser;
        data["muflag"] = this.muflag;
        data["noteId"] = this.noteId;
        data["otflag"] = this.otflag;
        data["ratePay"] = this.ratePay;
        data["ratePayHoliMulti"] = this.ratePayHoliMulti;
        data["rndMethod"] = this.rndMethod;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["timeBegin"] = this.timeBegin;
        data["timeEnd"] = this.timeEnd;
        data["unitType"] = this.unitType;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["cust"] = this.cust ? this.cust.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayRate {
    crtdDateTime?: Date | undefined;
    crtdProg?: string | undefined;
    crtdUser?: string | undefined;
    custId?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    daysValid?: string | undefined;
    earnType?: string | undefined;
    empId?: number;
    hcpcs?: number | undefined;
    lupdDateTime?: Date | undefined;
    lupdUser?: string | undefined;
    muflag?: string | undefined;
    noteId?: number | undefined;
    otflag?: string | undefined;
    ratePay?: number | undefined;
    ratePayHoliMulti?: number | undefined;
    rndMethod?: string | undefined;
    servCode?: number;
    status?: string | undefined;
    timeBegin?: string | undefined;
    timeEnd?: string | undefined;
    unitType?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    comment?: string | undefined;
    isDeleted?: boolean | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    cust?: CustEx;
}

export class PayRateModel implements IPayRateModel {
    servCodeId?: number;
    servCode?: string | undefined;
    description?: string | undefined;
    displayValue?: string | undefined;
    ratePay?: number | undefined;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    payCalc?: PayCalcMethod;
    caregiverEmployerMappingId?: number;
    participantEmployerMappingId?: number;

    constructor(data?: IPayRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.ratePay = _data["ratePay"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverId = _data["caregiverId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.payCalc = _data["payCalc"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.participantEmployerMappingId = _data["participantEmployerMappingId"];
        }
    }

    static fromJS(data: any): PayRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["ratePay"] = this.ratePay;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["caregiverId"] = this.caregiverId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["payCalc"] = this.payCalc;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["participantEmployerMappingId"] = this.participantEmployerMappingId;
        return data;
    }
}

export interface IPayRateModel {
    servCodeId?: number;
    servCode?: string | undefined;
    description?: string | undefined;
    displayValue?: string | undefined;
    ratePay?: number | undefined;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    payCalc?: PayCalcMethod;
    caregiverEmployerMappingId?: number;
    participantEmployerMappingId?: number;
}

export class Payor implements IPayor {
    id?: number;
    companyId?: number | undefined;
    payorId?: string | undefined;
    payorName?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    active?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDate?: DayOfWeek;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    state?: State;
    clientInsuranceInfo?: ClientInsuranceInfo[] | undefined;
    lateServiceThresholdDays?: number | undefined;

    constructor(data?: IPayor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.contactName = _data["contactName"];
            this.emailId = _data["emailId"];
            this.active = _data["active"];
            this.phone = _data["phone"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.comment = _data["comment"];
            this.weekStartingDate = _data["weekStartingDate"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            this.state = _data["state"] ? State.fromJS(_data["state"]) : <any>undefined;
            if (Array.isArray(_data["clientInsuranceInfo"])) {
                this.clientInsuranceInfo = [] as any;
                for (let item of _data["clientInsuranceInfo"])
                    this.clientInsuranceInfo!.push(ClientInsuranceInfo.fromJS(item));
            }
            this.lateServiceThresholdDays = _data["lateServiceThresholdDays"];
        }
    }

    static fromJS(data: any): Payor {
        data = typeof data === 'object' ? data : {};
        let result = new Payor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["contactName"] = this.contactName;
        data["emailId"] = this.emailId;
        data["active"] = this.active;
        data["phone"] = this.phone;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["comment"] = this.comment;
        data["weekStartingDate"] = this.weekStartingDate;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        if (Array.isArray(this.clientInsuranceInfo)) {
            data["clientInsuranceInfo"] = [];
            for (let item of this.clientInsuranceInfo)
                data["clientInsuranceInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        data["lateServiceThresholdDays"] = this.lateServiceThresholdDays;
        return data;
    }
}

export interface IPayor {
    id?: number;
    companyId?: number | undefined;
    payorId?: string | undefined;
    payorName?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    active?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDate?: DayOfWeek;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    state?: State;
    clientInsuranceInfo?: ClientInsuranceInfo[] | undefined;
    lateServiceThresholdDays?: number | undefined;
}

export class PortalUserRequest implements IPortalUserRequest {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailId?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    ssn?: string | undefined;

    constructor(data?: IPortalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailId = _data["emailId"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): PortalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailId"] = this.emailId;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IPortalUserRequest {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailId?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    ssn?: string | undefined;
}

export class Program implements IProgram {
    progNbr?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    payorId?: number;
    npi?: string | undefined;
    fedTaxID?: string | undefined;
    submitNbr?: string | undefined;
    taxonomy?: string | undefined;
    fundingTypeId?: number;
    fundingSourceId?: number;
    programTypeId?: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    custEx?: CustEx[] | undefined;
    authHeader?: AuthHeader[] | undefined;
    receiverId?: string | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progNbr = _data["progNbr"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.payorId = _data["payorId"];
            this.npi = _data["npi"];
            this.fedTaxID = _data["fedTaxID"];
            this.submitNbr = _data["submitNbr"];
            this.taxonomy = _data["taxonomy"];
            this.fundingTypeId = _data["fundingTypeId"];
            this.fundingSourceId = _data["fundingSourceId"];
            this.programTypeId = _data["programTypeId"];
            this.contactName = _data["contactName"];
            this.phone = _data["phone"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["custEx"])) {
                this.custEx = [] as any;
                for (let item of _data["custEx"])
                    this.custEx!.push(CustEx.fromJS(item));
            }
            if (Array.isArray(_data["authHeader"])) {
                this.authHeader = [] as any;
                for (let item of _data["authHeader"])
                    this.authHeader!.push(AuthHeader.fromJS(item));
            }
            this.receiverId = _data["receiverId"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Program {
        data = typeof data === 'object' ? data : {};
        let result = new Program();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progNbr"] = this.progNbr;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["payorId"] = this.payorId;
        data["npi"] = this.npi;
        data["fedTaxID"] = this.fedTaxID;
        data["submitNbr"] = this.submitNbr;
        data["taxonomy"] = this.taxonomy;
        data["fundingTypeId"] = this.fundingTypeId;
        data["fundingSourceId"] = this.fundingSourceId;
        data["programTypeId"] = this.programTypeId;
        data["contactName"] = this.contactName;
        data["phone"] = this.phone;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["email"] = this.email;
        data["active"] = this.active;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.custEx)) {
            data["custEx"] = [];
            for (let item of this.custEx)
                data["custEx"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.authHeader)) {
            data["authHeader"] = [];
            for (let item of this.authHeader)
                data["authHeader"].push(item ? item.toJSON() : <any>undefined);
        }
        data["receiverId"] = this.receiverId;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgram {
    progNbr?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    payorId?: number;
    npi?: string | undefined;
    fedTaxID?: string | undefined;
    submitNbr?: string | undefined;
    taxonomy?: string | undefined;
    fundingTypeId?: number;
    fundingSourceId?: number;
    programTypeId?: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    custEx?: CustEx[] | undefined;
    authHeader?: AuthHeader[] | undefined;
    receiverId?: string | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class SFDetails implements ISFDetails {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ISFDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SFDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SFDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISFDetails {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class SFParticipantModel implements ISFParticipantModel {
    id?: number;
    name?: string | undefined;
    sfUserId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ISFParticipantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sfUserId = _data["sfUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SFParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new SFParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sfUserId"] = this.sfUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISFParticipantModel {
    id?: number;
    name?: string | undefined;
    sfUserId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class SFResponseModel implements ISFResponseModel {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    caseLoads?: CaseLoadsList[] | undefined;
    participantsCount?: number;

    constructor(data?: ISFResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["caseLoads"])) {
                this.caseLoads = [] as any;
                for (let item of _data["caseLoads"])
                    this.caseLoads!.push(CaseLoadsList.fromJS(item));
            }
            this.participantsCount = _data["participantsCount"];
        }
    }

    static fromJS(data: any): SFResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SFResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.caseLoads)) {
            data["caseLoads"] = [];
            for (let item of this.caseLoads)
                data["caseLoads"].push(item ? item.toJSON() : <any>undefined);
        }
        data["participantsCount"] = this.participantsCount;
        return data;
    }
}

export interface ISFResponseModel {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    caseLoads?: CaseLoadsList[] | undefined;
    participantsCount?: number;
}

export class SFUserModel implements ISFUserModel {
    sfId?: string | undefined;
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ISFUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sfId = _data["sfId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SFUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SFUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sfId"] = this.sfId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISFUserModel {
    sfId?: string | undefined;
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class ServCode implements IServCode {
    companyId?: number;
    description?: string | undefined;
    masterCode?: number | undefined;
    otflag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    servCode1?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number | undefined;
    serviceType?: number | undefined;
    displayValue?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    authDetails?: AuthDetails[] | undefined;
    billRate?: BillRateModel[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IServCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.masterCode = _data["masterCode"];
            this.otflag = _data["otflag"];
            this.okToWorkExemptFlag = _data["okToWorkExemptFlag"];
            this.servCode1 = _data["servCode1"];
            this.status = _data["status"];
            this.unitType = _data["unitType"];
            this.payCalculationMethod = _data["payCalculationMethod"];
            this.serviceType = _data["serviceType"];
            this.displayValue = _data["displayValue"];
            this.isDeleted = _data["isDeleted"];
            this.company = _data["company"] ? CompanyAuth.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["authDetails"])) {
                this.authDetails = [] as any;
                for (let item of _data["authDetails"])
                    this.authDetails!.push(AuthDetails.fromJS(item));
            }
            if (Array.isArray(_data["billRate"])) {
                this.billRate = [] as any;
                for (let item of _data["billRate"])
                    this.billRate!.push(BillRateModel.fromJS(item));
            }
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServCode {
        data = typeof data === 'object' ? data : {};
        let result = new ServCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["masterCode"] = this.masterCode;
        data["otflag"] = this.otflag;
        data["okToWorkExemptFlag"] = this.okToWorkExemptFlag;
        data["servCode1"] = this.servCode1;
        data["status"] = this.status;
        data["unitType"] = this.unitType;
        data["payCalculationMethod"] = this.payCalculationMethod;
        data["serviceType"] = this.serviceType;
        data["displayValue"] = this.displayValue;
        data["isDeleted"] = this.isDeleted;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.authDetails)) {
            data["authDetails"] = [];
            for (let item of this.authDetails)
                data["authDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billRate)) {
            data["billRate"] = [];
            for (let item of this.billRate)
                data["billRate"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServCode {
    companyId?: number;
    description?: string | undefined;
    masterCode?: number | undefined;
    otflag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    servCode1?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number | undefined;
    serviceType?: number | undefined;
    displayValue?: string | undefined;
    isDeleted?: boolean;
    company?: CompanyAuth;
    authDetails?: AuthDetails[] | undefined;
    billRate?: BillRateModel[] | undefined;
    id?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class ServCodeDocTypeModel implements IServCodeDocTypeModel {
    servCode?: string | undefined;
    docTypeCode?: string | undefined;

    constructor(data?: IServCodeDocTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.docTypeCode = _data["docTypeCode"];
        }
    }

    static fromJS(data: any): ServCodeDocTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeDocTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["docTypeCode"] = this.docTypeCode;
        return data;
    }
}

export interface IServCodeDocTypeModel {
    servCode?: string | undefined;
    docTypeCode?: string | undefined;
}

export class ServiceCodePrerequisites implements IServiceCodePrerequisites {
    serviceCodePrerequisiteId?: number;
    servCodeId?: number;
    servCode?: string | undefined;
    evalType?: ServCodePrerequisiteEvalType;
    prerequisiteServCodeId?: number;
    prerequisiteServCode?: string | undefined;

    constructor(data?: IServiceCodePrerequisites) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodePrerequisiteId = _data["serviceCodePrerequisiteId"];
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.evalType = _data["evalType"];
            this.prerequisiteServCodeId = _data["prerequisiteServCodeId"];
            this.prerequisiteServCode = _data["prerequisiteServCode"];
        }
    }

    static fromJS(data: any): ServiceCodePrerequisites {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodePrerequisites();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodePrerequisiteId"] = this.serviceCodePrerequisiteId;
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["evalType"] = this.evalType;
        data["prerequisiteServCodeId"] = this.prerequisiteServCodeId;
        data["prerequisiteServCode"] = this.prerequisiteServCode;
        return data;
    }
}

export interface IServiceCodePrerequisites {
    serviceCodePrerequisiteId?: number;
    servCodeId?: number;
    servCode?: string | undefined;
    evalType?: ServCodePrerequisiteEvalType;
    prerequisiteServCodeId?: number;
    prerequisiteServCode?: string | undefined;
}

export class ServiceCodeResponse implements IServiceCodeResponse {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    authType?: AuthType;
    cchFlag?: string | undefined;
    servCode?: string | undefined;
    serviceCodePrerequisites?: ServiceCodePrerequisites[] | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number;
    payCalculationMethodText?: string | undefined;
    shift?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: boolean;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    isBillable?: string | undefined;
    commentsRequiredValue?: CommentsRequired;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IServiceCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.masterCode = _data["masterCode"];
            this.otFlag = _data["otFlag"];
            this.okToWorkExemptFlag = _data["okToWorkExemptFlag"];
            this.authType = _data["authType"];
            this.cchFlag = _data["cchFlag"];
            this.servCode = _data["servCode"];
            if (Array.isArray(_data["serviceCodePrerequisites"])) {
                this.serviceCodePrerequisites = [] as any;
                for (let item of _data["serviceCodePrerequisites"])
                    this.serviceCodePrerequisites!.push(ServiceCodePrerequisites.fromJS(item));
            }
            this.status = _data["status"];
            this.unitType = _data["unitType"];
            this.payCalculationMethod = _data["payCalculationMethod"];
            this.payCalculationMethodText = _data["payCalculationMethodText"];
            this.shift = _data["shift"];
            this.masterServCode = _data["masterServCode"];
            this.masterServCodeDescription = _data["masterServCodeDescription"];
            this.serviceType = _data["serviceType"];
            this.wwlFlag = _data["wwlFlag"];
            this.taskRequiredFlag = _data["taskRequiredFlag"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
            this.authAllocationFlag = _data["authAllocationFlag"];
            this.twenty147ExemptFlag = _data["twenty147ExemptFlag"];
            this.reportableFlag = _data["reportableFlag"];
            this.generatesAdminTimeFlag = _data["generatesAdminTimeFlag"];
            this.holidayEligibleFlag = _data["holidayEligibleFlag"];
            this.includedIn24HourRule = _data["includedIn24HourRule"];
            this.includedInDailyWorkLimitRule = _data["includedInDailyWorkLimitRule"];
            this.isBillable = _data["isBillable"];
            this.commentsRequiredValue = _data["commentsRequiredValue"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["masterCode"] = this.masterCode;
        data["otFlag"] = this.otFlag;
        data["okToWorkExemptFlag"] = this.okToWorkExemptFlag;
        data["authType"] = this.authType;
        data["cchFlag"] = this.cchFlag;
        data["servCode"] = this.servCode;
        if (Array.isArray(this.serviceCodePrerequisites)) {
            data["serviceCodePrerequisites"] = [];
            for (let item of this.serviceCodePrerequisites)
                data["serviceCodePrerequisites"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["unitType"] = this.unitType;
        data["payCalculationMethod"] = this.payCalculationMethod;
        data["payCalculationMethodText"] = this.payCalculationMethodText;
        data["shift"] = this.shift;
        data["masterServCode"] = this.masterServCode;
        data["masterServCodeDescription"] = this.masterServCodeDescription;
        data["serviceType"] = this.serviceType;
        data["wwlFlag"] = this.wwlFlag;
        data["taskRequiredFlag"] = this.taskRequiredFlag;
        data["serviceTypeCode"] = this.serviceTypeCode;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        data["authAllocationFlag"] = this.authAllocationFlag;
        data["twenty147ExemptFlag"] = this.twenty147ExemptFlag;
        data["reportableFlag"] = this.reportableFlag;
        data["generatesAdminTimeFlag"] = this.generatesAdminTimeFlag;
        data["holidayEligibleFlag"] = this.holidayEligibleFlag;
        data["includedIn24HourRule"] = this.includedIn24HourRule;
        data["includedInDailyWorkLimitRule"] = this.includedInDailyWorkLimitRule;
        data["isBillable"] = this.isBillable;
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceCodeResponse {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    authType?: AuthType;
    cchFlag?: string | undefined;
    servCode?: string | undefined;
    serviceCodePrerequisites?: ServiceCodePrerequisites[] | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number;
    payCalculationMethodText?: string | undefined;
    shift?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: boolean;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    isBillable?: string | undefined;
    commentsRequiredValue?: CommentsRequired;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class PayCycleDate implements IPayCycleDate {
    payCycleStart?: Date;
    payCycleEnd?: Date;

    constructor(data?: IPayCycleDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payCycleStart = _data["payCycleStart"] ? new Date(_data["payCycleStart"].toString()) : <any>undefined;
            this.payCycleEnd = _data["payCycleEnd"] ? new Date(_data["payCycleEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayCycleDate {
        data = typeof data === 'object' ? data : {};
        let result = new PayCycleDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payCycleStart"] = this.payCycleStart ? this.payCycleStart.toISOString() : <any>undefined;
        data["payCycleEnd"] = this.payCycleEnd ? this.payCycleEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayCycleDate {
    payCycleStart?: Date;
    payCycleEnd?: Date;
}

export class ServiceCodeResult implements IServiceCodeResult {
    servCode?: string | undefined;
    description?: string | undefined;
    displayValue?: string | undefined;
    employeeId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    taskRequired?: boolean;
    okToWorkExempt?: boolean;
    docType?: string[] | undefined;
    docTypeStr?: string | undefined;
    programId?: string | undefined;
    commentsRequiredValue?: CommentsRequired;

    constructor(data?: IServiceCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.employeeId = _data["employeeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.taskRequired = _data["taskRequired"];
            this.okToWorkExempt = _data["okToWorkExempt"];
            if (Array.isArray(_data["docType"])) {
                this.docType = [] as any;
                for (let item of _data["docType"])
                    this.docType!.push(item);
            }
            this.docTypeStr = _data["docTypeStr"];
            this.programId = _data["programId"];
            this.commentsRequiredValue = _data["commentsRequiredValue"];
        }
    }

    static fromJS(data: any): ServiceCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["employeeId"] = this.employeeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["taskRequired"] = this.taskRequired;
        data["okToWorkExempt"] = this.okToWorkExempt;
        if (Array.isArray(this.docType)) {
            data["docType"] = [];
            for (let item of this.docType)
                data["docType"].push(item);
        }
        data["docTypeStr"] = this.docTypeStr;
        data["programId"] = this.programId;
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        return data;
    }
}

export interface IServiceCodeResult {
    servCode?: string | undefined;
    description?: string | undefined;
    displayValue?: string | undefined;
    employeeId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    taskRequired?: boolean;
    okToWorkExempt?: boolean;
    docType?: string[] | undefined;
    docTypeStr?: string | undefined;
    programId?: string | undefined;
    commentsRequiredValue?: CommentsRequired;
}

export class ShiftServeCodeResult implements IShiftServeCodeResult {
    servCodes?: ServiceCodeResult[] | undefined;
    address?: AddressDTO;
    weekStartDateTime?: Date;

    constructor(data?: IShiftServeCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(ServiceCodeResult.fromJS(item));
            }
            this.address = _data["address"] ? AddressDTO.fromJS(_data["address"]) : <any>undefined;
            this.weekStartDateTime = _data["weekStartDateTime"] ? new Date(_data["weekStartDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftServeCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftServeCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["weekStartDateTime"] = this.weekStartDateTime ? this.weekStartDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IShiftServeCodeResult {
    servCodes?: ServiceCodeResult[] | undefined;
    address?: AddressDTO;
    weekStartDateTime?: Date;
}

export class State implements IState {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    country?: Country;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }
}

export interface IState {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    validFrom?: Date;
    validTo?: Date;
    country?: Country;
}

export class UnitRange implements IUnitRange {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    authDetails?: AuthDetails[] | undefined;

    constructor(data?: IUnitRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["authDetails"])) {
                this.authDetails = [] as any;
                for (let item of _data["authDetails"])
                    this.authDetails!.push(AuthDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitRange {
        data = typeof data === 'object' ? data : {};
        let result = new UnitRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.authDetails)) {
            data["authDetails"] = [];
            for (let item of this.authDetails)
                data["authDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUnitRange {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    authDetails?: AuthDetails[] | undefined;
}

export class ProgramServiceTypes implements IProgramServiceTypes {
    id?: number;
    programTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    revenueAccountId?: number;
    revenueAccount?: string | undefined;
    revenueAccountDescription?: string | undefined;
    serviceTypeId?: number;
    serviceTypeCode?: string | undefined;
    serviceDescription?: string | undefined;
    glAccount?: string | undefined;
    glDescription?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedByName?: string | undefined;
    programServiceDesc?: string | undefined;
    approvedOn?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IProgramServiceTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programTypeId = _data["programTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.revenueAccountId = _data["revenueAccountId"];
            this.revenueAccount = _data["revenueAccount"];
            this.revenueAccountDescription = _data["revenueAccountDescription"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            this.serviceDescription = _data["serviceDescription"];
            this.glAccount = _data["glAccount"];
            this.glDescription = _data["glDescription"];
            this.approvalStatus = _data["approvalStatus"];
            this.approvedBy = _data["approvedBy"];
            this.approvedByName = _data["approvedByName"];
            this.programServiceDesc = _data["programServiceDesc"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramServiceTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramServiceTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programTypeId"] = this.programTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["revenueAccountId"] = this.revenueAccountId;
        data["revenueAccount"] = this.revenueAccount;
        data["revenueAccountDescription"] = this.revenueAccountDescription;
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceTypeCode"] = this.serviceTypeCode;
        data["serviceDescription"] = this.serviceDescription;
        data["glAccount"] = this.glAccount;
        data["glDescription"] = this.glDescription;
        data["approvalStatus"] = this.approvalStatus;
        data["approvedBy"] = this.approvedBy;
        data["approvedByName"] = this.approvedByName;
        data["programServiceDesc"] = this.programServiceDesc;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramServiceTypes {
    id?: number;
    programTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    revenueAccountId?: number;
    revenueAccount?: string | undefined;
    revenueAccountDescription?: string | undefined;
    serviceTypeId?: number;
    serviceTypeCode?: string | undefined;
    serviceDescription?: string | undefined;
    glAccount?: string | undefined;
    glDescription?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedByName?: string | undefined;
    programServiceDesc?: string | undefined;
    approvedOn?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class Adjustment implements IAdjustment {
    ptpntCmpyCode?: string | undefined;
    svcCode?: string | undefined;
    ptpntId?: number | undefined;
    cgvId?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    extId?: string | undefined;
    refTxId?: string | undefined;
    transStatus?: number | undefined;
    ruleStatus?: string | undefined;
    docType?: string | undefined;
    txId?: string | undefined;
    recTyp?: string | undefined;

    constructor(data?: IAdjustment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            this.svcCode = _data["svcCode"];
            this.ptpntId = _data["ptpntId"];
            this.cgvId = _data["cgvId"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.extId = _data["extId"];
            this.refTxId = _data["refTxId"];
            this.transStatus = _data["transStatus"];
            this.ruleStatus = _data["ruleStatus"];
            this.docType = _data["docType"];
            this.txId = _data["txId"];
            this.recTyp = _data["recTyp"];
        }
    }

    static fromJS(data: any): Adjustment {
        data = typeof data === 'object' ? data : {};
        let result = new Adjustment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["svcCode"] = this.svcCode;
        data["ptpntId"] = this.ptpntId;
        data["cgvId"] = this.cgvId;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["extId"] = this.extId;
        data["refTxId"] = this.refTxId;
        data["transStatus"] = this.transStatus;
        data["ruleStatus"] = this.ruleStatus;
        data["docType"] = this.docType;
        data["txId"] = this.txId;
        data["recTyp"] = this.recTyp;
        return data;
    }
}

export interface IAdjustment {
    ptpntCmpyCode?: string | undefined;
    svcCode?: string | undefined;
    ptpntId?: number | undefined;
    cgvId?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    extId?: string | undefined;
    refTxId?: string | undefined;
    transStatus?: number | undefined;
    ruleStatus?: string | undefined;
    docType?: string | undefined;
    txId?: string | undefined;
    recTyp?: string | undefined;
}

export class AdjustmentResponse implements IAdjustmentResponse {
    items?: Adjustment[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IAdjustmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Adjustment.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAdjustmentResponse {
    items?: Adjustment[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class AdjustmentSearchRequest implements IAdjustmentSearchRequest {
    participantId!: number;
    caregiverIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;

    constructor(data?: IAdjustmentSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): AdjustmentSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IAdjustmentSearchRequest {
    participantId: number;
    caregiverIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export class BulkServCodeRequest implements IBulkServCodeRequest {
    participantIds?: string[] | undefined;
    caregiverIds?: string[] | undefined;
    bulkServCode?: string | undefined;

    constructor(data?: IBulkServCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            this.bulkServCode = _data["bulkServCode"];
        }
    }

    static fromJS(data: any): BulkServCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkServCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        data["bulkServCode"] = this.bulkServCode;
        return data;
    }
}

export interface IBulkServCodeRequest {
    participantIds?: string[] | undefined;
    caregiverIds?: string[] | undefined;
    bulkServCode?: string | undefined;
}

export class RefreshACNResponseDTO implements IRefreshACNResponseDTO {
    bcnId?: number;
    acn?: string | undefined;

    constructor(data?: IRefreshACNResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcnId = _data["bcnId"];
            this.acn = _data["acn"];
        }
    }

    static fromJS(data: any): RefreshACNResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshACNResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcnId"] = this.bcnId;
        data["acn"] = this.acn;
        return data;
    }
}

export interface IRefreshACNResponseDTO {
    bcnId?: number;
    acn?: string | undefined;
}

export class RefreshBillRateResponseDTO implements IRefreshBillRateResponseDTO {
    bcnId?: number;
    billRate?: number;
    billRateUnitMethod?: number | undefined;

    constructor(data?: IRefreshBillRateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcnId = _data["bcnId"];
            this.billRate = _data["billRate"];
            this.billRateUnitMethod = _data["billRateUnitMethod"];
        }
    }

    static fromJS(data: any): RefreshBillRateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshBillRateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcnId"] = this.bcnId;
        data["billRate"] = this.billRate;
        data["billRateUnitMethod"] = this.billRateUnitMethod;
        return data;
    }
}

export interface IRefreshBillRateResponseDTO {
    bcnId?: number;
    billRate?: number;
    billRateUnitMethod?: number | undefined;
}

export class RefreshPayRateResponseDTO implements IRefreshPayRateResponseDTO {
    bcnId?: number;
    payRate?: number | undefined;
    payRateUnitMethod?: number | undefined;

    constructor(data?: IRefreshPayRateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcnId = _data["bcnId"];
            this.payRate = _data["payRate"];
            this.payRateUnitMethod = _data["payRateUnitMethod"];
        }
    }

    static fromJS(data: any): RefreshPayRateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshPayRateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcnId"] = this.bcnId;
        data["payRate"] = this.payRate;
        data["payRateUnitMethod"] = this.payRateUnitMethod;
        return data;
    }
}

export interface IRefreshPayRateResponseDTO {
    bcnId?: number;
    payRate?: number | undefined;
    payRateUnitMethod?: number | undefined;
}

export class RefreshRequestDTO implements IRefreshRequestDTO {
    participantId?: string | undefined;
    agreementRequestDetailsDTO?: RefreshRequestDetailsDTO[] | undefined;

    constructor(data?: IRefreshRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["agreementRequestDetailsDTO"])) {
                this.agreementRequestDetailsDTO = [] as any;
                for (let item of _data["agreementRequestDetailsDTO"])
                    this.agreementRequestDetailsDTO!.push(RefreshRequestDetailsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RefreshRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        if (Array.isArray(this.agreementRequestDetailsDTO)) {
            data["agreementRequestDetailsDTO"] = [];
            for (let item of this.agreementRequestDetailsDTO)
                data["agreementRequestDetailsDTO"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRefreshRequestDTO {
    participantId?: string | undefined;
    agreementRequestDetailsDTO?: RefreshRequestDetailsDTO[] | undefined;
}

export class RefreshRequestDetailsDTO implements IRefreshRequestDetailsDTO {
    bcnid?: number;
    payRate?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    programCode?: string | undefined;
    caregiverId?: string | undefined;

    constructor(data?: IRefreshRequestDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcnid = _data["bcnid"];
            this.payRate = _data["payRate"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.programCode = _data["programCode"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): RefreshRequestDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequestDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcnid"] = this.bcnid;
        data["payRate"] = this.payRate;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["programCode"] = this.programCode;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IRefreshRequestDetailsDTO {
    bcnid?: number;
    payRate?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    programCode?: string | undefined;
    caregiverId?: string | undefined;
}

export class AgencyParticipantsFilterRequest implements IAgencyParticipantsFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IAgencyParticipantsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.agencyIds = _data["agencyIds"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): AgencyParticipantsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyParticipantsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["agencyIds"] = this.agencyIds;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IAgencyParticipantsFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class AgencyUserDto implements IAgencyUserDto {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IAgencyUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.emailId = _data["emailId"];
            this.agencyId = _data["agencyId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgencyUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["emailId"] = this.emailId;
        data["agencyId"] = this.agencyId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgencyUserDto {
    userId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    emailId?: string | undefined;
    agencyId?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class AgencyUsersFilterRequest implements IAgencyUsersFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    roleFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IAgencyUsersFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.agencyIds = _data["agencyIds"];
            this.roleFilter = _data["roleFilter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): AgencyUsersFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyUsersFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["agencyIds"] = this.agencyIds;
        data["roleFilter"] = this.roleFilter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IAgencyUsersFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    roleFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class AmtRangeDto implements IAmtRangeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAmtRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AmtRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmtRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IAmtRangeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class AnnouncementCreateUpdateRequest implements IAnnouncementCreateUpdateRequest {
    announcements?: AnnouncementCreateUpdateRequestDto[] | undefined;
    userId?: string | undefined;

    constructor(data?: IAnnouncementCreateUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["announcements"])) {
                this.announcements = [] as any;
                for (let item of _data["announcements"])
                    this.announcements!.push(AnnouncementCreateUpdateRequestDto.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AnnouncementCreateUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementCreateUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.announcements)) {
            data["announcements"] = [];
            for (let item of this.announcements)
                data["announcements"].push(item ? item.toJSON() : <any>undefined);
        }
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAnnouncementCreateUpdateRequest {
    announcements?: AnnouncementCreateUpdateRequestDto[] | undefined;
    userId?: string | undefined;
}

export class AnnouncementCreateUpdateRequestDto implements IAnnouncementCreateUpdateRequestDto {
    announcementId?: number | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    title?: string | undefined;
    body?: string | undefined;
    code?: string | undefined;

    constructor(data?: IAnnouncementCreateUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.announcementId = _data["announcementId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.body = _data["body"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AnnouncementCreateUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementCreateUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementId"] = this.announcementId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["body"] = this.body;
        data["code"] = this.code;
        return data;
    }
}

export interface IAnnouncementCreateUpdateRequestDto {
    announcementId?: number | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    title?: string | undefined;
    body?: string | undefined;
    code?: string | undefined;
}

export class AnnouncementDeleteRequest implements IAnnouncementDeleteRequest {
    ids?: number[] | undefined;
    userId?: string | undefined;

    constructor(data?: IAnnouncementDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AnnouncementDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAnnouncementDeleteRequest {
    ids?: number[] | undefined;
    userId?: string | undefined;
}

export class AnnouncementLanguageResponseDto implements IAnnouncementLanguageResponseDto {
    languageID?: number;
    lang?: string | undefined;

    constructor(data?: IAnnouncementLanguageResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageID = _data["languageID"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): AnnouncementLanguageResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementLanguageResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageID"] = this.languageID;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IAnnouncementLanguageResponseDto {
    languageID?: number;
    lang?: string | undefined;
}

export class AnnouncementResponseDto implements IAnnouncementResponseDto {
    announcementId?: number;
    name?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    code?: string | undefined;

    constructor(data?: IAnnouncementResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.announcementId = _data["announcementId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AnnouncementResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementId"] = this.announcementId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["body"] = this.body;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["code"] = this.code;
        return data;
    }
}

export interface IAnnouncementResponseDto {
    announcementId?: number;
    name?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    code?: string | undefined;
}

export class Authorization implements IAuthorization {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    acn?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    programType?: string | undefined;
    startDate?: Date | undefined;
    dob?: Date | undefined;
    ecmId?: number | undefined;
    ecmExId?: string | undefined;
    endDate?: Date | undefined;
    subAccount?: string | undefined;
    status?: AuthorizationStatus;
    budgetSummaries?: BudgetSummary[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDraft?: boolean;
    insuredId?: string | undefined;

    constructor(data?: IAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.programNumber = _data["programNumber"];
            this.companyCode = _data["companyCode"];
            this.acn = _data["acn"];
            this.diagId = _data["diagId"];
            this.diagCode = _data["diagCode"];
            this.agreementNumber = _data["agreementNumber"];
            this.custId = _data["custId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.programType = _data["programType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.ecmId = _data["ecmId"];
            this.ecmExId = _data["ecmExId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.subAccount = _data["subAccount"];
            this.status = _data["status"];
            if (Array.isArray(_data["budgetSummaries"])) {
                this.budgetSummaries = [] as any;
                for (let item of _data["budgetSummaries"])
                    this.budgetSummaries!.push(BudgetSummary.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDraft = _data["isDraft"];
            this.insuredId = _data["insuredId"];
        }
    }

    static fromJS(data: any): Authorization {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["programNumber"] = this.programNumber;
        data["companyCode"] = this.companyCode;
        data["acn"] = this.acn;
        data["diagId"] = this.diagId;
        data["diagCode"] = this.diagCode;
        data["agreementNumber"] = this.agreementNumber;
        data["custId"] = this.custId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["programType"] = this.programType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["ecmId"] = this.ecmId;
        data["ecmExId"] = this.ecmExId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["subAccount"] = this.subAccount;
        data["status"] = this.status;
        if (Array.isArray(this.budgetSummaries)) {
            data["budgetSummaries"] = [];
            for (let item of this.budgetSummaries)
                data["budgetSummaries"].push(item ? item.toJSON() : <any>undefined);
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDraft"] = this.isDraft;
        data["insuredId"] = this.insuredId;
        return data;
    }
}

export interface IAuthorization {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    acn?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    programType?: string | undefined;
    startDate?: Date | undefined;
    dob?: Date | undefined;
    ecmId?: number | undefined;
    ecmExId?: string | undefined;
    endDate?: Date | undefined;
    subAccount?: string | undefined;
    status?: AuthorizationStatus;
    budgetSummaries?: BudgetSummary[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDraft?: boolean;
    insuredId?: string | undefined;
}

export class AuthorizationSearchRequest implements IAuthorizationSearchRequest {
    searchParameter?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    participants?: string[] | undefined;
    stateCode?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IAuthorizationSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            this.stateCode = _data["stateCode"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthorizationSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        data["stateCode"] = this.stateCode;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAuthorizationSearchRequest {
    searchParameter?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    participants?: string[] | undefined;
    stateCode?: string | undefined;
    userId?: string | undefined;
}

export class BudgetSummary implements IBudgetSummary {
    id?: number | undefined;
    authCode?: string | undefined;
    servCodeId?: number | undefined;
    servCode?: string | undefined;
    servDescription?: string | undefined;
    displayValue?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    holdStartDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    acn?: string | undefined;
    status?: AuthorizationStatus;
    closeOverlappingServices?: boolean | undefined;
    range?: string | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;
    autoRenewal?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBudgetSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authCode = _data["authCode"];
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.servDescription = _data["servDescription"];
            this.displayValue = _data["displayValue"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.processingStartDate = _data["processingStartDate"] ? new Date(_data["processingStartDate"].toString()) : <any>undefined;
            this.processingEndDate = _data["processingEndDate"] ? new Date(_data["processingEndDate"].toString()) : <any>undefined;
            this.holdStartDate = _data["holdStartDate"] ? new Date(_data["holdStartDate"].toString()) : <any>undefined;
            this.holdEndDate = _data["holdEndDate"] ? new Date(_data["holdEndDate"].toString()) : <any>undefined;
            this.feePctPr = _data["feePctPr"];
            this.feePctAdmin = _data["feePctAdmin"];
            this.pmFee = _data["pmFee"];
            this.hours = _data["hours"];
            this.units = _data["units"];
            this.rangeUnits = _data["rangeUnits"];
            this.budgetAmt = _data["budgetAmt"];
            this.rangeAmt = _data["rangeAmt"];
            this.unitRange = _data["unitRange"];
            this.amtRange = _data["amtRange"];
            this.acn = _data["acn"];
            this.status = _data["status"];
            this.closeOverlappingServices = _data["closeOverlappingServices"];
            this.range = _data["range"];
            this.serviceType = _data["serviceType"];
            this.diagCode = _data["diagCode"];
            this.updated = _data["updated"];
            this.isDraft = _data["isDraft"];
            this.autoRenewal = _data["autoRenewal"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BudgetSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authCode"] = this.authCode;
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["servDescription"] = this.servDescription;
        data["displayValue"] = this.displayValue;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["processingStartDate"] = this.processingStartDate ? this.processingStartDate.toISOString() : <any>undefined;
        data["processingEndDate"] = this.processingEndDate ? this.processingEndDate.toISOString() : <any>undefined;
        data["holdStartDate"] = this.holdStartDate ? this.holdStartDate.toISOString() : <any>undefined;
        data["holdEndDate"] = this.holdEndDate ? this.holdEndDate.toISOString() : <any>undefined;
        data["feePctPr"] = this.feePctPr;
        data["feePctAdmin"] = this.feePctAdmin;
        data["pmFee"] = this.pmFee;
        data["hours"] = this.hours;
        data["units"] = this.units;
        data["rangeUnits"] = this.rangeUnits;
        data["budgetAmt"] = this.budgetAmt;
        data["rangeAmt"] = this.rangeAmt;
        data["unitRange"] = this.unitRange;
        data["amtRange"] = this.amtRange;
        data["acn"] = this.acn;
        data["status"] = this.status;
        data["closeOverlappingServices"] = this.closeOverlappingServices;
        data["range"] = this.range;
        data["serviceType"] = this.serviceType;
        data["diagCode"] = this.diagCode;
        data["updated"] = this.updated;
        data["isDraft"] = this.isDraft;
        data["autoRenewal"] = this.autoRenewal;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBudgetSummary {
    id?: number | undefined;
    authCode?: string | undefined;
    servCodeId?: number | undefined;
    servCode?: string | undefined;
    servDescription?: string | undefined;
    displayValue?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    holdStartDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    acn?: string | undefined;
    status?: AuthorizationStatus;
    closeOverlappingServices?: boolean | undefined;
    range?: string | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;
    autoRenewal?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class ServCodeAuthDetailsCacheEntity implements IServCodeAuthDetailsCacheEntity {
    isOnlyEVVEntryAllowed?: boolean;
    adjustmentReasonRequired?: boolean;
    servCode?: string | undefined;
    begDate?: Date;
    endDate?: Date;

    constructor(data?: IServCodeAuthDetailsCacheEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnlyEVVEntryAllowed = _data["isOnlyEVVEntryAllowed"];
            this.adjustmentReasonRequired = _data["adjustmentReasonRequired"];
            this.servCode = _data["servCode"];
            this.begDate = _data["begDate"] ? new Date(_data["begDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServCodeAuthDetailsCacheEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeAuthDetailsCacheEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnlyEVVEntryAllowed"] = this.isOnlyEVVEntryAllowed;
        data["adjustmentReasonRequired"] = this.adjustmentReasonRequired;
        data["servCode"] = this.servCode;
        data["begDate"] = this.begDate ? this.begDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServCodeAuthDetailsCacheEntity {
    isOnlyEVVEntryAllowed?: boolean;
    adjustmentReasonRequired?: boolean;
    servCode?: string | undefined;
    begDate?: Date;
    endDate?: Date;
}

export class BasePayorDTO implements IBasePayorDTO {
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    active?: string | undefined;
    weekStartingDay?: DayOfWeek;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBasePayorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.active = _data["active"];
            this.weekStartingDay = _data["weekStartingDay"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BasePayorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasePayorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["active"] = this.active;
        data["weekStartingDay"] = this.weekStartingDay;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBasePayorDTO {
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    active?: string | undefined;
    weekStartingDay?: DayOfWeek;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class BenefitContributionRequestDto implements IBenefitContributionRequestDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    rateStatus?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    rate?: number;
    companyId?: number;

    constructor(data?: IBenefitContributionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.rateStatus = _data["rateStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rate = _data["rate"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BenefitContributionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitContributionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["rateStatus"] = this.rateStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rate"] = this.rate;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IBenefitContributionRequestDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    rateStatus?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    rate?: number;
    companyId?: number;
}

export class BenefitContributionResponseDto implements IBenefitContributionResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    rate?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    rateStatus?: string | undefined;
    isDeleted?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBenefitContributionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rateStatus = _data["rateStatus"];
            this.isDeleted = _data["isDeleted"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BenefitContributionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitContributionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rateStatus"] = this.rateStatus;
        data["isDeleted"] = this.isDeleted;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBenefitContributionResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    rate?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    rateStatus?: string | undefined;
    isDeleted?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class BillCodeDTO implements IBillCodeDTO {
    id?: number;
    billCodeId?: string | undefined;
    description?: string | undefined;
    hcpcsCode?: string | undefined;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBillCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billCodeId = _data["billCodeId"];
            this.description = _data["description"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.m1 = _data["m1"];
            this.m2 = _data["m2"];
            this.m3 = _data["m3"];
            this.m4 = _data["m4"];
            this.active = _data["active"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BillCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billCodeId"] = this.billCodeId;
        data["description"] = this.description;
        data["hcpcsCode"] = this.hcpcsCode;
        data["m1"] = this.m1;
        data["m2"] = this.m2;
        data["m3"] = this.m3;
        data["m4"] = this.m4;
        data["active"] = this.active;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillCodeDTO {
    id?: number;
    billCodeId?: string | undefined;
    description?: string | undefined;
    hcpcsCode?: string | undefined;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class BillCodeRequest implements IBillCodeRequest {
    id!: number;
    billCodeId!: string;
    description!: string;
    hcpcsCode!: string;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;

    constructor(data?: IBillCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billCodeId = _data["billCodeId"];
            this.description = _data["description"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.m1 = _data["m1"];
            this.m2 = _data["m2"];
            this.m3 = _data["m3"];
            this.m4 = _data["m4"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): BillCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billCodeId"] = this.billCodeId;
        data["description"] = this.description;
        data["hcpcsCode"] = this.hcpcsCode;
        data["m1"] = this.m1;
        data["m2"] = this.m2;
        data["m3"] = this.m3;
        data["m4"] = this.m4;
        data["active"] = this.active;
        return data;
    }
}

export interface IBillCodeRequest {
    id: number;
    billCodeId: string;
    description: string;
    hcpcsCode: string;
    m1?: string | undefined;
    m2?: string | undefined;
    m3?: string | undefined;
    m4?: string | undefined;
    active?: string | undefined;
}

export interface IAccountLookupDto {
    id?: number;
    account?: string | undefined;
    description?: string | undefined;
}

export class AgencyParticipantListRequest implements IAgencyParticipantListRequest {
    agencyIds?: string | undefined;
    participantIds?: string | undefined;

    constructor(data?: IAgencyParticipantListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyIds = _data["agencyIds"];
            this.participantIds = _data["participantIds"];
        }
    }

    static fromJS(data: any): AgencyParticipantListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyParticipantListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyIds"] = this.agencyIds;
        data["participantIds"] = this.participantIds;
        return data;
    }
}

export interface IAgencyParticipantListRequest {
    agencyIds?: string | undefined;
    participantIds?: string | undefined;
}

export class BillRateByIdResponseDto implements IBillRateByIdResponseDto {
    id?: number;
    programId?: number;
    serveCodeId?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    rndMethodId?: number | undefined;
    budgetItem?: string | undefined;
    isDeleted?: boolean;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    pmRequiresService?: boolean;
    feeType?: number | undefined;
    unitMethod?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markupPC?: number | undefined;
    unitMulti?: number;
    note?: string | undefined;
    active?: string | undefined;
    serveCode?: string | undefined;
    description?: string | undefined;
    prognbr?: string | undefined;
    billCodeDescription?: string | undefined;
    billRateMappingData?: BillRateMappingDto[] | undefined;
    placeOfService?: number;
    statementDate?: Date | undefined;

    constructor(data?: IBillRateByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.serveCodeId = _data["serveCodeId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rndMethodId = _data["rndMethodId"];
            this.budgetItem = _data["budgetItem"];
            this.isDeleted = _data["isDeleted"];
            this.authReqd = _data["authReqd"];
            this.feeExempt = _data["feeExempt"];
            this.nonBillable = _data["nonBillable"];
            this.pmRequiresService = _data["pmRequiresService"];
            this.feeType = _data["feeType"];
            this.unitMethod = _data["unitMethod"];
            this.contAllow = _data["contAllow"];
            this.maxBillRate = _data["maxBillRate"];
            this.markUp = _data["markUp"];
            this.markupPC = _data["markupPC"];
            this.unitMulti = _data["unitMulti"];
            this.note = _data["note"];
            this.active = _data["active"];
            this.serveCode = _data["serveCode"];
            this.description = _data["description"];
            this.prognbr = _data["prognbr"];
            this.billCodeDescription = _data["billCodeDescription"];
            if (Array.isArray(_data["billRateMappingData"])) {
                this.billRateMappingData = [] as any;
                for (let item of _data["billRateMappingData"])
                    this.billRateMappingData!.push(BillRateMappingDto.fromJS(item));
            }
            this.placeOfService = _data["placeOfService"];
            this.statementDate = _data["statementDate"] ? new Date(_data["statementDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillRateByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["serveCodeId"] = this.serveCodeId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rndMethodId"] = this.rndMethodId;
        data["budgetItem"] = this.budgetItem;
        data["isDeleted"] = this.isDeleted;
        data["authReqd"] = this.authReqd;
        data["feeExempt"] = this.feeExempt;
        data["nonBillable"] = this.nonBillable;
        data["pmRequiresService"] = this.pmRequiresService;
        data["feeType"] = this.feeType;
        data["unitMethod"] = this.unitMethod;
        data["contAllow"] = this.contAllow;
        data["maxBillRate"] = this.maxBillRate;
        data["markUp"] = this.markUp;
        data["markupPC"] = this.markupPC;
        data["unitMulti"] = this.unitMulti;
        data["note"] = this.note;
        data["active"] = this.active;
        data["serveCode"] = this.serveCode;
        data["description"] = this.description;
        data["prognbr"] = this.prognbr;
        data["billCodeDescription"] = this.billCodeDescription;
        if (Array.isArray(this.billRateMappingData)) {
            data["billRateMappingData"] = [];
            for (let item of this.billRateMappingData)
                data["billRateMappingData"].push(item ? item.toJSON() : <any>undefined);
        }
        data["placeOfService"] = this.placeOfService;
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillRateByIdResponseDto {
    id?: number;
    programId?: number;
    serveCodeId?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    rndMethodId?: number | undefined;
    budgetItem?: string | undefined;
    isDeleted?: boolean;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    pmRequiresService?: boolean;
    feeType?: number | undefined;
    unitMethod?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markupPC?: number | undefined;
    unitMulti?: number;
    note?: string | undefined;
    active?: string | undefined;
    serveCode?: string | undefined;
    description?: string | undefined;
    prognbr?: string | undefined;
    billCodeDescription?: string | undefined;
    billRateMappingData?: BillRateMappingDto[] | undefined;
    placeOfService?: number;
    statementDate?: Date | undefined;
}

export class BillRateConfigurationDto implements IBillRateConfigurationDto {
    id?: number;
    intValue?: number;
    configuration?: string | undefined;
    isEnabled?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBillRateConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.intValue = _data["intValue"];
            this.configuration = _data["configuration"];
            this.isEnabled = _data["isEnabled"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillRateConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["intValue"] = this.intValue;
        data["configuration"] = this.configuration;
        data["isEnabled"] = this.isEnabled;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillRateConfigurationDto {
    id?: number;
    intValue?: number;
    configuration?: string | undefined;
    isEnabled?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class BillRateDto implements IBillRateDto {
    id?: number;
    programId!: number;
    serveCodeId!: number;
    beginDate!: Date;
    endDate?: Date | undefined;
    rnDMethodId?: number | undefined;
    budgetitem?: string | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    pmRequiresService?: boolean;
    feeType?: number | undefined;
    unitMethod?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markUpPC?: number | undefined;
    unitMulti?: number | undefined;
    note?: string | undefined;
    active?: string | undefined;
    billRateMappingData?: BillRateMappingDto[] | undefined;
    placeOfService?: number;
    statementDate?: Date | undefined;

    constructor(data?: IBillRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.serveCodeId = _data["serveCodeId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rnDMethodId = _data["rnDMethodId"];
            this.budgetitem = _data["budgetitem"];
            this.authReqd = _data["authReqd"];
            this.feeExempt = _data["feeExempt"];
            this.nonBillable = _data["nonBillable"];
            this.pmRequiresService = _data["pmRequiresService"];
            this.feeType = _data["feeType"];
            this.unitMethod = _data["unitMethod"];
            this.contAllow = _data["contAllow"];
            this.maxBillRate = _data["maxBillRate"];
            this.markUp = _data["markUp"];
            this.markUpPC = _data["markUpPC"];
            this.unitMulti = _data["unitMulti"];
            this.note = _data["note"];
            this.active = _data["active"];
            if (Array.isArray(_data["billRateMappingData"])) {
                this.billRateMappingData = [] as any;
                for (let item of _data["billRateMappingData"])
                    this.billRateMappingData!.push(BillRateMappingDto.fromJS(item));
            }
            this.placeOfService = _data["placeOfService"];
            this.statementDate = _data["statementDate"] ? new Date(_data["statementDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["serveCodeId"] = this.serveCodeId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rnDMethodId"] = this.rnDMethodId;
        data["budgetitem"] = this.budgetitem;
        data["authReqd"] = this.authReqd;
        data["feeExempt"] = this.feeExempt;
        data["nonBillable"] = this.nonBillable;
        data["pmRequiresService"] = this.pmRequiresService;
        data["feeType"] = this.feeType;
        data["unitMethod"] = this.unitMethod;
        data["contAllow"] = this.contAllow;
        data["maxBillRate"] = this.maxBillRate;
        data["markUp"] = this.markUp;
        data["markUpPC"] = this.markUpPC;
        data["unitMulti"] = this.unitMulti;
        data["note"] = this.note;
        data["active"] = this.active;
        if (Array.isArray(this.billRateMappingData)) {
            data["billRateMappingData"] = [];
            for (let item of this.billRateMappingData)
                data["billRateMappingData"].push(item ? item.toJSON() : <any>undefined);
        }
        data["placeOfService"] = this.placeOfService;
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillRateDto {
    id?: number;
    programId: number;
    serveCodeId: number;
    beginDate: Date;
    endDate?: Date | undefined;
    rnDMethodId?: number | undefined;
    budgetitem?: string | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    pmRequiresService?: boolean;
    feeType?: number | undefined;
    unitMethod?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    markUp?: number | undefined;
    markUpPC?: number | undefined;
    unitMulti?: number | undefined;
    note?: string | undefined;
    active?: string | undefined;
    billRateMappingData?: BillRateMappingDto[] | undefined;
    placeOfService?: number;
    statementDate?: Date | undefined;
}

export class BillRateMappingDto implements IBillRateMappingDto {
    id?: number;
    billRateId?: number;
    billRate?: number | undefined;
    intValue?: number;
    isDeleted?: boolean;
    billCodeId!: number;
    billCode?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    configuration?: string | undefined;
    revenueCode?: string | undefined;

    constructor(data?: IBillRateMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billRateId = _data["billRateId"];
            this.billRate = _data["billRate"];
            this.intValue = _data["intValue"];
            this.isDeleted = _data["isDeleted"];
            this.billCodeId = _data["billCodeId"];
            this.billCode = _data["billCode"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.configuration = _data["configuration"];
            this.revenueCode = _data["revenueCode"];
        }
    }

    static fromJS(data: any): BillRateMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billRateId"] = this.billRateId;
        data["billRate"] = this.billRate;
        data["intValue"] = this.intValue;
        data["isDeleted"] = this.isDeleted;
        data["billCodeId"] = this.billCodeId;
        data["billCode"] = this.billCode;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["configuration"] = this.configuration;
        data["revenueCode"] = this.revenueCode;
        return data;
    }
}

export interface IBillRateMappingDto {
    id?: number;
    billRateId?: number;
    billRate?: number | undefined;
    intValue?: number;
    isDeleted?: boolean;
    billCodeId: number;
    billCode?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    configuration?: string | undefined;
    revenueCode?: string | undefined;
}

export class BillRateResponseDto implements IBillRateResponseDto {
    id?: number;
    servCode?: string | undefined;
    billCode?: string | undefined;
    systemCode?: string | undefined;
    budgetItem?: string | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    unitMethod?: string | undefined;
    billRate?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    unitMulti?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    active?: string | undefined;
    markUp?: number | undefined;
    markUpPC?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IBillRateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.servCode = _data["servCode"];
            this.billCode = _data["billCode"];
            this.systemCode = _data["systemCode"];
            this.budgetItem = _data["budgetItem"];
            this.authReqd = _data["authReqd"];
            this.feeExempt = _data["feeExempt"];
            this.nonBillable = _data["nonBillable"];
            this.unitMethod = _data["unitMethod"];
            this.billRate = _data["billRate"];
            this.contAllow = _data["contAllow"];
            this.maxBillRate = _data["maxBillRate"];
            this.unitMulti = _data["unitMulti"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.markUp = _data["markUp"];
            this.markUpPC = _data["markUpPC"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillRateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillRateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["servCode"] = this.servCode;
        data["billCode"] = this.billCode;
        data["systemCode"] = this.systemCode;
        data["budgetItem"] = this.budgetItem;
        data["authReqd"] = this.authReqd;
        data["feeExempt"] = this.feeExempt;
        data["nonBillable"] = this.nonBillable;
        data["unitMethod"] = this.unitMethod;
        data["billRate"] = this.billRate;
        data["contAllow"] = this.contAllow;
        data["maxBillRate"] = this.maxBillRate;
        data["unitMulti"] = this.unitMulti;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["markUp"] = this.markUp;
        data["markUpPC"] = this.markUpPC;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillRateResponseDto {
    id?: number;
    servCode?: string | undefined;
    billCode?: string | undefined;
    systemCode?: string | undefined;
    budgetItem?: string | undefined;
    authReqd?: string | undefined;
    feeExempt?: string | undefined;
    nonBillable?: string | undefined;
    unitMethod?: string | undefined;
    billRate?: number | undefined;
    contAllow?: number | undefined;
    maxBillRate?: number | undefined;
    unitMulti?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    active?: string | undefined;
    markUp?: number | undefined;
    markUpPC?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class FeeDistDto implements IFeeDistDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFeeDistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeeDistDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeDistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IFeeDistDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class FeeTypeDto implements IFeeTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFeeTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IFeeTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class FeeTypeIdResponseDto implements IFeeTypeIdResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;

    constructor(data?: IFeeTypeIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FeeTypeIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeTypeIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IFeeTypeIdResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export class FeeTypeRequestDto implements IFeeTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    code!: string;
    status?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFeeTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeeTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["status"] = this.status;
        data["description"] = this.description;
        return data;
    }
}

export interface IFeeTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    code: string;
    status?: string | undefined;
    description?: string | undefined;
}

export class FeeTypeResponseDto implements IFeeTypeResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IFeeTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FeeTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFeeTypeResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class FundingTypeByIdResponseDto implements IFundingTypeByIdResponseDto {
    id?: number;
    type?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;

    constructor(data?: IFundingTypeByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FundingTypeByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundingTypeByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IFundingTypeByIdResponseDto {
    id?: number;
    type?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export class FundingTypeRequestDto implements IFundingTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    type!: string;
    status?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFundingTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FundingTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundingTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["description"] = this.description;
        return data;
    }
}

export interface IFundingTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    type: string;
    status?: string | undefined;
    description?: string | undefined;
}

export class FundingTypeResponseDto implements IFundingTypeResponseDto {
    id?: number;
    type?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IFundingTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FundingTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundingTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["description"] = this.description;
        data["status"] = this.status;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFundingTypeResponseDto {
    id?: number;
    type?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class HCPCSCodeResponseDto implements IHCPCSCodeResponseDto {
    id?: number;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    delimitedModifier?: string | undefined;
    description?: string | undefined;

    constructor(data?: IHCPCSCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.delimitedModifier = _data["delimitedModifier"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HCPCSCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HCPCSCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["delimitedModifier"] = this.delimitedModifier;
        data["description"] = this.description;
        return data;
    }
}

export interface IHCPCSCodeResponseDto {
    id?: number;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    delimitedModifier?: string | undefined;
    description?: string | undefined;
}

export class MUTypeDto implements IMUTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IMUTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MUTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MUTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMUTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class PayCycleDateRequest implements IPayCycleDateRequest {
    payCycleDate?: Date | undefined;

    constructor(data?: IPayCycleDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payCycleDate = _data["payCycleDate"] ? new Date(_data["payCycleDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayCycleDateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayCycleDateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payCycleDate"] = this.payCycleDate ? this.payCycleDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayCycleDateRequest {
    payCycleDate?: Date | undefined;
}

export class PayRateResponseDto implements IPayRateResponseDto {
    id?: number;
    employeeName?: string | undefined;
    customerName?: string | undefined;
    servCode?: string | undefined;
    employerId?: number;
    validDays?: string | undefined;
    roundMethod?: string | undefined;
    mutype?: string | undefined;
    payRate?: number | undefined;
    holiPremium?: number | undefined;
    beginDate?: Date;
    earnType?: string | undefined;
    otflag?: string | undefined;
    endDate?: Date | undefined;
    beginTime?: Date;
    endTime?: Date;
    comment?: string | undefined;
    active?: string | undefined;
    billCode?: string | undefined;
    unitType?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IPayRateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeName = _data["employeeName"];
            this.customerName = _data["customerName"];
            this.servCode = _data["servCode"];
            this.employerId = _data["employerId"];
            this.validDays = _data["validDays"];
            this.roundMethod = _data["roundMethod"];
            this.mutype = _data["mutype"];
            this.payRate = _data["payRate"];
            this.holiPremium = _data["holiPremium"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.earnType = _data["earnType"];
            this.otflag = _data["otflag"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.beginTime = _data["beginTime"] ? new Date(_data["beginTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.active = _data["active"];
            this.billCode = _data["billCode"];
            this.unitType = _data["unitType"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayRateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeName"] = this.employeeName;
        data["customerName"] = this.customerName;
        data["servCode"] = this.servCode;
        data["employerId"] = this.employerId;
        data["validDays"] = this.validDays;
        data["roundMethod"] = this.roundMethod;
        data["mutype"] = this.mutype;
        data["payRate"] = this.payRate;
        data["holiPremium"] = this.holiPremium;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["earnType"] = this.earnType;
        data["otflag"] = this.otflag;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["active"] = this.active;
        data["billCode"] = this.billCode;
        data["unitType"] = this.unitType;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayRateResponseDto {
    id?: number;
    employeeName?: string | undefined;
    customerName?: string | undefined;
    servCode?: string | undefined;
    employerId?: number;
    validDays?: string | undefined;
    roundMethod?: string | undefined;
    mutype?: string | undefined;
    payRate?: number | undefined;
    holiPremium?: number | undefined;
    beginDate?: Date;
    earnType?: string | undefined;
    otflag?: string | undefined;
    endDate?: Date | undefined;
    beginTime?: Date;
    endTime?: Date;
    comment?: string | undefined;
    active?: string | undefined;
    billCode?: string | undefined;
    unitType?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class PayRatesDto implements IPayRatesDto {
    id?: number;
    custId!: number;
    empId!: number;
    servCodeId!: number;
    rnDMethodId?: number | undefined;
    beginDate!: Date;
    endDate?: Date | undefined;
    beginTime!: Date;
    endTime!: Date;
    format?: boolean;
    validDays!: string;
    earnType?: string | undefined;
    payOt?: string | undefined;
    payRate?: number | undefined;
    holiPremium?: number | undefined;
    comment?: string | undefined;
    active?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;

    constructor(data?: IPayRatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.empId = _data["empId"];
            this.servCodeId = _data["servCodeId"];
            this.rnDMethodId = _data["rnDMethodId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.beginTime = _data["beginTime"] ? new Date(_data["beginTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.format = _data["format"];
            this.validDays = _data["validDays"];
            this.earnType = _data["earnType"];
            this.payOt = _data["payOt"];
            this.payRate = _data["payRate"];
            this.holiPremium = _data["holiPremium"];
            this.comment = _data["comment"];
            this.active = _data["active"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
        }
    }

    static fromJS(data: any): PayRatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["empId"] = this.empId;
        data["servCodeId"] = this.servCodeId;
        data["rnDMethodId"] = this.rnDMethodId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["format"] = this.format;
        data["validDays"] = this.validDays;
        data["earnType"] = this.earnType;
        data["payOt"] = this.payOt;
        data["payRate"] = this.payRate;
        data["holiPremium"] = this.holiPremium;
        data["comment"] = this.comment;
        data["active"] = this.active;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        return data;
    }
}

export interface IPayRatesDto {
    id?: number;
    custId: number;
    empId: number;
    servCodeId: number;
    rnDMethodId?: number | undefined;
    beginDate: Date;
    endDate?: Date | undefined;
    beginTime: Date;
    endTime: Date;
    format?: boolean;
    validDays: string;
    earnType?: string | undefined;
    payOt?: string | undefined;
    payRate?: number | undefined;
    holiPremium?: number | undefined;
    comment?: string | undefined;
    active?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;
}

export class RelationshipTypeDto implements IRelationshipTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    exempt?: string | undefined;
    displayOrder?: number | undefined;
    isFamilial?: boolean;

    constructor(data?: IRelationshipTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.exempt = _data["exempt"];
            this.displayOrder = _data["displayOrder"];
            this.isFamilial = _data["isFamilial"];
        }
    }

    static fromJS(data: any): RelationshipTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationshipTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["exempt"] = this.exempt;
        data["displayOrder"] = this.displayOrder;
        data["isFamilial"] = this.isFamilial;
        return data;
    }
}

export interface IRelationshipTypeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    exempt?: string | undefined;
    displayOrder?: number | undefined;
    isFamilial?: boolean;
}

export class ServCodeToServTypeDto implements IServCodeToServTypeDto {
    serviceCode?: string | undefined;
    serviceType?: string | undefined;
    serviceTypeId?: number;
    revenueAccountId?: number;
    programTypeId?: number;
    revenueAccount?: string | undefined;
    description?: string | undefined;
    programType?: string | undefined;

    constructor(data?: IServCodeToServTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceType = _data["serviceType"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.revenueAccountId = _data["revenueAccountId"];
            this.programTypeId = _data["programTypeId"];
            this.revenueAccount = _data["revenueAccount"];
            this.description = _data["description"];
            this.programType = _data["programType"];
        }
    }

    static fromJS(data: any): ServCodeToServTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeToServTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceType"] = this.serviceType;
        data["serviceTypeId"] = this.serviceTypeId;
        data["revenueAccountId"] = this.revenueAccountId;
        data["programTypeId"] = this.programTypeId;
        data["revenueAccount"] = this.revenueAccount;
        data["description"] = this.description;
        data["programType"] = this.programType;
        return data;
    }
}

export interface IServCodeToServTypeDto {
    serviceCode?: string | undefined;
    serviceType?: string | undefined;
    serviceTypeId?: number;
    revenueAccountId?: number;
    programTypeId?: number;
    revenueAccount?: string | undefined;
    description?: string | undefined;
    programType?: string | undefined;
}

export class ServeCodeDto implements IServeCodeDto {
    id?: number;
    companyId?: number;
    description!: string;
    displayValue!: string;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    authType?: AuthType;
    okToWorkExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode!: string;
    status?: string | undefined;
    unitTypes?: string | undefined;
    serviceType!: number;
    payCalculationMethod!: number;
    authAllocationFlag?: string | undefined;
    billableFlag?: string | undefined;
    departmentPaidHoursFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    commentsRequiredValue?: CommentsRequired;

    constructor(data?: IServeCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generatesAdminTimeFlag = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.masterCode = _data["masterCode"];
            this.otFlag = _data["otFlag"];
            this.authType = _data["authType"];
            this.okToWorkExemptFlag = _data["okToWorkExemptFlag"];
            this.reportableFlag = _data["reportableFlag"];
            this.holidayEligibleFlag = _data["holidayEligibleFlag"];
            this.includedIn24HourRule = _data["includedIn24HourRule"];
            this.includedInDailyWorkLimitRule = _data["includedInDailyWorkLimitRule"];
            this.cchFlag = _data["cchFlag"];
            this.wwlFlag = _data["wwlFlag"];
            this.taskRequiredFlag = _data["taskRequiredFlag"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.unitTypes = _data["unitTypes"];
            this.serviceType = _data["serviceType"];
            this.payCalculationMethod = _data["payCalculationMethod"];
            this.authAllocationFlag = _data["authAllocationFlag"];
            this.billableFlag = _data["billableFlag"];
            this.departmentPaidHoursFlag = _data["departmentPaidHoursFlag"];
            this.twenty147ExemptFlag = _data["twenty147ExemptFlag"];
            this.generatesAdminTimeFlag = _data["generatesAdminTimeFlag"] !== undefined ? _data["generatesAdminTimeFlag"] : true;
            this.commentsRequiredValue = _data["commentsRequiredValue"];
        }
    }

    static fromJS(data: any): ServeCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServeCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["masterCode"] = this.masterCode;
        data["otFlag"] = this.otFlag;
        data["authType"] = this.authType;
        data["okToWorkExemptFlag"] = this.okToWorkExemptFlag;
        data["reportableFlag"] = this.reportableFlag;
        data["holidayEligibleFlag"] = this.holidayEligibleFlag;
        data["includedIn24HourRule"] = this.includedIn24HourRule;
        data["includedInDailyWorkLimitRule"] = this.includedInDailyWorkLimitRule;
        data["cchFlag"] = this.cchFlag;
        data["wwlFlag"] = this.wwlFlag;
        data["taskRequiredFlag"] = this.taskRequiredFlag;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["unitTypes"] = this.unitTypes;
        data["serviceType"] = this.serviceType;
        data["payCalculationMethod"] = this.payCalculationMethod;
        data["authAllocationFlag"] = this.authAllocationFlag;
        data["billableFlag"] = this.billableFlag;
        data["departmentPaidHoursFlag"] = this.departmentPaidHoursFlag;
        data["twenty147ExemptFlag"] = this.twenty147ExemptFlag;
        data["generatesAdminTimeFlag"] = this.generatesAdminTimeFlag;
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        return data;
    }
}

export interface IServeCodeDto {
    id?: number;
    companyId?: number;
    description: string;
    displayValue: string;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    authType?: AuthType;
    okToWorkExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode: string;
    status?: string | undefined;
    unitTypes?: string | undefined;
    serviceType: number;
    payCalculationMethod: number;
    authAllocationFlag?: string | undefined;
    billableFlag?: string | undefined;
    departmentPaidHoursFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    commentsRequiredValue?: CommentsRequired;
}

export class ServiceCodeDetailsDto implements IServiceCodeDetailsDto {
    servCode?: string | undefined;
    companyId?: number;
    serviceCodeId?: number;
    description?: string | undefined;

    constructor(data?: IServiceCodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.companyId = _data["companyId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceCodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["companyId"] = this.companyId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["description"] = this.description;
        return data;
    }
}

export interface IServiceCodeDetailsDto {
    servCode?: string | undefined;
    companyId?: number;
    serviceCodeId?: number;
    description?: string | undefined;
}

export class ServiceCodeResponseDto implements IServiceCodeResponseDto {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    authType?: AuthType;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number | undefined;
    payCalculationMethodText?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;
    billableFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    departmentPaidHoursFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    documentType?: DocumentType[] | undefined;
    commentsRequiredValue?: CommentsRequired;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IServiceCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.masterCode = _data["masterCode"];
            this.otFlag = _data["otFlag"];
            this.authType = _data["authType"];
            this.cchFlag = _data["cchFlag"];
            this.wwlFlag = _data["wwlFlag"];
            this.taskRequiredFlag = _data["taskRequiredFlag"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.unitType = _data["unitType"];
            this.payCalculationMethod = _data["payCalculationMethod"];
            this.payCalculationMethodText = _data["payCalculationMethodText"];
            this.masterServCode = _data["masterServCode"];
            this.masterServCodeDescription = _data["masterServCodeDescription"];
            this.serviceType = _data["serviceType"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
            this.authAllocationFlag = _data["authAllocationFlag"];
            this.billableFlag = _data["billableFlag"];
            this.okToWorkExemptFlag = _data["okToWorkExemptFlag"];
            this.reportableFlag = _data["reportableFlag"];
            this.holidayEligibleFlag = _data["holidayEligibleFlag"];
            this.includedIn24HourRule = _data["includedIn24HourRule"];
            this.departmentPaidHoursFlag = _data["departmentPaidHoursFlag"];
            this.twenty147ExemptFlag = _data["twenty147ExemptFlag"];
            this.generatesAdminTimeFlag = _data["generatesAdminTimeFlag"];
            this.includedInDailyWorkLimitRule = _data["includedInDailyWorkLimitRule"];
            if (Array.isArray(_data["documentType"])) {
                this.documentType = [] as any;
                for (let item of _data["documentType"])
                    this.documentType!.push(DocumentType.fromJS(item));
            }
            this.commentsRequiredValue = _data["commentsRequiredValue"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["masterCode"] = this.masterCode;
        data["otFlag"] = this.otFlag;
        data["authType"] = this.authType;
        data["cchFlag"] = this.cchFlag;
        data["wwlFlag"] = this.wwlFlag;
        data["taskRequiredFlag"] = this.taskRequiredFlag;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["unitType"] = this.unitType;
        data["payCalculationMethod"] = this.payCalculationMethod;
        data["payCalculationMethodText"] = this.payCalculationMethodText;
        data["masterServCode"] = this.masterServCode;
        data["masterServCodeDescription"] = this.masterServCodeDescription;
        data["serviceType"] = this.serviceType;
        data["serviceTypeCode"] = this.serviceTypeCode;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        data["authAllocationFlag"] = this.authAllocationFlag;
        data["billableFlag"] = this.billableFlag;
        data["okToWorkExemptFlag"] = this.okToWorkExemptFlag;
        data["reportableFlag"] = this.reportableFlag;
        data["holidayEligibleFlag"] = this.holidayEligibleFlag;
        data["includedIn24HourRule"] = this.includedIn24HourRule;
        data["departmentPaidHoursFlag"] = this.departmentPaidHoursFlag;
        data["twenty147ExemptFlag"] = this.twenty147ExemptFlag;
        data["generatesAdminTimeFlag"] = this.generatesAdminTimeFlag;
        data["includedInDailyWorkLimitRule"] = this.includedInDailyWorkLimitRule;
        if (Array.isArray(this.documentType)) {
            data["documentType"] = [];
            for (let item of this.documentType)
                data["documentType"].push(item ? item.toJSON() : <any>undefined);
        }
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceCodeResponseDto {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    authType?: AuthType;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: number | undefined;
    payCalculationMethodText?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;
    billableFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    reportableFlag?: string | undefined;
    holidayEligibleFlag?: boolean;
    includedIn24HourRule?: boolean;
    departmentPaidHoursFlag?: string | undefined;
    twenty147ExemptFlag?: string | undefined;
    generatesAdminTimeFlag?: boolean;
    includedInDailyWorkLimitRule?: boolean;
    documentType?: DocumentType[] | undefined;
    commentsRequiredValue?: CommentsRequired;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class StateLookupDto implements IStateLookupDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IStateLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): StateLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IStateLookupDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class SubAccountLookupDto implements ISubAccountLookupDto {
    id?: number;
    sub?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISubAccountLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sub = _data["sub"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SubAccountLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sub"] = this.sub;
        data["description"] = this.description;
        return data;
    }
}

export interface ISubAccountLookupDto {
    id?: number;
    sub?: string | undefined;
    description?: string | undefined;
}

export class WriteOffCauseByIdResponseDto implements IWriteOffCauseByIdResponseDto {
    id?: number;
    woCause?: string | undefined;
    descr?: string | undefined;
    accountId?: number | undefined;
    account?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;

    constructor(data?: IWriteOffCauseByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.woCause = _data["woCause"];
            this.descr = _data["descr"];
            this.accountId = _data["accountId"];
            this.account = _data["account"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.status = _data["status"];
            this.approvalStatus = _data["approvalStatus"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffCauseByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffCauseByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["woCause"] = this.woCause;
        data["descr"] = this.descr;
        data["accountId"] = this.accountId;
        data["account"] = this.account;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["status"] = this.status;
        data["approvalStatus"] = this.approvalStatus;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWriteOffCauseByIdResponseDto {
    id?: number;
    woCause?: string | undefined;
    descr?: string | undefined;
    accountId?: number | undefined;
    account?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
}

export class WriteOffCauseIdRequestDto implements IWriteOffCauseIdRequestDto {
    ids?: number[] | undefined;

    constructor(data?: IWriteOffCauseIdRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): WriteOffCauseIdRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffCauseIdRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IWriteOffCauseIdRequestDto {
    ids?: number[] | undefined;
}

export class WriteOffCauseIdResponseDto implements IWriteOffCauseIdResponseDto {
    id?: number | undefined;
    writeOffCause?: string | undefined;

    constructor(data?: IWriteOffCauseIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.writeOffCause = _data["writeOffCause"];
        }
    }

    static fromJS(data: any): WriteOffCauseIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffCauseIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["writeOffCause"] = this.writeOffCause;
        return data;
    }
}

export interface IWriteOffCauseIdResponseDto {
    id?: number | undefined;
    writeOffCause?: string | undefined;
}

export class WriteOffCauseRequestDto implements IWriteOffCauseRequestDto {
    id?: number | undefined;
    accountId?: number;
    companyId?: number;
    woCause!: string;
    status?: string | undefined;
    descr?: string | undefined;
    approvalStatus?: string | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;

    constructor(data?: IWriteOffCauseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.companyId = _data["companyId"];
            this.woCause = _data["woCause"];
            this.status = _data["status"];
            this.descr = _data["descr"];
            this.approvalStatus = _data["approvalStatus"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
        }
    }

    static fromJS(data: any): WriteOffCauseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffCauseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["companyId"] = this.companyId;
        data["woCause"] = this.woCause;
        data["status"] = this.status;
        data["descr"] = this.descr;
        data["approvalStatus"] = this.approvalStatus;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        return data;
    }
}

export interface IWriteOffCauseRequestDto {
    id?: number | undefined;
    accountId?: number;
    companyId?: number;
    woCause: string;
    status?: string | undefined;
    descr?: string | undefined;
    approvalStatus?: string | undefined;
    approvedOn?: Date | undefined;
    approvedBy?: string | undefined;
}

export class WriteOffCauseResponseDto implements IWriteOffCauseResponseDto {
    id?: number;
    woCause?: string | undefined;
    description?: string | undefined;
    account?: string | undefined;
    companyName?: string | undefined;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedByName?: string | undefined;
    approvedOn?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IWriteOffCauseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.woCause = _data["woCause"];
            this.description = _data["description"];
            this.account = _data["account"];
            this.companyName = _data["companyName"];
            this.status = _data["status"];
            this.approvalStatus = _data["approvalStatus"];
            this.approvedBy = _data["approvedBy"];
            this.approvedByName = _data["approvedByName"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffCauseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffCauseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["woCause"] = this.woCause;
        data["description"] = this.description;
        data["account"] = this.account;
        data["companyName"] = this.companyName;
        data["status"] = this.status;
        data["approvalStatus"] = this.approvalStatus;
        data["approvedBy"] = this.approvedBy;
        data["approvedByName"] = this.approvedByName;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWriteOffCauseResponseDto {
    id?: number;
    woCause?: string | undefined;
    description?: string | undefined;
    account?: string | undefined;
    companyName?: string | undefined;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedByName?: string | undefined;
    approvedOn?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class DeleteShiftRequestDTO implements IDeleteShiftRequestDTO {
    id!: string;
    documentType!: string;

    constructor(data?: IDeleteShiftRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): DeleteShiftRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteShiftRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface IDeleteShiftRequestDTO {
    id: string;
    documentType: string;
}

export class DeleteShiftsRequestDTO implements IDeleteShiftsRequestDTO {
    shifts!: DeleteShiftRequestDTO[];
    participantId!: string;
    caregiverId!: string;
    logging?: ShiftDiagnosisLogging;

    constructor(data?: IDeleteShiftsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shifts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(DeleteShiftRequestDTO.fromJS(item));
            }
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.logging = _data["logging"] ? ShiftDiagnosisLogging.fromJS(_data["logging"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteShiftsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteShiftsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : <any>undefined);
        }
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["logging"] = this.logging ? this.logging.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteShiftsRequestDTO {
    shifts: DeleteShiftRequestDTO[];
    participantId: string;
    caregiverId: string;
    logging?: ShiftDiagnosisLogging;
}

export class EvvExceptionReasonCodeResponseDto implements IEvvExceptionReasonCodeResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    visibleInU2?: boolean;
    visibleInV4?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IEvvExceptionReasonCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.visibleInU2 = _data["visibleInU2"];
            this.visibleInV4 = _data["visibleInV4"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EvvExceptionReasonCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["visibleInU2"] = this.visibleInU2;
        data["visibleInV4"] = this.visibleInV4;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEvvExceptionReasonCodeResponseDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    visibleInU2?: boolean;
    visibleInV4?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class RejectShiftsRequestDTO implements IRejectShiftsRequestDTO {
    rejectionComments!: string;
    caregiverId!: string;
    participantId!: string;
    rejectedByUserId!: string;
    shiftId!: string;
    docType?: string | undefined;
    logging?: ShiftDiagnosisLogging;

    constructor(data?: IRejectShiftsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rejectionComments = _data["rejectionComments"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.rejectedByUserId = _data["rejectedByUserId"];
            this.shiftId = _data["shiftId"];
            this.docType = _data["docType"];
            this.logging = _data["logging"] ? ShiftDiagnosisLogging.fromJS(_data["logging"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RejectShiftsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RejectShiftsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rejectionComments"] = this.rejectionComments;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["rejectedByUserId"] = this.rejectedByUserId;
        data["shiftId"] = this.shiftId;
        data["docType"] = this.docType;
        data["logging"] = this.logging ? this.logging.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRejectShiftsRequestDTO {
    rejectionComments: string;
    caregiverId: string;
    participantId: string;
    rejectedByUserId: string;
    shiftId: string;
    docType?: string | undefined;
    logging?: ShiftDiagnosisLogging;
}

export class CaseLoadCreateUpdateRequest implements ICaseLoadCreateUpdateRequest {
    id?: number | undefined;
    name!: string;
    user!: string;
    agencyId!: number;
    participants?: CaseLoadParticipantId[] | undefined;
    serviceFacilitators?: ServiceFacilitatorId[] | undefined;
    selectedAllParticipant?: boolean;
    unSelectedParticipants?: CaseLoadParticipantId[] | undefined;

    constructor(data?: ICaseLoadCreateUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.user = _data["user"];
            this.agencyId = _data["agencyId"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(CaseLoadParticipantId.fromJS(item));
            }
            if (Array.isArray(_data["serviceFacilitators"])) {
                this.serviceFacilitators = [] as any;
                for (let item of _data["serviceFacilitators"])
                    this.serviceFacilitators!.push(ServiceFacilitatorId.fromJS(item));
            }
            this.selectedAllParticipant = _data["selectedAllParticipant"];
            if (Array.isArray(_data["unSelectedParticipants"])) {
                this.unSelectedParticipants = [] as any;
                for (let item of _data["unSelectedParticipants"])
                    this.unSelectedParticipants!.push(CaseLoadParticipantId.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseLoadCreateUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadCreateUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["user"] = this.user;
        data["agencyId"] = this.agencyId;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.serviceFacilitators)) {
            data["serviceFacilitators"] = [];
            for (let item of this.serviceFacilitators)
                data["serviceFacilitators"].push(item ? item.toJSON() : <any>undefined);
        }
        data["selectedAllParticipant"] = this.selectedAllParticipant;
        if (Array.isArray(this.unSelectedParticipants)) {
            data["unSelectedParticipants"] = [];
            for (let item of this.unSelectedParticipants)
                data["unSelectedParticipants"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICaseLoadCreateUpdateRequest {
    id?: number | undefined;
    name: string;
    user: string;
    agencyId: number;
    participants?: CaseLoadParticipantId[] | undefined;
    serviceFacilitators?: ServiceFacilitatorId[] | undefined;
    selectedAllParticipant?: boolean;
    unSelectedParticipants?: CaseLoadParticipantId[] | undefined;
}

export class CaseLoadDeleteRequest implements ICaseLoadDeleteRequest {
    ids?: string | undefined;
    user?: string | undefined;

    constructor(data?: ICaseLoadDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ids = _data["ids"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): CaseLoadDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ids"] = this.ids;
        data["user"] = this.user;
        return data;
    }
}

export interface ICaseLoadDeleteRequest {
    ids?: string | undefined;
    user?: string | undefined;
}

export class CaseLoadDetailsResponse implements ICaseLoadDetailsResponse {
    id?: number;
    agencyId?: number;
    name?: string | undefined;
    participants?: CaseLoadPerson[] | undefined;
    serviceFacilitators?: CaseLoadPerson[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICaseLoadDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyId = _data["agencyId"];
            this.name = _data["name"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(CaseLoadPerson.fromJS(item));
            }
            if (Array.isArray(_data["serviceFacilitators"])) {
                this.serviceFacilitators = [] as any;
                for (let item of _data["serviceFacilitators"])
                    this.serviceFacilitators!.push(CaseLoadPerson.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CaseLoadDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyId"] = this.agencyId;
        data["name"] = this.name;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.serviceFacilitators)) {
            data["serviceFacilitators"] = [];
            for (let item of this.serviceFacilitators)
                data["serviceFacilitators"].push(item ? item.toJSON() : <any>undefined);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICaseLoadDetailsResponse {
    id?: number;
    agencyId?: number;
    name?: string | undefined;
    participants?: CaseLoadPerson[] | undefined;
    serviceFacilitators?: CaseLoadPerson[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class CaseLoadParticipantId implements ICaseLoadParticipantId {
    id!: number;

    constructor(data?: ICaseLoadParticipantId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CaseLoadParticipantId {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadParticipantId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICaseLoadParticipantId {
    id: number;
}

export class CaseLoadPerson implements ICaseLoadPerson {
    id?: number;
    personId?: string | undefined;
    name?: string | undefined;
    insurerId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICaseLoadPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.insurerId = _data["insurerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CaseLoadPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["insurerId"] = this.insurerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICaseLoadPerson {
    id?: number;
    personId?: string | undefined;
    name?: string | undefined;
    insurerId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class CaseLoadResponse implements ICaseLoadResponse {
    id?: number;
    name?: string | undefined;
    serviceFacilitators?: string | undefined;
    participants?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICaseLoadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.serviceFacilitators = _data["serviceFacilitators"];
            this.participants = _data["participants"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseLoadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["serviceFacilitators"] = this.serviceFacilitators;
        data["participants"] = this.participants;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaseLoadResponse {
    id?: number;
    name?: string | undefined;
    serviceFacilitators?: string | undefined;
    participants?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CaseLoadSearchRequest implements ICaseLoadSearchRequest {
    agencyId!: number;
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: ICaseLoadSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"];
            this.searchParameter = _data["searchParameter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): CaseLoadSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId;
        data["searchParameter"] = this.searchParameter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface ICaseLoadSearchRequest {
    agencyId: number;
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class ServiceFacilitatorId implements IServiceFacilitatorId {
    id!: number;

    constructor(data?: IServiceFacilitatorId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ServiceFacilitatorId {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFacilitatorId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IServiceFacilitatorId {
    id: number;
}

export class ClaimType implements IClaimType {
    claimTypeId?: number;
    claimTypeCode?: string | undefined;
    claimTypeText?: string | undefined;

    constructor(data?: IClaimType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimTypeId = _data["claimTypeId"];
            this.claimTypeCode = _data["claimTypeCode"];
            this.claimTypeText = _data["claimTypeText"];
        }
    }

    static fromJS(data: any): ClaimType {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimTypeId"] = this.claimTypeId;
        data["claimTypeCode"] = this.claimTypeCode;
        data["claimTypeText"] = this.claimTypeText;
        return data;
    }
}

export interface IClaimType {
    claimTypeId?: number;
    claimTypeCode?: string | undefined;
    claimTypeText?: string | undefined;
}

export class ClientInsInfoDTO implements IClientInsInfoDTO {
    id?: number;
    payorId?: number;
    clearinghouse?: string | undefined;
    identification?: string | undefined;
    group?: string | undefined;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: string | undefined;
    maritalStatus?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    employer?: string | undefined;
    ptStatus?: string | undefined;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: string | undefined;
    otherAccident?: string | undefined;
    employment?: string | undefined;
    active?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    payerName?: string | undefined;
    payorName?: string | undefined;
    comment?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    syncParticipantDetails?: boolean;
    stateCode?: string | undefined;
    companyId?: number | undefined;
    personId?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IClientInsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payorId = _data["payorId"];
            this.clearinghouse = _data["clearinghouse"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.firstName = _data["firstName"];
            this.mi = _data["mi"];
            this.lastName = _data["lastName"];
            this.clientRelation = _data["clientRelation"];
            this.maritalStatus = _data["maritalStatus"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.employer = _data["employer"];
            this.ptStatus = _data["ptStatus"];
            this.phone = _data["phone"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.autoAccident = _data["autoAccident"];
            this.otherAccident = _data["otherAccident"];
            this.employment = _data["employment"];
            this.active = _data["active"];
            this.custId = _data["custId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.payerName = _data["payerName"];
            this.payorName = _data["payorName"];
            this.comment = _data["comment"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.syncParticipantDetails = _data["syncParticipantDetails"];
            this.stateCode = _data["stateCode"];
            this.companyId = _data["companyId"];
            this.personId = _data["personId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientInsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payorId"] = this.payorId;
        data["clearinghouse"] = this.clearinghouse;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["firstName"] = this.firstName;
        data["mi"] = this.mi;
        data["lastName"] = this.lastName;
        data["clientRelation"] = this.clientRelation;
        data["maritalStatus"] = this.maritalStatus;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["employer"] = this.employer;
        data["ptStatus"] = this.ptStatus;
        data["phone"] = this.phone;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["autoAccident"] = this.autoAccident;
        data["otherAccident"] = this.otherAccident;
        data["employment"] = this.employment;
        data["active"] = this.active;
        data["custId"] = this.custId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["payerName"] = this.payerName;
        data["payorName"] = this.payorName;
        data["comment"] = this.comment;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["syncParticipantDetails"] = this.syncParticipantDetails;
        data["stateCode"] = this.stateCode;
        data["companyId"] = this.companyId;
        data["personId"] = this.personId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientInsInfoDTO {
    id?: number;
    payorId?: number;
    clearinghouse?: string | undefined;
    identification?: string | undefined;
    group?: string | undefined;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: string | undefined;
    maritalStatus?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    employer?: string | undefined;
    ptStatus?: string | undefined;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: string | undefined;
    otherAccident?: string | undefined;
    employment?: string | undefined;
    active?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    payerName?: string | undefined;
    payorName?: string | undefined;
    comment?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    syncParticipantDetails?: boolean;
    stateCode?: string | undefined;
    companyId?: number | undefined;
    personId?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class ClientInsInfoRequest implements IClientInsInfoRequest {
    id?: number;
    custId!: number;
    payorId!: number;
    clearinghouse?: string | undefined;
    identification!: string;
    group?: string | undefined;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: ClientRelation;
    maritalStatus?: MaritalStatus;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: Gender;
    employer?: string | undefined;
    ptStatus?: PtStatus;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: CvetBoolean;
    otherAccident?: CvetBoolean;
    employment?: CvetBoolean;
    comment?: string | undefined;
    active?: Status;
    syncParticipantDetails?: boolean;

    constructor(data?: IClientInsInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.payorId = _data["payorId"];
            this.clearinghouse = _data["clearinghouse"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.firstName = _data["firstName"];
            this.mi = _data["mi"];
            this.lastName = _data["lastName"];
            this.clientRelation = _data["clientRelation"];
            this.maritalStatus = _data["maritalStatus"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.employer = _data["employer"];
            this.ptStatus = _data["ptStatus"];
            this.phone = _data["phone"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.autoAccident = _data["autoAccident"];
            this.otherAccident = _data["otherAccident"];
            this.employment = _data["employment"];
            this.comment = _data["comment"];
            this.active = _data["active"];
            this.syncParticipantDetails = _data["syncParticipantDetails"];
        }
    }

    static fromJS(data: any): ClientInsInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInsInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["payorId"] = this.payorId;
        data["clearinghouse"] = this.clearinghouse;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["firstName"] = this.firstName;
        data["mi"] = this.mi;
        data["lastName"] = this.lastName;
        data["clientRelation"] = this.clientRelation;
        data["maritalStatus"] = this.maritalStatus;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["employer"] = this.employer;
        data["ptStatus"] = this.ptStatus;
        data["phone"] = this.phone;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["autoAccident"] = this.autoAccident;
        data["otherAccident"] = this.otherAccident;
        data["employment"] = this.employment;
        data["comment"] = this.comment;
        data["active"] = this.active;
        data["syncParticipantDetails"] = this.syncParticipantDetails;
        return data;
    }
}

export interface IClientInsInfoRequest {
    id?: number;
    custId: number;
    payorId: number;
    clearinghouse?: string | undefined;
    identification: string;
    group?: string | undefined;
    firstName?: string | undefined;
    mi?: string | undefined;
    lastName?: string | undefined;
    clientRelation?: ClientRelation;
    maritalStatus?: MaritalStatus;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    dob?: Date | undefined;
    gender?: Gender;
    employer?: string | undefined;
    ptStatus?: PtStatus;
    phone?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    autoAccident?: CvetBoolean;
    otherAccident?: CvetBoolean;
    employment?: CvetBoolean;
    comment?: string | undefined;
    active?: Status;
    syncParticipantDetails?: boolean;
}

export class CommonLkpDTO implements ICommonLkpDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    status?: string | undefined;

    constructor(data?: ICommonLkpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CommonLkpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CommonLkpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["status"] = this.status;
        return data;
    }
}

export interface ICommonLkpDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    status?: string | undefined;
}

export class CustBySolomonRequestDto implements ICustBySolomonRequestDto {
    filterRequest?: CustExFilterRequest;
    participantIds?: string[] | undefined;

    constructor(data?: ICustBySolomonRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterRequest = _data["filterRequest"] ? CustExFilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CustBySolomonRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustBySolomonRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        return data;
    }
}

export interface ICustBySolomonRequestDto {
    filterRequest?: CustExFilterRequest;
    participantIds?: string[] | undefined;
}

export class CustExFilterRequest implements ICustExFilterRequest {
    einId?: number | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payorId?: number | undefined;

    constructor(data?: ICustExFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sortDirection = "ASC";
            this.pageSize = 10;
            this.pageNumber = 1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.einId = _data["einId"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : "ASC";
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : 10;
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : 1;
            this.payorId = _data["payorId"];
        }
    }

    static fromJS(data: any): CustExFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustExFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["einId"] = this.einId;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payorId"] = this.payorId;
        return data;
    }
}

export interface ICustExFilterRequest {
    einId?: number | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payorId?: number | undefined;
}

export class CustomerExDto implements ICustomerExDto {
    id?: number;
    custId?: string | undefined;
    companyId?: number;
    dob?: Date | undefined;
    clientName?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    pcid?: string | undefined;
    insuredId?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ICustomerExDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.companyId = _data["companyId"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.clientName = _data["clientName"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.pcid = _data["pcid"];
            this.insuredId = _data["insuredId"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): CustomerExDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["companyId"] = this.companyId;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["clientName"] = this.clientName;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["pcid"] = this.pcid;
        data["insuredId"] = this.insuredId;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ICustomerExDto {
    id?: number;
    custId?: string | undefined;
    companyId?: number;
    dob?: Date | undefined;
    clientName?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    pcid?: string | undefined;
    insuredId?: string | undefined;
    lastName?: string | undefined;
}

export class CustomerExResponseDto implements ICustomerExResponseDto {
    id?: number;
    custId?: string | undefined;
    companyId?: number;
    phone?: string | undefined;
    phoneVal?: PhoneDetail[] | undefined;
    name?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    addressVal?: AddressDTO[] | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;

    constructor(data?: ICustomerExResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.companyId = _data["companyId"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["phoneVal"])) {
                this.phoneVal = [] as any;
                for (let item of _data["phoneVal"])
                    this.phoneVal!.push(PhoneDetail.fromJS(item));
            }
            this.name = _data["name"];
            this.email = _data["email"];
            this.address = _data["address"];
            if (Array.isArray(_data["addressVal"])) {
                this.addressVal = [] as any;
                for (let item of _data["addressVal"])
                    this.addressVal!.push(AddressDTO.fromJS(item));
            }
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): CustomerExResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["companyId"] = this.companyId;
        data["phone"] = this.phone;
        if (Array.isArray(this.phoneVal)) {
            data["phoneVal"] = [];
            for (let item of this.phoneVal)
                data["phoneVal"].push(item ? item.toJSON() : <any>undefined);
        }
        data["name"] = this.name;
        data["email"] = this.email;
        data["address"] = this.address;
        if (Array.isArray(this.addressVal)) {
            data["addressVal"] = [];
            for (let item of this.addressVal)
                data["addressVal"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }
}

export interface ICustomerExResponseDto {
    id?: number;
    custId?: string | undefined;
    companyId?: number;
    phone?: string | undefined;
    phoneVal?: PhoneDetail[] | undefined;
    name?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    addressVal?: AddressDTO[] | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
}

export class DiagCodeDto implements IDiagCodeDto {
    id?: number;
    description?: string | undefined;
    diagCode?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IDiagCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.diagCode = _data["diagCode"];
            this.active = _data["active"];
            this.comment = _data["comment"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DiagCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiagCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["diagCode"] = this.diagCode;
        data["active"] = this.active;
        data["comment"] = this.comment;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDiagCodeDto {
    id?: number;
    description?: string | undefined;
    diagCode?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class DiagCodeRequest implements IDiagCodeRequest {
    id?: number;
    description?: string | undefined;
    diagCode!: string;
    active?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IDiagCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.diagCode = _data["diagCode"];
            this.active = _data["active"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DiagCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DiagCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["diagCode"] = this.diagCode;
        data["active"] = this.active;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IDiagCodeRequest {
    id?: number;
    description?: string | undefined;
    diagCode: string;
    active?: string | undefined;
    comment?: string | undefined;
}

export class DocumentType implements IDocumentType {
    documentTypeId?: number;
    documentTypeCode?: string | undefined;
    documentTypeText?: string | undefined;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeCode = _data["documentTypeCode"];
            this.documentTypeText = _data["documentTypeText"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeCode"] = this.documentTypeCode;
        data["documentTypeText"] = this.documentTypeText;
        return data;
    }
}

export interface IDocumentType {
    documentTypeId?: number;
    documentTypeCode?: string | undefined;
    documentTypeText?: string | undefined;
}

export class EmployeeFilterRequest implements IEmployeeFilterRequest {
    clientId?: number | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    includeProspects?: boolean;

    constructor(data?: IEmployeeFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sortDirection = "ASC";
            this.pageSize = 10;
            this.pageNumber = 1;
            this.includeProspects = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : "ASC";
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : 10;
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : 1;
            this.includeProspects = _data["includeProspects"] !== undefined ? _data["includeProspects"] : false;
        }
    }

    static fromJS(data: any): EmployeeFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["includeProspects"] = this.includeProspects;
        return data;
    }
}

export interface IEmployeeFilterRequest {
    clientId?: number | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    includeProspects?: boolean;
}

export class EmployeeLkpByIdsRequestDto implements IEmployeeLkpByIdsRequestDto {
    filterRequest?: EmployeeFilterRequest;
    caregiverIds?: string[] | undefined;

    constructor(data?: IEmployeeLkpByIdsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterRequest = _data["filterRequest"] ? EmployeeFilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeLkpByIdsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeLkpByIdsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        return data;
    }
}

export interface IEmployeeLkpByIdsRequestDto {
    filterRequest?: EmployeeFilterRequest;
    caregiverIds?: string[] | undefined;
}

export enum ClientRelation {
    S = "S",
    Sp = "Sp",
    C = "C",
    D = "D",
    O = "O",
}

export enum CvetBoolean {
    N = "N",
    Y = "Y",
}

export enum Gender {
    M = "M",
    F = "F",
    U = "U",
}

export enum MaritalStatus {
    Y = "Y",
    W = "W",
    U = "U",
    S = "S",
    J = "J",
    M = "M",
    H = "H",
}

export enum PayrollProgram {
    Solomon = "Solomon",
    WorkDay = "WorkDay",
}

export enum PtStatus {
    E = "E",
    U = "U",
    R = "R",
    F = "F",
    P = "P",
    O = "O",
}

export enum ServCodePrerequisiteEvalType {
    Day = "Day",
}

export enum Status {
    A = "A",
    I = "I",
}

export class EvvExceptionReasonCodeDto implements IEvvExceptionReasonCodeDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    visibleInU2?: boolean;
    visibleInV4?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isDeleted?: boolean;
    programId?: number;
    programName?: string | undefined;

    constructor(data?: IEvvExceptionReasonCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.visibleInU2 = _data["visibleInU2"];
            this.visibleInV4 = _data["visibleInV4"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.programId = _data["programId"];
            this.programName = _data["programName"];
        }
    }

    static fromJS(data: any): EvvExceptionReasonCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["visibleInU2"] = this.visibleInU2;
        data["visibleInV4"] = this.visibleInV4;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["programId"] = this.programId;
        data["programName"] = this.programName;
        return data;
    }
}

export interface IEvvExceptionReasonCodeDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    visibleInU2?: boolean;
    visibleInV4?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isDeleted?: boolean;
    programId?: number;
    programName?: string | undefined;
}

export class EvvExceptionReasonCodeProgramDto implements IEvvExceptionReasonCodeProgramDto {
    evvExceptionReasonCode?: EvvExceptionReasonCodeDto;
    evvExceptionReasonProgramDto?: EvvExceptionReasonProgramDto[] | undefined;

    constructor(data?: IEvvExceptionReasonCodeProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evvExceptionReasonCode = _data["evvExceptionReasonCode"] ? EvvExceptionReasonCodeDto.fromJS(_data["evvExceptionReasonCode"]) : <any>undefined;
            if (Array.isArray(_data["evvExceptionReasonProgramDto"])) {
                this.evvExceptionReasonProgramDto = [] as any;
                for (let item of _data["evvExceptionReasonProgramDto"])
                    this.evvExceptionReasonProgramDto!.push(EvvExceptionReasonProgramDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvvExceptionReasonCodeProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonCodeProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evvExceptionReasonCode"] = this.evvExceptionReasonCode ? this.evvExceptionReasonCode.toJSON() : <any>undefined;
        if (Array.isArray(this.evvExceptionReasonProgramDto)) {
            data["evvExceptionReasonProgramDto"] = [];
            for (let item of this.evvExceptionReasonProgramDto)
                data["evvExceptionReasonProgramDto"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEvvExceptionReasonCodeProgramDto {
    evvExceptionReasonCode?: EvvExceptionReasonCodeDto;
    evvExceptionReasonProgramDto?: EvvExceptionReasonProgramDto[] | undefined;
}

export class EvvExceptionReasonIdsDto implements IEvvExceptionReasonIdsDto {
    evvExceptionReasonCodeIds?: number[] | undefined;

    constructor(data?: IEvvExceptionReasonIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["evvExceptionReasonCodeIds"])) {
                this.evvExceptionReasonCodeIds = [] as any;
                for (let item of _data["evvExceptionReasonCodeIds"])
                    this.evvExceptionReasonCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EvvExceptionReasonIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.evvExceptionReasonCodeIds)) {
            data["evvExceptionReasonCodeIds"] = [];
            for (let item of this.evvExceptionReasonCodeIds)
                data["evvExceptionReasonCodeIds"].push(item);
        }
        return data;
    }
}

export interface IEvvExceptionReasonIdsDto {
    evvExceptionReasonCodeIds?: number[] | undefined;
}

export class EvvExceptionReasonProgramDto implements IEvvExceptionReasonProgramDto {
    programId?: number;
    programName?: string | undefined;

    constructor(data?: IEvvExceptionReasonProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.programName = _data["programName"];
        }
    }

    static fromJS(data: any): EvvExceptionReasonProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvvExceptionReasonProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["programName"] = this.programName;
        return data;
    }
}

export interface IEvvExceptionReasonProgramDto {
    programId?: number;
    programName?: string | undefined;
}

export class ExCaseMgrDetailsDto implements IExCaseMgrDetailsDto {
    id?: number;
    ecmExId?: string | undefined;
    active?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    attn?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    noteId?: number | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    program?: string | undefined;
    payorId?: number | undefined;
    payor?: string | undefined;
    vendorId?: number | undefined;
    vendor?: string | undefined;
    comment?: string | undefined;
    countryName?: string | undefined;
    programTypeDetails?: ExCmProgramTypeDetails[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IExCaseMgrDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ecmExId = _data["ecmExId"];
            this.active = _data["active"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.attn = _data["attn"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.emailAddress = _data["emailAddress"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.noteId = _data["noteId"];
            this.phone = _data["phone"];
            this.stateId = _data["stateId"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.programId = _data["programId"];
            this.program = _data["program"];
            this.payorId = _data["payorId"];
            this.payor = _data["payor"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"];
            this.comment = _data["comment"];
            this.countryName = _data["countryName"];
            if (Array.isArray(_data["programTypeDetails"])) {
                this.programTypeDetails = [] as any;
                for (let item of _data["programTypeDetails"])
                    this.programTypeDetails!.push(ExCmProgramTypeDetails.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExCaseMgrDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgrDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ecmExId"] = this.ecmExId;
        data["active"] = this.active;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["attn"] = this.attn;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["emailAddress"] = this.emailAddress;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["noteId"] = this.noteId;
        data["phone"] = this.phone;
        data["stateId"] = this.stateId;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["programId"] = this.programId;
        data["program"] = this.program;
        data["payorId"] = this.payorId;
        data["payor"] = this.payor;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor;
        data["comment"] = this.comment;
        data["countryName"] = this.countryName;
        if (Array.isArray(this.programTypeDetails)) {
            data["programTypeDetails"] = [];
            for (let item of this.programTypeDetails)
                data["programTypeDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExCaseMgrDetailsDto {
    id?: number;
    ecmExId?: string | undefined;
    active?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    attn?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    noteId?: number | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    program?: string | undefined;
    payorId?: number | undefined;
    payor?: string | undefined;
    vendorId?: number | undefined;
    vendor?: string | undefined;
    comment?: string | undefined;
    countryName?: string | undefined;
    programTypeDetails?: ExCmProgramTypeDetails[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class ExCaseMgrSearchRequest implements IExCaseMgrSearchRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IExCaseMgrSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): ExCaseMgrSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgrSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IExCaseMgrSearchRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class ExCmProgramTypeDetails implements IExCmProgramTypeDetails {
    id?: number | undefined;
    programTypeId?: number;
    programType?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date | undefined;

    constructor(data?: IExCmProgramTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programTypeId = _data["programTypeId"];
            this.programType = _data["programType"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExCmProgramTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExCmProgramTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programTypeId"] = this.programTypeId;
        data["programType"] = this.programType;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExCmProgramTypeDetails {
    id?: number | undefined;
    programTypeId?: number;
    programType?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
}

export class ExportRequest implements IExportRequest {
    exportType?: string | undefined;
    searchCriteria?: any | undefined;
    includeSearchCriteriaInMailBody?: boolean;

    constructor(data?: IExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportType = _data["exportType"];
            this.searchCriteria = _data["searchCriteria"];
            this.includeSearchCriteriaInMailBody = _data["includeSearchCriteriaInMailBody"];
        }
    }

    static fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportType"] = this.exportType;
        data["searchCriteria"] = this.searchCriteria;
        data["includeSearchCriteriaInMailBody"] = this.includeSearchCriteriaInMailBody;
        return data;
    }
}

export interface IExportRequest {
    exportType?: string | undefined;
    searchCriteria?: any | undefined;
    includeSearchCriteriaInMailBody?: boolean;
}

export class AuthCodeDetail implements IAuthCodeDetail {
    authCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    acn?: string | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    program?: string | undefined;
    serviceId?: string | undefined;

    constructor(data?: IAuthCodeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authCode = _data["authCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.acn = _data["acn"];
            this.participantId = _data["participantId"];
            this.servCode = _data["servCode"];
            this.program = _data["program"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): AuthCodeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuthCodeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authCode"] = this.authCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["acn"] = this.acn;
        data["participantId"] = this.participantId;
        data["servCode"] = this.servCode;
        data["program"] = this.program;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface IAuthCodeDetail {
    authCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    acn?: string | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    program?: string | undefined;
    serviceId?: string | undefined;
}

export class BatchReviewBillCodeDetail implements IBatchReviewBillCodeDetail {
    billCode?: string | undefined;
    hcpcs?: string | undefined;
    mod1?: string | undefined;
    mod2?: string | undefined;
    mod3?: string | undefined;
    mod4?: string | undefined;
    description?: string | undefined;
    isOverTime?: boolean;
    revenueCode?: string | undefined;

    constructor(data?: IBatchReviewBillCodeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billCode = _data["billCode"];
            this.hcpcs = _data["hcpcs"];
            this.mod1 = _data["mod1"];
            this.mod2 = _data["mod2"];
            this.mod3 = _data["mod3"];
            this.mod4 = _data["mod4"];
            this.description = _data["description"];
            this.isOverTime = _data["isOverTime"];
            this.revenueCode = _data["revenueCode"];
        }
    }

    static fromJS(data: any): BatchReviewBillCodeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewBillCodeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billCode"] = this.billCode;
        data["hcpcs"] = this.hcpcs;
        data["mod1"] = this.mod1;
        data["mod2"] = this.mod2;
        data["mod3"] = this.mod3;
        data["mod4"] = this.mod4;
        data["description"] = this.description;
        data["isOverTime"] = this.isOverTime;
        data["revenueCode"] = this.revenueCode;
        return data;
    }
}

export interface IBatchReviewBillCodeDetail {
    billCode?: string | undefined;
    hcpcs?: string | undefined;
    mod1?: string | undefined;
    mod2?: string | undefined;
    mod3?: string | undefined;
    mod4?: string | undefined;
    description?: string | undefined;
    isOverTime?: boolean;
    revenueCode?: string | undefined;
}

export class BatchReviewDetailsRequestForJSON implements IBatchReviewDetailsRequestForJSON {
    payorId?: string | undefined;
    programId?: string | undefined;
    billcodes?: string[] | undefined;
    caregivers?: string[] | undefined;
    participants?: string[] | undefined;
    companyId?: number;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    isParticipantAreaMappingFlag?: boolean;

    constructor(data?: IBatchReviewDetailsRequestForJSON) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            if (Array.isArray(_data["billcodes"])) {
                this.billcodes = [] as any;
                for (let item of _data["billcodes"])
                    this.billcodes!.push(item);
            }
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(item);
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            this.companyId = _data["companyId"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.isParticipantAreaMappingFlag = _data["isParticipantAreaMappingFlag"];
        }
    }

    static fromJS(data: any): BatchReviewDetailsRequestForJSON {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewDetailsRequestForJSON();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        if (Array.isArray(this.billcodes)) {
            data["billcodes"] = [];
            for (let item of this.billcodes)
                data["billcodes"].push(item);
        }
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        data["companyId"] = this.companyId;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["isParticipantAreaMappingFlag"] = this.isParticipantAreaMappingFlag;
        return data;
    }
}

export interface IBatchReviewDetailsRequestForJSON {
    payorId?: string | undefined;
    programId?: string | undefined;
    billcodes?: string[] | undefined;
    caregivers?: string[] | undefined;
    participants?: string[] | undefined;
    companyId?: number;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    isParticipantAreaMappingFlag?: boolean;
}

export class BatchReviewPayor implements IBatchReviewPayor {
    payorId?: string | undefined;
    payorName?: string | undefined;
    nationalPlanId?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    stateCode?: string | undefined;

    constructor(data?: IBatchReviewPayor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.nationalPlanId = _data["nationalPlanId"];
            this.contactName = _data["contactName"];
            this.emailId = _data["emailId"];
            this.phone = _data["phone"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateName = _data["stateName"];
            this.zip = _data["zip"];
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): BatchReviewPayor {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewPayor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["nationalPlanId"] = this.nationalPlanId;
        data["contactName"] = this.contactName;
        data["emailId"] = this.emailId;
        data["phone"] = this.phone;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateName"] = this.stateName;
        data["zip"] = this.zip;
        data["stateCode"] = this.stateCode;
        return data;
    }
}

export interface IBatchReviewPayor {
    payorId?: string | undefined;
    payorName?: string | undefined;
    nationalPlanId?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    stateCode?: string | undefined;
}

export class BillingAreaInfo implements IBillingAreaInfo {
    participantId?: number;
    area?: string | undefined;
    state?: string | undefined;
    areaStartDate?: Date;
    areaEndDate?: Date;

    constructor(data?: IBillingAreaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.area = _data["area"];
            this.state = _data["state"];
            this.areaStartDate = _data["areaStartDate"] ? new Date(_data["areaStartDate"].toString()) : <any>undefined;
            this.areaEndDate = _data["areaEndDate"] ? new Date(_data["areaEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingAreaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BillingAreaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["area"] = this.area;
        data["state"] = this.state;
        data["areaStartDate"] = this.areaStartDate ? this.areaStartDate.toISOString() : <any>undefined;
        data["areaEndDate"] = this.areaEndDate ? this.areaEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingAreaInfo {
    participantId?: number;
    area?: string | undefined;
    state?: string | undefined;
    areaStartDate?: Date;
    areaEndDate?: Date;
}

export class BillingProviderDetail implements IBillingProviderDetail {
    billingProviderId?: number;
    taxonomy?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    fedTaxId?: string | undefined;
    api?: string | undefined;
    programCode?: string | undefined;
    stateCode?: string | undefined;

    constructor(data?: IBillingProviderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingProviderId = _data["billingProviderId"];
            this.taxonomy = _data["taxonomy"];
            this.contactName = _data["contactName"];
            this.npi = _data["npi"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.fedTaxId = _data["fedTaxId"];
            this.api = _data["api"];
            this.programCode = _data["programCode"];
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): BillingProviderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BillingProviderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingProviderId"] = this.billingProviderId;
        data["taxonomy"] = this.taxonomy;
        data["contactName"] = this.contactName;
        data["npi"] = this.npi;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["fedTaxId"] = this.fedTaxId;
        data["api"] = this.api;
        data["programCode"] = this.programCode;
        data["stateCode"] = this.stateCode;
        return data;
    }
}

export interface IBillingProviderDetail {
    billingProviderId?: number;
    taxonomy?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    fedTaxId?: string | undefined;
    api?: string | undefined;
    programCode?: string | undefined;
    stateCode?: string | undefined;
}

export class ClaimBatchOutboundMetadata implements IClaimBatchOutboundMetadata {
    submitterDetail?: SubmitterDetail[] | undefined;
    receiverDetail?: ReceiverDetail[] | undefined;
    billingProviderDetail?: BillingProviderDetail[] | undefined;
    subscriberDetailInfo?: SubscriberDetailInfo[] | undefined;
    payorInfo?: BatchReviewPayor[] | undefined;
    renderingProviderDetail?: ProviderDetail[] | undefined;
    billCodeDetailsInfo?: BatchReviewBillCodeDetail[] | undefined;
    authCodeDetail?: AuthCodeDetail;
    billingAreaInfo?: BillingAreaInfo[] | undefined;

    constructor(data?: IClaimBatchOutboundMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["submitterDetail"])) {
                this.submitterDetail = [] as any;
                for (let item of _data["submitterDetail"])
                    this.submitterDetail!.push(SubmitterDetail.fromJS(item));
            }
            if (Array.isArray(_data["receiverDetail"])) {
                this.receiverDetail = [] as any;
                for (let item of _data["receiverDetail"])
                    this.receiverDetail!.push(ReceiverDetail.fromJS(item));
            }
            if (Array.isArray(_data["billingProviderDetail"])) {
                this.billingProviderDetail = [] as any;
                for (let item of _data["billingProviderDetail"])
                    this.billingProviderDetail!.push(BillingProviderDetail.fromJS(item));
            }
            if (Array.isArray(_data["subscriberDetailInfo"])) {
                this.subscriberDetailInfo = [] as any;
                for (let item of _data["subscriberDetailInfo"])
                    this.subscriberDetailInfo!.push(SubscriberDetailInfo.fromJS(item));
            }
            if (Array.isArray(_data["payorInfo"])) {
                this.payorInfo = [] as any;
                for (let item of _data["payorInfo"])
                    this.payorInfo!.push(BatchReviewPayor.fromJS(item));
            }
            if (Array.isArray(_data["renderingProviderDetail"])) {
                this.renderingProviderDetail = [] as any;
                for (let item of _data["renderingProviderDetail"])
                    this.renderingProviderDetail!.push(ProviderDetail.fromJS(item));
            }
            if (Array.isArray(_data["billCodeDetailsInfo"])) {
                this.billCodeDetailsInfo = [] as any;
                for (let item of _data["billCodeDetailsInfo"])
                    this.billCodeDetailsInfo!.push(BatchReviewBillCodeDetail.fromJS(item));
            }
            this.authCodeDetail = _data["authCodeDetail"] ? AuthCodeDetail.fromJS(_data["authCodeDetail"]) : <any>undefined;
            if (Array.isArray(_data["billingAreaInfo"])) {
                this.billingAreaInfo = [] as any;
                for (let item of _data["billingAreaInfo"])
                    this.billingAreaInfo!.push(BillingAreaInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaimBatchOutboundMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimBatchOutboundMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.submitterDetail)) {
            data["submitterDetail"] = [];
            for (let item of this.submitterDetail)
                data["submitterDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.receiverDetail)) {
            data["receiverDetail"] = [];
            for (let item of this.receiverDetail)
                data["receiverDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billingProviderDetail)) {
            data["billingProviderDetail"] = [];
            for (let item of this.billingProviderDetail)
                data["billingProviderDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.subscriberDetailInfo)) {
            data["subscriberDetailInfo"] = [];
            for (let item of this.subscriberDetailInfo)
                data["subscriberDetailInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.payorInfo)) {
            data["payorInfo"] = [];
            for (let item of this.payorInfo)
                data["payorInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.renderingProviderDetail)) {
            data["renderingProviderDetail"] = [];
            for (let item of this.renderingProviderDetail)
                data["renderingProviderDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billCodeDetailsInfo)) {
            data["billCodeDetailsInfo"] = [];
            for (let item of this.billCodeDetailsInfo)
                data["billCodeDetailsInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        data["authCodeDetail"] = this.authCodeDetail ? this.authCodeDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.billingAreaInfo)) {
            data["billingAreaInfo"] = [];
            for (let item of this.billingAreaInfo)
                data["billingAreaInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IClaimBatchOutboundMetadata {
    submitterDetail?: SubmitterDetail[] | undefined;
    receiverDetail?: ReceiverDetail[] | undefined;
    billingProviderDetail?: BillingProviderDetail[] | undefined;
    subscriberDetailInfo?: SubscriberDetailInfo[] | undefined;
    payorInfo?: BatchReviewPayor[] | undefined;
    renderingProviderDetail?: ProviderDetail[] | undefined;
    billCodeDetailsInfo?: BatchReviewBillCodeDetail[] | undefined;
    authCodeDetail?: AuthCodeDetail;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
}

export class CustMaintenanceJson implements ICustMaintenanceJson {
    participantId?: string | undefined;
    location?: string | undefined;

    constructor(data?: ICustMaintenanceJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): CustMaintenanceJson {
        data = typeof data === 'object' ? data : {};
        let result = new CustMaintenanceJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["location"] = this.location;
        return data;
    }
}

export interface ICustMaintenanceJson {
    participantId?: string | undefined;
    location?: string | undefined;
}

export class GLAccountDebitLineInfoForJson implements IGLAccountDebitLineInfoForJson {
    glAccount?: string | undefined;
    description?: string | undefined;
    glBatch?: string | undefined;
    woCause?: string | undefined;
    copayDebitAccount?: string | undefined;
    copayDebitAccountDescription?: string | undefined;

    constructor(data?: IGLAccountDebitLineInfoForJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.glAccount = _data["glAccount"];
            this.description = _data["description"];
            this.glBatch = _data["glBatch"];
            this.woCause = _data["woCause"];
            this.copayDebitAccount = _data["copayDebitAccount"];
            this.copayDebitAccountDescription = _data["copayDebitAccountDescription"];
        }
    }

    static fromJS(data: any): GLAccountDebitLineInfoForJson {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountDebitLineInfoForJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glAccount"] = this.glAccount;
        data["description"] = this.description;
        data["glBatch"] = this.glBatch;
        data["woCause"] = this.woCause;
        data["copayDebitAccount"] = this.copayDebitAccount;
        data["copayDebitAccountDescription"] = this.copayDebitAccountDescription;
        return data;
    }
}

export interface IGLAccountDebitLineInfoForJson {
    glAccount?: string | undefined;
    description?: string | undefined;
    glBatch?: string | undefined;
    woCause?: string | undefined;
    copayDebitAccount?: string | undefined;
    copayDebitAccountDescription?: string | undefined;
}

export class GLAccountInfoForJson implements IGLAccountInfoForJson {
    programDetails?: ProgramSetUpInfoJson[] | undefined;
    glBatch?: string | undefined;
    custInfo?: CustMaintenanceJson[] | undefined;
    debitLineDetails?: GLAccountDebitLineInfoForJson[] | undefined;

    constructor(data?: IGLAccountInfoForJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["programDetails"])) {
                this.programDetails = [] as any;
                for (let item of _data["programDetails"])
                    this.programDetails!.push(ProgramSetUpInfoJson.fromJS(item));
            }
            this.glBatch = _data["glBatch"];
            if (Array.isArray(_data["custInfo"])) {
                this.custInfo = [] as any;
                for (let item of _data["custInfo"])
                    this.custInfo!.push(CustMaintenanceJson.fromJS(item));
            }
            if (Array.isArray(_data["debitLineDetails"])) {
                this.debitLineDetails = [] as any;
                for (let item of _data["debitLineDetails"])
                    this.debitLineDetails!.push(GLAccountDebitLineInfoForJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GLAccountInfoForJson {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountInfoForJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.programDetails)) {
            data["programDetails"] = [];
            for (let item of this.programDetails)
                data["programDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["glBatch"] = this.glBatch;
        if (Array.isArray(this.custInfo)) {
            data["custInfo"] = [];
            for (let item of this.custInfo)
                data["custInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.debitLineDetails)) {
            data["debitLineDetails"] = [];
            for (let item of this.debitLineDetails)
                data["debitLineDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGLAccountInfoForJson {
    programDetails?: ProgramSetUpInfoJson[] | undefined;
    glBatch?: string | undefined;
    custInfo?: CustMaintenanceJson[] | undefined;
    debitLineDetails?: GLAccountDebitLineInfoForJson[] | undefined;
}

export class GLInfoValidation implements IGLInfoValidation {
    companyId?: number;
    accountType?: string | undefined;
    programId?: string[] | undefined;
    servCodes?: string[] | undefined;
    participantIds?: string[] | undefined;
    writeOffCauses?: string[] | undefined;
    unappliedWriteoffProgram?: string | undefined;
    batchId?: string | undefined;
    featureFlagForParticipantAreaMapping?: boolean;

    constructor(data?: IGLInfoValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.accountType = _data["accountType"];
            if (Array.isArray(_data["programId"])) {
                this.programId = [] as any;
                for (let item of _data["programId"])
                    this.programId!.push(item);
            }
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(item);
            }
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            if (Array.isArray(_data["writeOffCauses"])) {
                this.writeOffCauses = [] as any;
                for (let item of _data["writeOffCauses"])
                    this.writeOffCauses!.push(item);
            }
            this.unappliedWriteoffProgram = _data["unappliedWriteoffProgram"];
            this.batchId = _data["batchId"];
            this.featureFlagForParticipantAreaMapping = _data["featureFlagForParticipantAreaMapping"];
        }
    }

    static fromJS(data: any): GLInfoValidation {
        data = typeof data === 'object' ? data : {};
        let result = new GLInfoValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["accountType"] = this.accountType;
        if (Array.isArray(this.programId)) {
            data["programId"] = [];
            for (let item of this.programId)
                data["programId"].push(item);
        }
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item);
        }
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        if (Array.isArray(this.writeOffCauses)) {
            data["writeOffCauses"] = [];
            for (let item of this.writeOffCauses)
                data["writeOffCauses"].push(item);
        }
        data["unappliedWriteoffProgram"] = this.unappliedWriteoffProgram;
        data["batchId"] = this.batchId;
        data["featureFlagForParticipantAreaMapping"] = this.featureFlagForParticipantAreaMapping;
        return data;
    }
}

export interface IGLInfoValidation {
    companyId?: number;
    accountType?: string | undefined;
    programId?: string[] | undefined;
    servCodes?: string[] | undefined;
    participantIds?: string[] | undefined;
    writeOffCauses?: string[] | undefined;
    unappliedWriteoffProgram?: string | undefined;
    batchId?: string | undefined;
    featureFlagForParticipantAreaMapping?: boolean;
}

export class GlAccountRequestForJson implements IGlAccountRequestForJson {
    companyId?: number;
    accountType?: string | undefined;
    programId?: string[] | undefined;
    participantIds?: string[] | undefined;
    writeOffCauses?: string[] | undefined;

    constructor(data?: IGlAccountRequestForJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.accountType = _data["accountType"];
            if (Array.isArray(_data["programId"])) {
                this.programId = [] as any;
                for (let item of _data["programId"])
                    this.programId!.push(item);
            }
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            if (Array.isArray(_data["writeOffCauses"])) {
                this.writeOffCauses = [] as any;
                for (let item of _data["writeOffCauses"])
                    this.writeOffCauses!.push(item);
            }
        }
    }

    static fromJS(data: any): GlAccountRequestForJson {
        data = typeof data === 'object' ? data : {};
        let result = new GlAccountRequestForJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["accountType"] = this.accountType;
        if (Array.isArray(this.programId)) {
            data["programId"] = [];
            for (let item of this.programId)
                data["programId"].push(item);
        }
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        if (Array.isArray(this.writeOffCauses)) {
            data["writeOffCauses"] = [];
            for (let item of this.writeOffCauses)
                data["writeOffCauses"].push(item);
        }
        return data;
    }
}

export interface IGlAccountRequestForJson {
    companyId?: number;
    accountType?: string | undefined;
    programId?: string[] | undefined;
    participantIds?: string[] | undefined;
    writeOffCauses?: string[] | undefined;
}

export class ManualBatchReviewDetailsRequestForJson implements IManualBatchReviewDetailsRequestForJson {
    payorId?: string | undefined;
    programId?: string | undefined;
    billcodes?: string[] | undefined;
    participants?: string[] | undefined;
    companyId?: number;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    isParticipantAreaMappingFlag?: boolean;

    constructor(data?: IManualBatchReviewDetailsRequestForJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            if (Array.isArray(_data["billcodes"])) {
                this.billcodes = [] as any;
                for (let item of _data["billcodes"])
                    this.billcodes!.push(item);
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            this.companyId = _data["companyId"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.isParticipantAreaMappingFlag = _data["isParticipantAreaMappingFlag"];
        }
    }

    static fromJS(data: any): ManualBatchReviewDetailsRequestForJson {
        data = typeof data === 'object' ? data : {};
        let result = new ManualBatchReviewDetailsRequestForJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        if (Array.isArray(this.billcodes)) {
            data["billcodes"] = [];
            for (let item of this.billcodes)
                data["billcodes"].push(item);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        data["companyId"] = this.companyId;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["isParticipantAreaMappingFlag"] = this.isParticipantAreaMappingFlag;
        return data;
    }
}

export interface IManualBatchReviewDetailsRequestForJson {
    payorId?: string | undefined;
    programId?: string | undefined;
    billcodes?: string[] | undefined;
    participants?: string[] | undefined;
    companyId?: number;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    isParticipantAreaMappingFlag?: boolean;
}

export class ManualClaimBatchOutboundMetadata implements IManualClaimBatchOutboundMetadata {
    submitterDetail?: SubmitterDetail[] | undefined;
    receiverDetail?: ReceiverDetail[] | undefined;
    billingProviderDetail?: BillingProviderDetail[] | undefined;
    payorInfo?: BatchReviewPayor[] | undefined;
    subscriberDetailInfo?: SubscriberDetailInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BatchReviewBillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;

    constructor(data?: IManualClaimBatchOutboundMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["submitterDetail"])) {
                this.submitterDetail = [] as any;
                for (let item of _data["submitterDetail"])
                    this.submitterDetail!.push(SubmitterDetail.fromJS(item));
            }
            if (Array.isArray(_data["receiverDetail"])) {
                this.receiverDetail = [] as any;
                for (let item of _data["receiverDetail"])
                    this.receiverDetail!.push(ReceiverDetail.fromJS(item));
            }
            if (Array.isArray(_data["billingProviderDetail"])) {
                this.billingProviderDetail = [] as any;
                for (let item of _data["billingProviderDetail"])
                    this.billingProviderDetail!.push(BillingProviderDetail.fromJS(item));
            }
            if (Array.isArray(_data["payorInfo"])) {
                this.payorInfo = [] as any;
                for (let item of _data["payorInfo"])
                    this.payorInfo!.push(BatchReviewPayor.fromJS(item));
            }
            if (Array.isArray(_data["subscriberDetailInfo"])) {
                this.subscriberDetailInfo = [] as any;
                for (let item of _data["subscriberDetailInfo"])
                    this.subscriberDetailInfo!.push(SubscriberDetailInfo.fromJS(item));
            }
            if (Array.isArray(_data["billingAreaInfo"])) {
                this.billingAreaInfo = [] as any;
                for (let item of _data["billingAreaInfo"])
                    this.billingAreaInfo!.push(BillingAreaInfo.fromJS(item));
            }
            if (Array.isArray(_data["billCodeDetailsInfo"])) {
                this.billCodeDetailsInfo = [] as any;
                for (let item of _data["billCodeDetailsInfo"])
                    this.billCodeDetailsInfo!.push(BatchReviewBillCodeDetail.fromJS(item));
            }
            this.placeOfService = _data["placeOfService"];
            this.revenueCode = _data["revenueCode"];
            this.diagCode = _data["diagCode"];
        }
    }

    static fromJS(data: any): ManualClaimBatchOutboundMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ManualClaimBatchOutboundMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.submitterDetail)) {
            data["submitterDetail"] = [];
            for (let item of this.submitterDetail)
                data["submitterDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.receiverDetail)) {
            data["receiverDetail"] = [];
            for (let item of this.receiverDetail)
                data["receiverDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billingProviderDetail)) {
            data["billingProviderDetail"] = [];
            for (let item of this.billingProviderDetail)
                data["billingProviderDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.payorInfo)) {
            data["payorInfo"] = [];
            for (let item of this.payorInfo)
                data["payorInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.subscriberDetailInfo)) {
            data["subscriberDetailInfo"] = [];
            for (let item of this.subscriberDetailInfo)
                data["subscriberDetailInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billingAreaInfo)) {
            data["billingAreaInfo"] = [];
            for (let item of this.billingAreaInfo)
                data["billingAreaInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.billCodeDetailsInfo)) {
            data["billCodeDetailsInfo"] = [];
            for (let item of this.billCodeDetailsInfo)
                data["billCodeDetailsInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        data["placeOfService"] = this.placeOfService;
        data["revenueCode"] = this.revenueCode;
        data["diagCode"] = this.diagCode;
        return data;
    }
}

export interface IManualClaimBatchOutboundMetadata {
    submitterDetail?: SubmitterDetail[] | undefined;
    receiverDetail?: ReceiverDetail[] | undefined;
    billingProviderDetail?: BillingProviderDetail[] | undefined;
    payorInfo?: BatchReviewPayor[] | undefined;
    subscriberDetailInfo?: SubscriberDetailInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BatchReviewBillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;
}

export class ProgramSetUpInfoJson implements IProgramSetUpInfoJson {
    program?: string | undefined;
    programType?: string | undefined;
    payorType?: string | undefined;
    payorSource?: string | undefined;
    revenueAccount?: string | undefined;
    revenueAccountDescription?: string | undefined;
    copayCreditAccount?: string | undefined;
    copayCreditAccountDescription?: string | undefined;

    constructor(data?: IProgramSetUpInfoJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            this.programType = _data["programType"];
            this.payorType = _data["payorType"];
            this.payorSource = _data["payorSource"];
            this.revenueAccount = _data["revenueAccount"];
            this.revenueAccountDescription = _data["revenueAccountDescription"];
            this.copayCreditAccount = _data["copayCreditAccount"];
            this.copayCreditAccountDescription = _data["copayCreditAccountDescription"];
        }
    }

    static fromJS(data: any): ProgramSetUpInfoJson {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramSetUpInfoJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        data["programType"] = this.programType;
        data["payorType"] = this.payorType;
        data["payorSource"] = this.payorSource;
        data["revenueAccount"] = this.revenueAccount;
        data["revenueAccountDescription"] = this.revenueAccountDescription;
        data["copayCreditAccount"] = this.copayCreditAccount;
        data["copayCreditAccountDescription"] = this.copayCreditAccountDescription;
        return data;
    }
}

export interface IProgramSetUpInfoJson {
    program?: string | undefined;
    programType?: string | undefined;
    payorType?: string | undefined;
    payorSource?: string | undefined;
    revenueAccount?: string | undefined;
    revenueAccountDescription?: string | undefined;
    copayCreditAccount?: string | undefined;
    copayCreditAccountDescription?: string | undefined;
}

export class ProviderDetail implements IProviderDetail {
    firstName?: string | undefined;
    lastName?: string | undefined;
    npi?: string | undefined;
    api?: string | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;

    constructor(data?: IProviderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.npi = _data["npi"];
            this.api = _data["api"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
        }
    }

    static fromJS(data: any): ProviderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["npi"] = this.npi;
        data["api"] = this.api;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        return data;
    }
}

export interface IProviderDetail {
    firstName?: string | undefined;
    lastName?: string | undefined;
    npi?: string | undefined;
    api?: string | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
}

export class ReceiverDetail implements IReceiverDetail {
    receiverIdentifier?: number;
    receiverId?: string | undefined;
    receiverName?: string | undefined;
    programCode?: string | undefined;

    constructor(data?: IReceiverDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverIdentifier = _data["receiverIdentifier"];
            this.receiverId = _data["receiverId"];
            this.receiverName = _data["receiverName"];
            this.programCode = _data["programCode"];
        }
    }

    static fromJS(data: any): ReceiverDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverIdentifier"] = this.receiverIdentifier;
        data["receiverId"] = this.receiverId;
        data["receiverName"] = this.receiverName;
        data["programCode"] = this.programCode;
        return data;
    }
}

export interface IReceiverDetail {
    receiverIdentifier?: number;
    receiverId?: string | undefined;
    receiverName?: string | undefined;
    programCode?: string | undefined;
}

export class SubmitterDetail implements ISubmitterDetail {
    submitterIdentifier?: number;
    submitterId?: string | undefined;
    submitterName?: string | undefined;
    programCode?: string | undefined;

    constructor(data?: ISubmitterDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitterIdentifier = _data["submitterIdentifier"];
            this.submitterId = _data["submitterId"];
            this.submitterName = _data["submitterName"];
            this.programCode = _data["programCode"];
        }
    }

    static fromJS(data: any): SubmitterDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitterDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitterIdentifier"] = this.submitterIdentifier;
        data["submitterId"] = this.submitterId;
        data["submitterName"] = this.submitterName;
        data["programCode"] = this.programCode;
        return data;
    }
}

export interface ISubmitterDetail {
    submitterIdentifier?: number;
    submitterId?: string | undefined;
    submitterName?: string | undefined;
    programCode?: string | undefined;
}

export class SubscriberDetailInfo implements ISubscriberDetailInfo {
    subscriberDetailInfoId?: number;
    group?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    insuredId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    phone?: string | undefined;
    payorCode?: string | undefined;
    participantId?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ISubscriberDetailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriberDetailInfoId = _data["subscriberDetailInfoId"];
            this.group = _data["group"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.insuredId = _data["insuredId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.payorCode = _data["payorCode"];
            this.participantId = _data["participantId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriberDetailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberDetailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriberDetailInfoId"] = this.subscriberDetailInfoId;
        data["group"] = this.group;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["insuredId"] = this.insuredId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["payorCode"] = this.payorCode;
        data["participantId"] = this.participantId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISubscriberDetailInfo {
    subscriberDetailInfoId?: number;
    group?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    insuredId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    phone?: string | undefined;
    payorCode?: string | undefined;
    participantId?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class FeeRateDTO implements IFeeRateDTO {
    id?: number;
    programId?: number;
    prognbr?: string | undefined;
    feeCodeId?: number;
    feeServCode?: string | undefined;
    billCodeId?: number;
    billCode?: string | undefined;
    billCodeDescription?: string | undefined;
    startServiceDate?: Date;
    endServiceDate?: Date;
    active?: string | undefined;
    budgetItem?: string | undefined;
    requiresService?: string | undefined;
    feeType?: number | undefined;
    feeTypeCode?: string | undefined;
    feeRate?: number;
    minBudget?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IFeeRateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.prognbr = _data["prognbr"];
            this.feeCodeId = _data["feeCodeId"];
            this.feeServCode = _data["feeServCode"];
            this.billCodeId = _data["billCodeId"];
            this.billCode = _data["billCode"];
            this.billCodeDescription = _data["billCodeDescription"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.budgetItem = _data["budgetItem"];
            this.requiresService = _data["requiresService"];
            this.feeType = _data["feeType"];
            this.feeTypeCode = _data["feeTypeCode"];
            this.feeRate = _data["feeRate"];
            this.minBudget = _data["minBudget"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FeeRateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeeRateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["prognbr"] = this.prognbr;
        data["feeCodeId"] = this.feeCodeId;
        data["feeServCode"] = this.feeServCode;
        data["billCodeId"] = this.billCodeId;
        data["billCode"] = this.billCode;
        data["billCodeDescription"] = this.billCodeDescription;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["budgetItem"] = this.budgetItem;
        data["requiresService"] = this.requiresService;
        data["feeType"] = this.feeType;
        data["feeTypeCode"] = this.feeTypeCode;
        data["feeRate"] = this.feeRate;
        data["minBudget"] = this.minBudget;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFeeRateDTO {
    id?: number;
    programId?: number;
    prognbr?: string | undefined;
    feeCodeId?: number;
    feeServCode?: string | undefined;
    billCodeId?: number;
    billCode?: string | undefined;
    billCodeDescription?: string | undefined;
    startServiceDate?: Date;
    endServiceDate?: Date;
    active?: string | undefined;
    budgetItem?: string | undefined;
    requiresService?: string | undefined;
    feeType?: number | undefined;
    feeTypeCode?: string | undefined;
    feeRate?: number;
    minBudget?: number | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class FeeRateRequest implements IFeeRateRequest {
    id?: number;
    programId!: number;
    feeCodeId!: number;
    billCodeId!: number;
    startServiceDate!: Date;
    endServiceDate!: Date;
    active?: string | undefined;
    budgetItem?: string | undefined;
    requiresService?: string | undefined;
    feeType?: number | undefined;
    feeRate?: number;
    minBudget?: number | undefined;

    constructor(data?: IFeeRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.feeCodeId = _data["feeCodeId"];
            this.billCodeId = _data["billCodeId"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.budgetItem = _data["budgetItem"];
            this.requiresService = _data["requiresService"];
            this.feeType = _data["feeType"];
            this.feeRate = _data["feeRate"];
            this.minBudget = _data["minBudget"];
        }
    }

    static fromJS(data: any): FeeRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FeeRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["feeCodeId"] = this.feeCodeId;
        data["billCodeId"] = this.billCodeId;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["budgetItem"] = this.budgetItem;
        data["requiresService"] = this.requiresService;
        data["feeType"] = this.feeType;
        data["feeRate"] = this.feeRate;
        data["minBudget"] = this.minBudget;
        return data;
    }
}

export interface IFeeRateRequest {
    id?: number;
    programId: number;
    feeCodeId: number;
    billCodeId: number;
    startServiceDate: Date;
    endServiceDate: Date;
    active?: string | undefined;
    budgetItem?: string | undefined;
    requiresService?: string | undefined;
    feeType?: number | undefined;
    feeRate?: number;
    minBudget?: number | undefined;
}

export class FundingSourceRequestDto implements IFundingSourceRequestDto {
    id?: number | undefined;
    companyId?: number;
    fundingSource!: string;
    active?: string | undefined;
    description!: string;

    constructor(data?: IFundingSourceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.fundingSource = _data["fundingSource"];
            this.active = _data["active"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FundingSourceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundingSourceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["fundingSource"] = this.fundingSource;
        data["active"] = this.active;
        data["description"] = this.description;
        return data;
    }
}

export interface IFundingSourceRequestDto {
    id?: number | undefined;
    companyId?: number;
    fundingSource: string;
    active?: string | undefined;
    description: string;
}

export class CaregiverEmployerGHA implements ICaregiverEmployerGHA {
    caregiverId?: number | undefined;
    employerId?: number | undefined;
    employerUniqueId?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;

    constructor(data?: ICaregiverEmployerGHA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerId = _data["employerId"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.employerFirstName = _data["employerFirstName"];
            this.employerLastName = _data["employerLastName"];
            this.employerName = _data["employerName"];
        }
    }

    static fromJS(data: any): CaregiverEmployerGHA {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerGHA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerId"] = this.employerId;
        data["employerUniqueId"] = this.employerUniqueId;
        data["employerFirstName"] = this.employerFirstName;
        data["employerLastName"] = this.employerLastName;
        data["employerName"] = this.employerName;
        return data;
    }
}

export interface ICaregiverEmployerGHA {
    caregiverId?: number | undefined;
    employerId?: number | undefined;
    employerUniqueId?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
}

export class GHAShiftSubmissionRequest implements IGHAShiftSubmissionRequest {
    caregiverId?: string | undefined;
    ghaShifts?: UpsertGHAShiftRequest[] | undefined;

    constructor(data?: IGHAShiftSubmissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["ghaShifts"])) {
                this.ghaShifts = [] as any;
                for (let item of _data["ghaShifts"])
                    this.ghaShifts!.push(UpsertGHAShiftRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GHAShiftSubmissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GHAShiftSubmissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.ghaShifts)) {
            data["ghaShifts"] = [];
            for (let item of this.ghaShifts)
                data["ghaShifts"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGHAShiftSubmissionRequest {
    caregiverId?: string | undefined;
    ghaShifts?: UpsertGHAShiftRequest[] | undefined;
}

export class GetGHAShiftsRequest implements IGetGHAShiftsRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;

    constructor(data?: IGetGHAShiftsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): GetGHAShiftsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGHAShiftsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerUniqueId"] = this.employerUniqueId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IGetGHAShiftsRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
}

export class UpsertGHAShiftRequest implements IUpsertGHAShiftRequest {
    txnId?: string | undefined;
    docType?: string | undefined;
    date?: Date;
    time?: string;
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    caregiverComments?: string | undefined;
    serviceCode?: string | undefined;
    suppressWarnings?: boolean;
    isPSST?: boolean;

    constructor(data?: IUpsertGHAShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.txnId = _data["txnId"];
            this.docType = _data["docType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"];
            this.caregiverId = _data["caregiverId"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.caregiverComments = _data["caregiverComments"];
            this.serviceCode = _data["serviceCode"];
            this.suppressWarnings = _data["suppressWarnings"];
            this.isPSST = _data["isPSST"];
        }
    }

    static fromJS(data: any): UpsertGHAShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGHAShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["txnId"] = this.txnId;
        data["docType"] = this.docType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["caregiverId"] = this.caregiverId;
        data["employerUniqueId"] = this.employerUniqueId;
        data["caregiverComments"] = this.caregiverComments;
        data["serviceCode"] = this.serviceCode;
        data["suppressWarnings"] = this.suppressWarnings;
        data["isPSST"] = this.isPSST;
        return data;
    }
}

export interface IUpsertGHAShiftRequest {
    txnId?: string | undefined;
    docType?: string | undefined;
    date?: Date;
    time?: string;
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    caregiverComments?: string | undefined;
    serviceCode?: string | undefined;
    suppressWarnings?: boolean;
    isPSST?: boolean;
}

export class GLAccountAssignmentRequestDto implements IGLAccountAssignmentRequestDto {
    companyId?: number;
    accountReceivableId?: number;
    cashAccountId?: number;
    copayAccountId?: number | undefined;
    interestAccountId?: number | undefined;
    status?: string | undefined;
    glBatch?: string | undefined;
    payrollProgram?: PayrollProgram;
    email?: string | undefined;

    constructor(data?: IGLAccountAssignmentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.accountReceivableId = _data["accountReceivableId"];
            this.cashAccountId = _data["cashAccountId"];
            this.copayAccountId = _data["copayAccountId"];
            this.interestAccountId = _data["interestAccountId"];
            this.status = _data["status"];
            this.glBatch = _data["glBatch"];
            this.payrollProgram = _data["payrollProgram"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GLAccountAssignmentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountAssignmentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["accountReceivableId"] = this.accountReceivableId;
        data["cashAccountId"] = this.cashAccountId;
        data["copayAccountId"] = this.copayAccountId;
        data["interestAccountId"] = this.interestAccountId;
        data["status"] = this.status;
        data["glBatch"] = this.glBatch;
        data["payrollProgram"] = this.payrollProgram;
        data["email"] = this.email;
        return data;
    }
}

export interface IGLAccountAssignmentRequestDto {
    companyId?: number;
    accountReceivableId?: number;
    cashAccountId?: number;
    copayAccountId?: number | undefined;
    interestAccountId?: number | undefined;
    status?: string | undefined;
    glBatch?: string | undefined;
    payrollProgram?: PayrollProgram;
    email?: string | undefined;
}

export class GLAccountAssignmentResponseById implements IGLAccountAssignmentResponseById {
    id?: number;
    accountReceivableId?: number;
    accountReceivableAccount?: string | undefined;
    accountReceivableDescription?: string | undefined;
    cashAccountId?: number;
    cashAccountAccount?: string | undefined;
    cashAccountDescription?: string | undefined;
    copayAccountId?: number | undefined;
    copayAccountAccount?: string | undefined;
    copayAccountDescription?: string | undefined;
    interestAccountId?: number | undefined;
    interestAccountAccount?: string | undefined;
    interestAccountDescription?: string | undefined;
    accountStatus?: string | undefined;
    glBatch?: string | undefined;
    payrollProgram?: number;
    email?: string | undefined;

    constructor(data?: IGLAccountAssignmentResponseById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountReceivableId = _data["accountReceivableId"];
            this.accountReceivableAccount = _data["accountReceivableAccount"];
            this.accountReceivableDescription = _data["accountReceivableDescription"];
            this.cashAccountId = _data["cashAccountId"];
            this.cashAccountAccount = _data["cashAccountAccount"];
            this.cashAccountDescription = _data["cashAccountDescription"];
            this.copayAccountId = _data["copayAccountId"];
            this.copayAccountAccount = _data["copayAccountAccount"];
            this.copayAccountDescription = _data["copayAccountDescription"];
            this.interestAccountId = _data["interestAccountId"];
            this.interestAccountAccount = _data["interestAccountAccount"];
            this.interestAccountDescription = _data["interestAccountDescription"];
            this.accountStatus = _data["accountStatus"];
            this.glBatch = _data["glBatch"];
            this.payrollProgram = _data["payrollProgram"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GLAccountAssignmentResponseById {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountAssignmentResponseById();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountReceivableId"] = this.accountReceivableId;
        data["accountReceivableAccount"] = this.accountReceivableAccount;
        data["accountReceivableDescription"] = this.accountReceivableDescription;
        data["cashAccountId"] = this.cashAccountId;
        data["cashAccountAccount"] = this.cashAccountAccount;
        data["cashAccountDescription"] = this.cashAccountDescription;
        data["copayAccountId"] = this.copayAccountId;
        data["copayAccountAccount"] = this.copayAccountAccount;
        data["copayAccountDescription"] = this.copayAccountDescription;
        data["interestAccountId"] = this.interestAccountId;
        data["interestAccountAccount"] = this.interestAccountAccount;
        data["interestAccountDescription"] = this.interestAccountDescription;
        data["accountStatus"] = this.accountStatus;
        data["glBatch"] = this.glBatch;
        data["payrollProgram"] = this.payrollProgram;
        data["email"] = this.email;
        return data;
    }
}

export interface IGLAccountAssignmentResponseById {
    id?: number;
    accountReceivableId?: number;
    accountReceivableAccount?: string | undefined;
    accountReceivableDescription?: string | undefined;
    cashAccountId?: number;
    cashAccountAccount?: string | undefined;
    cashAccountDescription?: string | undefined;
    copayAccountId?: number | undefined;
    copayAccountAccount?: string | undefined;
    copayAccountDescription?: string | undefined;
    interestAccountId?: number | undefined;
    interestAccountAccount?: string | undefined;
    interestAccountDescription?: string | undefined;
    accountStatus?: string | undefined;
    glBatch?: string | undefined;
    payrollProgram?: number;
    email?: string | undefined;
}

export class GLAccountRequestDto implements IGLAccountRequestDto {
    id?: number | undefined;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;
    companyId?: number;

    constructor(data?: IGLAccountRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.glAccount = _data["glAccount"];
            this.description = _data["description"];
            this.accountStatus = _data["accountStatus"];
            this.isActive = _data["isActive"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): GLAccountRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["glAccount"] = this.glAccount;
        data["description"] = this.description;
        data["accountStatus"] = this.accountStatus;
        data["isActive"] = this.isActive;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IGLAccountRequestDto {
    id?: number | undefined;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;
    companyId?: number;
}

export class GLAccountResponseById implements IGLAccountResponseById {
    id?: number;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;

    constructor(data?: IGLAccountResponseById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.glAccount = _data["glAccount"];
            this.description = _data["description"];
            this.accountStatus = _data["accountStatus"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GLAccountResponseById {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountResponseById();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["glAccount"] = this.glAccount;
        data["description"] = this.description;
        data["accountStatus"] = this.accountStatus;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGLAccountResponseById {
    id?: number;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;
}

export class GLAccountResponseDto implements IGLAccountResponseDto {
    id?: number;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IGLAccountResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.glAccount = _data["glAccount"];
            this.description = _data["description"];
            this.accountStatus = _data["accountStatus"];
            this.isActive = _data["isActive"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GLAccountResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["glAccount"] = this.glAccount;
        data["description"] = this.description;
        data["accountStatus"] = this.accountStatus;
        data["isActive"] = this.isActive;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGLAccountResponseDto {
    id?: number;
    glAccount?: string | undefined;
    description?: string | undefined;
    accountStatus?: string | undefined;
    isActive?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class GetHistoryRequestBase implements IGetHistoryRequestBase {
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IGetHistoryRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["explicitColumns"])) {
                this.explicitColumns = [] as any;
                for (let item of _data["explicitColumns"])
                    this.explicitColumns!.push(item);
            }
            this.includeCreation = _data["includeCreation"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): GetHistoryRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.explicitColumns)) {
            data["explicitColumns"] = [];
            for (let item of this.explicitColumns)
                data["explicitColumns"].push(item);
        }
        data["includeCreation"] = this.includeCreation;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IGetHistoryRequestBase {
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class GetIdsFromNameRequest implements IGetIdsFromNameRequest {
    firstName!: string;
    lastName?: string | undefined;
    personType?: string | undefined;

    constructor(data?: IGetIdsFromNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.personType = _data["personType"];
        }
    }

    static fromJS(data: any): GetIdsFromNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdsFromNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["personType"] = this.personType;
        return data;
    }
}

export interface IGetIdsFromNameRequest {
    firstName: string;
    lastName?: string | undefined;
    personType?: string | undefined;
}

export class GetIdsFromNameResponse implements IGetIdsFromNameResponse {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date | undefined;

    constructor(data?: IGetIdsFromNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIdsFromNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdsFromNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetIdsFromNameResponse {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date | undefined;
}

export class GetPortalUsersWithoutAgencyRequest implements IGetPortalUsersWithoutAgencyRequest {
    searchParameter?: string | undefined;
    roleFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IGetPortalUsersWithoutAgencyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.roleFilter = _data["roleFilter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): GetPortalUsersWithoutAgencyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPortalUsersWithoutAgencyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["roleFilter"] = this.roleFilter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IGetPortalUsersWithoutAgencyRequest {
    searchParameter?: string | undefined;
    roleFilter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class GetUserNamesBySLId implements IGetUserNamesBySLId {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IGetUserNamesBySLId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetUserNamesBySLId {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserNamesBySLId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetUserNamesBySLId {
    id?: string | undefined;
    name?: string | undefined;
}

export class GridResponseBaseOfCompanyModel implements IGridResponseBaseOfCompanyModel {
    items?: CompanyModel[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyModel.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCompanyModel {
    items?: CompanyModel[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfOwnersResponse implements IGridResponseBaseOfOwnersResponse {
    items?: OwnersResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfOwnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OwnersResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfOwnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfOwnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfOwnersResponse {
    items?: OwnersResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfEinList implements IGridResponseBaseOfEinList {
    items?: EinList[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfEinList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EinList.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfEinList {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfEinList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfEinList {
    items?: EinList[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfFundingSourceResponse implements IGridResponseBaseOfFundingSourceResponse {
    items?: FundingSourceResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfFundingSourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FundingSourceResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfFundingSourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfFundingSourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfFundingSourceResponse {
    items?: FundingSourceResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfParticipantsList implements IGridResponseBaseOfParticipantsList {
    items?: ParticipantsList[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfParticipantsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParticipantsList.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfParticipantsList {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfParticipantsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfParticipantsList {
    items?: ParticipantsList[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfParticipants implements IGridResponseBaseOfParticipants {
    items?: Participants[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfParticipants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Participants.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfParticipants {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfParticipants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfParticipants {
    items?: Participants[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfProgramServiceTypes implements IGridResponseBaseOfProgramServiceTypes {
    items?: ProgramServiceTypes[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfProgramServiceTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProgramServiceTypes.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfProgramServiceTypes {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfProgramServiceTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfProgramServiceTypes {
    items?: ProgramServiceTypes[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfAgencyUserDto implements IGridResponseBaseOfAgencyUserDto {
    items?: AgencyUserDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfAgencyUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgencyUserDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfAgencyUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfAgencyUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfAgencyUserDto {
    items?: AgencyUserDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfBenefitContributionResponseDto implements IGridResponseBaseOfBenefitContributionResponseDto {
    items?: BenefitContributionResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfBenefitContributionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BenefitContributionResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfBenefitContributionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfBenefitContributionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfBenefitContributionResponseDto {
    items?: BenefitContributionResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfBillRateResponseDto implements IGridResponseBaseOfBillRateResponseDto {
    items?: BillRateResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfBillRateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BillRateResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfBillRateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfBillRateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfBillRateResponseDto {
    items?: BillRateResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfFeeTypeResponseDto implements IGridResponseBaseOfFeeTypeResponseDto {
    items?: FeeTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfFeeTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeeTypeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfFeeTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfFeeTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfFeeTypeResponseDto {
    items?: FeeTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfFundingTypeResponseDto implements IGridResponseBaseOfFundingTypeResponseDto {
    items?: FundingTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfFundingTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FundingTypeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfFundingTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfFundingTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfFundingTypeResponseDto {
    items?: FundingTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfHCPCSCodeResponseDto implements IGridResponseBaseOfHCPCSCodeResponseDto {
    items?: HCPCSCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfHCPCSCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HCPCSCodeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfHCPCSCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfHCPCSCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfHCPCSCodeResponseDto {
    items?: HCPCSCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfPayRateResponseDto implements IGridResponseBaseOfPayRateResponseDto {
    items?: PayRateResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfPayRateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayRateResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfPayRateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfPayRateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfPayRateResponseDto {
    items?: PayRateResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfRelationshipTypeDto implements IGridResponseBaseOfRelationshipTypeDto {
    items?: RelationshipTypeDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfRelationshipTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RelationshipTypeDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfRelationshipTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfRelationshipTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfRelationshipTypeDto {
    items?: RelationshipTypeDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfServiceCodeResponseDto implements IGridResponseBaseOfServiceCodeResponseDto {
    items?: ServiceCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfServiceCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCodeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfServiceCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfServiceCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfServiceCodeResponseDto {
    items?: ServiceCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfStateLookupDto implements IGridResponseBaseOfStateLookupDto {
    items?: StateLookupDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfStateLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StateLookupDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfStateLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfStateLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfStateLookupDto {
    items?: StateLookupDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfSubAccountLookupDto implements IGridResponseBaseOfSubAccountLookupDto {
    items?: SubAccountLookupDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfSubAccountLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubAccountLookupDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfSubAccountLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfSubAccountLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfSubAccountLookupDto {
    items?: SubAccountLookupDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfWriteOffCauseResponseDto implements IGridResponseBaseOfWriteOffCauseResponseDto {
    items?: WriteOffCauseResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfWriteOffCauseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WriteOffCauseResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfWriteOffCauseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfWriteOffCauseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfWriteOffCauseResponseDto {
    items?: WriteOffCauseResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfCaseLoadResponse implements IGridResponseBaseOfCaseLoadResponse {
    items?: CaseLoadResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCaseLoadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaseLoadResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCaseLoadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfCaseLoadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCaseLoadResponse {
    items?: CaseLoadResponse[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfClientInsInfoDTO implements IGridResponseBaseOfClientInsInfoDTO {
    items?: ClientInsInfoDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfClientInsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientInsInfoDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfClientInsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfClientInsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfClientInsInfoDTO {
    items?: ClientInsInfoDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfCommonLkpDTO implements IGridResponseBaseOfCommonLkpDTO {
    items?: CommonLkpDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCommonLkpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommonLkpDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCommonLkpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfCommonLkpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCommonLkpDTO {
    items?: CommonLkpDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfCustomerExDto implements IGridResponseBaseOfCustomerExDto {
    items?: CustomerExDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCustomerExDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerExDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCustomerExDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfCustomerExDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCustomerExDto {
    items?: CustomerExDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfCustomerExResponseDto implements IGridResponseBaseOfCustomerExResponseDto {
    items?: CustomerExResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCustomerExResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerExResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCustomerExResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfCustomerExResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCustomerExResponseDto {
    items?: CustomerExResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfDiagCodeDto implements IGridResponseBaseOfDiagCodeDto {
    items?: DiagCodeDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfDiagCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiagCodeDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfDiagCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfDiagCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfDiagCodeDto {
    items?: DiagCodeDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfExCaseMgrDetailsDto implements IGridResponseBaseOfExCaseMgrDetailsDto {
    items?: ExCaseMgrDetailsDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfExCaseMgrDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExCaseMgrDetailsDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfExCaseMgrDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfExCaseMgrDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfExCaseMgrDetailsDto {
    items?: ExCaseMgrDetailsDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfFeeRateDTO implements IGridResponseBaseOfFeeRateDTO {
    items?: FeeRateDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfFeeRateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeeRateDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfFeeRateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfFeeRateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfFeeRateDTO {
    items?: FeeRateDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfGLAccountResponseDto implements IGridResponseBaseOfGLAccountResponseDto {
    items?: GLAccountResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfGLAccountResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GLAccountResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfGLAccountResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfGLAccountResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfGLAccountResponseDto {
    items?: GLAccountResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfPayorDTO implements IGridResponseBaseOfPayorDTO {
    items?: PayorDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfPayorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayorDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfPayorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfPayorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfPayorDTO {
    items?: PayorDTO[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfPayorPortalUserMappingDto implements IGridResponseBaseOfPayorPortalUserMappingDto {
    items?: PayorPortalUserMappingDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfPayorPortalUserMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayorPortalUserMappingDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfPayorPortalUserMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfPayorPortalUserMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfPayorPortalUserMappingDto {
    items?: PayorPortalUserMappingDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfPortalUserDto implements IGridResponseBaseOfPortalUserDto {
    items?: PortalUserDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfPortalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PortalUserDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfPortalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfPortalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfPortalUserDto {
    items?: PortalUserDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfProgramDto implements IGridResponseBaseOfProgramDto {
    items?: ProgramDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProgramDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfProgramDto {
    items?: ProgramDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GridResponseBaseOfServiceTypeResponseDto implements IGridResponseBaseOfServiceTypeResponseDto {
    items?: ServiceTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfServiceTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceTypeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridResponseBaseOfServiceTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridResponseBaseOfServiceTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfServiceTypeResponseDto {
    items?: ServiceTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class HealthCheckResponse implements IHealthCheckResponse {
    message?: string | undefined;
    name?: string | undefined;
    link?: string | undefined;
    time?: string | undefined;
    status?: string | undefined;

    constructor(data?: IHealthCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.name = _data["name"];
            this.link = _data["link"];
            this.time = _data["time"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HealthCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["name"] = this.name;
        data["link"] = this.link;
        data["time"] = this.time;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResponse {
    message?: string | undefined;
    name?: string | undefined;
    link?: string | undefined;
    time?: string | undefined;
    status?: string | undefined;
}

export class McoParticipantsFilterRequest implements IMcoParticipantsFilterRequest {
    searchParameter?: string | undefined;
    userId?: string | undefined;
    stateCode?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IMcoParticipantsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.userId = _data["userId"];
            this.stateCode = _data["stateCode"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): McoParticipantsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new McoParticipantsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["userId"] = this.userId;
        data["stateCode"] = this.stateCode;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IMcoParticipantsFilterRequest {
    searchParameter?: string | undefined;
    userId?: string | undefined;
    stateCode?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class MileageSubmissionRequest implements IMileageSubmissionRequest {
    caregiverId?: string | undefined;
    mileageEntries?: UpsertMileageRequest[] | undefined;
    companyCode?: string | undefined;
    sourceType?: string | undefined;

    constructor(data?: IMileageSubmissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["mileageEntries"])) {
                this.mileageEntries = [] as any;
                for (let item of _data["mileageEntries"])
                    this.mileageEntries!.push(UpsertMileageRequest.fromJS(item));
            }
            this.companyCode = _data["companyCode"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): MileageSubmissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MileageSubmissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.mileageEntries)) {
            data["mileageEntries"] = [];
            for (let item of this.mileageEntries)
                data["mileageEntries"].push(item ? item.toJSON() : <any>undefined);
        }
        data["companyCode"] = this.companyCode;
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface IMileageSubmissionRequest {
    caregiverId?: string | undefined;
    mileageEntries?: UpsertMileageRequest[] | undefined;
    companyCode?: string | undefined;
    sourceType?: string | undefined;
}

export class UpsertMileageRequest implements IUpsertMileageRequest {
    tcn?: string | undefined;
    docType?: string | undefined;
    miles?: number;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    caregiverComments?: string | undefined;
    serviceCode?: string | undefined;
    source?: string | undefined;
    renderDate?: Date;
    isPSST?: boolean;
    suppressWarnings?: boolean;

    constructor(data?: IUpsertMileageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.docType = _data["docType"];
            this.miles = _data["miles"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.caregiverComments = _data["caregiverComments"];
            this.serviceCode = _data["serviceCode"];
            this.source = _data["source"];
            this.renderDate = _data["renderDate"] ? new Date(_data["renderDate"].toString()) : <any>undefined;
            this.isPSST = _data["isPSST"];
            this.suppressWarnings = _data["suppressWarnings"];
        }
    }

    static fromJS(data: any): UpsertMileageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMileageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["docType"] = this.docType;
        data["miles"] = this.miles;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["caregiverComments"] = this.caregiverComments;
        data["serviceCode"] = this.serviceCode;
        data["source"] = this.source;
        data["renderDate"] = this.renderDate ? this.renderDate.toISOString() : <any>undefined;
        data["isPSST"] = this.isPSST;
        data["suppressWarnings"] = this.suppressWarnings;
        return data;
    }
}

export interface IUpsertMileageRequest {
    tcn?: string | undefined;
    docType?: string | undefined;
    miles?: number;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    caregiverComments?: string | undefined;
    serviceCode?: string | undefined;
    source?: string | undefined;
    renderDate?: Date;
    isPSST?: boolean;
    suppressWarnings?: boolean;
}

export class ObserverMetaDataRequest implements IObserverMetaDataRequest {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    progNbr?: string | undefined;
    docType?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: IObserverMetaDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.servCode = _data["servCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.progNbr = _data["progNbr"];
            this.docType = _data["docType"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): ObserverMetaDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ObserverMetaDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["servCode"] = this.servCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["progNbr"] = this.progNbr;
        data["docType"] = this.docType;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IObserverMetaDataRequest {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    progNbr?: string | undefined;
    docType?: string | undefined;
    companyCode?: string | undefined;
}

export class ObserverMetaDataResponse implements IObserverMetaDataResponse {
    participantId?: string | undefined;
    diagCode?: string | undefined;
    nonBillable?: string | undefined;
    billRate?: number;
    payorWeekStartDay?: DayOfWeek;
    billUnits?: number;
    payUnits?: number;
    markUpPC?: number;
    markup?: number;
    billCodeId?: string | undefined;
    insuredId?: string | undefined;
    programCode?: string | undefined;
    payorCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    unitMethod?: number | undefined;
    unitMulti?: number;
    maxBillRate?: number | undefined;
    authReqd?: boolean;
    placeOfService?: number;
    acn?: string | undefined;
    authCode?: string | undefined;
    status?: string | undefined;
    authStatus?: string[] | undefined;
    detailsStatus?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    payDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    companyId?: number;
    isBillable?: string | undefined;

    constructor(data?: IObserverMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.diagCode = _data["diagCode"];
            this.nonBillable = _data["nonBillable"];
            this.billRate = _data["billRate"];
            this.payorWeekStartDay = _data["payorWeekStartDay"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.markUpPC = _data["markUpPC"];
            this.markup = _data["markup"];
            this.billCodeId = _data["billCodeId"];
            this.insuredId = _data["insuredId"];
            this.programCode = _data["programCode"];
            this.payorCode = _data["payorCode"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.servCode = _data["servCode"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unitMethod = _data["unitMethod"];
            this.unitMulti = _data["unitMulti"];
            this.maxBillRate = _data["maxBillRate"];
            this.authReqd = _data["authReqd"];
            this.placeOfService = _data["placeOfService"];
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.status = _data["status"];
            if (Array.isArray(_data["authStatus"])) {
                this.authStatus = [] as any;
                for (let item of _data["authStatus"])
                    this.authStatus!.push(item);
            }
            this.detailsStatus = _data["detailsStatus"];
            if (Array.isArray(_data["authDetailsStatus"])) {
                this.authDetailsStatus = [] as any;
                for (let item of _data["authDetailsStatus"])
                    this.authDetailsStatus!.push(item);
            }
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
            this.passportId = _data["passportId"];
            this.companyId = _data["companyId"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): ObserverMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObserverMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["diagCode"] = this.diagCode;
        data["nonBillable"] = this.nonBillable;
        data["billRate"] = this.billRate;
        data["payorWeekStartDay"] = this.payorWeekStartDay;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["markUpPC"] = this.markUpPC;
        data["markup"] = this.markup;
        data["billCodeId"] = this.billCodeId;
        data["insuredId"] = this.insuredId;
        data["programCode"] = this.programCode;
        data["payorCode"] = this.payorCode;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["servCode"] = this.servCode;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unitMethod"] = this.unitMethod;
        data["unitMulti"] = this.unitMulti;
        data["maxBillRate"] = this.maxBillRate;
        data["authReqd"] = this.authReqd;
        data["placeOfService"] = this.placeOfService;
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["status"] = this.status;
        if (Array.isArray(this.authStatus)) {
            data["authStatus"] = [];
            for (let item of this.authStatus)
                data["authStatus"].push(item);
        }
        data["detailsStatus"] = this.detailsStatus;
        if (Array.isArray(this.authDetailsStatus)) {
            data["authDetailsStatus"] = [];
            for (let item of this.authDetailsStatus)
                data["authDetailsStatus"].push(item);
        }
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        data["passportId"] = this.passportId;
        data["companyId"] = this.companyId;
        data["isBillable"] = this.isBillable;
        return data;
    }
}

export interface IObserverMetaDataResponse {
    participantId?: string | undefined;
    diagCode?: string | undefined;
    nonBillable?: string | undefined;
    billRate?: number;
    payorWeekStartDay?: DayOfWeek;
    billUnits?: number;
    payUnits?: number;
    markUpPC?: number;
    markup?: number;
    billCodeId?: string | undefined;
    insuredId?: string | undefined;
    programCode?: string | undefined;
    payorCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    unitMethod?: number | undefined;
    unitMulti?: number;
    maxBillRate?: number | undefined;
    authReqd?: boolean;
    placeOfService?: number;
    acn?: string | undefined;
    authCode?: string | undefined;
    status?: string | undefined;
    authStatus?: string[] | undefined;
    detailsStatus?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    payDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    companyId?: number;
    isBillable?: string | undefined;
}

export class OwnersListRequestDto implements IOwnersListRequestDto {
    searchString?: string | undefined;
    refresh?: boolean;

    constructor(data?: IOwnersListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.refresh = _data["refresh"];
        }
    }

    static fromJS(data: any): OwnersListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnersListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["refresh"] = this.refresh;
        return data;
    }
}

export interface IOwnersListRequestDto {
    searchString?: string | undefined;
    refresh?: boolean;
}

export class ParticipantDto implements IParticipantDto {
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    insuredId?: string | undefined;

    constructor(data?: IParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.insuredId = _data["insuredId"];
        }
    }

    static fromJS(data: any): ParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["insuredId"] = this.insuredId;
        return data;
    }
}

export interface IParticipantDto {
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    insuredId?: string | undefined;
}

export class ParticipantsFilterRequest implements IParticipantsFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    svcFacilitatorId?: string | undefined;
    caseLoadMappedIds?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IParticipantsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.agencyIds = _data["agencyIds"];
            this.svcFacilitatorId = _data["svcFacilitatorId"];
            this.caseLoadMappedIds = _data["caseLoadMappedIds"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): ParticipantsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["agencyIds"] = this.agencyIds;
        data["svcFacilitatorId"] = this.svcFacilitatorId;
        data["caseLoadMappedIds"] = this.caseLoadMappedIds;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IParticipantsFilterRequest {
    searchParameter?: string | undefined;
    agencyIds?: string | undefined;
    svcFacilitatorId?: string | undefined;
    caseLoadMappedIds?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class PayCalculationMethod implements IPayCalculationMethod {
    payCalculationMethodId?: number;
    payCalculationMethodCode?: string | undefined;
    payCalculationMethodText?: string | undefined;

    constructor(data?: IPayCalculationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payCalculationMethodId = _data["payCalculationMethodId"];
            this.payCalculationMethodCode = _data["payCalculationMethodCode"];
            this.payCalculationMethodText = _data["payCalculationMethodText"];
        }
    }

    static fromJS(data: any): PayCalculationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PayCalculationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payCalculationMethodId"] = this.payCalculationMethodId;
        data["payCalculationMethodCode"] = this.payCalculationMethodCode;
        data["payCalculationMethodText"] = this.payCalculationMethodText;
        return data;
    }
}

export interface IPayCalculationMethod {
    payCalculationMethodId?: number;
    payCalculationMethodCode?: string | undefined;
    payCalculationMethodText?: string | undefined;
}

export class PayRateByIdResponseDto implements IPayRateByIdResponseDto {
    id?: number;
    custID?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    daysValid?: string | undefined;
    earnType?: string | undefined;
    empID?: number;
    otFlag?: string | undefined;
    ratePay?: number | undefined;
    ratePayHoliMulti?: number | undefined;
    rndMethod?: number | undefined;
    servCode?: number;
    status?: string | undefined;
    timeBegin?: Date;
    timeEnd?: Date;
    unitType?: string | undefined;
    comment?: string | undefined;
    active?: string | undefined;
    timeFormat?: boolean;
    serveCode?: string | undefined;
    servcodeDescription?: string | undefined;
    employeeName?: string | undefined;
    customerName?: string | undefined;

    constructor(data?: IPayRateByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custID = _data["custID"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.daysValid = _data["daysValid"];
            this.earnType = _data["earnType"];
            this.empID = _data["empID"];
            this.otFlag = _data["otFlag"];
            this.ratePay = _data["ratePay"];
            this.ratePayHoliMulti = _data["ratePayHoliMulti"];
            this.rndMethod = _data["rndMethod"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.timeBegin = _data["timeBegin"] ? new Date(_data["timeBegin"].toString()) : <any>undefined;
            this.timeEnd = _data["timeEnd"] ? new Date(_data["timeEnd"].toString()) : <any>undefined;
            this.unitType = _data["unitType"];
            this.comment = _data["comment"];
            this.active = _data["active"];
            this.timeFormat = _data["timeFormat"];
            this.serveCode = _data["serveCode"];
            this.servcodeDescription = _data["servcodeDescription"];
            this.employeeName = _data["employeeName"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): PayRateByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custID"] = this.custID;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["daysValid"] = this.daysValid;
        data["earnType"] = this.earnType;
        data["empID"] = this.empID;
        data["otFlag"] = this.otFlag;
        data["ratePay"] = this.ratePay;
        data["ratePayHoliMulti"] = this.ratePayHoliMulti;
        data["rndMethod"] = this.rndMethod;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["timeBegin"] = this.timeBegin ? this.timeBegin.toISOString() : <any>undefined;
        data["timeEnd"] = this.timeEnd ? this.timeEnd.toISOString() : <any>undefined;
        data["unitType"] = this.unitType;
        data["comment"] = this.comment;
        data["active"] = this.active;
        data["timeFormat"] = this.timeFormat;
        data["serveCode"] = this.serveCode;
        data["servcodeDescription"] = this.servcodeDescription;
        data["employeeName"] = this.employeeName;
        data["customerName"] = this.customerName;
        return data;
    }
}

export interface IPayRateByIdResponseDto {
    id?: number;
    custID?: number;
    dateBegin?: Date;
    dateEnd?: Date | undefined;
    daysValid?: string | undefined;
    earnType?: string | undefined;
    empID?: number;
    otFlag?: string | undefined;
    ratePay?: number | undefined;
    ratePayHoliMulti?: number | undefined;
    rndMethod?: number | undefined;
    servCode?: number;
    status?: string | undefined;
    timeBegin?: Date;
    timeEnd?: Date;
    unitType?: string | undefined;
    comment?: string | undefined;
    active?: string | undefined;
    timeFormat?: boolean;
    serveCode?: string | undefined;
    servcodeDescription?: string | undefined;
    employeeName?: string | undefined;
    customerName?: string | undefined;
}

export class PayWeekStartDayRequest implements IPayWeekStartDayRequest {
    payorId?: string | undefined;
    programId?: string | undefined;

    constructor(data?: IPayWeekStartDayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): PayWeekStartDayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayWeekStartDayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        return data;
    }
}

export interface IPayWeekStartDayRequest {
    payorId?: string | undefined;
    programId?: string | undefined;
}

export class PayorConfigDTO implements IPayorConfigDTO {
    payorId?: string | undefined;
    payorName?: string | undefined;
    weekStartingDay?: DayOfWeek;
    lateServiceThresholdDays?: number;
    receiverId?: string | undefined;

    constructor(data?: IPayorConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.weekStartingDay = _data["weekStartingDay"];
            this.lateServiceThresholdDays = _data["lateServiceThresholdDays"];
            this.receiverId = _data["receiverId"];
        }
    }

    static fromJS(data: any): PayorConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayorConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["weekStartingDay"] = this.weekStartingDay;
        data["lateServiceThresholdDays"] = this.lateServiceThresholdDays;
        data["receiverId"] = this.receiverId;
        return data;
    }
}

export interface IPayorConfigDTO {
    payorId?: string | undefined;
    payorName?: string | undefined;
    weekStartingDay?: DayOfWeek;
    lateServiceThresholdDays?: number;
    receiverId?: string | undefined;
}

export class PayorDTO implements IPayorDTO {
    contactName?: string | undefined;
    nationalPlanId?: string | undefined;
    receiverId?: string | undefined;
    emailId?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDate?: string | undefined;
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    active?: string | undefined;
    weekStartingDay?: DayOfWeek;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IPayorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactName = _data["contactName"];
            this.nationalPlanId = _data["nationalPlanId"];
            this.receiverId = _data["receiverId"];
            this.emailId = _data["emailId"];
            this.phone = _data["phone"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
            this.zip = _data["zip"];
            this.comment = _data["comment"];
            this.weekStartingDate = _data["weekStartingDate"];
            this.id = _data["id"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.active = _data["active"];
            this.weekStartingDay = _data["weekStartingDay"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactName"] = this.contactName;
        data["nationalPlanId"] = this.nationalPlanId;
        data["receiverId"] = this.receiverId;
        data["emailId"] = this.emailId;
        data["phone"] = this.phone;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        data["zip"] = this.zip;
        data["comment"] = this.comment;
        data["weekStartingDate"] = this.weekStartingDate;
        data["id"] = this.id;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["active"] = this.active;
        data["weekStartingDay"] = this.weekStartingDay;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayorDTO {
    contactName?: string | undefined;
    nationalPlanId?: string | undefined;
    receiverId?: string | undefined;
    emailId?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDate?: string | undefined;
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    active?: string | undefined;
    weekStartingDay?: DayOfWeek;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class PayorPortalUserMappingDto implements IPayorPortalUserMappingDto {
    id?: number | undefined;
    portalUserId?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    payorDescription?: string | undefined;
    portalUserName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IPayorPortalUserMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.portalUserId = _data["portalUserId"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.payorDescription = _data["payorDescription"];
            this.portalUserName = _data["portalUserName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): PayorPortalUserMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayorPortalUserMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["portalUserId"] = this.portalUserId;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["payorDescription"] = this.payorDescription;
        data["portalUserName"] = this.portalUserName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IPayorPortalUserMappingDto {
    id?: number | undefined;
    portalUserId?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    payorDescription?: string | undefined;
    portalUserName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
}

export class PayorPortalUserMappingFilterRequest implements IPayorPortalUserMappingFilterRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IPayorPortalUserMappingFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): PayorPortalUserMappingFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayorPortalUserMappingFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IPayorPortalUserMappingFilterRequest {
    searchParameter?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class PayorRequest implements IPayorRequest {
    id!: number;
    payorId!: string;
    payorName!: string;
    nationalPlanId?: string | undefined;
    receiverId?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    active?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDay?: DayOfWeek;

    constructor(data?: IPayorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.nationalPlanId = _data["nationalPlanId"];
            this.receiverId = _data["receiverId"];
            this.contactName = _data["contactName"];
            this.emailId = _data["emailId"];
            this.active = _data["active"];
            this.phone = _data["phone"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.comment = _data["comment"];
            this.weekStartingDay = _data["weekStartingDay"];
        }
    }

    static fromJS(data: any): PayorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["nationalPlanId"] = this.nationalPlanId;
        data["receiverId"] = this.receiverId;
        data["contactName"] = this.contactName;
        data["emailId"] = this.emailId;
        data["active"] = this.active;
        data["phone"] = this.phone;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["comment"] = this.comment;
        data["weekStartingDay"] = this.weekStartingDay;
        return data;
    }
}

export interface IPayorRequest {
    id: number;
    payorId: string;
    payorName: string;
    nationalPlanId?: string | undefined;
    receiverId?: string | undefined;
    contactName?: string | undefined;
    emailId?: string | undefined;
    active?: string | undefined;
    phone?: string | undefined;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    comment?: string | undefined;
    weekStartingDay?: DayOfWeek;
}

export class PayrollProgramDto implements IPayrollProgramDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPayrollProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PayrollProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPayrollProgramDto {
    id?: number;
    name?: string | undefined;
}

export class PortalUserDto implements IPortalUserDto {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    emailId?: string | undefined;

    constructor(data?: IPortalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.emailId = _data["emailId"];
        }
    }

    static fromJS(data: any): PortalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["emailId"] = this.emailId;
        return data;
    }
}

export interface IPortalUserDto {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    emailId?: string | undefined;
}

export class ProgramByPayorIdDto implements IProgramByPayorIdDto {
    id?: number;
    progNbr?: string | undefined;

    constructor(data?: IProgramByPayorIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progNbr = _data["progNbr"];
        }
    }

    static fromJS(data: any): ProgramByPayorIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramByPayorIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progNbr"] = this.progNbr;
        return data;
    }
}

export interface IProgramByPayorIdDto {
    id?: number;
    progNbr?: string | undefined;
}

export class ProgramDto implements IProgramDto {
    id?: number;
    progNbr?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    payorId?: number;
    payorName?: string | undefined;
    npi?: string | undefined;
    fedTaxID?: string | undefined;
    submitNbr?: string | undefined;
    taxonomy?: string | undefined;
    fundingTypeId?: number;
    fundingTypeName?: string | undefined;
    fundingSourceId?: number;
    fundingSourceName?: string | undefined;
    programTypeId?: number;
    programType?: string | undefined;
    diagCodeId?: number;
    defaultDiagnosisCode?: string | undefined;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    stateName?: string | undefined;
    stateCode?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    claimFileDestination?: string | undefined;
    payrollFileDestination?: string | undefined;
    receiverId?: string | undefined;
    api?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    onlyEVVShifts?: boolean;
    adjustmentReasonRequired?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progNbr = _data["progNbr"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.npi = _data["npi"];
            this.fedTaxID = _data["fedTaxID"];
            this.submitNbr = _data["submitNbr"];
            this.taxonomy = _data["taxonomy"];
            this.fundingTypeId = _data["fundingTypeId"];
            this.fundingTypeName = _data["fundingTypeName"];
            this.fundingSourceId = _data["fundingSourceId"];
            this.fundingSourceName = _data["fundingSourceName"];
            this.programTypeId = _data["programTypeId"];
            this.programType = _data["programType"];
            this.diagCodeId = _data["diagCodeId"];
            this.defaultDiagnosisCode = _data["defaultDiagnosisCode"];
            this.contactName = _data["contactName"];
            this.phone = _data["phone"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.stateName = _data["stateName"];
            this.stateCode = _data["stateCode"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.comment = _data["comment"];
            this.claimFileDestination = _data["claimFileDestination"];
            this.payrollFileDestination = _data["payrollFileDestination"];
            this.receiverId = _data["receiverId"];
            this.api = _data["api"];
            this.senderName = _data["senderName"];
            this.receiverName = _data["receiverName"];
            this.onlyEVVShifts = _data["onlyEVVShifts"];
            this.adjustmentReasonRequired = _data["adjustmentReasonRequired"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progNbr"] = this.progNbr;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["npi"] = this.npi;
        data["fedTaxID"] = this.fedTaxID;
        data["submitNbr"] = this.submitNbr;
        data["taxonomy"] = this.taxonomy;
        data["fundingTypeId"] = this.fundingTypeId;
        data["fundingTypeName"] = this.fundingTypeName;
        data["fundingSourceId"] = this.fundingSourceId;
        data["fundingSourceName"] = this.fundingSourceName;
        data["programTypeId"] = this.programTypeId;
        data["programType"] = this.programType;
        data["diagCodeId"] = this.diagCodeId;
        data["defaultDiagnosisCode"] = this.defaultDiagnosisCode;
        data["contactName"] = this.contactName;
        data["phone"] = this.phone;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["stateName"] = this.stateName;
        data["stateCode"] = this.stateCode;
        data["email"] = this.email;
        data["active"] = this.active;
        data["comment"] = this.comment;
        data["claimFileDestination"] = this.claimFileDestination;
        data["payrollFileDestination"] = this.payrollFileDestination;
        data["receiverId"] = this.receiverId;
        data["api"] = this.api;
        data["senderName"] = this.senderName;
        data["receiverName"] = this.receiverName;
        data["onlyEVVShifts"] = this.onlyEVVShifts;
        data["adjustmentReasonRequired"] = this.adjustmentReasonRequired;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramDto {
    id?: number;
    progNbr?: string | undefined;
    name?: string | undefined;
    companyId?: number;
    payorId?: number;
    payorName?: string | undefined;
    npi?: string | undefined;
    fedTaxID?: string | undefined;
    submitNbr?: string | undefined;
    taxonomy?: string | undefined;
    fundingTypeId?: number;
    fundingTypeName?: string | undefined;
    fundingSourceId?: number;
    fundingSourceName?: string | undefined;
    programTypeId?: number;
    programType?: string | undefined;
    diagCodeId?: number;
    defaultDiagnosisCode?: string | undefined;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    stateName?: string | undefined;
    stateCode?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    claimFileDestination?: string | undefined;
    payrollFileDestination?: string | undefined;
    receiverId?: string | undefined;
    api?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    onlyEVVShifts?: boolean;
    adjustmentReasonRequired?: boolean;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class ProgramFilterRequest implements IProgramFilterRequest {
    searchParameter?: string | undefined;
    payorId?: number[] | undefined;
    activeOnly?: boolean | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IProgramFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParameter = _data["searchParameter"];
            if (Array.isArray(_data["payorId"])) {
                this.payorId = [] as any;
                for (let item of _data["payorId"])
                    this.payorId!.push(item);
            }
            this.activeOnly = _data["activeOnly"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): ProgramFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParameter"] = this.searchParameter;
        if (Array.isArray(this.payorId)) {
            data["payorId"] = [];
            for (let item of this.payorId)
                data["payorId"].push(item);
        }
        data["activeOnly"] = this.activeOnly;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IProgramFilterRequest {
    searchParameter?: string | undefined;
    payorId?: number[] | undefined;
    activeOnly?: boolean | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class ProgramTypeRequestDto implements IProgramTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    name!: string;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    description?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    seviceTypes?: ProgramServiceTypes[] | undefined;

    constructor(data?: IProgramTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.approvalStatus = _data["approvalStatus"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["seviceTypes"])) {
                this.seviceTypes = [] as any;
                for (let item of _data["seviceTypes"])
                    this.seviceTypes!.push(ProgramServiceTypes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["approvalStatus"] = this.approvalStatus;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.seviceTypes)) {
            data["seviceTypes"] = [];
            for (let item of this.seviceTypes)
                data["seviceTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProgramTypeRequestDto {
    id?: number | undefined;
    companyId?: number;
    name: string;
    status?: string | undefined;
    approvalStatus?: string | undefined;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    description?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    seviceTypes?: ProgramServiceTypes[] | undefined;
}

export interface IProgramTypeExport  {

    id?: number | undefined;
    programType?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
}
export class ProgramServiceTypeExport extends FilterRequest implements IProgramTypeExport {
    id?: number | undefined;
    programType?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;



    constructor(data?: IProgramTypeExport) {
        super();
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programType = _data["programType"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
         }
    }

    static fromJS(data: any): ProgramServiceTypeExport {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramServiceTypeExport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};

        data["id"] = this.id;
        data["programType"] = this.programType;
        data["description"] = this.description;
        data["status"] = this.status;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class GetBillingDataForRulesRequest implements IGetBillingDataForRulesRequest {
    servCode?: string | undefined;
    serviceDate?: Date;
    payorId?: string | undefined;
    progNbr?: string | undefined;

    constructor(data?: IGetBillingDataForRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.payorId = _data["payorId"];
            this.progNbr = _data["progNbr"];
        }
    }

    static fromJS(data: any): GetBillingDataForRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillingDataForRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["payorId"] = this.payorId;
        data["progNbr"] = this.progNbr;
        return data;
    }
}

export interface IGetBillingDataForRulesRequest {
    servCode?: string | undefined;
    serviceDate?: Date;
    payorId?: string | undefined;
    progNbr?: string | undefined;
}

export class GetBillingDataForRulesResponse implements IGetBillingDataForRulesResponse {
    id?: number;
    billRate?: number | undefined;
    unitMulti?: number | undefined;
    markUpPC?: number | undefined;
    unitMethod?: number | undefined;
    maxBillRate?: number | undefined;
    authReqd?: string | undefined;
    lateServiceThresholdDays?: number | undefined;
    billCodeId?: string | undefined;
    markUp?: number | undefined;
    payDate?: Date | undefined;
    payorWeekStartDay?: number | undefined;
    otBillRate?: number | undefined;
    nonBillable?: string | undefined;
    placeOfService?: number;
    revenueCode?: string | undefined;
    statementDate?: Date | undefined;

    constructor(data?: IGetBillingDataForRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billRate = _data["billRate"];
            this.unitMulti = _data["unitMulti"];
            this.markUpPC = _data["markUpPC"];
            this.unitMethod = _data["unitMethod"];
            this.maxBillRate = _data["maxBillRate"];
            this.authReqd = _data["authReqd"];
            this.lateServiceThresholdDays = _data["lateServiceThresholdDays"];
            this.billCodeId = _data["billCodeId"];
            this.markUp = _data["markUp"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.payorWeekStartDay = _data["payorWeekStartDay"];
            this.otBillRate = _data["otBillRate"];
            this.nonBillable = _data["nonBillable"];
            this.placeOfService = _data["placeOfService"];
            this.revenueCode = _data["revenueCode"];
            this.statementDate = _data["statementDate"] ? new Date(_data["statementDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBillingDataForRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillingDataForRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billRate"] = this.billRate;
        data["unitMulti"] = this.unitMulti;
        data["markUpPC"] = this.markUpPC;
        data["unitMethod"] = this.unitMethod;
        data["maxBillRate"] = this.maxBillRate;
        data["authReqd"] = this.authReqd;
        data["lateServiceThresholdDays"] = this.lateServiceThresholdDays;
        data["billCodeId"] = this.billCodeId;
        data["markUp"] = this.markUp;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["payorWeekStartDay"] = this.payorWeekStartDay;
        data["otBillRate"] = this.otBillRate;
        data["nonBillable"] = this.nonBillable;
        data["placeOfService"] = this.placeOfService;
        data["revenueCode"] = this.revenueCode;
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetBillingDataForRulesResponse {
    id?: number;
    billRate?: number | undefined;
    unitMulti?: number | undefined;
    markUpPC?: number | undefined;
    unitMethod?: number | undefined;
    maxBillRate?: number | undefined;
    authReqd?: string | undefined;
    lateServiceThresholdDays?: number | undefined;
    billCodeId?: string | undefined;
    markUp?: number | undefined;
    payDate?: Date | undefined;
    payorWeekStartDay?: number | undefined;
    otBillRate?: number | undefined;
    nonBillable?: string | undefined;
    placeOfService?: number;
    revenueCode?: string | undefined;
    statementDate?: Date | undefined;
}

export class RuleDetails implements IRuleDetails {
    ruleId?: string | undefined;
    isEnabled?: boolean;
    documentTypes?: RuleDocumentTypeDetails[] | undefined;
    failureType?: string | undefined;

    constructor(data?: IRuleDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["ruleId"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(RuleDocumentTypeDetails.fromJS(item));
            }
            this.failureType = _data["failureType"];
        }
    }

    static fromJS(data: any): RuleDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["failureType"] = this.failureType;
        return data;
    }
}

export interface IRuleDetails {
    ruleId?: string | undefined;
    isEnabled?: boolean;
    documentTypes?: RuleDocumentTypeDetails[] | undefined;
    failureType?: string | undefined;
}

export class RuleDocumentTypeDetails implements IRuleDocumentTypeDetails {
    documentType?: string | undefined;
    isEnabled?: boolean;
    exceptions?: string[] | undefined;

    constructor(data?: IRuleDocumentTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(item);
            }
        }
    }

    static fromJS(data: any): RuleDocumentTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDocumentTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item);
        }
        return data;
    }
}

export interface IRuleDocumentTypeDetails {
    documentType?: string | undefined;
    isEnabled?: boolean;
    exceptions?: string[] | undefined;
}

export class RulesConfigDTO implements IRulesConfigDTO {
    ruleId?: string | undefined;
    priority?: number;
    failureType?: string | undefined;

    constructor(data?: IRulesConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["ruleId"];
            this.priority = _data["priority"];
            this.failureType = _data["failureType"];
        }
    }

    static fromJS(data: any): RulesConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RulesConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        data["priority"] = this.priority;
        data["failureType"] = this.failureType;
        return data;
    }
}

export interface IRulesConfigDTO {
    ruleId?: string | undefined;
    priority?: number;
    failureType?: string | undefined;
}

export class RulesConfigRequest implements IRulesConfigRequest {
    companyCode?: string | undefined;
    docType?: string | undefined;
    servDate?: Date | undefined;
    servCode?: string | undefined;
    ruleSet?: string | undefined;
    system?: string | undefined;

    constructor(data?: IRulesConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.docType = _data["docType"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.servCode = _data["servCode"];
            this.ruleSet = _data["ruleSet"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): RulesConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RulesConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["docType"] = this.docType;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["servCode"] = this.servCode;
        data["ruleSet"] = this.ruleSet;
        data["system"] = this.system;
        return data;
    }
}

export interface IRulesConfigRequest {
    companyCode?: string | undefined;
    docType?: string | undefined;
    servDate?: Date | undefined;
    servCode?: string | undefined;
    ruleSet?: string | undefined;
    system?: string | undefined;
}

export class SFListRequestDto implements ISFListRequestDto {
    agencyId?: number;
    searchParam?: string | undefined;

    constructor(data?: ISFListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"];
            this.searchParam = _data["searchParam"];
        }
    }

    static fromJS(data: any): SFListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SFListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId;
        data["searchParam"] = this.searchParam;
        return data;
    }
}

export interface ISFListRequestDto {
    agencyId?: number;
    searchParam?: string | undefined;
}

export class ServCodeAuthDetailsRequest implements IServCodeAuthDetailsRequest {
    participantId?: string | undefined;
    gracePeriod?: number;

    constructor(data?: IServCodeAuthDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.gracePeriod = _data["gracePeriod"];
        }
    }

    static fromJS(data: any): ServCodeAuthDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeAuthDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["gracePeriod"] = this.gracePeriod;
        return data;
    }
}

export interface IServCodeAuthDetailsRequest {
    participantId?: string | undefined;
    gracePeriod?: number;
}

export class ServeCodeFilterRequest implements IServeCodeFilterRequest {
    searchParam?: string | undefined;
    serveCodeId?: number | undefined;
    otFlag?: boolean | undefined;
    adminAuthFlag?: boolean | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IServeCodeFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchParam = _data["searchParam"];
            this.serveCodeId = _data["serveCodeId"];
            this.otFlag = _data["otFlag"];
            this.adminAuthFlag = _data["adminAuthFlag"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): ServeCodeFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServeCodeFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchParam"] = this.searchParam;
        data["serveCodeId"] = this.serveCodeId;
        data["otFlag"] = this.otFlag;
        data["adminAuthFlag"] = this.adminAuthFlag;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IServeCodeFilterRequest {
    searchParam?: string | undefined;
    serveCodeId?: number | undefined;
    otFlag?: boolean | undefined;
    adminAuthFlag?: boolean | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export class ServiceFacilitatorRequest implements IServiceFacilitatorRequest {
    ids?: string | undefined;
    agencyId?: number;

    constructor(data?: IServiceFacilitatorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ids = _data["ids"];
            this.agencyId = _data["agencyId"];
        }
    }

    static fromJS(data: any): ServiceFacilitatorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFacilitatorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ids"] = this.ids;
        data["agencyId"] = this.agencyId;
        return data;
    }
}

export interface IServiceFacilitatorRequest {
    ids?: string | undefined;
    agencyId?: number;
}

export class ServiceTypeRequestDto implements IServiceTypeRequestDto {
    id!: number;
    serviceTypeCode?: string | undefined;
    description?: string | undefined;
    active?: string | undefined;
    documentTypeId?: number[] | undefined;

    constructor(data?: IServiceTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            this.description = _data["description"];
            this.active = _data["active"];
            if (Array.isArray(_data["documentTypeId"])) {
                this.documentTypeId = [] as any;
                for (let item of _data["documentTypeId"])
                    this.documentTypeId!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceTypeCode"] = this.serviceTypeCode;
        data["description"] = this.description;
        data["active"] = this.active;
        if (Array.isArray(this.documentTypeId)) {
            data["documentTypeId"] = [];
            for (let item of this.documentTypeId)
                data["documentTypeId"].push(item);
        }
        return data;
    }
}

export interface IServiceTypeRequestDto {
    id: number;
    serviceTypeCode?: string | undefined;
    description?: string | undefined;
    active?: string | undefined;
    documentTypeId?: number[] | undefined;
}

export class ServiceTypeResponseDto implements IServiceTypeResponseDto {
    id?: number;
    serviceTypeCode?: string | undefined;
    documentType?: DocumentType[] | undefined;
    description?: string | undefined;
    active?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IServiceTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            if (Array.isArray(_data["documentType"])) {
                this.documentType = [] as any;
                for (let item of _data["documentType"])
                    this.documentType!.push(DocumentType.fromJS(item));
            }
            this.description = _data["description"];
            this.active = _data["active"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceTypeCode"] = this.serviceTypeCode;
        if (Array.isArray(this.documentType)) {
            data["documentType"] = [];
            for (let item of this.documentType)
                data["documentType"].push(item ? item.toJSON() : <any>undefined);
        }
        data["description"] = this.description;
        data["active"] = this.active;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceTypeResponseDto {
    id?: number;
    serviceTypeCode?: string | undefined;
    documentType?: DocumentType[] | undefined;
    description?: string | undefined;
    active?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class Shift implements IShift {
    participantName?: string | undefined;
    participantId?: string | undefined;
    employeeName?: string | undefined;
    employeeId?: string | undefined;
    transactionStatus?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceDate?: Date | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
    hours?: number | undefined;
    source?: string | undefined;
    rulesStatus?: string | undefined;
    transactionId?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: string | undefined;
    paidDate?: string | undefined;
    notes?: string | undefined;
    exceptionQueue?: string | undefined;
    exception?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantName = _data["participantName"];
            this.participantId = _data["participantId"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.transactionStatus = _data["transactionStatus"];
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeDescription = _data["serviceCodeDescription"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.timeIn = _data["timeIn"];
            this.timeOut = _data["timeOut"];
            this.hours = _data["hours"];
            this.source = _data["source"];
            this.rulesStatus = _data["rulesStatus"];
            this.transactionId = _data["transactionId"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"];
            this.notes = _data["notes"];
            this.exceptionQueue = _data["exceptionQueue"];
            this.exception = _data["exception"];
            this.resolution = _data["resolution"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): Shift {
        data = typeof data === 'object' ? data : {};
        let result = new Shift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantName"] = this.participantName;
        data["participantId"] = this.participantId;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["transactionStatus"] = this.transactionStatus;
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeDescription"] = this.serviceCodeDescription;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["timeIn"] = this.timeIn;
        data["timeOut"] = this.timeOut;
        data["hours"] = this.hours;
        data["source"] = this.source;
        data["rulesStatus"] = this.rulesStatus;
        data["transactionId"] = this.transactionId;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate;
        data["notes"] = this.notes;
        data["exceptionQueue"] = this.exceptionQueue;
        data["exception"] = this.exception;
        data["resolution"] = this.resolution;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IShift {
    participantName?: string | undefined;
    participantId?: string | undefined;
    employeeName?: string | undefined;
    employeeId?: string | undefined;
    transactionStatus?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceDate?: Date | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
    hours?: number | undefined;
    source?: string | undefined;
    rulesStatus?: string | undefined;
    transactionId?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: string | undefined;
    paidDate?: string | undefined;
    notes?: string | undefined;
    exceptionQueue?: string | undefined;
    exception?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
}

export class ShiftActionResponseDTO implements IShiftActionResponseDTO {
    isSuccess?: boolean;
    errorMessages?: string[] | undefined;
    warnings?: string[] | undefined;
    shiftId?: string | undefined;

    constructor(data?: IShiftActionResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): ShiftActionResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftActionResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        data["shiftId"] = this.shiftId;
        return data;
    }
}

export interface IShiftActionResponseDTO {
    isSuccess?: boolean;
    errorMessages?: string[] | undefined;
    warnings?: string[] | undefined;
    shiftId?: string | undefined;
}

export class ShiftDetailsEntity implements IShiftDetailsEntity {
    inTimeString!: string;
    outTimeString!: string;
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    stAddress?: Address;
    endAddress?: Address;
    isStLocPtpntLocSame?: boolean | undefined;
    ptpntCmnts?: string | undefined;
    isMalformed?: boolean;
    cgvId!: string;
    cgvCmpyCode?: string | undefined;
    svcCode!: string;
    inTime!: Date;
    outTime!: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType!: string;
    src!: string;
    destType?: string | undefined;
    transStatus!: number;
    ruleStatus!: string;
    ctdBy!: string;
    mdfdBy!: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId!: string;
    ptpntId!: string;
    readonly ptnKey?: string | undefined;
    docType!: string;
    ptpntCmpyCode!: string;
    ttl?: number | undefined;
    readonly version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;

    constructor(data?: IShiftDetailsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inTimeString = _data["inTimeString"];
            this.outTimeString = _data["outTimeString"];
            this.inTimeActual = _data["inTimeActual"] ? new Date(_data["inTimeActual"].toString()) : <any>undefined;
            this.outTimeActual = _data["outTimeActual"] ? new Date(_data["outTimeActual"].toString()) : <any>undefined;
            this.stAddress = _data["stAddress"] ? Address.fromJS(_data["stAddress"]) : <any>undefined;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : <any>undefined;
            this.isStLocPtpntLocSame = _data["isStLocPtpntLocSame"];
            this.ptpntCmnts = _data["ptpntCmnts"];
            this.isMalformed = _data["isMalformed"];
            this.cgvId = _data["cgvId"];
            this.cgvCmpyCode = _data["cgvCmpyCode"];
            this.svcCode = _data["svcCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.extId = _data["extId"];
            if (Array.isArray(_data["Overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["Overrides"])
                    this.overrides!.push(RuleOverride.fromJS(item));
            }
            this.recTyp = _data["recTyp"];
            this.cgCmnts = _data["cgCmnts"];
            this.srcType = _data["srcType"];
            this.src = _data["src"];
            this.destType = _data["destType"];
            this.transStatus = _data["transStatus"];
            this.ruleStatus = _data["ruleStatus"];
            this.ctdBy = _data["ctdBy"];
            this.mdfdBy = _data["mdfdBy"];
            this.sysMdfdBy = _data["sysMdfdBy"];
            this.sysLstUpdtdDate = _data["sysLstUpdtdDate"] ? new Date(_data["sysLstUpdtdDate"].toString()) : <any>undefined;
            this.refTxId = _data["refTxId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.isPositive = _data["isPositive"];
            this.isVoid = _data["isVoid"];
            this.isVoidOnly = _data["isVoidOnly"];
            this.onHold = _data["onHold"];
            this.adjType = _data["adjType"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.isPSST = _data["isPSST"];
            this.statusDisplayText = _data["statusDisplayText"];
            this.statusTitle = _data["statusTitle"];
            this.statusDisplayTitle = _data["statusDisplayTitle"];
            this.id = _data["id"];
            this.txId = _data["txId"];
            this.ptpntId = _data["ptpntId"];
            (<any>this).ptnKey = _data["ptnKey"];
            this.docType = _data["docType"];
            this.ptpntCmpyCode = _data["ptpntCmpyCode"];
            this.ttl = _data["ttl"];
            (<any>this).version = _data["version"];
            this.isDel = _data["isDel"];
            this.ctdDate = _data["ctdDate"] ? new Date(_data["ctdDate"].toString()) : <any>undefined;
            this.lstUpdtdDate = _data["lstUpdtdDate"] ? new Date(_data["lstUpdtdDate"].toString()) : <any>undefined;
            this._etag = _data["_etag"];
            this.companyContext = _data["companyContext"];
            this.nwRetryCount = _data["nwRetryCount"];
            this.priority = _data["priority"];
            this.gpsIn = _data["gpsIn"] ? Gps.fromJS(_data["gpsIn"]) : <any>undefined;
            this.gpsOut = _data["gpsOut"] ? Gps.fromJS(_data["gpsOut"]) : <any>undefined;
            this.ivrNbrIn = _data["ivrNbrIn"];
            this.ivrNbrOut = _data["ivrNbrOut"];
            this.adjReasonCode = _data["adjReasonCode"];
        }
    }

    static fromJS(data: any): ShiftDetailsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inTimeString"] = this.inTimeString;
        data["outTimeString"] = this.outTimeString;
        data["inTimeActual"] = this.inTimeActual ? this.inTimeActual.toISOString() : <any>undefined;
        data["outTimeActual"] = this.outTimeActual ? this.outTimeActual.toISOString() : <any>undefined;
        data["stAddress"] = this.stAddress ? this.stAddress.toJSON() : <any>undefined;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : <any>undefined;
        data["isStLocPtpntLocSame"] = this.isStLocPtpntLocSame;
        data["ptpntCmnts"] = this.ptpntCmnts;
        data["isMalformed"] = this.isMalformed;
        data["cgvId"] = this.cgvId;
        data["cgvCmpyCode"] = this.cgvCmpyCode;
        data["svcCode"] = this.svcCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["extId"] = this.extId;
        if (Array.isArray(this.overrides)) {
            data["Overrides"] = [];
            for (let item of this.overrides)
                data["Overrides"].push(item ? item.toJSON() : <any>undefined);
        }
        data["recTyp"] = this.recTyp;
        data["cgCmnts"] = this.cgCmnts;
        data["srcType"] = this.srcType;
        data["src"] = this.src;
        data["destType"] = this.destType;
        data["transStatus"] = this.transStatus;
        data["ruleStatus"] = this.ruleStatus;
        data["ctdBy"] = this.ctdBy;
        data["mdfdBy"] = this.mdfdBy;
        data["sysMdfdBy"] = this.sysMdfdBy;
        data["sysLstUpdtdDate"] = this.sysLstUpdtdDate ? this.sysLstUpdtdDate.toISOString() : <any>undefined;
        data["refTxId"] = this.refTxId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["isPositive"] = this.isPositive;
        data["isVoid"] = this.isVoid;
        data["isVoidOnly"] = this.isVoidOnly;
        data["onHold"] = this.onHold;
        data["adjType"] = this.adjType;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["isPSST"] = this.isPSST;
        data["statusDisplayText"] = this.statusDisplayText;
        data["statusTitle"] = this.statusTitle;
        data["statusDisplayTitle"] = this.statusDisplayTitle;
        data["id"] = this.id;
        data["txId"] = this.txId;
        data["ptpntId"] = this.ptpntId;
        data["ptnKey"] = this.ptnKey;
        data["docType"] = this.docType;
        data["ptpntCmpyCode"] = this.ptpntCmpyCode;
        data["ttl"] = this.ttl;
        data["version"] = this.version;
        data["isDel"] = this.isDel;
        data["ctdDate"] = this.ctdDate ? this.ctdDate.toISOString() : <any>undefined;
        data["lstUpdtdDate"] = this.lstUpdtdDate ? this.lstUpdtdDate.toISOString() : <any>undefined;
        data["_etag"] = this._etag;
        data["companyContext"] = this.companyContext;
        data["nwRetryCount"] = this.nwRetryCount;
        data["priority"] = this.priority;
        data["gpsIn"] = this.gpsIn ? this.gpsIn.toJSON() : <any>undefined;
        data["gpsOut"] = this.gpsOut ? this.gpsOut.toJSON() : <any>undefined;
        data["ivrNbrIn"] = this.ivrNbrIn;
        data["ivrNbrOut"] = this.ivrNbrOut;
        data["adjReasonCode"] = this.adjReasonCode;
        return data;
    }
}

export interface IShiftDetailsEntity {
    inTimeString: string;
    outTimeString: string;
    inTimeActual?: Date | undefined;
    outTimeActual?: Date | undefined;
    stAddress?: Address;
    endAddress?: Address;
    isStLocPtpntLocSame?: boolean | undefined;
    ptpntCmnts?: string | undefined;
    isMalformed?: boolean;
    cgvId: string;
    cgvCmpyCode?: string | undefined;
    svcCode: string;
    inTime: Date;
    outTime: Date;
    calHrs?: number | undefined;
    extId?: string | undefined;
    overrides?: RuleOverride[] | undefined;
    recTyp?: string | undefined;
    cgCmnts?: string | undefined;
    srcType: string;
    src: string;
    destType?: string | undefined;
    transStatus: number;
    ruleStatus: string;
    ctdBy: string;
    mdfdBy: string;
    sysMdfdBy?: string | undefined;
    sysLstUpdtdDate?: Date;
    refTxId?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    isPositive?: boolean;
    isVoid?: boolean;
    isVoidOnly?: boolean;
    onHold?: boolean;
    adjType?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    statusDisplayText?: string | undefined;
    statusTitle?: string | undefined;
    statusDisplayTitle?: string | undefined;
    id?: string | undefined;
    txId: string;
    ptpntId: string;
    ptnKey?: string | undefined;
    docType: string;
    ptpntCmpyCode: string;
    ttl?: number | undefined;
    version?: string | undefined;
    isDel?: boolean;
    ctdDate?: Date;
    lstUpdtdDate?: Date;
    _etag?: string | undefined;
    companyContext?: string | undefined;
    nwRetryCount?: number;
    priority?: number;
    gpsIn?: Gps;
    gpsOut?: Gps;
    ivrNbrIn?: string | undefined;
    ivrNbrOut?: string | undefined;
    adjReasonCode?: string | undefined;
}

export class ShiftSubmissionDTO implements IShiftSubmissionDTO {
    id?: string | undefined;
    inTime!: Date;
    outTime!: Date;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    shiftStatusId?: number;
    caregiverComments?: string | undefined;
    participantComments?: string | undefined;
    isShiftCommentRequired?: boolean;
    serviceCodeId?: string | undefined;
    cellId?: string | undefined;
    calculatedHours?: number | undefined;
    suppressWarnings?: boolean;
    participantCompanyCode?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    sourceType?: string | undefined;
    source?: string | undefined;
    ruleStatus?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjReasonCode?: string | undefined;
    startLocnSameAsPtpntHomeAddress?: boolean | undefined;
    startAddress?: Address;
    endAddress?: Address;
    participantAddress?: Address;
    companyCode?: string | undefined;
    logging?: ShiftDiagnosisLogging;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    docType?: string | undefined;
    inTimeString!: string;
    outTimeString!: string;
    programId?: string | undefined;

    constructor(data?: IShiftSubmissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.shiftStatusId = _data["shiftStatusId"];
            this.caregiverComments = _data["caregiverComments"];
            this.participantComments = _data["participantComments"];
            this.isShiftCommentRequired = _data["isShiftCommentRequired"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.cellId = _data["cellId"];
            this.calculatedHours = _data["calculatedHours"];
            this.suppressWarnings = _data["suppressWarnings"];
            this.participantCompanyCode = _data["participantCompanyCode"];
            this.caregiverCompanyCode = _data["caregiverCompanyCode"];
            this.sourceType = _data["sourceType"];
            this.source = _data["source"];
            this.ruleStatus = _data["ruleStatus"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.adjReasonCode = _data["adjReasonCode"];
            this.startLocnSameAsPtpntHomeAddress = _data["startLocnSameAsPtpntHomeAddress"];
            this.startAddress = _data["startAddress"] ? Address.fromJS(_data["startAddress"]) : <any>undefined;
            this.endAddress = _data["endAddress"] ? Address.fromJS(_data["endAddress"]) : <any>undefined;
            this.participantAddress = _data["participantAddress"] ? Address.fromJS(_data["participantAddress"]) : <any>undefined;
            this.companyCode = _data["companyCode"];
            this.logging = _data["logging"] ? ShiftDiagnosisLogging.fromJS(_data["logging"]) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
            this.isPSST = _data["isPSST"];
            this.docType = _data["docType"];
            this.inTimeString = _data["inTimeString"];
            this.outTimeString = _data["outTimeString"];
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): ShiftSubmissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSubmissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["shiftStatusId"] = this.shiftStatusId;
        data["caregiverComments"] = this.caregiverComments;
        data["participantComments"] = this.participantComments;
        data["isShiftCommentRequired"] = this.isShiftCommentRequired;
        data["serviceCodeId"] = this.serviceCodeId;
        data["cellId"] = this.cellId;
        data["calculatedHours"] = this.calculatedHours;
        data["suppressWarnings"] = this.suppressWarnings;
        data["participantCompanyCode"] = this.participantCompanyCode;
        data["caregiverCompanyCode"] = this.caregiverCompanyCode;
        data["sourceType"] = this.sourceType;
        data["source"] = this.source;
        data["ruleStatus"] = this.ruleStatus;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["adjReasonCode"] = this.adjReasonCode;
        data["startLocnSameAsPtpntHomeAddress"] = this.startLocnSameAsPtpntHomeAddress;
        data["startAddress"] = this.startAddress ? this.startAddress.toJSON() : <any>undefined;
        data["endAddress"] = this.endAddress ? this.endAddress.toJSON() : <any>undefined;
        data["participantAddress"] = this.participantAddress ? this.participantAddress.toJSON() : <any>undefined;
        data["companyCode"] = this.companyCode;
        data["logging"] = this.logging ? this.logging.toJSON() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        data["isPSST"] = this.isPSST;
        data["docType"] = this.docType;
        data["inTimeString"] = this.inTimeString;
        data["outTimeString"] = this.outTimeString;
        data["programId"] = this.programId;
        return data;
    }
}

export interface IShiftSubmissionDTO {
    id?: string | undefined;
    inTime: Date;
    outTime: Date;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    shiftStatusId?: number;
    caregiverComments?: string | undefined;
    participantComments?: string | undefined;
    isShiftCommentRequired?: boolean;
    serviceCodeId?: string | undefined;
    cellId?: string | undefined;
    calculatedHours?: number | undefined;
    suppressWarnings?: boolean;
    participantCompanyCode?: string | undefined;
    caregiverCompanyCode?: string | undefined;
    sourceType?: string | undefined;
    source?: string | undefined;
    ruleStatus?: string | undefined;
    reasonId?: string | undefined;
    reasonDescription?: string | undefined;
    adjReasonCode?: string | undefined;
    startLocnSameAsPtpntHomeAddress?: boolean | undefined;
    startAddress?: Address;
    endAddress?: Address;
    participantAddress?: Address;
    companyCode?: string | undefined;
    logging?: ShiftDiagnosisLogging;
    tasks?: string[] | undefined;
    isPSST?: boolean;
    docType?: string | undefined;
    inTimeString: string;
    outTimeString: string;
    programId?: string | undefined;
}

export class ServiceCodeRequest implements IServiceCodeRequest {
    servCodeType?: string | undefined;
    wkStDate?: Date;
    empId?: string | undefined;
    ptpntId?: string | undefined;
    ptpntStCode?: string | undefined;
    addrTyp?: string | undefined;
    istwoweek?: boolean;
    empIds?: string[] | undefined;

    constructor(data?: IServiceCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCodeType = _data["ServCodeType"];
            this.wkStDate = _data["WkStDate"] ? new Date(_data["WkStDate"].toString()) : <any>undefined;
            this.empId = _data["EmpId"];
            this.ptpntId = _data["PtpntId"];
            this.ptpntStCode = _data["PtpntStCode"];
            this.addrTyp = _data["AddrTyp"];
            this.istwoweek = _data["Istwoweek"];
            if (Array.isArray(_data["EmpIds"])) {
                this.empIds = [] as any;
                for (let item of _data["EmpIds"])
                    this.empIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServCodeType"] = this.servCodeType;
        data["WkStDate"] = this.wkStDate ? this.wkStDate.toISOString() : <any>undefined;
        data["EmpId"] = this.empId;
        data["PtpntId"] = this.ptpntId;
        data["PtpntStCode"] = this.ptpntStCode;
        data["AddrTyp"] = this.addrTyp;
        data["Istwoweek"] = this.istwoweek;
        if (Array.isArray(this.empIds)) {
            data["EmpIds"] = [];
            for (let item of this.empIds)
                data["EmpIds"].push(item);
        }
        return data;
    }
}

export interface IServiceCodeRequest {
    servCodeType?: string | undefined;
    wkStDate?: Date;
    empId?: string | undefined;
    ptpntId?: string | undefined;
    ptpntStCode?: string | undefined;
    addrTyp?: string | undefined;
    istwoweek?: boolean;
    empIds?: string[] | undefined;
}

export class ServiceCodeWithDocTypeRequest implements IServiceCodeWithDocTypeRequest {
    servCodeType?: string[] | undefined;
    wkStDate?: Date;
    empId?: string | undefined;
    ptpntId?: string | undefined;
    ptpntStCode?: string | undefined;
    addrTyp?: string | undefined;
    istwoweek?: boolean;
    empIds?: string[] | undefined;

    constructor(data?: IServiceCodeWithDocTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ServCodeType"])) {
                this.servCodeType = [] as any;
                for (let item of _data["ServCodeType"])
                    this.servCodeType!.push(item);
            }
            this.wkStDate = _data["WkStDate"] ? new Date(_data["WkStDate"].toString()) : <any>undefined;
            this.empId = _data["EmpId"];
            this.ptpntId = _data["PtpntId"];
            this.ptpntStCode = _data["PtpntStCode"];
            this.addrTyp = _data["AddrTyp"];
            this.istwoweek = _data["Istwoweek"];
            if (Array.isArray(_data["EmpIds"])) {
                this.empIds = [] as any;
                for (let item of _data["EmpIds"])
                    this.empIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceCodeWithDocTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeWithDocTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servCodeType)) {
            data["ServCodeType"] = [];
            for (let item of this.servCodeType)
                data["ServCodeType"].push(item);
        }
        data["WkStDate"] = this.wkStDate ? this.wkStDate.toISOString() : <any>undefined;
        data["EmpId"] = this.empId;
        data["PtpntId"] = this.ptpntId;
        data["PtpntStCode"] = this.ptpntStCode;
        data["AddrTyp"] = this.addrTyp;
        data["Istwoweek"] = this.istwoweek;
        if (Array.isArray(this.empIds)) {
            data["EmpIds"] = [];
            for (let item of this.empIds)
                data["EmpIds"].push(item);
        }
        return data;
    }
}

export interface IServiceCodeWithDocTypeRequest {
    servCodeType?: string[] | undefined;
    wkStDate?: Date;
    empId?: string | undefined;
    ptpntId?: string | undefined;
    ptpntStCode?: string | undefined;
    addrTyp?: string | undefined;
    istwoweek?: boolean;
    empIds?: string[] | undefined;
}

export class ServiceCodes implements IServiceCodes {
    servCodes?: string[] | undefined;

    constructor(data?: IServiceCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceCodes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item);
        }
        return data;
    }
}

export interface IServiceCodes {
    servCodes?: string[] | undefined;
}

export class ServiceLogDetailResponse implements IServiceLogDetailResponse {
    servTimeOutCalc?: string | undefined;
    servWeek?: number;
    payStatus?: string | undefined;
    payUnits?: number;
    payRatePre?: number;
    payDate?: Date | undefined;
    holiFlag?: string | undefined;
    apRef?: string | undefined;
    billStatus?: string | undefined;
    billUnits?: number;
    billRatePre?: number;
    billRef?: string | undefined;
    billTotalPre?: number;
    recordType?: string | undefined;
    documentId?: number;
    utexId?: number;
    recordId?: number;
    payTotalPre?: number | undefined;
    billRate?: number | undefined;
    billTotal?: number | undefined;
    vendId?: string | undefined;
    empID?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date | undefined;
    billCode?: string | undefined;
    servStatus?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;

    constructor(data?: IServiceLogDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servTimeOutCalc = _data["servTimeOutCalc"];
            this.servWeek = _data["servWeek"];
            this.payStatus = _data["payStatus"];
            this.payUnits = _data["payUnits"];
            this.payRatePre = _data["payRatePre"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.holiFlag = _data["holiFlag"];
            this.apRef = _data["apRef"];
            this.billStatus = _data["billStatus"];
            this.billUnits = _data["billUnits"];
            this.billRatePre = _data["billRatePre"];
            this.billRef = _data["billRef"];
            this.billTotalPre = _data["billTotalPre"];
            this.recordType = _data["recordType"];
            this.documentId = _data["documentId"];
            this.utexId = _data["utexId"];
            this.recordId = _data["recordId"];
            this.payTotalPre = _data["payTotalPre"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.vendId = _data["vendId"];
            this.empID = _data["empID"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.billCode = _data["billCode"];
            this.servStatus = _data["servStatus"];
            this.timeIn = _data["timeIn"];
            this.timeOut = _data["timeOut"];
        }
    }

    static fromJS(data: any): ServiceLogDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servTimeOutCalc"] = this.servTimeOutCalc;
        data["servWeek"] = this.servWeek;
        data["payStatus"] = this.payStatus;
        data["payUnits"] = this.payUnits;
        data["payRatePre"] = this.payRatePre;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["holiFlag"] = this.holiFlag;
        data["apRef"] = this.apRef;
        data["billStatus"] = this.billStatus;
        data["billUnits"] = this.billUnits;
        data["billRatePre"] = this.billRatePre;
        data["billRef"] = this.billRef;
        data["billTotalPre"] = this.billTotalPre;
        data["recordType"] = this.recordType;
        data["documentId"] = this.documentId;
        data["utexId"] = this.utexId;
        data["recordId"] = this.recordId;
        data["payTotalPre"] = this.payTotalPre;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["vendId"] = this.vendId;
        data["empID"] = this.empID;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["billCode"] = this.billCode;
        data["servStatus"] = this.servStatus;
        data["timeIn"] = this.timeIn;
        data["timeOut"] = this.timeOut;
        return data;
    }
}

export interface IServiceLogDetailResponse {
    servTimeOutCalc?: string | undefined;
    servWeek?: number;
    payStatus?: string | undefined;
    payUnits?: number;
    payRatePre?: number;
    payDate?: Date | undefined;
    holiFlag?: string | undefined;
    apRef?: string | undefined;
    billStatus?: string | undefined;
    billUnits?: number;
    billRatePre?: number;
    billRef?: string | undefined;
    billTotalPre?: number;
    recordType?: string | undefined;
    documentId?: number;
    utexId?: number;
    recordId?: number;
    payTotalPre?: number | undefined;
    billRate?: number | undefined;
    billTotal?: number | undefined;
    vendId?: string | undefined;
    empID?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date | undefined;
    billCode?: string | undefined;
    servStatus?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
}

export class ServiceLogRequest implements IServiceLogRequest {
    companyCode?: string | undefined;
    custID?: string | undefined;
    agreenbr?: string | undefined;
    dateBeg?: string | undefined;
    dateEnd?: string | undefined;
    empId?: string | undefined;
    vendId?: string | undefined;
    servCode?: string | undefined;

    constructor(data?: IServiceLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.custID = _data["custID"];
            this.agreenbr = _data["agreenbr"];
            this.dateBeg = _data["dateBeg"];
            this.dateEnd = _data["dateEnd"];
            this.empId = _data["empId"];
            this.vendId = _data["vendId"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): ServiceLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["custID"] = this.custID;
        data["agreenbr"] = this.agreenbr;
        data["dateBeg"] = this.dateBeg;
        data["dateEnd"] = this.dateEnd;
        data["empId"] = this.empId;
        data["vendId"] = this.vendId;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface IServiceLogRequest {
    companyCode?: string | undefined;
    custID?: string | undefined;
    agreenbr?: string | undefined;
    dateBeg?: string | undefined;
    dateEnd?: string | undefined;
    empId?: string | undefined;
    vendId?: string | undefined;
    servCode?: string | undefined;
}

export class TimeShiftByIdRequestDTO implements ITimeShiftByIdRequestDTO {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    shiftId?: string | undefined;
    companyCode?: string | undefined;
    docType?: string | undefined;

    constructor(data?: ITimeShiftByIdRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.shiftId = _data["shiftId"];
            this.companyCode = _data["companyCode"];
            this.docType = _data["docType"];
        }
    }

    static fromJS(data: any): TimeShiftByIdRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeShiftByIdRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["shiftId"] = this.shiftId;
        data["companyCode"] = this.companyCode;
        data["docType"] = this.docType;
        return data;
    }
}

export interface ITimeShiftByIdRequestDTO {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    shiftId?: string | undefined;
    companyCode?: string | undefined;
    docType?: string | undefined;
}

export class UnitRangeDto implements IUnitRangeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUnitRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UnitRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IUnitRangeDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class UserRoleCompany implements IUserRoleCompany {
    userId?: string | undefined;
    companyId?: number;
    roleId?: number[] | undefined;

    constructor(data?: IUserRoleCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["roleId"])) {
                this.roleId = [] as any;
                for (let item of _data["roleId"])
                    this.roleId!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRoleCompany {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.roleId)) {
            data["roleId"] = [];
            for (let item of this.roleId)
                data["roleId"].push(item);
        }
        return data;
    }
}

export interface IUserRoleCompany {
    userId?: string | undefined;
    companyId?: number;
    roleId?: number[] | undefined;
}

export class WeekDetailsDto implements IWeekDetailsDto {
    week?: number;
    weekEnd?: string | undefined;
    weekStart?: string | undefined;

    constructor(data?: IWeekDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week = _data["week"];
            this.weekEnd = _data["weekEnd"];
            this.weekStart = _data["weekStart"];
        }
    }

    static fromJS(data: any): WeekDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week;
        data["weekEnd"] = this.weekEnd;
        data["weekStart"] = this.weekStart;
        return data;
    }
}

export interface IWeekDetailsDto {
    week?: number;
    weekEnd?: string | undefined;
    weekStart?: string | undefined;
}

export class WeekDetailsRequest implements IWeekDetailsRequest {
    companyCode?: string | undefined;
    shiftDate?: Date;

    constructor(data?: IWeekDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.shiftDate = _data["shiftDate"] ? new Date(_data["shiftDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeekDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWeekDetailsRequest {
    companyCode?: string | undefined;
    shiftDate?: Date;
}

export class ADUserModel implements IADUserModel {
    objectId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;

    constructor(data?: IADUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any): ADUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ADUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface IADUserModel {
    objectId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
}

export class CompaniesModel implements ICompaniesModel {
    companyId?: number;
    companyName?: string | undefined;
    isSelected?: boolean;

    constructor(data?: ICompaniesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): CompaniesModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompaniesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ICompaniesModel {
    companyId?: number;
    companyName?: string | undefined;
    isSelected?: boolean;
}

export class CompanyConfigModel implements ICompanyConfigModel {
    companyId?: number;
    companyCode?: string | undefined;
    trimmerConfigJson?: string | undefined;
    isRounding?: boolean;

    constructor(data?: ICompanyConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.trimmerConfigJson = _data["trimmerConfigJson"];
            this.isRounding = _data["isRounding"];
        }
    }

    static fromJS(data: any): CompanyConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["trimmerConfigJson"] = this.trimmerConfigJson;
        data["isRounding"] = this.isRounding;
        return data;
    }
}

export interface ICompanyConfigModel {
    companyId?: number;
    companyCode?: string | undefined;
    trimmerConfigJson?: string | undefined;
    isRounding?: boolean;
}

export class LookupInstance implements ILookupInstance {
    displayText?: string | undefined;
    code?: string | undefined;
    valueText?: number;

    constructor(data?: ILookupInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayText = _data["displayText"];
            this.code = _data["code"];
            this.valueText = _data["valueText"];
        }
    }

    static fromJS(data: any): LookupInstance {
        data = typeof data === 'object' ? data : {};
        let result = new LookupInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayText"] = this.displayText;
        data["code"] = this.code;
        data["valueText"] = this.valueText;
        return data;
    }
}

export interface ILookupInstance {
    displayText?: string | undefined;
    code?: string | undefined;
    valueText?: number;
}

export class NonUserModel implements INonUserModel {
    userId?: number;
    userName?: string | undefined;

    constructor(data?: INonUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): NonUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new NonUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface INonUserModel {
    userId?: number;
    userName?: string | undefined;
}

export class PemissionsModel implements IPemissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IPemissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.permissionName = _data["permissionName"];
        }
    }

    static fromJS(data: any): PemissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PemissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["permissionName"] = this.permissionName;
        return data;
    }
}

export interface IPemissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;
}

export class RoleCompanyModel implements IRoleCompanyModel {
    roleId?: number;
    roleName?: string | undefined;
    companies?: CompaniesModel[] | undefined;
    hasAllCompanies?: boolean;

    constructor(data?: IRoleCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompaniesModel.fromJS(item));
            }
            this.hasAllCompanies = _data["hasAllCompanies"];
        }
    }

    static fromJS(data: any): RoleCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        data["hasAllCompanies"] = this.hasAllCompanies;
        return data;
    }
}

export interface IRoleCompanyModel {
    roleId?: number;
    roleName?: string | undefined;
    companies?: CompaniesModel[] | undefined;
    hasAllCompanies?: boolean;
}

export class RoleModel implements IRoleModel {
    roleId?: number;
    roleName!: string;
    companies?: CompaniesModel[] | undefined;
    screens?: ScreensModel[] | undefined;
    hasAllCompanies?: boolean;
    canImpersonate?: boolean;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompaniesModel.fromJS(item));
            }
            if (Array.isArray(_data["screens"])) {
                this.screens = [] as any;
                for (let item of _data["screens"])
                    this.screens!.push(ScreensModel.fromJS(item));
            }
            this.hasAllCompanies = _data["hasAllCompanies"];
            this.canImpersonate = _data["canImpersonate"];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.screens)) {
            data["screens"] = [];
            for (let item of this.screens)
                data["screens"].push(item ? item.toJSON() : <any>undefined);
        }
        data["hasAllCompanies"] = this.hasAllCompanies;
        data["canImpersonate"] = this.canImpersonate;
        return data;
    }
}

export interface IRoleModel {
    roleId?: number;
    roleName: string;
    companies?: CompaniesModel[] | undefined;
    screens?: ScreensModel[] | undefined;
    hasAllCompanies?: boolean;
    canImpersonate?: boolean;
}

export class ScreensModel implements IScreensModel {
    screenId?: number;
    screenName?: string | undefined;
    isEdit?: boolean;
    isDelete?: boolean;
    isRead?: boolean;
    isCreate?: boolean;
    isApprove?: boolean;
    pemissions?: PemissionsModel[] | undefined;

    constructor(data?: IScreensModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenId = _data["screenId"];
            this.screenName = _data["screenName"];
            this.isEdit = _data["isEdit"];
            this.isDelete = _data["isDelete"];
            this.isRead = _data["isRead"];
            this.isCreate = _data["isCreate"];
            this.isApprove = _data["isApprove"];
            if (Array.isArray(_data["pemissions"])) {
                this.pemissions = [] as any;
                for (let item of _data["pemissions"])
                    this.pemissions!.push(PemissionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScreensModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScreensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenId"] = this.screenId;
        data["screenName"] = this.screenName;
        data["isEdit"] = this.isEdit;
        data["isDelete"] = this.isDelete;
        data["isRead"] = this.isRead;
        data["isCreate"] = this.isCreate;
        data["isApprove"] = this.isApprove;
        if (Array.isArray(this.pemissions)) {
            data["pemissions"] = [];
            for (let item of this.pemissions)
                data["pemissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScreensModel {
    screenId?: number;
    screenName?: string | undefined;
    isEdit?: boolean;
    isDelete?: boolean;
    isRead?: boolean;
    isCreate?: boolean;
    isApprove?: boolean;
    pemissions?: PemissionsModel[] | undefined;
}

export class UserModel implements IUserModel {
    userRoleId?: number;
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRoleId = _data["userRoleId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRoleId"] = this.userRoleId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserModel {
    userRoleId?: number;
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;
}

export class UserRoleModel implements IUserRoleModel {
    roleId!: number;
    userId?: number[] | undefined;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        return data;
    }
}

export interface IUserRoleModel {
    roleId: number;
    userId?: number[] | undefined;
}

export class AgencyCreateRequest implements IAgencyCreateRequest {
    id?: number;
    agencyCode!: string;
    name!: string;
    companyId?: number;

    constructor(data?: IAgencyCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyCode = _data["agencyCode"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): AgencyCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyCode"] = this.agencyCode;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IAgencyCreateRequest {
    id?: number;
    agencyCode: string;
    name: string;
    companyId?: number;
}

export class AuthorizationCreateRequest implements IAuthorizationCreateRequest {
    programId?: number | undefined;
    companyCode?: string | undefined;
    clientId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    programType?: string | undefined;
    programNumber?: string | undefined;
    ecmExId?: string | undefined;
    custId?: number | undefined;
    ecmId?: number | undefined;
    isDraft?: boolean;
    budgetSummaries?: BudgetSummaryCreateRequest[] | undefined;

    constructor(data?: IAuthorizationCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.companyCode = _data["companyCode"];
            this.clientId = _data["clientId"];
            this.diagId = _data["diagId"];
            this.diagCode = _data["diagCode"];
            this.programType = _data["programType"];
            this.programNumber = _data["programNumber"];
            this.ecmExId = _data["ecmExId"];
            this.custId = _data["custId"];
            this.ecmId = _data["ecmId"];
            this.isDraft = _data["isDraft"];
            if (Array.isArray(_data["budgetSummaries"])) {
                this.budgetSummaries = [] as any;
                for (let item of _data["budgetSummaries"])
                    this.budgetSummaries!.push(BudgetSummaryCreateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["companyCode"] = this.companyCode;
        data["clientId"] = this.clientId;
        data["diagId"] = this.diagId;
        data["diagCode"] = this.diagCode;
        data["programType"] = this.programType;
        data["programNumber"] = this.programNumber;
        data["ecmExId"] = this.ecmExId;
        data["custId"] = this.custId;
        data["ecmId"] = this.ecmId;
        data["isDraft"] = this.isDraft;
        if (Array.isArray(this.budgetSummaries)) {
            data["budgetSummaries"] = [];
            for (let item of this.budgetSummaries)
                data["budgetSummaries"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAuthorizationCreateRequest {
    programId?: number | undefined;
    companyCode?: string | undefined;
    clientId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    programType?: string | undefined;
    programNumber?: string | undefined;
    ecmExId?: string | undefined;
    custId?: number | undefined;
    ecmId?: number | undefined;
    isDraft?: boolean;
    budgetSummaries?: BudgetSummaryCreateRequest[] | undefined;
}

export class AuthorizationUpdateRequest implements IAuthorizationUpdateRequest {
    id!: number;
    acn!: string;
    subAccount?: string | undefined;
    agreementNumber?: string | undefined;
    programId?: number | undefined;
    companyCode?: string | undefined;
    clientId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    programType?: string | undefined;
    programNumber?: string | undefined;
    ecmExId?: string | undefined;
    custId?: number | undefined;
    ecmId?: number | undefined;
    isDraft?: boolean;
    budgetSummaries?: BudgetSummaryCreateRequest[] | undefined;

    constructor(data?: IAuthorizationUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acn = _data["acn"];
            this.subAccount = _data["subAccount"];
            this.agreementNumber = _data["agreementNumber"];
            this.programId = _data["programId"];
            this.companyCode = _data["companyCode"];
            this.clientId = _data["clientId"];
            this.diagId = _data["diagId"];
            this.diagCode = _data["diagCode"];
            this.programType = _data["programType"];
            this.programNumber = _data["programNumber"];
            this.ecmExId = _data["ecmExId"];
            this.custId = _data["custId"];
            this.ecmId = _data["ecmId"];
            this.isDraft = _data["isDraft"];
            if (Array.isArray(_data["budgetSummaries"])) {
                this.budgetSummaries = [] as any;
                for (let item of _data["budgetSummaries"])
                    this.budgetSummaries!.push(BudgetSummaryCreateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acn"] = this.acn;
        data["subAccount"] = this.subAccount;
        data["agreementNumber"] = this.agreementNumber;
        data["programId"] = this.programId;
        data["companyCode"] = this.companyCode;
        data["clientId"] = this.clientId;
        data["diagId"] = this.diagId;
        data["diagCode"] = this.diagCode;
        data["programType"] = this.programType;
        data["programNumber"] = this.programNumber;
        data["ecmExId"] = this.ecmExId;
        data["custId"] = this.custId;
        data["ecmId"] = this.ecmId;
        data["isDraft"] = this.isDraft;
        if (Array.isArray(this.budgetSummaries)) {
            data["budgetSummaries"] = [];
            for (let item of this.budgetSummaries)
                data["budgetSummaries"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAuthorizationUpdateRequest {
    id: number;
    acn: string;
    subAccount?: string | undefined;
    agreementNumber?: string | undefined;
    programId?: number | undefined;
    companyCode?: string | undefined;
    clientId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    programType?: string | undefined;
    programNumber?: string | undefined;
    ecmExId?: string | undefined;
    custId?: number | undefined;
    ecmId?: number | undefined;
    isDraft?: boolean;
    budgetSummaries?: BudgetSummaryCreateRequest[] | undefined;
}

export class BudgetSummaryCreateRequest implements IBudgetSummaryCreateRequest {
    id?: number | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    servCodeId?: number;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    holdStartDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    closeOverlappingServices?: boolean | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;

    constructor(data?: IBudgetSummaryCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
            this.servCodeId = _data["servCodeId"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.processingStartDate = _data["processingStartDate"] ? new Date(_data["processingStartDate"].toString()) : <any>undefined;
            this.processingEndDate = _data["processingEndDate"] ? new Date(_data["processingEndDate"].toString()) : <any>undefined;
            this.holdStartDate = _data["holdStartDate"] ? new Date(_data["holdStartDate"].toString()) : <any>undefined;
            this.holdEndDate = _data["holdEndDate"] ? new Date(_data["holdEndDate"].toString()) : <any>undefined;
            this.feePctPr = _data["feePctPr"];
            this.feePctAdmin = _data["feePctAdmin"];
            this.pmFee = _data["pmFee"];
            this.hours = _data["hours"];
            this.units = _data["units"];
            this.rangeUnits = _data["rangeUnits"];
            this.budgetAmt = _data["budgetAmt"];
            this.rangeAmt = _data["rangeAmt"];
            this.unitRange = _data["unitRange"];
            this.amtRange = _data["amtRange"];
            this.closeOverlappingServices = _data["closeOverlappingServices"];
            this.serviceType = _data["serviceType"];
            this.diagCode = _data["diagCode"];
            this.updated = _data["updated"];
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): BudgetSummaryCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummaryCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        data["servCodeId"] = this.servCodeId;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["processingStartDate"] = this.processingStartDate ? this.processingStartDate.toISOString() : <any>undefined;
        data["processingEndDate"] = this.processingEndDate ? this.processingEndDate.toISOString() : <any>undefined;
        data["holdStartDate"] = this.holdStartDate ? this.holdStartDate.toISOString() : <any>undefined;
        data["holdEndDate"] = this.holdEndDate ? this.holdEndDate.toISOString() : <any>undefined;
        data["feePctPr"] = this.feePctPr;
        data["feePctAdmin"] = this.feePctAdmin;
        data["pmFee"] = this.pmFee;
        data["hours"] = this.hours;
        data["units"] = this.units;
        data["rangeUnits"] = this.rangeUnits;
        data["budgetAmt"] = this.budgetAmt;
        data["rangeAmt"] = this.rangeAmt;
        data["unitRange"] = this.unitRange;
        data["amtRange"] = this.amtRange;
        data["closeOverlappingServices"] = this.closeOverlappingServices;
        data["serviceType"] = this.serviceType;
        data["diagCode"] = this.diagCode;
        data["updated"] = this.updated;
        data["isDraft"] = this.isDraft;
        return data;
    }
}

export interface IBudgetSummaryCreateRequest {
    id?: number | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    servCodeId?: number;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    holdStartDate?: Date | undefined;
    holdEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    closeOverlappingServices?: boolean | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;
}

export class ExCaseMgProgramTypeCreateRequest implements IExCaseMgProgramTypeCreateRequest {
    id?: number | undefined;
    programTypeId!: number;
    programType?: string | undefined;
    dateBegin!: Date;
    dateEnd?: Date | undefined;

    constructor(data?: IExCaseMgProgramTypeCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programTypeId = _data["programTypeId"];
            this.programType = _data["programType"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExCaseMgProgramTypeCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgProgramTypeCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programTypeId"] = this.programTypeId;
        data["programType"] = this.programType;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExCaseMgProgramTypeCreateRequest {
    id?: number | undefined;
    programTypeId: number;
    programType?: string | undefined;
    dateBegin: Date;
    dateEnd?: Date | undefined;
}

export class ExCaseMgrCreateRequest implements IExCaseMgrCreateRequest {
    active?: Status;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName!: string;
    lastName?: string | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    payorId!: number;
    vendorId?: number | undefined;
    comment?: string | undefined;
    programTypeDetails?: ExCaseMgProgramTypeCreateRequest[] | undefined;

    constructor(data?: IExCaseMgrCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.emailAddress = _data["emailAddress"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.programId = _data["programId"];
            this.payorId = _data["payorId"];
            this.vendorId = _data["vendorId"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["programTypeDetails"])) {
                this.programTypeDetails = [] as any;
                for (let item of _data["programTypeDetails"])
                    this.programTypeDetails!.push(ExCaseMgProgramTypeCreateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExCaseMgrCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgrCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["emailAddress"] = this.emailAddress;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["programId"] = this.programId;
        data["payorId"] = this.payorId;
        data["vendorId"] = this.vendorId;
        data["comment"] = this.comment;
        if (Array.isArray(this.programTypeDetails)) {
            data["programTypeDetails"] = [];
            for (let item of this.programTypeDetails)
                data["programTypeDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IExCaseMgrCreateRequest {
    active?: Status;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName: string;
    lastName?: string | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    payorId: number;
    vendorId?: number | undefined;
    comment?: string | undefined;
    programTypeDetails?: ExCaseMgProgramTypeCreateRequest[] | undefined;
}

export class ExCaseMgrUpdateRequest implements IExCaseMgrUpdateRequest {
    id!: number;
    ecmId!: string;
    active?: Status;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName!: string;
    lastName?: string | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    payorId!: number;
    vendorId?: number | undefined;
    comment?: string | undefined;
    programTypeDetails?: ExCaseMgProgramTypeCreateRequest[] | undefined;

    constructor(data?: IExCaseMgrUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ecmId = _data["ecmId"];
            this.active = _data["active"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.emailAddress = _data["emailAddress"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.programId = _data["programId"];
            this.payorId = _data["payorId"];
            this.vendorId = _data["vendorId"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["programTypeDetails"])) {
                this.programTypeDetails = [] as any;
                for (let item of _data["programTypeDetails"])
                    this.programTypeDetails!.push(ExCaseMgProgramTypeCreateRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExCaseMgrUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExCaseMgrUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ecmId"] = this.ecmId;
        data["active"] = this.active;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["emailAddress"] = this.emailAddress;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["programId"] = this.programId;
        data["payorId"] = this.payorId;
        data["vendorId"] = this.vendorId;
        data["comment"] = this.comment;
        if (Array.isArray(this.programTypeDetails)) {
            data["programTypeDetails"] = [];
            for (let item of this.programTypeDetails)
                data["programTypeDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IExCaseMgrUpdateRequest {
    id: number;
    ecmId: string;
    active?: Status;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    emailAddress?: string | undefined;
    fax?: string | undefined;
    firstName: string;
    lastName?: string | undefined;
    phone?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    programId?: number | undefined;
    payorId: number;
    vendorId?: number | undefined;
    comment?: string | undefined;
    programTypeDetails?: ExCaseMgProgramTypeCreateRequest[] | undefined;
}

export class ProgramCreateRequest implements IProgramCreateRequest {
    id?: number | undefined;
    progNbr!: string;
    name!: string;
    companyId?: number;
    payorId!: number;
    receiverId!: string;
    npi!: string;
    fedTaxID!: string;
    submitNbr!: string;
    taxonomy!: string;
    fundingTypeId!: number;
    fundingSourceId!: number;
    programTypeId!: number;
    diagCodeId!: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    claimFileDestination?: string | undefined;
    payrollFileDestination?: string | undefined;
    api?: string | undefined;
    senderName!: string;
    receiverName!: string;
    stateCode?: string | undefined;

    constructor(data?: IProgramCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progNbr = _data["progNbr"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.payorId = _data["payorId"];
            this.receiverId = _data["receiverId"];
            this.npi = _data["npi"];
            this.fedTaxID = _data["fedTaxID"];
            this.submitNbr = _data["submitNbr"];
            this.taxonomy = _data["taxonomy"];
            this.fundingTypeId = _data["fundingTypeId"];
            this.fundingSourceId = _data["fundingSourceId"];
            this.programTypeId = _data["programTypeId"];
            this.diagCodeId = _data["diagCodeId"];
            this.contactName = _data["contactName"];
            this.phone = _data["phone"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateId = _data["stateId"];
            this.zip = _data["zip"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.comment = _data["comment"];
            this.claimFileDestination = _data["claimFileDestination"];
            this.payrollFileDestination = _data["payrollFileDestination"];
            this.api = _data["api"];
            this.senderName = _data["senderName"];
            this.receiverName = _data["receiverName"];
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): ProgramCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progNbr"] = this.progNbr;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["payorId"] = this.payorId;
        data["receiverId"] = this.receiverId;
        data["npi"] = this.npi;
        data["fedTaxID"] = this.fedTaxID;
        data["submitNbr"] = this.submitNbr;
        data["taxonomy"] = this.taxonomy;
        data["fundingTypeId"] = this.fundingTypeId;
        data["fundingSourceId"] = this.fundingSourceId;
        data["programTypeId"] = this.programTypeId;
        data["diagCodeId"] = this.diagCodeId;
        data["contactName"] = this.contactName;
        data["phone"] = this.phone;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateId"] = this.stateId;
        data["zip"] = this.zip;
        data["email"] = this.email;
        data["active"] = this.active;
        data["comment"] = this.comment;
        data["claimFileDestination"] = this.claimFileDestination;
        data["payrollFileDestination"] = this.payrollFileDestination;
        data["api"] = this.api;
        data["senderName"] = this.senderName;
        data["receiverName"] = this.receiverName;
        data["stateCode"] = this.stateCode;
        return data;
    }
}

export interface IProgramCreateRequest {
    id?: number | undefined;
    progNbr: string;
    name: string;
    companyId?: number;
    payorId: number;
    receiverId: string;
    npi: string;
    fedTaxID: string;
    submitNbr: string;
    taxonomy: string;
    fundingTypeId: number;
    fundingSourceId: number;
    programTypeId: number;
    diagCodeId: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    active?: string | undefined;
    comment?: string | undefined;
    claimFileDestination?: string | undefined;
    payrollFileDestination?: string | undefined;
    api?: string | undefined;
    senderName: string;
    receiverName: string;
    stateCode?: string | undefined;
}

export class UnitMultiplierRequest implements IUnitMultiplierRequest {
    programId?: number | undefined;
    serveCodeId?: number | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    progNbr?: string | undefined;
    servCode?: string | undefined;

    constructor(data?: IUnitMultiplierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.serveCodeId = _data["serveCodeId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.progNbr = _data["progNbr"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): UnitMultiplierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMultiplierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["serveCodeId"] = this.serveCodeId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["progNbr"] = this.progNbr;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface IUnitMultiplierRequest {
    programId?: number | undefined;
    serveCodeId?: number | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    progNbr?: string | undefined;
    servCode?: string | undefined;
}

export class UserRoleMappingRequest implements IUserRoleMappingRequest {
    userIds!: number[];
    roleList!: number[];

    constructor(data?: IUserRoleMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userIds = [];
            this.roleList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["roleList"])) {
                this.roleList = [] as any;
                for (let item of _data["roleList"])
                    this.roleList!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRoleMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.roleList)) {
            data["roleList"] = [];
            for (let item of this.roleList)
                data["roleList"].push(item);
        }
        return data;
    }
}

export interface IUserRoleMappingRequest {
    userIds: number[];
    roleList: number[];
}

export class ServCodeHistory implements IServCodeHistory {
    range?: string | undefined;
    servDescription?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    authCode?: string | undefined;
    pmFee?: boolean | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: IServCodeHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.range = _data["range"];
            this.servDescription = _data["servDescription"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.processingStartDate = _data["processingStartDate"] ? new Date(_data["processingStartDate"].toString()) : <any>undefined;
            this.processingEndDate = _data["processingEndDate"] ? new Date(_data["processingEndDate"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.units = _data["units"];
            this.rangeUnits = _data["rangeUnits"];
            this.budgetAmt = _data["budgetAmt"];
            this.authCode = _data["authCode"];
            this.pmFee = _data["pmFee"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): ServCodeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["range"] = this.range;
        data["servDescription"] = this.servDescription;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["processingStartDate"] = this.processingStartDate ? this.processingStartDate.toISOString() : <any>undefined;
        data["processingEndDate"] = this.processingEndDate ? this.processingEndDate.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["units"] = this.units;
        data["rangeUnits"] = this.rangeUnits;
        data["budgetAmt"] = this.budgetAmt;
        data["authCode"] = this.authCode;
        data["pmFee"] = this.pmFee;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["displayValue"] = this.displayValue;
        return data;
    }
}

export interface IServCodeHistory {
    range?: string | undefined;
    servDescription?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    processingStartDate?: Date | undefined;
    processingEndDate?: Date | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    authCode?: string | undefined;
    pmFee?: boolean | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    displayValue?: string | undefined;
}

export class ShiftsViewModel implements IShiftsViewModel {
    shifts?: Shift[] | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    personType?: string | undefined;
    begDate?: Date;
    endDate?: Date;

    constructor(data?: IShiftsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(Shift.fromJS(item));
            }
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.personType = _data["personType"];
            this.begDate = _data["begDate"] ? new Date(_data["begDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : <any>undefined);
        }
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["personType"] = this.personType;
        data["begDate"] = this.begDate ? this.begDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IShiftsViewModel {
    shifts?: Shift[] | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    personType?: string | undefined;
    begDate?: Date;
    endDate?: Date;
}

export class UnitMultiplierResponse implements IUnitMultiplierResponse {
    isExists?: boolean;
    value?: number;
    isValid?: boolean;
    authRequired?: boolean;
    feeRequired?: boolean;

    constructor(data?: IUnitMultiplierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExists = _data["isExists"];
            this.value = _data["value"];
            this.isValid = _data["isValid"];
            this.authRequired = _data["authRequired"];
            this.feeRequired = _data["feeRequired"];
        }
    }

    static fromJS(data: any): UnitMultiplierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMultiplierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExists"] = this.isExists;
        data["value"] = this.value;
        data["isValid"] = this.isValid;
        data["authRequired"] = this.authRequired;
        data["feeRequired"] = this.feeRequired;
        return data;
    }
}

export interface IUnitMultiplierResponse {
    isExists?: boolean;
    value?: number;
    isValid?: boolean;
    authRequired?: boolean;
    feeRequired?: boolean;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}